window.ZUITABLE_STORES = [
  {
    "id": "040-mannenmode-5625-aa-eindhoven",
    "name": "040 Mannenmode",
    "type": "Partner Store",
    "street": "Winkelzentrum Woensel",
    "house_number": "9",
    "street_line": "Winkelzentrum Woensel 9",
    "zip": "5625 AA",
    "city": "Eindhoven",
    "country": "The Netherlands",
    "country_label": "Niederlande",
    "region": "The Netherlands",
    "language": "Englisch",
    "address": "Winkelzentrum Woensel 9, 5625 AA Eindhoven, Niederlande",
    "map_query": "Winkelzentrum Woensel 9, 5625 AA Eindhoven, Niederlande",
    "maps_query": "040 Mannenmode, Winkelzentrum Woensel 9, 5625 AA Eindhoven, Niederlande",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 2
  },
  {
    "id": "4fashion-w-gmbh-und-co-kg-74193-schwaigern",
    "name": "4Fashion W GmbH & Co KG",
    "type": "Partner Store",
    "street": "Theodor-Heuss-Str.",
    "house_number": "25",
    "street_line": "Theodor-Heuss-Str. 25",
    "zip": "74193",
    "city": "Schwaigern",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Theodor-Heuss-Str. 25, 74193 Schwaigern, Deutschland",
    "map_query": "Theodor-Heuss-Str. 25, 74193 Schwaigern, Deutschland",
    "maps_query": "4Fashion W GmbH & Co KG, Theodor-Heuss-Str. 25, 74193 Schwaigern, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 3
  },
  {
    "id": "a-mode-stock-8000-brugge",
    "name": "A-Mode Stock",
    "type": "Partner Store",
    "street": "Korte Gotevlietstraat",
    "house_number": "2",
    "street_line": "Korte Gotevlietstraat 2",
    "zip": "8000",
    "city": "Brügge",
    "country": "Belgium",
    "country_label": "Belgien",
    "region": "Belgium",
    "language": "Englisch",
    "address": "Korte Gotevlietstraat 2, 8000 Brügge, Belgien",
    "map_query": "Korte Gotevlietstraat 2, 8000 Brügge, Belgien",
    "maps_query": "A-Mode Stock, Korte Gotevlietstraat 2, 8000 Brügge, Belgien",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 4
  },
  {
    "id": "a-seefried-herrenbekleidung-gmbh-86720-nordlingen",
    "name": "A. Seefried Herrenbekleidung GmbH",
    "type": "Partner Store",
    "street": "Eisengasse",
    "house_number": "7",
    "street_line": "Eisengasse 7",
    "zip": "86720",
    "city": "Nördlingen",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Eisengasse 7, 86720 Nördlingen, Deutschland",
    "map_query": "Eisengasse 7, 86720 Nördlingen, Deutschland",
    "maps_query": "A. Seefried Herrenbekleidung GmbH, Eisengasse 7, 86720 Nördlingen, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 5
  },
  {
    "id": "achilles-tailor-8820-torhout",
    "name": "Achilles Tailor",
    "type": "Partner Store",
    "street": "Roeselaarseweg",
    "house_number": "65",
    "street_line": "Roeselaarseweg 65",
    "zip": "8820",
    "city": "Torhout",
    "country": "Belgium",
    "country_label": "Belgien",
    "region": "Belgium",
    "language": "Englisch",
    "address": "Roeselaarseweg 65, 8820 Torhout, Belgien",
    "map_query": "Roeselaarseweg 65, 8820 Torhout, Belgien",
    "maps_query": "Achilles Tailor, Roeselaarseweg 65, 8820 Torhout, Belgien",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 6
  },
  {
    "id": "active-resource-fashion-gmbh-03046-cottbus",
    "name": "Active resource Fashion GmbH",
    "type": "Partner Store",
    "street": "Altmarkt",
    "house_number": "15",
    "street_line": "Altmarkt 15",
    "zip": "03046",
    "city": "Cottbus",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Altmarkt 15, 03046 Cottbus, Deutschland",
    "map_query": "Altmarkt 15, 03046 Cottbus, Deutschland",
    "maps_query": "Active resource Fashion GmbH, Altmarkt 15, 03046 Cottbus, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 7
  },
  {
    "id": "adam-und-eva-moden-wulf-gmbh-59348-ludinghausen",
    "name": "Adam & Eva Moden Wulf GmbH",
    "type": "Partner Store",
    "street": "Wilhelmstraße",
    "house_number": "1-5",
    "street_line": "Wilhelmstraße 1-5",
    "zip": "59348",
    "city": "Lüdinghausen",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Wilhelmstraße 1-5, 59348 Lüdinghausen, Deutschland",
    "map_query": "Wilhelmstraße 1-5, 59348 Lüdinghausen, Deutschland",
    "maps_query": "Adam & Eva Moden Wulf GmbH, Wilhelmstraße 1-5, 59348 Lüdinghausen, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 8
  },
  {
    "id": "adamski-gmbh-und-co-kg-31134-hildesheim",
    "name": "Adamski GmbH & Co. KG",
    "type": "Partner Store",
    "street": "Hoher Weg",
    "house_number": "7-8",
    "street_line": "Hoher Weg 7-8",
    "zip": "31134",
    "city": "Hildesheim",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Hoher Weg 7-8, 31134 Hildesheim, Deutschland",
    "map_query": "Hoher Weg 7-8, 31134 Hildesheim, Deutschland",
    "maps_query": "Adamski GmbH & Co. KG, Hoher Weg 7-8, 31134 Hildesheim, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 9
  },
  {
    "id": "adonis-8800-roeselare",
    "name": "Adonis",
    "type": "Partner Store",
    "street": "Noordstraat",
    "house_number": "23",
    "street_line": "Noordstraat 23",
    "zip": "8800",
    "city": "Roeselare",
    "country": "Belgium",
    "country_label": "Belgien",
    "region": "Belgium",
    "language": "Englisch",
    "address": "Noordstraat 23, 8800 Roeselare, Belgien",
    "map_query": "Noordstraat 23, 8800 Roeselare, Belgien",
    "maps_query": "Adonis, Noordstraat 23, 8800 Roeselare, Belgien",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 10
  },
  {
    "id": "aernout-mode-8908-vlamertinge",
    "name": "AERNOUT MODE",
    "type": "Partner Store",
    "street": "Poperingseweg",
    "house_number": "451",
    "street_line": "Poperingseweg 451",
    "zip": "8908",
    "city": "Vlamertinge",
    "country": "Belgium",
    "country_label": "Belgien",
    "region": "Belgium",
    "language": "Englisch",
    "address": "Poperingseweg 451, 8908 Vlamertinge, Belgien",
    "map_query": "Poperingseweg 451, 8908 Vlamertinge, Belgien",
    "maps_query": "AERNOUT MODE, Poperingseweg 451, 8908 Vlamertinge, Belgien",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 11
  },
  {
    "id": "ahrens-gmbh-und-co-kg-35037-marburg",
    "name": "Ahrens GmbH & Co KG",
    "type": "Partner Store",
    "street": "Universitätsstr.",
    "house_number": "14 - 22",
    "street_line": "Universitätsstr. 14 - 22",
    "zip": "35037",
    "city": "Marburg",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Universitätsstr. 14 - 22, 35037 Marburg, Deutschland",
    "map_query": "Universitätsstr. 14 - 22, 35037 Marburg, Deutschland",
    "maps_query": "Ahrens GmbH & Co KG, Universitätsstr. 14 - 22, 35037 Marburg, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 12
  },
  {
    "id": "an-dy-fashion-life-style-71364-winnenden",
    "name": "AN.DY FASHION.LIFE.STYLE",
    "type": "Partner Store",
    "street": "Ringstraße",
    "house_number": "57",
    "street_line": "Ringstraße 57",
    "zip": "71364",
    "city": "Winnenden",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Ringstraße 57, 71364 Winnenden, Deutschland",
    "map_query": "Ringstraße 57, 71364 Winnenden, Deutschland",
    "maps_query": "AN.DY FASHION.LIFE.STYLE, Ringstraße 57, 71364 Winnenden, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 13
  },
  {
    "id": "anders-und-anders-01309-dresden",
    "name": "Anders & Anders",
    "type": "Partner Store",
    "street": "Hüblerstrasse",
    "house_number": "4",
    "street_line": "Hüblerstrasse 4",
    "zip": "01309",
    "city": "Dresden",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Hüblerstrasse 4, 01309 Dresden, Deutschland",
    "map_query": "Hüblerstrasse 4, 01309 Dresden, Deutschland",
    "maps_query": "Anders & Anders, Hüblerstrasse 4, 01309 Dresden, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 14
  },
  {
    "id": "anson-s-augsburg-city-278-34355-staufenberg",
    "name": "Anson's Augsburg City 278",
    "type": "Partner Store",
    "street": "Vor der Hecke",
    "house_number": "4-12a",
    "street_line": "Vor der Hecke 4-12a",
    "zip": "34355",
    "city": "Staufenberg",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Vor der Hecke 4-12a, 34355 Staufenberg, Deutschland",
    "map_query": "Vor der Hecke 4-12a, 34355 Staufenberg, Deutschland",
    "maps_query": "Anson's Augsburg City 278, Vor der Hecke 4-12a, 34355 Staufenberg, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 15
  },
  {
    "id": "anson-s-berlin-steglitz-135-14612-falkensee",
    "name": "Anson's Berlin Steglitz 135",
    "type": "Partner Store",
    "street": "Straße der Einheit",
    "house_number": "139",
    "street_line": "Straße der Einheit 139",
    "zip": "14612",
    "city": "Falkensee",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Straße der Einheit 139, 14612 Falkensee, Deutschland",
    "map_query": "Straße der Einheit 139, 14612 Falkensee, Deutschland",
    "maps_query": "Anson's Berlin Steglitz 135, Straße der Einheit 139, 14612 Falkensee, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 16
  },
  {
    "id": "anson-s-bonn-074-50181-bedburg",
    "name": "Anson's Bonn 074",
    "type": "Partner Store",
    "street": "Sany Allee",
    "house_number": "2",
    "street_line": "Sany Allee 2",
    "zip": "50181",
    "city": "Bedburg",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Sany Allee 2, 50181 Bedburg, Deutschland",
    "map_query": "Sany Allee 2, 50181 Bedburg, Deutschland",
    "maps_query": "Anson's Bonn 074, Sany Allee 2, 50181 Bedburg, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 17
  },
  {
    "id": "anson-s-bremen-216-34355-staufenberg",
    "name": "Anson's Bremen 216",
    "type": "Partner Store",
    "street": "Vor der Hecke",
    "house_number": "4-12a",
    "street_line": "Vor der Hecke 4-12a",
    "zip": "34355",
    "city": "Staufenberg",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Vor der Hecke 4-12a, 34355 Staufenberg, Deutschland",
    "map_query": "Vor der Hecke 4-12a, 34355 Staufenberg, Deutschland",
    "maps_query": "Anson's Bremen 216, Vor der Hecke 4-12a, 34355 Staufenberg, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 18
  },
  {
    "id": "anson-s-dortmund-ii-232-50181-bedburg",
    "name": "Anson's Dortmund II 232",
    "type": "Partner Store",
    "street": "Sany Allee",
    "house_number": "2",
    "street_line": "Sany Allee 2",
    "zip": "50181",
    "city": "Bedburg",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Sany Allee 2, 50181 Bedburg, Deutschland",
    "map_query": "Sany Allee 2, 50181 Bedburg, Deutschland",
    "maps_query": "Anson's Dortmund II 232, Sany Allee 2, 50181 Bedburg, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 19
  },
  {
    "id": "anson-s-dusseldorf-ii-115-50181-bedburg",
    "name": "Anson's Düsseldorf II 115",
    "type": "Partner Store",
    "street": "Sany Allee",
    "house_number": "2",
    "street_line": "Sany Allee 2",
    "zip": "50181",
    "city": "Bedburg",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Sany Allee 2, 50181 Bedburg, Deutschland",
    "map_query": "Sany Allee 2, 50181 Bedburg, Deutschland",
    "maps_query": "Anson's Düsseldorf II 115, Sany Allee 2, 50181 Bedburg, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 20
  },
  {
    "id": "anson-s-frankfurt-238-63329-egelsbach",
    "name": "Anson's Frankfurt 238",
    "type": "Partner Store",
    "street": "Marie-Curie-Straße",
    "house_number": "24",
    "street_line": "Marie-Curie-Straße 24",
    "zip": "63329",
    "city": "Egelsbach",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Marie-Curie-Straße 24, 63329 Egelsbach, Deutschland",
    "map_query": "Marie-Curie-Straße 24, 63329 Egelsbach, Deutschland",
    "maps_query": "Anson's Frankfurt 238, Marie-Curie-Straße 24, 63329 Egelsbach, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 21
  },
  {
    "id": "anson-s-hamburg-279-34355-staufenberg",
    "name": "Anson's Hamburg 279",
    "type": "Partner Store",
    "street": "Vor der Hecke",
    "house_number": "4-12a",
    "street_line": "Vor der Hecke 4-12a",
    "zip": "34355",
    "city": "Staufenberg",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Vor der Hecke 4-12a, 34355 Staufenberg, Deutschland",
    "map_query": "Vor der Hecke 4-12a, 34355 Staufenberg, Deutschland",
    "maps_query": "Anson's Hamburg 279, Vor der Hecke 4-12a, 34355 Staufenberg, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 22
  },
  {
    "id": "anson-s-hamburg-eez-215-34355-staufenberg",
    "name": "Anson's Hamburg EEZ 215",
    "type": "Partner Store",
    "street": "Vor der Hecke",
    "house_number": "4-12a",
    "street_line": "Vor der Hecke 4-12a",
    "zip": "34355",
    "city": "Staufenberg",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Vor der Hecke 4-12a, 34355 Staufenberg, Deutschland",
    "map_query": "Vor der Hecke 4-12a, 34355 Staufenberg, Deutschland",
    "maps_query": "Anson's Hamburg EEZ 215, Vor der Hecke 4-12a, 34355 Staufenberg, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 23
  },
  {
    "id": "anson-s-hamburg-moe-117-34355-staufenberg",
    "name": "Anson's Hamburg Moe 117",
    "type": "Partner Store",
    "street": "Vor der Hecke",
    "house_number": "4-12a",
    "street_line": "Vor der Hecke 4-12a",
    "zip": "34355",
    "city": "Staufenberg",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Vor der Hecke 4-12a, 34355 Staufenberg, Deutschland",
    "map_query": "Vor der Hecke 4-12a, 34355 Staufenberg, Deutschland",
    "maps_query": "Anson's Hamburg Moe 117, Vor der Hecke 4-12a, 34355 Staufenberg, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 24
  },
  {
    "id": "anson-s-haus-essen-ii-017-50181-bedburg",
    "name": "Anson's Haus Essen II 017",
    "type": "Partner Store",
    "street": "Sany Allee",
    "house_number": "2",
    "street_line": "Sany Allee 2",
    "zip": "50181",
    "city": "Bedburg",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Sany Allee 2, 50181 Bedburg, Deutschland",
    "map_query": "Sany Allee 2, 50181 Bedburg, Deutschland",
    "maps_query": "Anson's Haus Essen II 017, Sany Allee 2, 50181 Bedburg, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 25
  },
  {
    "id": "anson-s-hh-alstertal-118-34355-staufenberg",
    "name": "Anson's HH-Alstertal 118",
    "type": "Partner Store",
    "street": "Vor der Hecke",
    "house_number": "4-12a",
    "street_line": "Vor der Hecke 4-12a",
    "zip": "34355",
    "city": "Staufenberg",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Vor der Hecke 4-12a, 34355 Staufenberg, Deutschland",
    "map_query": "Vor der Hecke 4-12a, 34355 Staufenberg, Deutschland",
    "maps_query": "Anson's HH-Alstertal 118, Vor der Hecke 4-12a, 34355 Staufenberg, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 26
  },
  {
    "id": "anson-s-hh-wandsbek-119-34355-staufenberg",
    "name": "Anson's HH-Wandsbek 119",
    "type": "Partner Store",
    "street": "Vor der Hecke",
    "house_number": "4-12a",
    "street_line": "Vor der Hecke 4-12a",
    "zip": "34355",
    "city": "Staufenberg",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Vor der Hecke 4-12a, 34355 Staufenberg, Deutschland",
    "map_query": "Vor der Hecke 4-12a, 34355 Staufenberg, Deutschland",
    "maps_query": "Anson's HH-Wandsbek 119, Vor der Hecke 4-12a, 34355 Staufenberg, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 27
  },
  {
    "id": "anson-s-karlsruhe-ii-234-34355-staufenberg",
    "name": "Anson's Karlsruhe II 234",
    "type": "Partner Store",
    "street": "Vor der Hecke",
    "house_number": "9-12a",
    "street_line": "Vor der Hecke 9-12a",
    "zip": "34355",
    "city": "Staufenberg",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Vor der Hecke 9-12a, 34355 Staufenberg, Deutschland",
    "map_query": "Vor der Hecke 9-12a, 34355 Staufenberg, Deutschland",
    "maps_query": "Anson's Karlsruhe II 234, Vor der Hecke 9-12a, 34355 Staufenberg, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 28
  },
  {
    "id": "anson-s-koln-ii-217-50181-bedburg",
    "name": "Anson's Köln II 217",
    "type": "Partner Store",
    "street": "Sany Allee",
    "house_number": "2",
    "street_line": "Sany Allee 2",
    "zip": "50181",
    "city": "Bedburg",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Sany Allee 2, 50181 Bedburg, Deutschland",
    "map_query": "Sany Allee 2, 50181 Bedburg, Deutschland",
    "maps_query": "Anson's Köln II 217, Sany Allee 2, 50181 Bedburg, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 29
  },
  {
    "id": "anson-s-krefeld-029-50181-bedburg",
    "name": "Anson's Krefeld 029",
    "type": "Partner Store",
    "street": "Sany Allee",
    "house_number": "2",
    "street_line": "Sany Allee 2",
    "zip": "50181",
    "city": "Bedburg",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Sany Allee 2, 50181 Bedburg, Deutschland",
    "map_query": "Sany Allee 2, 50181 Bedburg, Deutschland",
    "maps_query": "Anson's Krefeld 029, Sany Allee 2, 50181 Bedburg, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 30
  },
  {
    "id": "anson-s-mainz-243-63329-egelsbach",
    "name": "Anson's Mainz 243",
    "type": "Partner Store",
    "street": "Marie-Curie-Straße",
    "house_number": "24",
    "street_line": "Marie-Curie-Straße 24",
    "zip": "63329",
    "city": "Egelsbach",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Marie-Curie-Straße 24, 63329 Egelsbach, Deutschland",
    "map_query": "Marie-Curie-Straße 24, 63329 Egelsbach, Deutschland",
    "maps_query": "Anson's Mainz 243, Marie-Curie-Straße 24, 63329 Egelsbach, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 31
  },
  {
    "id": "anson-s-mtz-ii-204-63329-egelsbach",
    "name": "Anson's MTZ-II 204",
    "type": "Partner Store",
    "street": "Marie-Curie-Straße",
    "house_number": "24",
    "street_line": "Marie-Curie-Straße 24",
    "zip": "63329",
    "city": "Egelsbach",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Marie-Curie-Straße 24, 63329 Egelsbach, Deutschland",
    "map_query": "Marie-Curie-Straße 24, 63329 Egelsbach, Deutschland",
    "maps_query": "Anson's MTZ-II 204, Marie-Curie-Straße 24, 63329 Egelsbach, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 32
  },
  {
    "id": "anson-s-mulheim-ii-231-50181-bedburg",
    "name": "Anson's Mülheim II 231",
    "type": "Partner Store",
    "street": "Sany",
    "house_number": "2",
    "street_line": "Sany 2",
    "zip": "50181",
    "city": "Bedburg",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Sany 2, 50181 Bedburg, Deutschland",
    "map_query": "Sany 2, 50181 Bedburg, Deutschland",
    "maps_query": "Anson's Mülheim II 231, Sany 2, 50181 Bedburg, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 33
  },
  {
    "id": "anson-s-nurnberg-059-34355-staufenberg",
    "name": "Anson's Nürnberg 059",
    "type": "Partner Store",
    "street": "Vor der Hecke",
    "house_number": "4-12a",
    "street_line": "Vor der Hecke 4-12a",
    "zip": "34355",
    "city": "Staufenberg",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Vor der Hecke 4-12a, 34355 Staufenberg, Deutschland",
    "map_query": "Vor der Hecke 4-12a, 34355 Staufenberg, Deutschland",
    "maps_query": "Anson's Nürnberg 059, Vor der Hecke 4-12a, 34355 Staufenberg, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 34
  },
  {
    "id": "anson-s-regensburg-168-34355-staufenberg",
    "name": "Anson's Regensburg 168",
    "type": "Partner Store",
    "street": "Vor der Hecke",
    "house_number": "4-12a",
    "street_line": "Vor der Hecke 4-12a",
    "zip": "34355",
    "city": "Staufenberg",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Vor der Hecke 4-12a, 34355 Staufenberg, Deutschland",
    "map_query": "Vor der Hecke 4-12a, 34355 Staufenberg, Deutschland",
    "maps_query": "Anson's Regensburg 168, Vor der Hecke 4-12a, 34355 Staufenberg, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 35
  },
  {
    "id": "anson-s-saarbrucken-ii-149-34355-staufenberg",
    "name": "Anson's Saarbrücken II 149",
    "type": "Partner Store",
    "street": "Vor der Hecke",
    "house_number": "9-12a",
    "street_line": "Vor der Hecke 9-12a",
    "zip": "34355",
    "city": "Staufenberg",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Vor der Hecke 9-12a, 34355 Staufenberg, Deutschland",
    "map_query": "Vor der Hecke 9-12a, 34355 Staufenberg, Deutschland",
    "maps_query": "Anson's Saarbrücken II 149, Vor der Hecke 9-12a, 34355 Staufenberg, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 36
  },
  {
    "id": "anton-echter-gmbh-und-co-kg-82418-murnau",
    "name": "ANTON ECHTER GMBH & CO.KG",
    "type": "Partner Store",
    "street": "Obermarkt",
    "house_number": "2-4",
    "street_line": "Obermarkt 2-4",
    "zip": "82418",
    "city": "Murnau",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Obermarkt 2-4, 82418 Murnau, Deutschland",
    "map_query": "Obermarkt 2-4, 82418 Murnau, Deutschland",
    "maps_query": "ANTON ECHTER GMBH & CO.KG, Obermarkt 2-4, 82418 Murnau, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 37
  },
  {
    "id": "arezzo-bvba-9340-lede",
    "name": "Arezzo BVBA",
    "type": "Partner Store",
    "street": "Rammelstraat",
    "house_number": "22-24",
    "street_line": "Rammelstraat 22-24",
    "zip": "9340",
    "city": "Lede",
    "country": "Belgium",
    "country_label": "Belgien",
    "region": "Belgium",
    "language": "Englisch",
    "address": "Rammelstraat 22-24, 9340 Lede, Belgien",
    "map_query": "Rammelstraat 22-24, 9340 Lede, Belgien",
    "maps_query": "Arezzo BVBA, Rammelstraat 22-24, 9340 Lede, Belgien",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 38
  },
  {
    "id": "ariso-1840-londerzeel",
    "name": "Ariso",
    "type": "Partner Store",
    "street": "Kerkhofstraat",
    "house_number": "45",
    "street_line": "Kerkhofstraat 45",
    "zip": "1840",
    "city": "Londerzeel",
    "country": "Belgium",
    "country_label": "Belgien",
    "region": "Belgium",
    "language": "Englisch",
    "address": "Kerkhofstraat 45, 1840 Londerzeel, Belgien",
    "map_query": "Kerkhofstraat 45, 1840 Londerzeel, Belgien",
    "maps_query": "Ariso, Kerkhofstraat 45, 1840 Londerzeel, Belgien",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 39
  },
  {
    "id": "arts-en-nooijen-b-v-5831-jc-boxmeer",
    "name": "Arts en Nooijen B.V.",
    "type": "Partner Store",
    "street": "Steenstraat",
    "house_number": "73",
    "street_line": "Steenstraat 73",
    "zip": "5831 JC",
    "city": "Boxmeer",
    "country": "The Netherlands",
    "country_label": "Niederlande",
    "region": "The Netherlands",
    "language": "Englisch",
    "address": "Steenstraat 73, 5831 JC Boxmeer, Niederlande",
    "map_query": "Steenstraat 73, 5831 JC Boxmeer, Niederlande",
    "maps_query": "Arts en Nooijen B.V., Steenstraat 73, 5831 JC Boxmeer, Niederlande",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 40
  },
  {
    "id": "atelier-9-8071-gr-nunspeet",
    "name": "Atelier 9",
    "type": "Partner Store",
    "street": "Brinkersweg",
    "house_number": "9",
    "street_line": "Brinkersweg 9",
    "zip": "8071 GR",
    "city": "Nunspeet",
    "country": "The Netherlands",
    "country_label": "Niederlande",
    "region": "The Netherlands",
    "language": "Englisch",
    "address": "Brinkersweg 9, 8071 GR Nunspeet, Niederlande",
    "map_query": "Brinkersweg 9, 8071 GR Nunspeet, Niederlande",
    "maps_query": "Atelier 9, Brinkersweg 9, 8071 GR Nunspeet, Niederlande",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 41
  },
  {
    "id": "atelier-duetz-bv-1211cl-hilversum",
    "name": "Atelier Duetz BV",
    "type": "Partner Store",
    "street": "Kerkstraat",
    "house_number": "63-6",
    "street_line": "Kerkstraat 63-6",
    "zip": "1211CL",
    "city": "Hilversum",
    "country": "The Netherlands",
    "country_label": "Niederlande",
    "region": "The Netherlands",
    "language": "Englisch",
    "address": "Kerkstraat 63-6, 1211CL Hilversum, Niederlande",
    "map_query": "Kerkstraat 63-6, 1211CL Hilversum, Niederlande",
    "maps_query": "Atelier Duetz BV, Kerkstraat 63-6, 1211CL Hilversum, Niederlande",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 42
  },
  {
    "id": "august-bickert-gmbh-und-co-kg-63762-groostheim",
    "name": "August Bickert GmbH & Co KG",
    "type": "Partner Store",
    "street": "Aschaffenburger Str.",
    "house_number": "38",
    "street_line": "Aschaffenburger Str. 38",
    "zip": "63762",
    "city": "Großostheim",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Aschaffenburger Str. 38, 63762 Großostheim, Deutschland",
    "map_query": "Aschaffenburger Str. 38, 63762 Großostheim, Deutschland",
    "maps_query": "August Bickert GmbH & Co KG, Aschaffenburger Str. 38, 63762 Großostheim, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 43
  },
  {
    "id": "awg-allgemeine-warenvertriebs-gmbh-73257-kongen",
    "name": "AWG Allgemeine Warenvertriebs GmbH",
    "type": "Partner Store",
    "street": "Imanuel-Maier-Straße",
    "house_number": "2",
    "street_line": "Imanuel-Maier-Straße 2",
    "zip": "73257",
    "city": "Köngen",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Imanuel-Maier-Straße 2, 73257 Köngen, Deutschland",
    "map_query": "Imanuel-Maier-Straße 2, 73257 Köngen, Deutschland",
    "maps_query": "AWG Allgemeine Warenvertriebs GmbH, Imanuel-Maier-Straße 2, 73257 Köngen, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 44
  },
  {
    "id": "b-und-u-einzelhandels-gmbh-58636-iserlohn",
    "name": "B & U Einzelhandels GmbH",
    "type": "Partner Store",
    "street": "Unnaer Str. 6 -",
    "house_number": "12",
    "street_line": "Unnaer Str. 6 - 12",
    "zip": "58636",
    "city": "Iserlohn",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Unnaer Str. 6 - 12, 58636 Iserlohn, Deutschland",
    "map_query": "Unnaer Str. 6 - 12, 58636 Iserlohn, Deutschland",
    "maps_query": "B & U Einzelhandels GmbH, Unnaer Str. 6 - 12, 58636 Iserlohn, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 45
  },
  {
    "id": "b-und-g-herenmode-vof-1961-nx-heemskerk",
    "name": "B&G Herenmode VOF",
    "type": "Partner Store",
    "street": "Van Coevenhovenstraat",
    "house_number": "6",
    "street_line": "Van Coevenhovenstraat 6",
    "zip": "1961 NX",
    "city": "Heemskerk",
    "country": "The Netherlands",
    "country_label": "Niederlande",
    "region": "The Netherlands",
    "language": "Englisch",
    "address": "Van Coevenhovenstraat 6, 1961 NX Heemskerk, Niederlande",
    "map_query": "Van Coevenhovenstraat 6, 1961 NX Heemskerk, Niederlande",
    "maps_query": "B&G Herenmode VOF, Van Coevenhovenstraat 6, 1961 NX Heemskerk, Niederlande",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 46
  },
  {
    "id": "b-michaux-nv-6600-bastogne",
    "name": "B. Michaux NV",
    "type": "Partner Store",
    "street": "Rue du Sablon",
    "house_number": "93",
    "street_line": "Rue du Sablon 93",
    "zip": "6600",
    "city": "Bastogne",
    "country": "Belgium",
    "country_label": "Belgien",
    "region": "Belgium",
    "language": "Englisch",
    "address": "Rue du Sablon 93, 6600 Bastogne, Belgien",
    "map_query": "Rue du Sablon 93, 6600 Bastogne, Belgien",
    "maps_query": "B. Michaux NV, Rue du Sablon 93, 6600 Bastogne, Belgien",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 47
  },
  {
    "id": "b-stammel-gmbh-und-co-kg-86807-buchloe",
    "name": "B. Stammel GmbH & Co. KG",
    "type": "Partner Store",
    "street": "Bahnhofstraße",
    "house_number": "54",
    "street_line": "Bahnhofstraße 54",
    "zip": "86807",
    "city": "Buchloe",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "",
    "language": "Deutsch",
    "address": "Bahnhofstraße 54, 86807 Buchloe, Deutschland",
    "map_query": "Bahnhofstraße 54, 86807 Buchloe, Deutschland",
    "maps_query": "B. Stammel GmbH & Co. KG, Bahnhofstraße 54, 86807 Buchloe, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 48
  },
  {
    "id": "b-stammel-gmbh-und-co-kg-87719-mindelheim",
    "name": "B. Stammel GmbH & Co. KG",
    "type": "Partner Store",
    "street": "Maximilianstr.",
    "house_number": "20",
    "street_line": "Maximilianstr. 20",
    "zip": "87719",
    "city": "Mindelheim",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "",
    "language": "Deutsch",
    "address": "Maximilianstr. 20, 87719 Mindelheim, Deutschland",
    "map_query": "Maximilianstr. 20, 87719 Mindelheim, Deutschland",
    "maps_query": "B. Stammel GmbH & Co. KG, Maximilianstr. 20, 87719 Mindelheim, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 49
  },
  {
    "id": "b-stammel-gmbh-und-co-kg-86830-schwabmunchen",
    "name": "B. Stammel GmbH & Co.KG",
    "type": "Partner Store",
    "street": "Fuggerstr.",
    "house_number": "15",
    "street_line": "Fuggerstr. 15",
    "zip": "86830",
    "city": "Schwabmünchen",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Fuggerstr. 15, 86830 Schwabmünchen, Deutschland",
    "map_query": "Fuggerstr. 15, 86830 Schwabmünchen, Deutschland",
    "maps_query": "B. Stammel GmbH & Co.KG, Fuggerstr. 15, 86830 Schwabmünchen, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 50
  },
  {
    "id": "baker-und-baker-3353-hh-papendrecht",
    "name": "Baker & Baker",
    "type": "Partner Store",
    "street": "Meentpassage",
    "house_number": "22",
    "street_line": "Meentpassage 22",
    "zip": "3353 HH",
    "city": "Papendrecht",
    "country": "The Netherlands",
    "country_label": "Niederlande",
    "region": "The Netherlands",
    "language": "Englisch",
    "address": "Meentpassage 22, 3353 HH Papendrecht, Niederlande",
    "map_query": "Meentpassage 22, 3353 HH Papendrecht, Niederlande",
    "maps_query": "Baker & Baker, Meentpassage 22, 3353 HH Papendrecht, Niederlande",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 51
  },
  {
    "id": "bantel-gmbh-73614-schorndorf",
    "name": "Bantel GmbH",
    "type": "Partner Store",
    "street": "Johann-Philipp-Palm-Str. 23 -",
    "house_number": "25",
    "street_line": "Johann-Philipp-Palm-Str. 23 - 25",
    "zip": "73614",
    "city": "Schorndorf",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Johann-Philipp-Palm-Str. 23 - 25, 73614 Schorndorf, Deutschland",
    "map_query": "Johann-Philipp-Palm-Str. 23 - 25, 73614 Schorndorf, Deutschland",
    "maps_query": "Bantel GmbH, Johann-Philipp-Palm-Str. 23 - 25, 73614 Schorndorf, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 52
  },
  {
    "id": "basile-family-srl-6900-marche-en-famenne",
    "name": "Basile Family SRL",
    "type": "Partner Store",
    "street": "Chaussée di Liége",
    "house_number": "11",
    "street_line": "Chaussée di Liége 11",
    "zip": "6900",
    "city": "Marche-en-Famenne",
    "country": "Belgium",
    "country_label": "Belgien",
    "region": "Belgium",
    "language": "Englisch",
    "address": "Chaussée di Liége 11, 6900 Marche-en-Famenne, Belgien",
    "map_query": "Chaussée di Liége 11, 6900 Marche-en-Famenne, Belgien",
    "maps_query": "Basile Family SRL, Chaussée di Liége 11, 6900 Marche-en-Famenne, Belgien",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 53
  },
  {
    "id": "bastiaansen-modestad-4854ct-bavel",
    "name": "Bastiaansen Modestad",
    "type": "Partner Store",
    "street": "Brigidastraat",
    "house_number": "2",
    "street_line": "Brigidastraat 2",
    "zip": "4854CT",
    "city": "Bavel",
    "country": "The Netherlands",
    "country_label": "Niederlande",
    "region": "The Netherlands",
    "language": "Englisch",
    "address": "Brigidastraat 2, 4854CT Bavel, Niederlande",
    "map_query": "Brigidastraat 2, 4854CT Bavel, Niederlande",
    "maps_query": "Bastiaansen Modestad, Brigidastraat 2, 4854CT Bavel, Niederlande",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 54
  },
  {
    "id": "becker-und-exner-95444-bayreuth",
    "name": "Becker & Exner",
    "type": "Partner Store",
    "street": "Dammallee",
    "house_number": "19",
    "street_line": "Dammallee 19",
    "zip": "95444",
    "city": "Bayreuth",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Dammallee 19, 95444 Bayreuth, Deutschland",
    "map_query": "Dammallee 19, 95444 Bayreuth, Deutschland",
    "maps_query": "Becker & Exner, Dammallee 19, 95444 Bayreuth, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 55
  },
  {
    "id": "beermann-man-und-mode-8011-vx-zwolle",
    "name": "Beermann Man & Mode",
    "type": "Partner Store",
    "street": "Diezerpoortenplas",
    "house_number": "20",
    "street_line": "Diezerpoortenplas 20",
    "zip": "8011 VX",
    "city": "Zwolle",
    "country": "The Netherlands",
    "country_label": "Niederlande",
    "region": "The Netherlands",
    "language": "Englisch",
    "address": "Diezerpoortenplas 20, 8011 VX Zwolle, Niederlande",
    "map_query": "Diezerpoortenplas 20, 8011 VX Zwolle, Niederlande",
    "maps_query": "Beermann Man & Mode, Diezerpoortenplas 20, 8011 VX Zwolle, Niederlande",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 56
  },
  {
    "id": "bekleidungshaus-bufler-gmbh-88161-lindenberg",
    "name": "Bekleidungshaus Bufler GmbH",
    "type": "Partner Store",
    "street": "Bahnhofstr.",
    "house_number": "1",
    "street_line": "Bahnhofstr. 1",
    "zip": "88161",
    "city": "Lindenberg",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Bahnhofstr. 1, 88161 Lindenberg, Deutschland",
    "map_query": "Bahnhofstr. 1, 88161 Lindenberg, Deutschland",
    "maps_query": "Bekleidungshaus Bufler GmbH, Bahnhofstr. 1, 88161 Lindenberg, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 57
  },
  {
    "id": "bekleidungshaus-fruhauf-gmbh-92342-freystadt",
    "name": "Bekleidungshaus Frühauf GmbH",
    "type": "Partner Store",
    "street": "Marktplatz",
    "house_number": "15",
    "street_line": "Marktplatz 15",
    "zip": "92342",
    "city": "Freystadt",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Marktplatz 15, 92342 Freystadt, Deutschland",
    "map_query": "Marktplatz 15, 92342 Freystadt, Deutschland",
    "maps_query": "Bekleidungshaus Frühauf GmbH, Marktplatz 15, 92342 Freystadt, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 58
  },
  {
    "id": "bekleidungshaus-g-wahl-gmbh-88521-ertingen",
    "name": "Bekleidungshaus G. Wahl GmbH",
    "type": "Partner Store",
    "street": "Kronenweg",
    "house_number": "2",
    "street_line": "Kronenweg 2",
    "zip": "88521",
    "city": "Ertingen",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Kronenweg 2, 88521 Ertingen, Deutschland",
    "map_query": "Kronenweg 2, 88521 Ertingen, Deutschland",
    "maps_query": "Bekleidungshaus G. Wahl GmbH, Kronenweg 2, 88521 Ertingen, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 59
  },
  {
    "id": "bekleidungshaus-schmidt-ohg-71229-leonberg",
    "name": "Bekleidungshaus Schmidt OHG",
    "type": "Partner Store",
    "street": "Bismarckstr.",
    "house_number": "22",
    "street_line": "Bismarckstr. 22",
    "zip": "71229",
    "city": "Leonberg",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Bismarckstr. 22, 71229 Leonberg, Deutschland",
    "map_query": "Bismarckstr. 22, 71229 Leonberg, Deutschland",
    "maps_query": "Bekleidungshaus Schmidt OHG, Bismarckstr. 22, 71229 Leonberg, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 60
  },
  {
    "id": "bekleidungshaus-seeg-gmbh-und-co-kg-91413-neustadt-an-der-aisch",
    "name": "Bekleidungshaus Seeg GmbH & Co. KG",
    "type": "Partner Store",
    "street": "Bamberger Straße",
    "house_number": "9",
    "street_line": "Bamberger Straße 9",
    "zip": "91413",
    "city": "Neustadt an der Aisch",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Bamberger Straße 9, 91413 Neustadt an der Aisch, Deutschland",
    "map_query": "Bamberger Straße 9, 91413 Neustadt an der Aisch, Deutschland",
    "maps_query": "Bekleidungshaus Seeg GmbH & Co. KG, Bamberger Straße 9, 91413 Neustadt an der Aisch, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 61
  },
  {
    "id": "bekleidungshauser-karl-vockeroth-gmbh-37073-gottingen",
    "name": "Bekleidungshäuser Karl Vockeroth GmbH",
    "type": "Partner Store",
    "street": "Kornmarkt",
    "house_number": "12-16",
    "street_line": "Kornmarkt 12-16",
    "zip": "37073",
    "city": "Göttingen",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Kornmarkt 12-16, 37073 Göttingen, Deutschland",
    "map_query": "Kornmarkt 12-16, 37073 Göttingen, Deutschland",
    "maps_query": "Bekleidungshäuser Karl Vockeroth GmbH, Kornmarkt 12-16, 37073 Göttingen, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 62
  },
  {
    "id": "bello-01000-bourg-en-bresse",
    "name": "Bello",
    "type": "Partner Store",
    "street": "rue Maréchal Joffre",
    "house_number": "9",
    "street_line": "rue Maréchal Joffre 9",
    "zip": "01000",
    "city": "Bourg en Bresse",
    "country": "France",
    "country_label": "Frankreich",
    "region": "France",
    "language": "Englisch",
    "address": "rue Maréchal Joffre 9, 01000 Bourg en Bresse, Frankreich",
    "map_query": "rue Maréchal Joffre 9, 01000 Bourg en Bresse, Frankreich",
    "maps_query": "Bello, rue Maréchal Joffre 9, 01000 Bourg en Bresse, Frankreich",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 63
  },
  {
    "id": "belly-menswear-1500-halle",
    "name": "Belly Menswear",
    "type": "Partner Store",
    "street": "Ninoofsteenweg",
    "house_number": "18",
    "street_line": "Ninoofsteenweg 18",
    "zip": "1500",
    "city": "Halle",
    "country": "Belgium",
    "country_label": "Belgien",
    "region": "Belgium",
    "language": "Englisch",
    "address": "Ninoofsteenweg 18, 1500 Halle, Belgien",
    "map_query": "Ninoofsteenweg 18, 1500 Halle, Belgien",
    "maps_query": "Belly Menswear, Ninoofsteenweg 18, 1500 Halle, Belgien",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 64
  },
  {
    "id": "ben-s-fashion-2691-bg-gravenzande",
    "name": "Ben's Fashion",
    "type": "Partner Store",
    "street": "Langestraat",
    "house_number": "255",
    "street_line": "Langestraat 255",
    "zip": "2691 BG",
    "city": "Gravenzande",
    "country": "The Netherlands",
    "country_label": "Niederlande",
    "region": "The Netherlands",
    "language": "Englisch",
    "address": "Langestraat 255, 2691 BG Gravenzande, Niederlande",
    "map_query": "Langestraat 255, 2691 BG Gravenzande, Niederlande",
    "maps_query": "Ben's Fashion, Langestraat 255, 2691 BG Gravenzande, Niederlande",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 65
  },
  {
    "id": "berden-mode-venray-b-v-5801-be-venray",
    "name": "Berden Mode Venray B.V.",
    "type": "Partner Store",
    "street": "Grotestraat",
    "house_number": "23",
    "street_line": "Grotestraat 23",
    "zip": "5801 BE",
    "city": "Venray",
    "country": "The Netherlands",
    "country_label": "Niederlande",
    "region": "The Netherlands",
    "language": "Englisch",
    "address": "Grotestraat 23, 5801 BE Venray, Niederlande",
    "map_query": "Grotestraat 23, 5801 BE Venray, Niederlande",
    "maps_query": "Berden Mode Venray B.V., Grotestraat 23, 5801 BE Venray, Niederlande",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 66
  },
  {
    "id": "bernard-herenmode-b-v-6131-ea-sittard",
    "name": "Bernard Herenmode B.V.",
    "type": "Partner Store",
    "street": "Limbricherstraat",
    "house_number": "17",
    "street_line": "Limbricherstraat 17",
    "zip": "6131 EA",
    "city": "Sittard",
    "country": "The Netherlands",
    "country_label": "Niederlande",
    "region": "The Netherlands",
    "language": "Englisch",
    "address": "Limbricherstraat 17, 6131 EA Sittard, Niederlande",
    "map_query": "Limbricherstraat 17, 6131 EA Sittard, Niederlande",
    "maps_query": "Bernard Herenmode B.V., Limbricherstraat 17, 6131 EA Sittard, Niederlande",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 67
  },
  {
    "id": "berry-shop-1074-ae-amsterdam",
    "name": "Berry Shop",
    "type": "Partner Store",
    "street": "Van Woustraat 95-H",
    "house_number": "",
    "street_line": "Van Woustraat 95-H",
    "zip": "1074 AE",
    "city": "Amsterdam",
    "country": "The Netherlands",
    "country_label": "Niederlande",
    "region": "The Netherlands",
    "language": "Englisch",
    "address": "Van Woustraat 95-H, 1074 AE Amsterdam, Niederlande",
    "map_query": "Berry Shop, Van Woustraat 95-H, 1074 AE Amsterdam, Niederlande",
    "maps_query": "Berry Shop, Van Woustraat 95-H, 1074 AE Amsterdam, Niederlande",
    "note": "Sortiment und Verfügbarkeit können variieren. Adresse bitte vor Besuch über den Händler prüfen.",
    "data_quality": [
      "house_number_missing"
    ],
    "source_row": 68
  },
  {
    "id": "bex-kleding-heren-bv-3512-stevoort-hasselt",
    "name": "Bex kleding heren bv",
    "type": "Partner Store",
    "street": "Sint-Maartenplein",
    "house_number": "4",
    "street_line": "Sint-Maartenplein 4",
    "zip": "3512",
    "city": "Stevoort - Hasselt",
    "country": "Belgium",
    "country_label": "Belgien",
    "region": "Belgium",
    "language": "Englisch",
    "address": "Sint-Maartenplein 4, 3512 Stevoort - Hasselt, Belgien",
    "map_query": "Sint-Maartenplein 4, 3512 Stevoort - Hasselt, Belgien",
    "maps_query": "Bex kleding heren bv, Sint-Maartenplein 4, 3512 Stevoort - Hasselt, Belgien",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 69
  },
  {
    "id": "bij-schulten-8131-ba-wijhe",
    "name": "Bij Schulten",
    "type": "Partner Store",
    "street": "Langstraat",
    "house_number": "31",
    "street_line": "Langstraat 31",
    "zip": "8131 BA",
    "city": "Wijhe",
    "country": "The Netherlands",
    "country_label": "Niederlande",
    "region": "The Netherlands",
    "language": "Englisch",
    "address": "Langstraat 31, 8131 BA Wijhe, Niederlande",
    "map_query": "Langstraat 31, 8131 BA Wijhe, Niederlande",
    "maps_query": "Bij Schulten, Langstraat 31, 8131 BA Wijhe, Niederlande",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 70
  },
  {
    "id": "bijnen-mode-5504-ba-veldhoven",
    "name": "Bijnen Mode",
    "type": "Partner Store",
    "street": "Kromstraat",
    "house_number": "11",
    "street_line": "Kromstraat 11",
    "zip": "5504 BA",
    "city": "Veldhoven",
    "country": "The Netherlands",
    "country_label": "Niederlande",
    "region": "The Netherlands",
    "language": "Englisch",
    "address": "Kromstraat 11, 5504 BA Veldhoven, Niederlande",
    "map_query": "Kromstraat 11, 5504 BA Veldhoven, Niederlande",
    "maps_query": "Bijnen Mode, Kromstraat 11, 5504 BA Veldhoven, Niederlande",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 71
  },
  {
    "id": "binky-shop-3600-genk",
    "name": "Binky Shop",
    "type": "Partner Store",
    "street": "Stalenstraat",
    "house_number": "175",
    "street_line": "Stalenstraat 175",
    "zip": "3600",
    "city": "Genk",
    "country": "Belgium",
    "country_label": "Belgien",
    "region": "Belgium",
    "language": "Englisch",
    "address": "Stalenstraat 175, 3600 Genk, Belgien",
    "map_query": "Stalenstraat 175, 3600 Genk, Belgien",
    "maps_query": "Binky Shop, Stalenstraat 175, 3600 Genk, Belgien",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 72
  },
  {
    "id": "blatter-mens-fashion-gmbh-9400-rorschach",
    "name": "Blatter men’s fashion GmbH",
    "type": "Partner Store",
    "street": "Hauptstrasse",
    "house_number": "75",
    "street_line": "Hauptstrasse 75",
    "zip": "9400",
    "city": "Rorschach",
    "country": "Switzerland",
    "country_label": "Schweiz",
    "region": "Switzerland",
    "language": "Englisch",
    "address": "Hauptstrasse 75, 9400 Rorschach, Schweiz",
    "map_query": "Hauptstrasse 75, 9400 Rorschach, Schweiz",
    "maps_query": "Blatter men’s fashion GmbH, Hauptstrasse 75, 9400 Rorschach, Schweiz",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 73
  },
  {
    "id": "blijdesteijn-mode-b-v-4001-lt-tiel",
    "name": "Blijdesteijn Mode B.V.",
    "type": "Partner Store",
    "street": "Voorstad",
    "house_number": "24",
    "street_line": "Voorstad 24",
    "zip": "4001 LT",
    "city": "Tiel",
    "country": "The Netherlands",
    "country_label": "Niederlande",
    "region": "The Netherlands",
    "language": "Englisch",
    "address": "Voorstad 24, 4001 LT Tiel, Niederlande",
    "map_query": "Voorstad 24, 4001 LT Tiel, Niederlande",
    "maps_query": "Blijdesteijn Mode B.V., Voorstad 24, 4001 LT Tiel, Niederlande",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 74
  },
  {
    "id": "bluepoint-fashion-m-v-2671-ev-naaldwijk",
    "name": "Bluepoint Fashion M/V",
    "type": "Partner Store",
    "street": "Molenstraat",
    "house_number": "19",
    "street_line": "Molenstraat 19",
    "zip": "2671 EV",
    "city": "Naaldwijk",
    "country": "The Netherlands",
    "country_label": "Niederlande",
    "region": "The Netherlands",
    "language": "Englisch",
    "address": "Molenstraat 19, 2671 EV Naaldwijk, Niederlande",
    "map_query": "Molenstraat 19, 2671 EV Naaldwijk, Niederlande",
    "maps_query": "Bluepoint Fashion M/V, Molenstraat 19, 2671 EV Naaldwijk, Niederlande",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 75
  },
  {
    "id": "bockmann-zentralverwaltungs-49661-cloppenburg",
    "name": "Böckmann Zentralverwaltungs",
    "type": "Partner Store",
    "street": "Bahnhofstraße",
    "house_number": "9-11",
    "street_line": "Bahnhofstraße 9-11",
    "zip": "49661",
    "city": "Cloppenburg",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Bahnhofstraße 9-11, 49661 Cloppenburg, Deutschland",
    "map_query": "Bahnhofstraße 9-11, 49661 Cloppenburg, Deutschland",
    "maps_query": "Böckmann Zentralverwaltungs, Bahnhofstraße 9-11, 49661 Cloppenburg, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 76
  },
  {
    "id": "bomont-centraal-4338ra-middelburg",
    "name": "Bomont Centraal",
    "type": "Partner Store",
    "street": "Anodeweg",
    "house_number": "62",
    "street_line": "Anodeweg 62",
    "zip": "4338RA",
    "city": "Middelburg",
    "country": "The Netherlands",
    "country_label": "Niederlande",
    "region": "The Netherlands",
    "language": "Englisch",
    "address": "Anodeweg 62, 4338RA Middelburg, Niederlande",
    "map_query": "Anodeweg 62, 4338RA Middelburg, Niederlande",
    "maps_query": "Bomont Centraal, Anodeweg 62, 4338RA Middelburg, Niederlande",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 77
  },
  {
    "id": "bon-ami-mannenmode-6741-zr-lunteren",
    "name": "Bon Ami Mannenmode",
    "type": "Partner Store",
    "street": "Molenparkweg",
    "house_number": "4b",
    "street_line": "Molenparkweg 4b",
    "zip": "6741 ZR",
    "city": "Lunteren",
    "country": "The Netherlands",
    "country_label": "Niederlande",
    "region": "The Netherlands",
    "language": "Englisch",
    "address": "Molenparkweg 4b, 6741 ZR Lunteren, Niederlande",
    "map_query": "Molenparkweg 4b, 6741 ZR Lunteren, Niederlande",
    "maps_query": "Bon Ami Mannenmode, Molenparkweg 4b, 6741 ZR Lunteren, Niederlande",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 78
  },
  {
    "id": "boniberger-85354-freising",
    "name": "Boniberger",
    "type": "Partner Store",
    "street": "Obere Hauptstr.",
    "house_number": "11",
    "street_line": "Obere Hauptstr. 11",
    "zip": "85354",
    "city": "Freising",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Obere Hauptstr. 11, 85354 Freising, Deutschland",
    "map_query": "Obere Hauptstr. 11, 85354 Freising, Deutschland",
    "maps_query": "Boniberger, Obere Hauptstr. 11, 85354 Freising, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 79
  },
  {
    "id": "boniberger-herrenmode-81241-munchen",
    "name": "Boniberger Herrenmode",
    "type": "Partner Store",
    "street": "Spiegelstr.",
    "house_number": "4",
    "street_line": "Spiegelstr. 4",
    "zip": "81241",
    "city": "München",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Spiegelstr. 4, 81241 München, Deutschland",
    "map_query": "Spiegelstr. 4, 81241 München, Deutschland",
    "maps_query": "Boniberger Herrenmode, Spiegelstr. 4, 81241 München, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 80
  },
  {
    "id": "bonomo-gro-und-einzelhandel-80807-munchen",
    "name": "BONOMO Groß- und Einzelhandel",
    "type": "Partner Store",
    "street": "Taunusstraße",
    "house_number": "45",
    "street_line": "Taunusstraße 45",
    "zip": "80807",
    "city": "München",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Taunusstraße 45, 80807 München, Deutschland",
    "map_query": "Taunusstraße 45, 80807 München, Deutschland",
    "maps_query": "BONOMO Groß- und Einzelhandel, Taunusstraße 45, 80807 München, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 81
  },
  {
    "id": "borsalino-knokke-bv-8301-knokke-heist",
    "name": "Borsalino Knokke BV",
    "type": "Partner Store",
    "street": "Graaf D`Ursellaan",
    "house_number": "41",
    "street_line": "Graaf D`Ursellaan 41",
    "zip": "8301",
    "city": "Knokke Heist",
    "country": "Belgium",
    "country_label": "Belgien",
    "region": "Belgium",
    "language": "Englisch",
    "address": "Graaf D`Ursellaan 41, 8301 Knokke Heist, Belgien",
    "map_query": "Graaf D`Ursellaan 41, 8301 Knokke Heist, Belgien",
    "maps_query": "Borsalino Knokke BV, Graaf D`Ursellaan 41, 8301 Knokke Heist, Belgien",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 82
  },
  {
    "id": "bossenbroek-man-3781-ga-voorthuizen",
    "name": "Bossenbroek Man",
    "type": "Partner Store",
    "street": "Kerkstraat",
    "house_number": "21",
    "street_line": "Kerkstraat 21",
    "zip": "3781 GA",
    "city": "Voorthuizen",
    "country": "The Netherlands",
    "country_label": "Niederlande",
    "region": "The Netherlands",
    "language": "Englisch",
    "address": "Kerkstraat 21, 3781 GA Voorthuizen, Niederlande",
    "map_query": "Kerkstraat 21, 3781 GA Voorthuizen, Niederlande",
    "maps_query": "Bossenbroek Man, Kerkstraat 21, 3781 GA Voorthuizen, Niederlande",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 83
  },
  {
    "id": "boutiek-foulie-8650-merkem",
    "name": "Boutiek Foulie",
    "type": "Partner Store",
    "street": "Kouterstraat",
    "house_number": "69",
    "street_line": "Kouterstraat 69",
    "zip": "8650",
    "city": "Merkem",
    "country": "Belgium",
    "country_label": "Belgien",
    "region": "Belgium",
    "language": "Englisch",
    "address": "Kouterstraat 69, 8650 Merkem, Belgien",
    "map_query": "Kouterstraat 69, 8650 Merkem, Belgien",
    "maps_query": "Boutiek Foulie, Kouterstraat 69, 8650 Merkem, Belgien",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 84
  },
  {
    "id": "boutique-kalin-moda-sagl-6600-locarno",
    "name": "Boutique Kälin Moda Sagl",
    "type": "Partner Store",
    "street": "Piazza Grande",
    "house_number": "34",
    "street_line": "Piazza Grande 34",
    "zip": "6600",
    "city": "Locarno",
    "country": "Switzerland",
    "country_label": "Schweiz",
    "region": "Switzerland",
    "language": "Englisch",
    "address": "Piazza Grande 34, 6600 Locarno, Schweiz",
    "map_query": "Piazza Grande 34, 6600 Locarno, Schweiz",
    "maps_query": "Boutique Kälin Moda Sagl, Piazza Grande 34, 6600 Locarno, Schweiz",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 85
  },
  {
    "id": "brautfashion-ag-5643-sins",
    "name": "Brautfashion AG",
    "type": "Partner Store",
    "street": "Luzernstrasse",
    "house_number": "33",
    "street_line": "Luzernstrasse 33",
    "zip": "5643",
    "city": "Sins",
    "country": "Switzerland",
    "country_label": "Schweiz",
    "region": "Switzerland",
    "language": "Englisch",
    "address": "Luzernstrasse 33, 5643 Sins, Schweiz",
    "map_query": "Luzernstrasse 33, 5643 Sins, Schweiz",
    "maps_query": "Brautfashion AG, Luzernstrasse 33, 5643 Sins, Schweiz",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 86
  },
  {
    "id": "bredl-gmbh-88214-ravensburg",
    "name": "Bredl GmbH",
    "type": "Partner Store",
    "street": "Bachstr. 2 -",
    "house_number": "4",
    "street_line": "Bachstr. 2 - 4",
    "zip": "88214",
    "city": "Ravensburg",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Bachstr. 2 - 4, 88214 Ravensburg, Deutschland",
    "map_query": "Bachstr. 2 - 4, 88214 Ravensburg, Deutschland",
    "maps_query": "Bredl GmbH, Bachstr. 2 - 4, 88214 Ravensburg, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 87
  },
  {
    "id": "broghammer-men-und-women-ohg-78050-vs-villingen",
    "name": "Broghammer Men & Women OHG",
    "type": "Partner Store",
    "street": "Niedere Str. 78 -",
    "house_number": "84",
    "street_line": "Niedere Str. 78 - 84",
    "zip": "78050",
    "city": "VS-Villingen",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Niedere Str. 78 - 84, 78050 VS-Villingen, Deutschland",
    "map_query": "Niedere Str. 78 - 84, 78050 VS-Villingen, Deutschland",
    "maps_query": "Broghammer Men & Women OHG, Niedere Str. 78 - 84, 78050 VS-Villingen, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 88
  },
  {
    "id": "bruurs-2320-hoogstraten",
    "name": "BRUURS",
    "type": "Partner Store",
    "street": "VRIJHEID",
    "house_number": "93",
    "street_line": "VRIJHEID 93",
    "zip": "2320",
    "city": "HOOGSTRATEN",
    "country": "Belgium",
    "country_label": "Belgien",
    "region": "Belgium",
    "language": "Englisch",
    "address": "VRIJHEID 93, 2320 HOOGSTRATEN, Belgien",
    "map_query": "VRIJHEID 93, 2320 HOOGSTRATEN, Belgien",
    "maps_query": "BRUURS, VRIJHEID 93, 2320 HOOGSTRATEN, Belgien",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 89
  },
  {
    "id": "bulte-showroom-nv-9950-lievegem",
    "name": "Bulte Showroom NV",
    "type": "Partner Store",
    "street": "H. Consciencelaan",
    "house_number": "6",
    "street_line": "H. Consciencelaan 6",
    "zip": "9950",
    "city": "Lievegem",
    "country": "Belgium",
    "country_label": "Belgien",
    "region": "Belgium",
    "language": "Englisch",
    "address": "H. Consciencelaan 6, 9950 Lievegem, Belgien",
    "map_query": "H. Consciencelaan 6, 9950 Lievegem, Belgien",
    "maps_query": "Bulte Showroom NV, H. Consciencelaan 6, 9950 Lievegem, Belgien",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 90
  },
  {
    "id": "bungert-ohg-54516-wittlich",
    "name": "Bungert OHG",
    "type": "Partner Store",
    "street": "Friedrichstr.",
    "house_number": "59",
    "street_line": "Friedrichstr. 59",
    "zip": "54516",
    "city": "Wittlich",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Friedrichstr. 59, 54516 Wittlich, Deutschland",
    "map_query": "Friedrichstr. 59, 54516 Wittlich, Deutschland",
    "maps_query": "Bungert OHG, Friedrichstr. 59, 54516 Wittlich, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 91
  },
  {
    "id": "burghaus-gmbh-und-co-kg-57518-betzdorf",
    "name": "Burghaus GmbH & Co KG",
    "type": "Partner Store",
    "street": "Wilhelmstraße",
    "house_number": "45-47",
    "street_line": "Wilhelmstraße 45-47",
    "zip": "57518",
    "city": "Betzdorf",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Wilhelmstraße 45-47, 57518 Betzdorf, Deutschland",
    "map_query": "Wilhelmstraße 45-47, 57518 Betzdorf, Deutschland",
    "maps_query": "Burghaus GmbH & Co KG, Wilhelmstraße 45-47, 57518 Betzdorf, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 92
  },
  {
    "id": "businessoutfit-mr-85375-neufahrn",
    "name": "Businessoutfit MR",
    "type": "Partner Store",
    "street": "Gottfried von Cramm Str",
    "house_number": "1",
    "street_line": "Gottfried von Cramm Str 1",
    "zip": "85375",
    "city": "Neufahrn",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Gottfried von Cramm Str 1, 85375 Neufahrn, Deutschland",
    "map_query": "Gottfried von Cramm Str 1, 85375 Neufahrn, Deutschland",
    "maps_query": "Businessoutfit MR, Gottfried von Cramm Str 1, 85375 Neufahrn, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 93
  },
  {
    "id": "bv-boetiek-pexters-3830-berlingen-wellen",
    "name": "BV Boetiek Pexters",
    "type": "Partner Store",
    "street": "Bronstraat",
    "house_number": "4",
    "street_line": "Bronstraat 4",
    "zip": "3830",
    "city": "Berlingen-Wellen",
    "country": "Belgium",
    "country_label": "Belgien",
    "region": "Belgium",
    "language": "Englisch",
    "address": "Bronstraat 4, 3830 Berlingen-Wellen, Belgien",
    "map_query": "Bronstraat 4, 3830 Berlingen-Wellen, Belgien",
    "maps_query": "BV Boetiek Pexters, Bronstraat 4, 3830 Berlingen-Wellen, Belgien",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 94
  },
  {
    "id": "bv-evos-2800-mechelen",
    "name": "BV Evos",
    "type": "Partner Store",
    "street": "Vleeshouwersstraat",
    "house_number": "1",
    "street_line": "Vleeshouwersstraat 1",
    "zip": "2800",
    "city": "Mechelen",
    "country": "Belgium",
    "country_label": "Belgien",
    "region": "Belgium",
    "language": "Englisch",
    "address": "Vleeshouwersstraat 1, 2800 Mechelen, Belgien",
    "map_query": "Vleeshouwersstraat 1, 2800 Mechelen, Belgien",
    "maps_query": "BV Evos, Vleeshouwersstraat 1, 2800 Mechelen, Belgien",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 95
  },
  {
    "id": "bv-fortyfour-fashion-8980-beselare",
    "name": "BV Fortyfour Fashion",
    "type": "Partner Store",
    "street": "Wervikstraat",
    "house_number": "127",
    "street_line": "Wervikstraat 127",
    "zip": "8980",
    "city": "Beselare",
    "country": "Belgium",
    "country_label": "Belgien",
    "region": "Belgium",
    "language": "Englisch",
    "address": "Wervikstraat 127, 8980 Beselare, Belgien",
    "map_query": "Wervikstraat 127, 8980 Beselare, Belgien",
    "maps_query": "BV Fortyfour Fashion, Wervikstraat 127, 8980 Beselare, Belgien",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 96
  },
  {
    "id": "bvba-azaro-8300-knokke",
    "name": "BVBA Azaro",
    "type": "Partner Store",
    "street": "Lippenslaan 244 Bus",
    "house_number": "05",
    "street_line": "Lippenslaan 244 Bus 05",
    "zip": "8300",
    "city": "Knokke",
    "country": "Belgium",
    "country_label": "Belgien",
    "region": "Belgium",
    "language": "Englisch",
    "address": "Lippenslaan 244 Bus 05, 8300 Knokke, Belgien",
    "map_query": "Lippenslaan 244 Bus 05, 8300 Knokke, Belgien",
    "maps_query": "BVBA Azaro, Lippenslaan 244 Bus 05, 8300 Knokke, Belgien",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 97
  },
  {
    "id": "bvba-melovan-cartouche-3520-zonhoven",
    "name": "BVBA Melovan (Cartouche)",
    "type": "Partner Store",
    "street": "Ramaekersveldweg",
    "house_number": "8",
    "street_line": "Ramaekersveldweg 8",
    "zip": "3520",
    "city": "Zonhoven",
    "country": "Belgium",
    "country_label": "Belgien",
    "region": "Belgium",
    "language": "Englisch",
    "address": "Ramaekersveldweg 8, 3520 Zonhoven, Belgien",
    "map_query": "Ramaekersveldweg 8, 3520 Zonhoven, Belgien",
    "maps_query": "BVBA Melovan (Cartouche), Ramaekersveldweg 8, 3520 Zonhoven, Belgien",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 98
  },
  {
    "id": "bvba-windsor-9300-aalst",
    "name": "BVBA Windsor",
    "type": "Partner Store",
    "street": "Kattestraat",
    "house_number": "19",
    "street_line": "Kattestraat 19",
    "zip": "9300",
    "city": "Aalst",
    "country": "Belgium",
    "country_label": "Belgien",
    "region": "Belgium",
    "language": "Englisch",
    "address": "Kattestraat 19, 9300 Aalst, Belgien",
    "map_query": "Kattestraat 19, 9300 Aalst, Belgien",
    "maps_query": "BVBA Windsor, Kattestraat 19, 9300 Aalst, Belgien",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 99
  },
  {
    "id": "by-krijn-2681-ce-monster",
    "name": "By Krijn",
    "type": "Partner Store",
    "street": "Hortensiastraat",
    "house_number": "4-8",
    "street_line": "Hortensiastraat 4-8",
    "zip": "2681 CE",
    "city": "Monster",
    "country": "The Netherlands",
    "country_label": "Niederlande",
    "region": "The Netherlands",
    "language": "Englisch",
    "address": "Hortensiastraat 4-8, 2681 CE Monster, Niederlande",
    "map_query": "Hortensiastraat 4-8, 2681 CE Monster, Niederlande",
    "maps_query": "By Krijn, Hortensiastraat 4-8, 2681 CE Monster, Niederlande",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 100
  },
  {
    "id": "by-nico-s-mannenmode-8701-kh-bolsward",
    "name": "By Nico's Mannenmode",
    "type": "Partner Store",
    "street": "Appelmarkt",
    "house_number": "16",
    "street_line": "Appelmarkt 16",
    "zip": "8701",
    "city": "KH Bolsward",
    "country": "The Netherlands",
    "country_label": "Niederlande",
    "region": "The Netherlands",
    "language": "Englisch",
    "address": "Appelmarkt 16, 8701 KH Bolsward, Niederlande",
    "map_query": "Appelmarkt 16, 8701 KH Bolsward, Niederlande",
    "maps_query": "By Nico's Mannenmode, Appelmarkt 16, 8701 KH Bolsward, Niederlande",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 101
  },
  {
    "id": "c-j-schmidt-gmbh-25813-husum",
    "name": "C.J. Schmidt GmbH",
    "type": "Partner Store",
    "street": "Krämerstr. 1 -",
    "house_number": "7",
    "street_line": "Krämerstr. 1 - 7",
    "zip": "25813",
    "city": "Husum",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Krämerstr. 1 - 7, 25813 Husum, Deutschland",
    "map_query": "Krämerstr. 1 - 7, 25813 Husum, Deutschland",
    "maps_query": "C.J. Schmidt GmbH, Krämerstr. 1 - 7, 25813 Husum, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 102
  },
  {
    "id": "calliste-s-a-9999-wemperhardt",
    "name": "Calliste S.A.",
    "type": "Partner Store",
    "street": "Op der Hardt",
    "house_number": "24",
    "street_line": "Op der Hardt 24",
    "zip": "9999",
    "city": "Wemperhardt",
    "country": "Luxembourg",
    "country_label": "Luxemburg",
    "region": "Luxembourg",
    "language": "Englisch",
    "address": "Op der Hardt 24, 9999 Wemperhardt, Luxemburg",
    "map_query": "Op der Hardt 24, 9999 Wemperhardt, Luxemburg",
    "maps_query": "Calliste S.A., Op der Hardt 24, 9999 Wemperhardt, Luxemburg",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 103
  },
  {
    "id": "carl-prinz-gmbh-53879-euskirchen",
    "name": "Carl Prinz GmbH",
    "type": "Partner Store",
    "street": "Neustr.",
    "house_number": "30-32",
    "street_line": "Neustr. 30-32",
    "zip": "53879",
    "city": "Euskirchen",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Neustr. 30-32, 53879 Euskirchen, Deutschland",
    "map_query": "Neustr. 30-32, 53879 Euskirchen, Deutschland",
    "maps_query": "Carl Prinz GmbH, Neustr. 30-32, 53879 Euskirchen, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 104
  },
  {
    "id": "carlo-kleding-bvba-9700-oudenaarde",
    "name": "Carlo Kleding BVBA",
    "type": "Partner Store",
    "street": "Markt",
    "house_number": "23",
    "street_line": "Markt 23",
    "zip": "9700",
    "city": "Oudenaarde",
    "country": "Belgium",
    "country_label": "Belgien",
    "region": "Belgium",
    "language": "Englisch",
    "address": "Markt 23, 9700 Oudenaarde, Belgien",
    "map_query": "Markt 23, 9700 Oudenaarde, Belgien",
    "maps_query": "Carlo Kleding BVBA, Markt 23, 9700 Oudenaarde, Belgien",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 105
  },
  {
    "id": "caroline-frey-gmbh-und-co-kg-93444-bad-kotzting",
    "name": "Caroline Frey GmbH & Co. KG",
    "type": "Partner Store",
    "street": "Schirnstr.",
    "house_number": "1",
    "street_line": "Schirnstr. 1",
    "zip": "93444",
    "city": "Bad Kötzting",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Schirnstr. 1, 93444 Bad Kötzting, Deutschland",
    "map_query": "Schirnstr. 1, 93444 Bad Kötzting, Deutschland",
    "maps_query": "Caroline Frey GmbH & Co. KG, Schirnstr. 1, 93444 Bad Kötzting, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 106
  },
  {
    "id": "castelijn-mode-beek-6191-jk-beek",
    "name": "Castelijn Mode Beek",
    "type": "Partner Store",
    "street": "Markt",
    "house_number": "71",
    "street_line": "Markt 71",
    "zip": "6191 JK",
    "city": "Beek",
    "country": "The Netherlands",
    "country_label": "Niederlande",
    "region": "The Netherlands",
    "language": "Englisch",
    "address": "Markt 71, 6191 JK Beek, Niederlande",
    "map_query": "Markt 71, 6191 JK Beek, Niederlande",
    "maps_query": "Castelijn Mode Beek, Markt 71, 6191 JK Beek, Niederlande",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 107
  },
  {
    "id": "cavori-nv-9991-adegem",
    "name": "Cavori NV",
    "type": "Partner Store",
    "street": "Staatsbaan",
    "house_number": "25",
    "street_line": "Staatsbaan 25",
    "zip": "9991",
    "city": "Adegem",
    "country": "Belgium",
    "country_label": "Belgien",
    "region": "Belgium",
    "language": "Englisch",
    "address": "Staatsbaan 25, 9991 Adegem, Belgien",
    "map_query": "Staatsbaan 25, 9991 Adegem, Belgien",
    "maps_query": "Cavori NV, Staatsbaan 25, 9991 Adegem, Belgien",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 108
  },
  {
    "id": "christiaans-bvba-8620-nieuwpoort",
    "name": "Christiaans BVBA",
    "type": "Partner Store",
    "street": "August Oleffelaan",
    "house_number": "4a",
    "street_line": "August Oleffelaan 4a",
    "zip": "8620",
    "city": "Nieuwpoort",
    "country": "Belgium",
    "country_label": "Belgien",
    "region": "Belgium",
    "language": "Englisch",
    "address": "August Oleffelaan 4a, 8620 Nieuwpoort, Belgien",
    "map_query": "August Oleffelaan 4a, 8620 Nieuwpoort, Belgien",
    "maps_query": "Christiaans BVBA, August Oleffelaan 4a, 8620 Nieuwpoort, Belgien",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 109
  },
  {
    "id": "christian-leisse-40476-dusseldorf",
    "name": "Christian Leisse",
    "type": "Partner Store",
    "street": "Seydlitzstr.",
    "house_number": "36",
    "street_line": "Seydlitzstr. 36",
    "zip": "40476",
    "city": "Düsseldorf",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Seydlitzstr. 36, 40476 Düsseldorf, Deutschland",
    "map_query": "Seydlitzstr. 36, 40476 Düsseldorf, Deutschland",
    "maps_query": "Christian Leisse, Seydlitzstr. 36, 40476 Düsseldorf, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 110
  },
  {
    "id": "concept-costumes-3035-av-rotterdam",
    "name": "Concept Costumes",
    "type": "Partner Store",
    "street": "Zwartjanstraat",
    "house_number": "66a",
    "street_line": "Zwartjanstraat 66a",
    "zip": "3035 AV",
    "city": "Rotterdam",
    "country": "The Netherlands",
    "country_label": "Niederlande",
    "region": "Belgium",
    "language": "Englisch",
    "address": "Zwartjanstraat 66a, 3035 AV Rotterdam, Niederlande",
    "map_query": "Zwartjanstraat 66a, 3035 AV Rotterdam, Niederlande",
    "maps_query": "Concept Costumes, Zwartjanstraat 66a, 3035 AV Rotterdam, Niederlande",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 111
  },
  {
    "id": "confection-lanners-6001-marcinelle",
    "name": "Confection Lanners",
    "type": "Partner Store",
    "street": "Rue du Penitent",
    "house_number": "16",
    "street_line": "Rue du Penitent 16",
    "zip": "6001",
    "city": "Marcinelle",
    "country": "Belgium",
    "country_label": "Belgien",
    "region": "Luxembourg",
    "language": "Englisch",
    "address": "Rue du Penitent 16, 6001 Marcinelle, Belgien",
    "map_query": "Rue du Penitent 16, 6001 Marcinelle, Belgien",
    "maps_query": "Confection Lanners, Rue du Penitent 16, 6001 Marcinelle, Belgien",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 112
  },
  {
    "id": "coparsel-9050-ettelbruck",
    "name": "Coparsel",
    "type": "Partner Store",
    "street": "Grand Rue",
    "house_number": "18",
    "street_line": "Grand Rue 18",
    "zip": "9050",
    "city": "Ettelbruck",
    "country": "Luxembourg",
    "country_label": "Luxemburg",
    "region": "Belgium",
    "language": "Englisch",
    "address": "Grand Rue 18, 9050 Ettelbruck, Luxemburg",
    "map_query": "Grand Rue 18, 9050 Ettelbruck, Luxemburg",
    "maps_query": "Coparsel, Grand Rue 18, 9050 Ettelbruck, Luxemburg",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 113
  },
  {
    "id": "cornelius-1201-genf",
    "name": "Cornelius",
    "type": "Partner Store",
    "street": "Rue de Coutance",
    "house_number": "29",
    "street_line": "Rue de Coutance 29",
    "zip": "1201",
    "city": "Genf",
    "country": "Switzerland",
    "country_label": "Schweiz",
    "region": "The Netherlands",
    "language": "Englisch",
    "address": "Rue de Coutance 29, 1201 Genf, Schweiz",
    "map_query": "Rue de Coutance 29, 1201 Genf, Schweiz",
    "maps_query": "Cornelius, Rue de Coutance 29, 1201 Genf, Schweiz",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 114
  },
  {
    "id": "coster-nieuwpoort-bv-4811-wp-breda",
    "name": "Coster Nieuwpoort BV",
    "type": "Partner Store",
    "street": "Lange Brugstraat",
    "house_number": "29",
    "street_line": "Lange Brugstraat 29",
    "zip": "4811 WP",
    "city": "Breda",
    "country": "The Netherlands",
    "country_label": "Niederlande",
    "region": "The Netherlands",
    "language": "Englisch",
    "address": "Lange Brugstraat 29, 4811 WP Breda, Niederlande",
    "map_query": "Lange Brugstraat 29, 4811 WP Breda, Niederlande",
    "maps_query": "Coster Nieuwpoort BV, Lange Brugstraat 29, 4811 WP Breda, Niederlande",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 115
  },
  {
    "id": "costumes-leone-srl-3201-es-spijkenisse",
    "name": "Costumes Leone SRL",
    "type": "Partner Store",
    "street": "Stadhuispassage",
    "house_number": "9",
    "street_line": "Stadhuispassage 9",
    "zip": "3201 ES",
    "city": "Spijkenisse",
    "country": "The Netherlands",
    "country_label": "Niederlande",
    "region": "Belgium",
    "language": "Englisch",
    "address": "Stadhuispassage 9, 3201 ES Spijkenisse, Niederlande",
    "map_query": "Stadhuispassage 9, 3201 ES Spijkenisse, Niederlande",
    "maps_query": "Costumes Leone SRL, Stadhuispassage 9, 3201 ES Spijkenisse, Niederlande",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 116
  },
  {
    "id": "cramers-van-asten-6811gj-arnhem",
    "name": "Cramers van Asten",
    "type": "Partner Store",
    "street": "Jansstraat",
    "house_number": "8a",
    "street_line": "Jansstraat 8a",
    "zip": "6811GJ",
    "city": "Arnhem",
    "country": "The Netherlands",
    "country_label": "Niederlande",
    "region": "The Netherlands",
    "language": "Englisch",
    "address": "Jansstraat 8a, 6811GJ Arnhem, Niederlande",
    "map_query": "Jansstraat 8a, 6811GJ Arnhem, Niederlande",
    "maps_query": "Cramers van Asten, Jansstraat 8a, 6811GJ Arnhem, Niederlande",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 117
  },
  {
    "id": "cruse-arnsberg-gmbh-7411-jm-deventer",
    "name": "Cruse Arnsberg GmbH",
    "type": "Partner Store",
    "street": "Overstraat",
    "house_number": "28",
    "street_line": "Overstraat 28",
    "zip": "7411 JM",
    "city": "Deventer",
    "country": "The Netherlands",
    "country_label": "Niederlande",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Overstraat 28, 7411 JM Deventer, Niederlande",
    "map_query": "Overstraat 28, 7411 JM Deventer, Niederlande",
    "maps_query": "Cruse Arnsberg GmbH, Overstraat 28, 7411 JM Deventer, Niederlande",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 118
  },
  {
    "id": "cult-men-einzelunternehmen-2000-neuchatel",
    "name": "Cult Men Einzelunternehmen",
    "type": "Partner Store",
    "street": "Rue du Seyon 24 B",
    "house_number": "",
    "street_line": "Rue du Seyon 24 B",
    "zip": "2000",
    "city": "Neuchatel",
    "country": "Switzerland",
    "country_label": "Schweiz",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Rue du Seyon 24 B, 2000 Neuchatel, Schweiz",
    "map_query": "Cult Men Einzelunternehmen, Rue du Seyon 24 B, 2000 Neuchatel, Schweiz",
    "maps_query": "Cult Men Einzelunternehmen, Rue du Seyon 24 B, 2000 Neuchatel, Schweiz",
    "note": "Sortiment und Verfügbarkeit können variieren. Adresse bitte vor Besuch über den Händler prüfen.",
    "data_quality": [
      "house_number_missing"
    ],
    "source_row": 119
  },
  {
    "id": "cuypers-mode-nv-33129-delbruck",
    "name": "Cuypers Mode NV",
    "type": "Partner Store",
    "street": "Lange Str.",
    "house_number": "6",
    "street_line": "Lange Str. 6",
    "zip": "33129",
    "city": "Delbrück",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Belgium",
    "language": "Englisch",
    "address": "Lange Str. 6, 33129 Delbrück, Deutschland",
    "map_query": "Lange Str. 6, 33129 Delbrück, Deutschland",
    "maps_query": "Cuypers Mode NV, Lange Str. 6, 33129 Delbrück, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 120
  },
  {
    "id": "d-n-v-sprl-3253-ac-ouddorp",
    "name": "D.N.V. SPRL",
    "type": "Partner Store",
    "street": "Boompjes",
    "house_number": "15",
    "street_line": "Boompjes 15",
    "zip": "3253 AC",
    "city": "Ouddorp",
    "country": "The Netherlands",
    "country_label": "Niederlande",
    "region": "Belgium",
    "language": "Englisch",
    "address": "Boompjes 15, 3253 AC Ouddorp, Niederlande",
    "map_query": "Boompjes 15, 3253 AC Ouddorp, Niederlande",
    "maps_query": "D.N.V. SPRL, Boompjes 15, 3253 AC Ouddorp, Niederlande",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 121
  },
  {
    "id": "daan-s-company-5001-belgrade",
    "name": "Daan`s Company",
    "type": "Partner Store",
    "street": "Route de Lorrain- la- Neuve",
    "house_number": "4",
    "street_line": "Route de Lorrain- la- Neuve 4",
    "zip": "5001",
    "city": "Belgrade",
    "country": "Belgium",
    "country_label": "Belgien",
    "region": "The Netherlands",
    "language": "Englisch",
    "address": "Route de Lorrain- la- Neuve 4, 5001 Belgrade, Belgien",
    "map_query": "Route de Lorrain- la- Neuve 4, 5001 Belgrade, Belgien",
    "maps_query": "Daan`s Company, Route de Lorrain- la- Neuve 4, 5001 Belgrade, Belgien",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 122
  },
  {
    "id": "dac-sa-delvenne-2914-ke-nieuwerkerk-aan-den-ijssel",
    "name": "DAC SA Delvenne",
    "type": "Partner Store",
    "street": "Reigerhof",
    "house_number": "106",
    "street_line": "Reigerhof 106",
    "zip": "2914 KE",
    "city": "Nieuwerkerk aan den Ijssel",
    "country": "The Netherlands",
    "country_label": "Niederlande",
    "region": "Belgium",
    "language": "Englisch",
    "address": "Reigerhof 106, 2914 KE Nieuwerkerk aan den Ijssel, Niederlande",
    "map_query": "Reigerhof 106, 2914 KE Nieuwerkerk aan den Ijssel, Niederlande",
    "maps_query": "DAC SA Delvenne, Reigerhof 106, 2914 KE Nieuwerkerk aan den Ijssel, Niederlande",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 123
  },
  {
    "id": "david-s-mode-4960-malmedy",
    "name": "David`s Mode",
    "type": "Partner Store",
    "street": "Route de Waimes",
    "house_number": "111",
    "street_line": "Route de Waimes 111",
    "zip": "4960",
    "city": "Malmedy",
    "country": "Belgium",
    "country_label": "Belgien",
    "region": "Switzerland",
    "language": "Deutsch",
    "address": "Route de Waimes 111, 4960 Malmedy, Belgien",
    "map_query": "Route de Waimes 111, 4960 Malmedy, Belgien",
    "maps_query": "David`s Mode, Route de Waimes 111, 4960 Malmedy, Belgien",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 124
  },
  {
    "id": "de-kepper-nv-u-men-7902eg-hoogeveen",
    "name": "De Kepper NV (U-Men)",
    "type": "Partner Store",
    "street": "De Hoofdstraat",
    "house_number": "169",
    "street_line": "De Hoofdstraat 169",
    "zip": "7902EG",
    "city": "Hoogeveen",
    "country": "The Netherlands",
    "country_label": "Niederlande",
    "region": "Belgium",
    "language": "Englisch",
    "address": "De Hoofdstraat 169, 7902EG Hoogeveen, Niederlande",
    "map_query": "De Hoofdstraat 169, 7902EG Hoogeveen, Niederlande",
    "maps_query": "De Kepper NV (U-Men), De Hoofdstraat 169, 7902EG Hoogeveen, Niederlande",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 125
  },
  {
    "id": "de-man-mode-und-jeans-2220-heist-op-den-berg",
    "name": "De Man Mode & Jeans",
    "type": "Partner Store",
    "street": "Bergstraat",
    "house_number": "52",
    "street_line": "Bergstraat 52",
    "zip": "2220",
    "city": "Heist op den Berg",
    "country": "Belgium",
    "country_label": "Belgien",
    "region": "The Netherlands",
    "language": "Englisch",
    "address": "Bergstraat 52, 2220 Heist op den Berg, Belgien",
    "map_query": "Bergstraat 52, 2220 Heist op den Berg, Belgien",
    "maps_query": "De Man Mode & Jeans, Bergstraat 52, 2220 Heist op den Berg, Belgien",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 126
  },
  {
    "id": "de-vits-bv-8780-oostrozebeke",
    "name": "De Vits BV",
    "type": "Partner Store",
    "street": "Gentstraat",
    "house_number": "39",
    "street_line": "Gentstraat 39",
    "zip": "8780",
    "city": "OOSTROZEBEKE",
    "country": "Belgium",
    "country_label": "Belgien",
    "region": "Belgium",
    "language": "Englisch",
    "address": "Gentstraat 39, 8780 OOSTROZEBEKE, Belgien",
    "map_query": "Gentstraat 39, 8780 OOSTROZEBEKE, Belgien",
    "maps_query": "De Vits BV, Gentstraat 39, 8780 OOSTROZEBEKE, Belgien",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 127
  },
  {
    "id": "de-zaak-van-ruud-9400-ninove",
    "name": "De Zaak van Ruud",
    "type": "Partner Store",
    "street": "Graanmarkt",
    "house_number": "57",
    "street_line": "Graanmarkt 57",
    "zip": "9400",
    "city": "Ninove",
    "country": "Belgium",
    "country_label": "Belgien",
    "region": "The Netherlands",
    "language": "Englisch",
    "address": "Graanmarkt 57, 9400 Ninove, Belgien",
    "map_query": "Graanmarkt 57, 9400 Ninove, Belgien",
    "maps_query": "De Zaak van Ruud, Graanmarkt 57, 9400 Ninove, Belgien",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 128
  },
  {
    "id": "de-zon-bv-6641-cs-beuningen",
    "name": "DE ZON BV",
    "type": "Partner Store",
    "street": "Julianaplein",
    "house_number": "35",
    "street_line": "Julianaplein 35",
    "zip": "6641 CS",
    "city": "Beuningen",
    "country": "The Netherlands",
    "country_label": "Niederlande",
    "region": "Belgium",
    "language": "Englisch",
    "address": "Julianaplein 35, 6641 CS Beuningen, Niederlande",
    "map_query": "Julianaplein 35, 6641 CS Beuningen, Niederlande",
    "maps_query": "DE ZON BV, Julianaplein 35, 6641 CS Beuningen, Niederlande",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 129
  },
  {
    "id": "deitmers-3768-ej-soest",
    "name": "Deitmers",
    "type": "Partner Store",
    "street": "Soesterbergsestraat",
    "house_number": "54",
    "street_line": "Soesterbergsestraat 54",
    "zip": "3768 EJ",
    "city": "Soest",
    "country": "The Netherlands",
    "country_label": "Niederlande",
    "region": "The Netherlands",
    "language": "Englisch",
    "address": "Soesterbergsestraat 54, 3768 EJ Soest, Niederlande",
    "map_query": "Soesterbergsestraat 54, 3768 EJ Soest, Niederlande",
    "maps_query": "Deitmers, Soesterbergsestraat 54, 3768 EJ Soest, Niederlande",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 130
  },
  {
    "id": "den-engelsman-en-van-driel-1441-ct-purmerend",
    "name": "Den Engelsman en van Driel",
    "type": "Partner Store",
    "street": "Dubbele Buurt",
    "house_number": "7",
    "street_line": "Dubbele Buurt 7",
    "zip": "1441 CT",
    "city": "Purmerend",
    "country": "The Netherlands",
    "country_label": "Niederlande",
    "region": "The Netherlands",
    "language": "Englisch",
    "address": "Dubbele Buurt 7, 1441 CT Purmerend, Niederlande",
    "map_query": "Dubbele Buurt 7, 1441 CT Purmerend, Niederlande",
    "maps_query": "Den Engelsman en van Driel, Dubbele Buurt 7, 1441 CT Purmerend, Niederlande",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 131
  },
  {
    "id": "den-yzer-nv-4697-eh-sint-annaland",
    "name": "Den Yzer NV",
    "type": "Partner Store",
    "street": "Voorstraat",
    "house_number": "15",
    "street_line": "Voorstraat 15",
    "zip": "4697 EH",
    "city": "Sint-Annaland",
    "country": "The Netherlands",
    "country_label": "Niederlande",
    "region": "Belgium",
    "language": "Englisch",
    "address": "Voorstraat 15, 4697 EH Sint-Annaland, Niederlande",
    "map_query": "Voorstraat 15, 4697 EH Sint-Annaland, Niederlande",
    "maps_query": "Den Yzer NV, Voorstraat 15, 4697 EH Sint-Annaland, Niederlande",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 132
  },
  {
    "id": "desdemona-bv-8850-ardooie",
    "name": "Desdemona BV",
    "type": "Partner Store",
    "street": "Stationsstraat",
    "house_number": "22",
    "street_line": "Stationsstraat 22",
    "zip": "8850",
    "city": "Ardooie",
    "country": "Belgium",
    "country_label": "Belgien",
    "region": "Belgium",
    "language": "Englisch",
    "address": "Stationsstraat 22, 8850 Ardooie, Belgien",
    "map_query": "Stationsstraat 22, 8850 Ardooie, Belgien",
    "maps_query": "Desdemona BV, Stationsstraat 22, 8850 Ardooie, Belgien",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 133
  },
  {
    "id": "deville-fashion-bv-2440-geel",
    "name": "deVille Fashion BV",
    "type": "Partner Store",
    "street": "Nieuwstraat",
    "house_number": "18",
    "street_line": "Nieuwstraat 18",
    "zip": "2440",
    "city": "Geel",
    "country": "Belgium",
    "country_label": "Belgien",
    "region": "Belgium",
    "language": "Englisch",
    "address": "Nieuwstraat 18, 2440 Geel, Belgien",
    "map_query": "Nieuwstraat 18, 2440 Geel, Belgien",
    "maps_query": "deVille Fashion BV, Nieuwstraat 18, 2440 Geel, Belgien",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 134
  },
  {
    "id": "dhaene-tailor-bvba-2300-turnhout",
    "name": "Dhaene Tailor BVBA",
    "type": "Partner Store",
    "street": "Gasthuisstraat",
    "house_number": "39",
    "street_line": "Gasthuisstraat 39",
    "zip": "2300",
    "city": "Turnhout",
    "country": "Belgium",
    "country_label": "Belgien",
    "region": "Belgium",
    "language": "Englisch",
    "address": "Gasthuisstraat 39, 2300 Turnhout, Belgien",
    "map_query": "Gasthuisstraat 39, 2300 Turnhout, Belgien",
    "maps_query": "Dhaene Tailor BVBA, Gasthuisstraat 39, 2300 Turnhout, Belgien",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 135
  },
  {
    "id": "dirk-de-wit-mode-bovenkarspel-59555-lippstadt",
    "name": "Dirk de Wit Mode Bovenkarspel",
    "type": "Partner Store",
    "street": "Soeststraße",
    "house_number": "31-35",
    "street_line": "Soeststraße 31-35",
    "zip": "59555",
    "city": "Lippstadt",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "The Netherlands",
    "language": "Englisch",
    "address": "Soeststraße 31-35, 59555 Lippstadt, Deutschland",
    "map_query": "Soeststraße 31-35, 59555 Lippstadt, Deutschland",
    "maps_query": "Dirk de Wit Mode Bovenkarspel, Soeststraße 31-35, 59555 Lippstadt, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 136
  },
  {
    "id": "distri-shoe-nv-1611-an-bovenkarspel",
    "name": "Distri Shoe NV",
    "type": "Partner Store",
    "street": "Hoofdstraat",
    "house_number": "224",
    "street_line": "Hoofdstraat 224",
    "zip": "1611 AN",
    "city": "Bovenkarspel",
    "country": "The Netherlands",
    "country_label": "Niederlande",
    "region": "Belgium",
    "language": "Englisch",
    "address": "Hoofdstraat 224, 1611 AN Bovenkarspel, Niederlande",
    "map_query": "Hoofdstraat 224, 1611 AN Bovenkarspel, Niederlande",
    "maps_query": "Distri Shoe NV, Hoofdstraat 224, 1611 AN Bovenkarspel, Niederlande",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 137
  },
  {
    "id": "dodenhof-posthausen-kg-1980-zemst",
    "name": "Dodenhof Posthausen KG",
    "type": "Partner Store",
    "street": "Brusselsesteenweg",
    "house_number": "129",
    "street_line": "Brusselsesteenweg 129",
    "zip": "1980",
    "city": "Zemst",
    "country": "Belgium",
    "country_label": "Belgien",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Brusselsesteenweg 129, 1980 Zemst, Belgien",
    "map_query": "Brusselsesteenweg 129, 1980 Zemst, Belgien",
    "maps_query": "Dodenhof Posthausen KG, Brusselsesteenweg 129, 1980 Zemst, Belgien",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 138
  },
  {
    "id": "douwe-beintema-mannenmode-b-v-5554-hp-valkenswaard",
    "name": "Douwe Beintema Mannenmode B.V.",
    "type": "Partner Store",
    "street": "Handwerkstraat",
    "house_number": "15",
    "street_line": "Handwerkstraat 15",
    "zip": "5554 HP",
    "city": "Valkenswaard",
    "country": "The Netherlands",
    "country_label": "Niederlande",
    "region": "The Netherlands",
    "language": "Englisch",
    "address": "Handwerkstraat 15, 5554 HP Valkenswaard, Niederlande",
    "map_query": "Handwerkstraat 15, 5554 HP Valkenswaard, Niederlande",
    "maps_query": "Douwe Beintema Mannenmode B.V., Handwerkstraat 15, 5554 HP Valkenswaard, Niederlande",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 139
  },
  {
    "id": "downtown-dachau-9203-cs-drachten",
    "name": "Downtown Dachau",
    "type": "Partner Store",
    "street": "Zuiderbuurt",
    "house_number": "13",
    "street_line": "Zuiderbuurt 13",
    "zip": "9203 CS",
    "city": "Drachten",
    "country": "The Netherlands",
    "country_label": "Niederlande",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Zuiderbuurt 13, 9203 CS Drachten, Niederlande",
    "map_query": "Zuiderbuurt 13, 9203 CS Drachten, Niederlande",
    "maps_query": "Downtown Dachau, Zuiderbuurt 13, 9203 CS Drachten, Niederlande",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 140
  },
  {
    "id": "dresscode-hamburg-49716-meppen",
    "name": "Dresscode Hamburg",
    "type": "Partner Store",
    "street": "Markt",
    "house_number": "10",
    "street_line": "Markt 10",
    "zip": "49716",
    "city": "Meppen",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Markt 10, 49716 Meppen, Deutschland",
    "map_query": "Markt 10, 49716 Meppen, Deutschland",
    "maps_query": "Dresscode Hamburg, Markt 10, 49716 Meppen, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 141
  },
  {
    "id": "dux-textilien-ag-44225-dortmund",
    "name": "Dux Textilien AG",
    "type": "Partner Store",
    "street": "Harkortstrasse",
    "house_number": "25-27",
    "street_line": "Harkortstrasse 25-27",
    "zip": "44225",
    "city": "Dortmund",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Switzerland",
    "language": "Englisch",
    "address": "Harkortstrasse 25-27, 44225 Dortmund, Deutschland",
    "map_query": "Harkortstrasse 25-27, 44225 Dortmund, Deutschland",
    "maps_query": "Dux Textilien AG, Harkortstrasse 25-27, 44225 Dortmund, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 142
  },
  {
    "id": "e-van-e-8200-schaffhausen",
    "name": "E van E",
    "type": "Partner Store",
    "street": "Vorstadt",
    "house_number": "33",
    "street_line": "Vorstadt 33",
    "zip": "8200",
    "city": "Schaffhausen",
    "country": "Switzerland",
    "country_label": "Schweiz",
    "region": "The Netherlands",
    "language": "Englisch",
    "address": "Vorstadt 33, 8200 Schaffhausen, Schweiz",
    "map_query": "Vorstadt 33, 8200 Schaffhausen, Schweiz",
    "maps_query": "E van E, Vorstadt 33, 8200 Schaffhausen, Schweiz",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 143
  },
  {
    "id": "e-und-r-wedding-und-fashion-6561-cb-groesbeek",
    "name": "E&R WEDDING & FASHION",
    "type": "Partner Store",
    "street": "Dorpstraat 34 B",
    "house_number": "",
    "street_line": "Dorpstraat 34 B",
    "zip": "6561 CB",
    "city": "Groesbeek",
    "country": "The Netherlands",
    "country_label": "Niederlande",
    "region": "Belgium",
    "language": "Englisch",
    "address": "Dorpstraat 34 B, 6561 CB Groesbeek, Niederlande",
    "map_query": "E&R WEDDING & FASHION, Dorpstraat 34 B, 6561 CB Groesbeek, Niederlande",
    "maps_query": "E&R WEDDING & FASHION, Dorpstraat 34 B, 6561 CB Groesbeek, Niederlande",
    "note": "Sortiment und Verfügbarkeit können variieren. Adresse bitte vor Besuch über den Händler prüfen.",
    "data_quality": [
      "house_number_missing"
    ],
    "source_row": 144
  },
  {
    "id": "e5-fashion-bv-3581-beverlo",
    "name": "E5 Fashion BV",
    "type": "Partner Store",
    "street": "Beverlodorp",
    "house_number": "4",
    "street_line": "Beverlodorp 4",
    "zip": "3581",
    "city": "Beverlo",
    "country": "Belgium",
    "country_label": "Belgien",
    "region": "Belgium",
    "language": "Englisch",
    "address": "Beverlodorp 4, 3581 Beverlo, Belgien",
    "map_query": "Beverlodorp 4, 3581 Beverlo, Belgien",
    "maps_query": "E5 Fashion BV, Beverlodorp 4, 3581 Beverlo, Belgien",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 145
  },
  {
    "id": "ebeling-menswear-v-o-f-9100-sint-niklaas",
    "name": "Ebeling Menswear V.O.F.",
    "type": "Partner Store",
    "street": "Hoogkarnerstraat",
    "house_number": "1",
    "street_line": "Hoogkarnerstraat 1",
    "zip": "9100",
    "city": "Sint-Niklaas",
    "country": "Belgium",
    "country_label": "Belgien",
    "region": "The Netherlands",
    "language": "Englisch",
    "address": "Hoogkarnerstraat 1, 9100 Sint-Niklaas, Belgien",
    "map_query": "Hoogkarnerstraat 1, 9100 Sint-Niklaas, Belgien",
    "maps_query": "Ebeling Menswear V.O.F., Hoogkarnerstraat 1, 9100 Sint-Niklaas, Belgien",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 146
  },
  {
    "id": "eberhard-wigner-gmbh-und-co-kg-7551-et-hengelo",
    "name": "Eberhard Wigner GmbH & Co. KG",
    "type": "Partner Store",
    "street": "Wemenstraat",
    "house_number": "19",
    "street_line": "Wemenstraat 19",
    "zip": "7551 ET",
    "city": "Hengelo",
    "country": "The Netherlands",
    "country_label": "Niederlande",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Wemenstraat 19, 7551 ET Hengelo, Niederlande",
    "map_query": "Wemenstraat 19, 7551 ET Hengelo, Niederlande",
    "maps_query": "Eberhard Wigner GmbH & Co. KG, Wemenstraat 19, 7551 ET Hengelo, Niederlande",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 147
  },
  {
    "id": "eckhofer-moden-gmbh-90513-zirndorf",
    "name": "Eckhofer Moden GmbH",
    "type": "Partner Store",
    "street": "Albrecht-Dürer-Straße",
    "house_number": "66",
    "street_line": "Albrecht-Dürer-Straße 66",
    "zip": "90513",
    "city": "Zirndorf",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Albrecht-Dürer-Straße 66, 90513 Zirndorf, Deutschland",
    "map_query": "Albrecht-Dürer-Straße 66, 90513 Zirndorf, Deutschland",
    "maps_query": "Eckhofer Moden GmbH, Albrecht-Dürer-Straße 66, 90513 Zirndorf, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 148
  },
  {
    "id": "eggert-maddox-b-v-87700-memmingen",
    "name": "Eggert Maddox B.V.",
    "type": "Partner Store",
    "street": "Maximilianstr.",
    "house_number": "3",
    "street_line": "Maximilianstr. 3",
    "zip": "87700",
    "city": "Memmingen",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "The Netherlands",
    "language": "Englisch",
    "address": "Maximilianstr. 3, 87700 Memmingen, Deutschland",
    "map_query": "Maximilianstr. 3, 87700 Memmingen, Deutschland",
    "maps_query": "Eggert Maddox B.V., Maximilianstr. 3, 87700 Memmingen, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 149
  },
  {
    "id": "eitzenhofer-gmbh-6041-jp-roermond",
    "name": "Eitzenhöfer GmbH",
    "type": "Partner Store",
    "street": "Bakkerstraat",
    "house_number": "9",
    "street_line": "Bakkerstraat 9",
    "zip": "6041 JP",
    "city": "Roermond",
    "country": "The Netherlands",
    "country_label": "Niederlande",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Bakkerstraat 9, 6041 JP Roermond, Niederlande",
    "map_query": "Bakkerstraat 9, 6041 JP Roermond, Niederlande",
    "maps_query": "Eitzenhöfer GmbH, Bakkerstraat 9, 6041 JP Roermond, Niederlande",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 150
  },
  {
    "id": "elegant-mode-b-v-35745-herborn",
    "name": "Elegant Mode B.V.",
    "type": "Partner Store",
    "street": "Hauptstraße",
    "house_number": "115",
    "street_line": "Hauptstraße 115",
    "zip": "35745",
    "city": "Herborn",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Belgium",
    "language": "Englisch",
    "address": "Hauptstraße 115, 35745 Herborn, Deutschland",
    "map_query": "Hauptstraße 115, 35745 Herborn, Deutschland",
    "maps_query": "Elegant Mode B.V., Hauptstraße 115, 35745 Herborn, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 151
  },
  {
    "id": "elinga-mode-1840-malderen",
    "name": "Elinga Mode",
    "type": "Partner Store",
    "street": "Jozef Vermaesenplein",
    "house_number": "4",
    "street_line": "Jozef Vermaesenplein 4",
    "zip": "1840",
    "city": "Malderen",
    "country": "Belgium",
    "country_label": "Belgien",
    "region": "The Netherlands",
    "language": "Englisch",
    "address": "Jozef Vermaesenplein 4, 1840 Malderen, Belgien",
    "map_query": "Jozef Vermaesenplein 4, 1840 Malderen, Belgien",
    "maps_query": "Elinga Mode, Jozef Vermaesenplein 4, 1840 Malderen, Belgien",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 152
  },
  {
    "id": "emma-bvba-9203-cx-drachten",
    "name": "EMMA BVBA",
    "type": "Partner Store",
    "street": "Zuiderbuurt",
    "house_number": "30-36",
    "street_line": "Zuiderbuurt 30-36",
    "zip": "9203 CX",
    "city": "Drachten",
    "country": "The Netherlands",
    "country_label": "Niederlande",
    "region": "Belgium",
    "language": "Englisch",
    "address": "Zuiderbuurt 30-36, 9203 CX Drachten, Niederlande",
    "map_query": "Zuiderbuurt 30-36, 9203 CX Drachten, Niederlande",
    "maps_query": "EMMA BVBA, Zuiderbuurt 30-36, 9203 CX Drachten, Niederlande",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 153
  },
  {
    "id": "engelhardt-und-walter-gmbh-8400-oostende",
    "name": "Engelhardt & Walter GmbH",
    "type": "Partner Store",
    "street": "Madridstraat",
    "house_number": "4",
    "street_line": "Madridstraat 4",
    "zip": "8400",
    "city": "Oostende",
    "country": "Belgium",
    "country_label": "Belgien",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Madridstraat 4, 8400 Oostende, Belgien",
    "map_query": "Madridstraat 4, 8400 Oostende, Belgien",
    "maps_query": "Engelhardt & Walter GmbH, Madridstraat 4, 8400 Oostende, Belgien",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 154
  },
  {
    "id": "engelhardt-walter-gmbh-92224-amberg",
    "name": "Engelhardt + Walter GmbH",
    "type": "Partner Store",
    "street": "Georgenstraße",
    "house_number": "8",
    "street_line": "Georgenstraße 8",
    "zip": "92224",
    "city": "Amberg",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Georgenstraße 8, 92224 Amberg, Deutschland",
    "map_query": "Georgenstraße 8, 92224 Amberg, Deutschland",
    "maps_query": "Engelhardt + Walter GmbH, Georgenstraße 8, 92224 Amberg, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 155
  },
  {
    "id": "engelhorn-mode-gmbh-91207-lauf-a-d-pegnitz",
    "name": "Engelhorn Mode GmbH",
    "type": "Partner Store",
    "street": "Friedensplatz",
    "house_number": "5",
    "street_line": "Friedensplatz 5",
    "zip": "91207",
    "city": "Lauf a.d.Pegnitz",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Friedensplatz 5, 91207 Lauf a.d.Pegnitz, Deutschland",
    "map_query": "Friedensplatz 5, 91207 Lauf a.d.Pegnitz, Deutschland",
    "maps_query": "Engelhorn Mode GmbH, Friedensplatz 5, 91207 Lauf a.d.Pegnitz, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 156
  },
  {
    "id": "engelrelst-68163-mannheim",
    "name": "Engelrelst",
    "type": "Partner Store",
    "street": "Fabrikationsstraße",
    "house_number": "40",
    "street_line": "Fabrikationsstraße 40",
    "zip": "68163",
    "city": "Mannheim",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Belgium",
    "language": "Englisch",
    "address": "Fabrikationsstraße 40, 68163 Mannheim, Deutschland",
    "map_query": "Fabrikationsstraße 40, 68163 Mannheim, Deutschland",
    "maps_query": "Engelrelst, Fabrikationsstraße 40, 68163 Mannheim, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 157
  },
  {
    "id": "ernst-echter-gmbh-und-co-kg-8380-zeebrugge",
    "name": "ERNST ECHTER GMBH & CO. KG",
    "type": "Partner Store",
    "street": "Vismijnstraat",
    "house_number": "36",
    "street_line": "Vismijnstraat 36",
    "zip": "8380",
    "city": "Zeebrugge",
    "country": "Belgium",
    "country_label": "Belgien",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Vismijnstraat 36, 8380 Zeebrugge, Belgien",
    "map_query": "Vismijnstraat 36, 8380 Zeebrugge, Belgien",
    "maps_query": "ERNST ECHTER GMBH & CO. KG, Vismijnstraat 36, 8380 Zeebrugge, Belgien",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 158
  },
  {
    "id": "ernst-stackmann-gmbh-und-co-kg-82362-weilheim",
    "name": "Ernst Stackmann GmbH & Co. KG",
    "type": "Partner Store",
    "street": "Rathausplatz 9-11,",
    "house_number": "",
    "street_line": "Rathausplatz 9-11,",
    "zip": "82362",
    "city": "Weilheim",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Rathausplatz 9-11,, 82362 Weilheim, Deutschland",
    "map_query": "Ernst Stackmann GmbH & Co. KG, Rathausplatz 9-11,, 82362 Weilheim, Deutschland",
    "maps_query": "Ernst Stackmann GmbH & Co. KG, Rathausplatz 9-11,, 82362 Weilheim, Deutschland",
    "note": "Sortiment und Verfügbarkeit können variieren. Adresse bitte vor Besuch über den Händler prüfen.",
    "data_quality": [
      "house_number_missing"
    ],
    "source_row": 159
  },
  {
    "id": "ersem-fashion-21614-buxtehude",
    "name": "Ersem Fashion",
    "type": "Partner Store",
    "street": "Lange Str. 39 -",
    "house_number": "45",
    "street_line": "Lange Str. 39 - 45",
    "zip": "21614",
    "city": "Buxtehude",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "The Netherlands",
    "language": "Englisch",
    "address": "Lange Str. 39 - 45, 21614 Buxtehude, Deutschland",
    "map_query": "Lange Str. 39 - 45, 21614 Buxtehude, Deutschland",
    "maps_query": "Ersem Fashion, Lange Str. 39 - 45, 21614 Buxtehude, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 160
  },
  {
    "id": "ertl-herrenmoden-5211-kg-s-hertogenbosch",
    "name": "Ertl Herrenmoden",
    "type": "Partner Store",
    "street": "Kerkstraat",
    "house_number": "36",
    "street_line": "Kerkstraat 36",
    "zip": "5211 KG",
    "city": "'s-Hertogenbosch",
    "country": "The Netherlands",
    "country_label": "Niederlande",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Kerkstraat 36, 5211 KG 's-Hertogenbosch, Niederlande",
    "map_query": "Kerkstraat 36, 5211 KG 's-Hertogenbosch, Niederlande",
    "maps_query": "Ertl Herrenmoden, Kerkstraat 36, 5211 KG 's-Hertogenbosch, Niederlande",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 161
  },
  {
    "id": "esenzo-85049-ingolstadt",
    "name": "Esenzo",
    "type": "Partner Store",
    "street": "Ludwigstraße",
    "house_number": "1",
    "street_line": "Ludwigstraße 1",
    "zip": "85049",
    "city": "Ingolstadt",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Belgium",
    "language": "Englisch",
    "address": "Ludwigstraße 1, 85049 Ingolstadt, Deutschland",
    "map_query": "Ludwigstraße 1, 85049 Ingolstadt, Deutschland",
    "maps_query": "Esenzo, Ludwigstraße 1, 85049 Ingolstadt, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 162
  },
  {
    "id": "eshuis-mode-b-v-2260-westerlo",
    "name": "Eshuis Mode B.V.",
    "type": "Partner Store",
    "street": "Tongerlostraat",
    "house_number": "61",
    "street_line": "Tongerlostraat 61",
    "zip": "2260",
    "city": "Westerlo",
    "country": "Belgium",
    "country_label": "Belgien",
    "region": "The Netherlands",
    "language": "Englisch",
    "address": "Tongerlostraat 61, 2260 Westerlo, Belgien",
    "map_query": "Tongerlostraat 61, 2260 Westerlo, Belgien",
    "maps_query": "Eshuis Mode B.V., Tongerlostraat 61, 2260 Westerlo, Belgien",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 163
  },
  {
    "id": "eswo-bv-7461-ke-rijssen",
    "name": "ESWO BV",
    "type": "Partner Store",
    "street": "Grotestraat",
    "house_number": "3",
    "street_line": "Grotestraat 3",
    "zip": "7461 KE",
    "city": "Rijssen",
    "country": "The Netherlands",
    "country_label": "Niederlande",
    "region": "Belgium",
    "language": "Englisch",
    "address": "Grotestraat 3, 7461 KE Rijssen, Niederlande",
    "map_query": "Grotestraat 3, 7461 KE Rijssen, Niederlande",
    "maps_query": "ESWO BV, Grotestraat 3, 7461 KE Rijssen, Niederlande",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 164
  },
  {
    "id": "eunova-herrenfabrikation-e-k-3300-tienen",
    "name": "EUNOVA Herrenfabrikation e.K.",
    "type": "Partner Store",
    "street": "Hennemarkt",
    "house_number": "9",
    "street_line": "Hennemarkt 9",
    "zip": "3300",
    "city": "Tienen",
    "country": "Belgium",
    "country_label": "Belgien",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Hennemarkt 9, 3300 Tienen, Belgien",
    "map_query": "Hennemarkt 9, 3300 Tienen, Belgien",
    "maps_query": "EUNOVA Herrenfabrikation e.K., Hennemarkt 9, 3300 Tienen, Belgien",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 165
  },
  {
    "id": "eurl-sophia-59964-medebach",
    "name": "EURL Sophia",
    "type": "Partner Store",
    "street": "Südwall",
    "house_number": "1a",
    "street_line": "Südwall 1a",
    "zip": "59964",
    "city": "Medebach",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "France",
    "language": "Englisch",
    "address": "Südwall 1a, 59964 Medebach, Deutschland",
    "map_query": "Südwall 1a, 59964 Medebach, Deutschland",
    "maps_query": "EURL Sophia, Südwall 1a, 59964 Medebach, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 166
  },
  {
    "id": "exclusief-men-83400-hyeres",
    "name": "Exclusief men",
    "type": "Partner Store",
    "street": "avenue général de Gaulle",
    "house_number": "17",
    "street_line": "avenue général de Gaulle 17",
    "zip": "83400",
    "city": "Hyeres",
    "country": "France",
    "country_label": "Frankreich",
    "region": "Belgium",
    "language": "Englisch",
    "address": "avenue général de Gaulle 17, 83400 Hyeres, Frankreich",
    "map_query": "avenue général de Gaulle 17, 83400 Hyeres, Frankreich",
    "maps_query": "Exclusief men, avenue général de Gaulle 17, 83400 Hyeres, Frankreich",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 167
  },
  {
    "id": "extra-uomo-sportswear-gmbh-9160-lokeren",
    "name": "EXTRA Uomo Sportswear GmbH",
    "type": "Partner Store",
    "street": "Markt",
    "house_number": "55",
    "street_line": "Markt 55",
    "zip": "9160",
    "city": "Lokeren",
    "country": "Belgium",
    "country_label": "Belgien",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Markt 55, 9160 Lokeren, Belgien",
    "map_query": "Markt 55, 9160 Lokeren, Belgien",
    "maps_query": "EXTRA Uomo Sportswear GmbH, Markt 55, 9160 Lokeren, Belgien",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 168
  },
  {
    "id": "extravagant-67655-kaiserslautern",
    "name": "EXTRAVAGANT",
    "type": "Partner Store",
    "street": "Schneiderstraße",
    "house_number": "10",
    "street_line": "Schneiderstraße 10",
    "zip": "67655",
    "city": "Kaiserslautern",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Schneiderstraße 10, 67655 Kaiserslautern, Deutschland",
    "map_query": "Schneiderstraße 10, 67655 Kaiserslautern, Deutschland",
    "maps_query": "EXTRAVAGANT, Schneiderstraße 10, 67655 Kaiserslautern, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 169
  },
  {
    "id": "fabry-moden-43-155-bierun",
    "name": "Fabry Moden",
    "type": "Partner Store",
    "street": "Warszawska",
    "house_number": "342",
    "street_line": "Warszawska 342",
    "zip": "43-155",
    "city": "Bierun",
    "country": "Poland",
    "country_label": "Poland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Warszawska 342, 43-155 Bierun, Poland",
    "map_query": "Warszawska 342, 43-155 Bierun, Poland",
    "maps_query": "Fabry Moden, Warszawska 342, 43-155 Bierun, Poland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 170
  },
  {
    "id": "fashion-forum-4331-lt-middelburg",
    "name": "Fashion Forum",
    "type": "Partner Store",
    "street": "Langeviele",
    "house_number": "2",
    "street_line": "Langeviele 2",
    "zip": "4331 LT",
    "city": "Middelburg",
    "country": "The Netherlands",
    "country_label": "Niederlande",
    "region": "Belgium",
    "language": "Englisch",
    "address": "Langeviele 2, 4331 LT Middelburg, Niederlande",
    "map_query": "Langeviele 2, 4331 LT Middelburg, Niederlande",
    "maps_query": "Fashion Forum, Langeviele 2, 4331 LT Middelburg, Niederlande",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 171
  },
  {
    "id": "fashion-store-gmbh-und-co-kg-3401-xz-ijsselstein",
    "name": "Fashion Store GmbH & Co. KG",
    "type": "Partner Store",
    "street": "Van Leuffenpad",
    "house_number": "27",
    "street_line": "Van Leuffenpad 27",
    "zip": "3401 XZ",
    "city": "IJsselstein",
    "country": "The Netherlands",
    "country_label": "Niederlande",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Van Leuffenpad 27, 3401 XZ IJsselstein, Niederlande",
    "map_query": "Van Leuffenpad 27, 3401 XZ IJsselstein, Niederlande",
    "maps_query": "Fashion Store GmbH & Co. KG, Van Leuffenpad 27, 3401 XZ IJsselstein, Niederlande",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 172
  },
  {
    "id": "fashion-store-frank-schweizer-e-k-32257-bunde",
    "name": "Fashion-Store Frank Schweizer e.K.",
    "type": "Partner Store",
    "street": "Eschstraße",
    "house_number": "28",
    "street_line": "Eschstraße 28",
    "zip": "32257",
    "city": "Bünde",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Eschstraße 28, 32257 Bünde, Deutschland",
    "map_query": "Eschstraße 28, 32257 Bünde, Deutschland",
    "maps_query": "Fashion-Store Frank Schweizer e.K., Eschstraße 28, 32257 Bünde, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 173
  },
  {
    "id": "fedeluc-bv-72622-nurtingen",
    "name": "Fedeluc BV",
    "type": "Partner Store",
    "street": "Kirchstr.",
    "house_number": "28",
    "street_line": "Kirchstr. 28",
    "zip": "72622",
    "city": "Nürtingen",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Belgium",
    "language": "Englisch",
    "address": "Kirchstr. 28, 72622 Nürtingen, Deutschland",
    "map_query": "Kirchstr. 28, 72622 Nürtingen, Deutschland",
    "maps_query": "Fedeluc BV, Kirchstr. 28, 72622 Nürtingen, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 174
  },
  {
    "id": "first-man-59-900-zgorzelec",
    "name": "First Man",
    "type": "Partner Store",
    "street": "Kosciuszki",
    "house_number": "4-6",
    "street_line": "Kosciuszki 4-6",
    "zip": "59-900",
    "city": "Zgorzelec",
    "country": "Poland",
    "country_label": "Poland",
    "region": "The Netherlands",
    "language": "Englisch",
    "address": "Kosciuszki 4-6, 59-900 Zgorzelec, Poland",
    "map_query": "Kosciuszki 4-6, 59-900 Zgorzelec, Poland",
    "maps_query": "First Man, Kosciuszki 4-6, 59-900 Zgorzelec, Poland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 175
  },
  {
    "id": "firstman-hoogezand-bv-2225-gb-katwijk",
    "name": "Firstman Hoogezand BV",
    "type": "Partner Store",
    "street": "Princestraat",
    "house_number": "22",
    "street_line": "Princestraat 22",
    "zip": "2225 GB",
    "city": "Katwijk",
    "country": "The Netherlands",
    "country_label": "Niederlande",
    "region": "The Netherlands",
    "language": "Englisch",
    "address": "Princestraat 22, 2225 GB Katwijk, Niederlande",
    "map_query": "Princestraat 22, 2225 GB Katwijk, Niederlande",
    "maps_query": "Firstman Hoogezand BV, Princestraat 22, 2225 GB Katwijk, Niederlande",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 176
  },
  {
    "id": "fischer-moden-gmbh-9603-ae-hoogezand",
    "name": "Fischer-Moden GmbH",
    "type": "Partner Store",
    "street": "Gorecht Oost",
    "house_number": "147",
    "street_line": "Gorecht Oost 147",
    "zip": "9603 AE",
    "city": "Hoogezand",
    "country": "The Netherlands",
    "country_label": "Niederlande",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Gorecht Oost 147, 9603 AE Hoogezand, Niederlande",
    "map_query": "Gorecht Oost 147, 9603 AE Hoogezand, Niederlande",
    "maps_query": "Fischer-Moden GmbH, Gorecht Oost 147, 9603 AE Hoogezand, Niederlande",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 177
  },
  {
    "id": "fragine-1861-jt-bergen",
    "name": "Fragine",
    "type": "Partner Store",
    "street": "Jan Oldenburglaan",
    "house_number": "6",
    "street_line": "Jan Oldenburglaan 6",
    "zip": "1861 JT",
    "city": "Bergen",
    "country": "The Netherlands",
    "country_label": "Niederlande",
    "region": "Belgium",
    "language": "Englisch",
    "address": "Jan Oldenburglaan 6, 1861 JT Bergen, Niederlande",
    "map_query": "Jan Oldenburglaan 6, 1861 JT Bergen, Niederlande",
    "maps_query": "Fragine, Jan Oldenburglaan 6, 1861 JT Bergen, Niederlande",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 178
  },
  {
    "id": "franz-jahrstorfer-e-k-8540-deerlijk",
    "name": "Franz Jahrstorfer e.K.",
    "type": "Partner Store",
    "street": "Harelbekestraat",
    "house_number": "2a",
    "street_line": "Harelbekestraat 2a",
    "zip": "8540",
    "city": "Deerlijk",
    "country": "Belgium",
    "country_label": "Belgien",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Harelbekestraat 2a, 8540 Deerlijk, Belgien",
    "map_query": "Harelbekestraat 2a, 8540 Deerlijk, Belgien",
    "maps_query": "Franz Jahrstorfer e.K., Harelbekestraat 2a, 8540 Deerlijk, Belgien",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 179
  },
  {
    "id": "freiwahl-kaufhaus-gmbh-und-co-centrum-kg-94428-eichendorf",
    "name": "Freiwahl Kaufhaus GmbH&Co.Centrum KG",
    "type": "Partner Store",
    "street": "Marktplatz",
    "house_number": "10",
    "street_line": "Marktplatz 10",
    "zip": "94428",
    "city": "Eichendorf",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Marktplatz 10, 94428 Eichendorf, Deutschland",
    "map_query": "Marktplatz 10, 94428 Eichendorf, Deutschland",
    "maps_query": "Freiwahl Kaufhaus GmbH&Co.Centrum KG, Marktplatz 10, 94428 Eichendorf, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 180
  },
  {
    "id": "fresh-look-herrenmoden-95615-marktredwitz",
    "name": "Fresh Look Herrenmoden",
    "type": "Partner Store",
    "street": "Leopoldstr.",
    "house_number": "19-23",
    "street_line": "Leopoldstr. 19-23",
    "zip": "95615",
    "city": "Marktredwitz",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Leopoldstr. 19-23, 95615 Marktredwitz, Deutschland",
    "map_query": "Leopoldstr. 19-23, 95615 Marktredwitz, Deutschland",
    "maps_query": "Fresh Look Herrenmoden, Leopoldstr. 19-23, 95615 Marktredwitz, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 181
  },
  {
    "id": "frey-mode-und-textil-gmbh-16303-schwedt-oder",
    "name": "Frey Mode und Textil GmbH",
    "type": "Partner Store",
    "street": "Landgrabenpark",
    "house_number": "1",
    "street_line": "Landgrabenpark 1",
    "zip": "16303",
    "city": "Schwedt / Oder",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Landgrabenpark 1, 16303 Schwedt / Oder, Deutschland",
    "map_query": "Landgrabenpark 1, 16303 Schwedt / Oder, Deutschland",
    "maps_query": "Frey Mode und Textil GmbH, Landgrabenpark 1, 16303 Schwedt / Oder, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 182
  },
  {
    "id": "frey-handels-centrum-gmbh-und-co-kg-73066-uhingen",
    "name": "Frey-Handels-Centrum GmbH&Co.KG",
    "type": "Partner Store",
    "street": "Stuttgarter Str.",
    "house_number": "1",
    "street_line": "Stuttgarter Str. 1",
    "zip": "73066",
    "city": "Uhingen",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Stuttgarter Str. 1, 73066 Uhingen, Deutschland",
    "map_query": "Stuttgarter Str. 1, 73066 Uhingen, Deutschland",
    "maps_query": "Frey-Handels-Centrum GmbH&Co.KG, Stuttgarter Str. 1, 73066 Uhingen, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 183
  },
  {
    "id": "frink-mode-92421-schwandorf",
    "name": "Frink Mode",
    "type": "Partner Store",
    "street": "Friedrich-Ebert-Str.",
    "house_number": "53",
    "street_line": "Friedrich-Ebert-Str. 53",
    "zip": "92421",
    "city": "Schwandorf",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Austria",
    "language": "Deutsch",
    "address": "Friedrich-Ebert-Str. 53, 92421 Schwandorf, Deutschland",
    "map_query": "Friedrich-Ebert-Str. 53, 92421 Schwandorf, Deutschland",
    "maps_query": "Frink Mode, Friedrich-Ebert-Str. 53, 92421 Schwandorf, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 184
  },
  {
    "id": "fritz-maier-gmbh-und-co-kg-9020-klagenfurt",
    "name": "Fritz Maier GmbH & Co.KG",
    "type": "Partner Store",
    "street": "Pernhartgasse",
    "house_number": "1",
    "street_line": "Pernhartgasse 1",
    "zip": "9020",
    "city": "Klagenfurt",
    "country": "Austria",
    "country_label": "Österreich",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Pernhartgasse 1, 9020 Klagenfurt, Österreich",
    "map_query": "Pernhartgasse 1, 9020 Klagenfurt, Österreich",
    "maps_query": "Fritz Maier GmbH & Co.KG, Pernhartgasse 1, 9020 Klagenfurt, Österreich",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 185
  },
  {
    "id": "fritz-schmitz-herrenmoden-72458-albstadt",
    "name": "Fritz Schmitz Herrenmoden",
    "type": "Partner Store",
    "street": "Bahnhofstraße",
    "house_number": "4",
    "street_line": "Bahnhofstraße 4",
    "zip": "72458",
    "city": "Albstadt",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Bahnhofstraße 4, 72458 Albstadt, Deutschland",
    "map_query": "Bahnhofstraße 4, 72458 Albstadt, Deutschland",
    "maps_query": "Fritz Schmitz Herrenmoden, Bahnhofstraße 4, 72458 Albstadt, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 186
  },
  {
    "id": "fuchsweber-41747-viersen",
    "name": "Fuchsweber",
    "type": "Partner Store",
    "street": "Remigiusplatz",
    "house_number": "17",
    "street_line": "Remigiusplatz 17",
    "zip": "41747",
    "city": "Viersen",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Remigiusplatz 17, 41747 Viersen, Deutschland",
    "map_query": "Remigiusplatz 17, 41747 Viersen, Deutschland",
    "maps_query": "Fuchsweber, Remigiusplatz 17, 41747 Viersen, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 187
  },
  {
    "id": "funk-men-gmbh-82256-furstenfeldbruck",
    "name": "FUNK men GmbH",
    "type": "Partner Store",
    "street": "Schöngeisinger Str.",
    "house_number": "7",
    "street_line": "Schöngeisinger Str. 7",
    "zip": "82256",
    "city": "Fürstenfeldbruck",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Schöngeisinger Str. 7, 82256 Fürstenfeldbruck, Deutschland",
    "map_query": "Schöngeisinger Str. 7, 82256 Fürstenfeldbruck, Deutschland",
    "maps_query": "FUNK men GmbH, Schöngeisinger Str. 7, 82256 Fürstenfeldbruck, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 188
  },
  {
    "id": "furnkranz-mode-e-k-52349-duren",
    "name": "Fürnkranz Mode e. K.",
    "type": "Partner Store",
    "street": "Hirschgasse",
    "house_number": "1-3",
    "street_line": "Hirschgasse 1-3",
    "zip": "52349",
    "city": "Düren",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Hirschgasse 1-3, 52349 Düren, Deutschland",
    "map_query": "Hirschgasse 1-3, 52349 Düren, Deutschland",
    "maps_query": "Fürnkranz Mode e. K., Hirschgasse 1-3, 52349 Düren, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 189
  },
  {
    "id": "futuro-mannenmode-b-v-53111-bonn",
    "name": "Futuro Mannenmode B.V.",
    "type": "Partner Store",
    "street": "Friedrichstr.",
    "house_number": "21",
    "street_line": "Friedrichstr. 21",
    "zip": "53111",
    "city": "Bonn",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "The Netherlands",
    "language": "Englisch",
    "address": "Friedrichstr. 21, 53111 Bonn, Deutschland",
    "map_query": "Friedrichstr. 21, 53111 Bonn, Deutschland",
    "maps_query": "Futuro Mannenmode B.V., Friedrichstr. 21, 53111 Bonn, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 190
  },
  {
    "id": "ganzbeck-gmbh-und-co-kg-8152-glattbrugg",
    "name": "Ganzbeck GmbH & Co KG",
    "type": "Partner Store",
    "street": "Industriestraße",
    "house_number": "57",
    "street_line": "Industriestraße 57",
    "zip": "8152",
    "city": "Glattbrugg",
    "country": "Switzerland",
    "country_label": "Schweiz",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Industriestraße 57, 8152 Glattbrugg, Schweiz",
    "map_query": "Industriestraße 57, 8152 Glattbrugg, Schweiz",
    "maps_query": "Ganzbeck GmbH & Co KG, Industriestraße 57, 8152 Glattbrugg, Schweiz",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 191
  },
  {
    "id": "garderobe-fur-mann-und-frau-84524-neuotting",
    "name": "Garderobe für Mann und Frau",
    "type": "Partner Store",
    "street": "Ludwigstraße",
    "house_number": "88-92",
    "street_line": "Ludwigstraße 88-92",
    "zip": "84524",
    "city": "Neuötting",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Ludwigstraße 88-92, 84524 Neuötting, Deutschland",
    "map_query": "Ludwigstraße 88-92, 84524 Neuötting, Deutschland",
    "maps_query": "Garderobe für Mann und Frau, Ludwigstraße 88-92, 84524 Neuötting, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 192
  },
  {
    "id": "garzon-herrenmode-gmbh-10178-berlin",
    "name": "Garzon Herrenmode Gmbh",
    "type": "Partner Store",
    "street": "Rosenthaler Str.",
    "house_number": "36",
    "street_line": "Rosenthaler Str. 36",
    "zip": "10178",
    "city": "Berlin",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Austria",
    "language": "Deutsch",
    "address": "Rosenthaler Str. 36, 10178 Berlin, Deutschland",
    "map_query": "Rosenthaler Str. 36, 10178 Berlin, Deutschland",
    "maps_query": "Garzon Herrenmode Gmbh, Rosenthaler Str. 36, 10178 Berlin, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 193
  },
  {
    "id": "geerits-nv-6850-dornbirn",
    "name": "Geerits NV",
    "type": "Partner Store",
    "street": "Klostergasse",
    "house_number": "6",
    "street_line": "Klostergasse 6",
    "zip": "6850",
    "city": "Dornbirn",
    "country": "Austria",
    "country_label": "Österreich",
    "region": "Belgium",
    "language": "Englisch",
    "address": "Klostergasse 6, 6850 Dornbirn, Österreich",
    "map_query": "Klostergasse 6, 6850 Dornbirn, Österreich",
    "maps_query": "Geerits NV, Klostergasse 6, 6850 Dornbirn, Österreich",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 194
  },
  {
    "id": "gent-e-k-8900-ieper",
    "name": "Gent e. K.",
    "type": "Partner Store",
    "street": "Grote Markt",
    "house_number": "39",
    "street_line": "Grote Markt 39",
    "zip": "8900",
    "city": "Ieper",
    "country": "Belgium",
    "country_label": "Belgien",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Grote Markt 39, 8900 Ieper, Belgien",
    "map_query": "Grote Markt 39, 8900 Ieper, Belgien",
    "maps_query": "Gent e. K., Grote Markt 39, 8900 Ieper, Belgien",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 195
  },
  {
    "id": "gentleman-sp-z-o-o-78628-rottweil",
    "name": "GENTLEMAN Sp. z.o.o.",
    "type": "Partner Store",
    "street": "Hochbrücktorstr.",
    "house_number": "23",
    "street_line": "Hochbrücktorstr. 23",
    "zip": "78628",
    "city": "Rottweil",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Poland",
    "language": "Englisch",
    "address": "Hochbrücktorstr. 23, 78628 Rottweil, Deutschland",
    "map_query": "Hochbrücktorstr. 23, 78628 Rottweil, Deutschland",
    "maps_query": "GENTLEMAN Sp. z.o.o., Hochbrücktorstr. 23, 78628 Rottweil, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 196
  },
  {
    "id": "gentlemen-nv-64-514-pamiatkowo",
    "name": "Gentlemen NV",
    "type": "Partner Store",
    "street": "Obornicka",
    "house_number": "6",
    "street_line": "Obornicka 6",
    "zip": "64-514",
    "city": "Pamiatkowo",
    "country": "Poland",
    "country_label": "Poland",
    "region": "Belgium",
    "language": "Englisch",
    "address": "Obornicka 6, 64-514 Pamiatkowo, Poland",
    "map_query": "Obornicka 6, 64-514 Pamiatkowo, Poland",
    "maps_query": "Gentlemen NV, Obornicka 6, 64-514 Pamiatkowo, Poland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 197
  },
  {
    "id": "geschwister-may-ohg-1800-vilvoorde",
    "name": "Geschwister May oHG",
    "type": "Partner Store",
    "street": "J.B. Mowelei",
    "house_number": "43",
    "street_line": "J.B. Mowelei 43",
    "zip": "1800",
    "city": "Vilvoorde",
    "country": "Belgium",
    "country_label": "Belgien",
    "region": "Germany",
    "language": "Deutsch",
    "address": "J.B. Mowelei 43, 1800 Vilvoorde, Belgien",
    "map_query": "J.B. Mowelei 43, 1800 Vilvoorde, Belgien",
    "maps_query": "Geschwister May oHG, J.B. Mowelei 43, 1800 Vilvoorde, Belgien",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 198
  },
  {
    "id": "gg-modehaus-wurzburg-gmbh-79761-waldshut",
    "name": "GG Modehaus Würzburg GmbH",
    "type": "Partner Store",
    "street": "Kaiserstr.",
    "house_number": "57",
    "street_line": "Kaiserstr. 57",
    "zip": "79761",
    "city": "Waldshut",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Kaiserstr. 57, 79761 Waldshut, Deutschland",
    "map_query": "Kaiserstr. 57, 79761 Waldshut, Deutschland",
    "maps_query": "GG Modehaus Würzburg GmbH, Kaiserstr. 57, 79761 Waldshut, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 199
  },
  {
    "id": "giesler-moden-e-k-97082-wurzburg",
    "name": "Giesler Moden e.K.",
    "type": "Partner Store",
    "street": "Mainaustraße",
    "house_number": "53",
    "street_line": "Mainaustraße 53",
    "zip": "97082",
    "city": "Würzburg",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Mainaustraße 53, 97082 Würzburg, Deutschland",
    "map_query": "Mainaustraße 53, 97082 Würzburg, Deutschland",
    "maps_query": "Giesler Moden e.K., Mainaustraße 53, 97082 Würzburg, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 200
  },
  {
    "id": "giesler-moden-e-k-oberkirch-77716-haslach",
    "name": "Giesler Moden e.K. Oberkirch",
    "type": "Partner Store",
    "street": "Am Marktplatz",
    "house_number": "4",
    "street_line": "Am Marktplatz 4",
    "zip": "77716",
    "city": "Haslach",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Am Marktplatz 4, 77716 Haslach, Deutschland",
    "map_query": "Am Marktplatz 4, 77716 Haslach, Deutschland",
    "maps_query": "Giesler Moden e.K. Oberkirch, Am Marktplatz 4, 77716 Haslach, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 201
  },
  {
    "id": "gilsing-herenmode-77716-haslach",
    "name": "Gilsing Herenmode",
    "type": "Partner Store",
    "street": "Am Marktplatz",
    "house_number": "4",
    "street_line": "Am Marktplatz 4",
    "zip": "77716",
    "city": "Haslach",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "The Netherlands",
    "language": "Englisch",
    "address": "Am Marktplatz 4, 77716 Haslach, Deutschland",
    "map_query": "Am Marktplatz 4, 77716 Haslach, Deutschland",
    "maps_query": "Gilsing Herenmode, Am Marktplatz 4, 77716 Haslach, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 202
  },
  {
    "id": "giorgio-6942-ea-didam",
    "name": "Giorgio",
    "type": "Partner Store",
    "street": "Spoorstraat",
    "house_number": "11",
    "street_line": "Spoorstraat 11",
    "zip": "6942 EA",
    "city": "Didam",
    "country": "The Netherlands",
    "country_label": "Niederlande",
    "region": "Belgium",
    "language": "Englisch",
    "address": "Spoorstraat 11, 6942 EA Didam, Niederlande",
    "map_query": "Spoorstraat 11, 6942 EA Didam, Niederlande",
    "maps_query": "Giorgio, Spoorstraat 11, 6942 EA Didam, Niederlande",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 203
  },
  {
    "id": "goedenco-fashion-houten-8610-kortemark",
    "name": "GoedenCo Fashion Houten",
    "type": "Partner Store",
    "street": "Hoogledestraat",
    "house_number": "60",
    "street_line": "Hoogledestraat 60",
    "zip": "8610",
    "city": "Kortemark",
    "country": "Belgium",
    "country_label": "Belgien",
    "region": "The Netherlands",
    "language": "Englisch",
    "address": "Hoogledestraat 60, 8610 Kortemark, Belgien",
    "map_query": "Hoogledestraat 60, 8610 Kortemark, Belgien",
    "maps_query": "GoedenCo Fashion Houten, Hoogledestraat 60, 8610 Kortemark, Belgien",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 204
  },
  {
    "id": "goosse-tendance-3995-dp-houten",
    "name": "Goosse Tendance",
    "type": "Partner Store",
    "street": "Het Rond",
    "house_number": "150",
    "street_line": "Het Rond 150",
    "zip": "3995 DP",
    "city": "Houten",
    "country": "The Netherlands",
    "country_label": "Niederlande",
    "region": "Belgium",
    "language": "Englisch",
    "address": "Het Rond 150, 3995 DP Houten, Niederlande",
    "map_query": "Het Rond 150, 3995 DP Houten, Niederlande",
    "maps_query": "Goosse Tendance, Het Rond 150, 3995 DP Houten, Niederlande",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 205
  },
  {
    "id": "grusenmeyer-nv-6987-rendeux",
    "name": "Grusenmeyer NV",
    "type": "Partner Store",
    "street": "Route de Hotton",
    "house_number": "33",
    "street_line": "Route de Hotton 33",
    "zip": "6987",
    "city": "Rendeux",
    "country": "Belgium",
    "country_label": "Belgien",
    "region": "Belgium",
    "language": "Englisch",
    "address": "Route de Hotton 33, 6987 Rendeux, Belgien",
    "map_query": "Route de Hotton 33, 6987 Rendeux, Belgien",
    "maps_query": "Grusenmeyer NV, Route de Hotton 33, 6987 Rendeux, Belgien",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 206
  },
  {
    "id": "gseven-9800-deinze",
    "name": "GSEVEN",
    "type": "Partner Store",
    "street": "Louis Dhontstraat",
    "house_number": "2",
    "street_line": "Louis Dhontstraat 2",
    "zip": "9800",
    "city": "Deinze",
    "country": "Belgium",
    "country_label": "Belgien",
    "region": "Belgium",
    "language": "Englisch",
    "address": "Louis Dhontstraat 2, 9800 Deinze, Belgien",
    "map_query": "Louis Dhontstraat 2, 9800 Deinze, Belgien",
    "maps_query": "GSEVEN, Louis Dhontstraat 2, 9800 Deinze, Belgien",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 207
  },
  {
    "id": "gtg-fashion-b-v-2500-lier",
    "name": "GTG Fashion B.V.",
    "type": "Partner Store",
    "street": "Heilige Geeststraat",
    "house_number": "3",
    "street_line": "Heilige Geeststraat 3",
    "zip": "2500",
    "city": "Lier",
    "country": "Belgium",
    "country_label": "Belgien",
    "region": "The Netherlands",
    "language": "Englisch",
    "address": "Heilige Geeststraat 3, 2500 Lier, Belgien",
    "map_query": "Heilige Geeststraat 3, 2500 Lier, Belgien",
    "maps_query": "GTG Fashion B.V., Heilige Geeststraat 3, 2500 Lier, Belgien",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 208
  },
  {
    "id": "guggis-shoes-fashion-lifestyle-5101-bergheim-bei-salzburg",
    "name": "Guggis Shoes, Fashion, Lifestyle",
    "type": "Partner Store",
    "street": "Moosfeldstraße 1, EG B16",
    "house_number": "",
    "street_line": "Moosfeldstraße 1, EG B16",
    "zip": "5101",
    "city": "Bergheim bei Salzburg",
    "country": "Austria",
    "country_label": "Österreich",
    "region": "Austria",
    "language": "Deutsch",
    "address": "Moosfeldstraße 1, EG B16, 5101 Bergheim bei Salzburg, Österreich",
    "map_query": "Guggis Shoes, Fashion, Lifestyle, Moosfeldstraße 1, EG B16, 5101 Bergheim bei Salzburg, Österreich",
    "maps_query": "Guggis Shoes, Fashion, Lifestyle, Moosfeldstraße 1, EG B16, 5101 Bergheim bei Salzburg, Österreich",
    "note": "Sortiment und Verfügbarkeit können variieren. Adresse bitte vor Besuch über den Händler prüfen.",
    "data_quality": [
      "house_number_missing"
    ],
    "source_row": 209
  },
  {
    "id": "gustav-ramelow-gmbh-und-co-kg-4880-st-georgen",
    "name": "Gustav Ramelow GmbH & Co. KG",
    "type": "Partner Store",
    "street": "Attergaustraße",
    "house_number": "37",
    "street_line": "Attergaustraße 37",
    "zip": "4880",
    "city": "St Georgen",
    "country": "Austria",
    "country_label": "Österreich",
    "region": "",
    "language": "Englisch",
    "address": "Attergaustraße 37, 4880 St Georgen, Österreich",
    "map_query": "Attergaustraße 37, 4880 St Georgen, Österreich",
    "maps_query": "Gustav Ramelow GmbH & Co. KG, Attergaustraße 37, 4880 St Georgen, Österreich",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 210
  },
  {
    "id": "gustav-ramelow-heide-25335-elmshorn",
    "name": "Gustav Ramelow Heide",
    "type": "Partner Store",
    "street": "Königstraße",
    "house_number": "33-35",
    "street_line": "Königstraße 33-35",
    "zip": "25335",
    "city": "Elmshorn",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Königstraße 33-35, 25335 Elmshorn, Deutschland",
    "map_query": "Königstraße 33-35, 25335 Elmshorn, Deutschland",
    "maps_query": "Gustav Ramelow Heide, Königstraße 33-35, 25335 Elmshorn, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 211
  },
  {
    "id": "gustav-ramelow-stendal-25746-heide",
    "name": "Gustav Ramelow Stendal",
    "type": "Partner Store",
    "street": "Markt",
    "house_number": "14-16",
    "street_line": "Markt 14-16",
    "zip": "25746",
    "city": "Heide",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Markt 14-16, 25746 Heide, Deutschland",
    "map_query": "Markt 14-16, 25746 Heide, Deutschland",
    "maps_query": "Gustav Ramelow Stendal, Markt 14-16, 25746 Heide, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 212
  },
  {
    "id": "gustav-ramelow-uelzen-39576-stendal",
    "name": "Gustav Ramelow Uelzen",
    "type": "Partner Store",
    "street": "Breite Str.",
    "house_number": "20-21",
    "street_line": "Breite Str. 20-21",
    "zip": "39576",
    "city": "Stendal",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Breite Str. 20-21, 39576 Stendal, Deutschland",
    "map_query": "Breite Str. 20-21, 39576 Stendal, Deutschland",
    "maps_query": "Gustav Ramelow Uelzen, Breite Str. 20-21, 39576 Stendal, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 213
  },
  {
    "id": "gutbrod-modenhaus-gmbh-und-co-kg-29525-uelzen",
    "name": "Gutbrod Modenhaus GmbH & Co.KG",
    "type": "Partner Store",
    "street": "Bahnhofstraße",
    "house_number": "18-22",
    "street_line": "Bahnhofstraße 18-22",
    "zip": "29525",
    "city": "Uelzen",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Bahnhofstraße 18-22, 29525 Uelzen, Deutschland",
    "map_query": "Bahnhofstraße 18-22, 29525 Uelzen, Deutschland",
    "maps_query": "Gutbrod Modenhaus GmbH & Co.KG, Bahnhofstraße 18-22, 29525 Uelzen, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 214
  },
  {
    "id": "gutmann-herrenbekleidung-92342-freystadt",
    "name": "Gutmann Herrenbekleidung",
    "type": "Partner Store",
    "street": "Marktplatz",
    "house_number": "37",
    "street_line": "Marktplatz 37",
    "zip": "92342",
    "city": "Freystadt",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Marktplatz 37, 92342 Freystadt, Deutschland",
    "map_query": "Marktplatz 37, 92342 Freystadt, Deutschland",
    "maps_query": "Gutmann Herrenbekleidung, Marktplatz 37, 92342 Freystadt, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 215
  },
  {
    "id": "gutschlhofer-moden-e-u-91781-weienburg",
    "name": "Gutschlhofer Moden e.U.",
    "type": "Partner Store",
    "street": "Emetzheimer Str.",
    "house_number": "1",
    "street_line": "Emetzheimer Str. 1",
    "zip": "91781",
    "city": "Weißenburg",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Austria",
    "language": "Deutsch",
    "address": "Emetzheimer Str. 1, 91781 Weißenburg, Deutschland",
    "map_query": "Emetzheimer Str. 1, 91781 Weißenburg, Deutschland",
    "maps_query": "Gutschlhofer Moden e.U., Emetzheimer Str. 1, 91781 Weißenburg, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 216
  },
  {
    "id": "gygax-retail-ag-6240-rattenberg",
    "name": "Gygax Retail AG",
    "type": "Partner Store",
    "street": "Hassauerstraße",
    "house_number": "73",
    "street_line": "Hassauerstraße 73",
    "zip": "6240",
    "city": "Rattenberg",
    "country": "Austria",
    "country_label": "Österreich",
    "region": "Switzerland",
    "language": "Englisch",
    "address": "Hassauerstraße 73, 6240 Rattenberg, Österreich",
    "map_query": "Hassauerstraße 73, 6240 Rattenberg, Österreich",
    "maps_query": "Gygax Retail AG, Hassauerstraße 73, 6240 Rattenberg, Österreich",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 217
  },
  {
    "id": "h-p-steingass-gmbh-und-co-kg-2982-ah-ridderkerk",
    "name": "H.P. Steingass GmbH & Co.KG",
    "type": "Partner Store",
    "street": "Konninginneweg",
    "house_number": "49",
    "street_line": "Konninginneweg 49",
    "zip": "2982 AH",
    "city": "Ridderkerk",
    "country": "The Netherlands",
    "country_label": "Niederlande",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Konninginneweg 49, 2982 AH Ridderkerk, Niederlande",
    "map_query": "Konninginneweg 49, 2982 AH Ridderkerk, Niederlande",
    "maps_query": "H.P. Steingass GmbH & Co.KG, Konninginneweg 49, 2982 AH Ridderkerk, Niederlande",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 218
  },
  {
    "id": "haas-mode-gmbh-89520-heidenheim",
    "name": "Haas Mode GmbH",
    "type": "Partner Store",
    "street": "Mittelrainstraße",
    "house_number": "8",
    "street_line": "Mittelrainstraße 8",
    "zip": "89520",
    "city": "Heidenheim",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Mittelrainstraße 8, 89520 Heidenheim, Deutschland",
    "map_query": "Mittelrainstraße 8, 89520 Heidenheim, Deutschland",
    "maps_query": "Haas Mode GmbH, Mittelrainstraße 8, 89520 Heidenheim, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 219
  },
  {
    "id": "haffke-gmbh-und-co-kg-52152-simmerath",
    "name": "Haffke GmbH & Co KG",
    "type": "Partner Store",
    "street": "Hauptstraße",
    "house_number": "65",
    "street_line": "Hauptstraße 65",
    "zip": "52152",
    "city": "Simmerath",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Hauptstraße 65, 52152 Simmerath, Deutschland",
    "map_query": "Hauptstraße 65, 52152 Simmerath, Deutschland",
    "maps_query": "Haffke GmbH & Co KG, Hauptstraße 65, 52152 Simmerath, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 220
  },
  {
    "id": "haider-moden-gmbh-und-co-kg-32423-minden",
    "name": "Haider Moden GmbH & Co. KG",
    "type": "Partner Store",
    "street": "Scharn 9 -",
    "house_number": "17",
    "street_line": "Scharn 9 - 17",
    "zip": "32423",
    "city": "Minden",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Scharn 9 - 17, 32423 Minden, Deutschland",
    "map_query": "Scharn 9 - 17, 32423 Minden, Deutschland",
    "maps_query": "Haider Moden GmbH & Co. KG, Scharn 9 - 17, 32423 Minden, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 221
  },
  {
    "id": "hans-b-und-g-83278-traunstein",
    "name": "Hans B & G",
    "type": "Partner Store",
    "street": "Bahnhofstraße",
    "house_number": "6",
    "street_line": "Bahnhofstraße 6",
    "zip": "83278",
    "city": "Traunstein",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "The Netherlands",
    "language": "Englisch",
    "address": "Bahnhofstraße 6, 83278 Traunstein, Deutschland",
    "map_query": "Bahnhofstraße 6, 83278 Traunstein, Deutschland",
    "maps_query": "Hans B & G, Bahnhofstraße 6, 83278 Traunstein, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 222
  },
  {
    "id": "hans-raithle-gmbh-1741-gc-schagen",
    "name": "Hans Raithle GmbH",
    "type": "Partner Store",
    "street": "Gedempte Gracht",
    "house_number": "12",
    "street_line": "Gedempte Gracht 12",
    "zip": "1741 GC",
    "city": "Schagen",
    "country": "The Netherlands",
    "country_label": "Niederlande",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Gedempte Gracht 12, 1741 GC Schagen, Niederlande",
    "map_query": "Gedempte Gracht 12, 1741 GC Schagen, Niederlande",
    "maps_query": "Hans Raithle GmbH, Gedempte Gracht 12, 1741 GC Schagen, Niederlande",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 223
  },
  {
    "id": "harald-lehmeier-manner-73650-winterbach",
    "name": "Harald Lehmeier - Männer",
    "type": "Partner Store",
    "street": "Oberdorf",
    "house_number": "9",
    "street_line": "Oberdorf 9",
    "zip": "73650",
    "city": "Winterbach",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Oberdorf 9, 73650 Winterbach, Deutschland",
    "map_query": "Oberdorf 9, 73650 Winterbach, Deutschland",
    "maps_query": "Harald Lehmeier - Männer, Oberdorf 9, 73650 Winterbach, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 224
  },
  {
    "id": "harders-90403-nurnberg",
    "name": "Harders",
    "type": "Partner Store",
    "street": "Winklerstr.",
    "house_number": "1",
    "street_line": "Winklerstr. 1",
    "zip": "90403",
    "city": "Nürnberg",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Winklerstr. 1, 90403 Nürnberg, Deutschland",
    "map_query": "Winklerstr. 1, 90403 Nürnberg, Deutschland",
    "maps_query": "Harders, Winklerstr. 1, 90403 Nürnberg, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 225
  },
  {
    "id": "harders-fashion-gmbh-47051-duisburg",
    "name": "HARDERS Fashion GmbH",
    "type": "Partner Store",
    "street": "Königstraße",
    "house_number": "7",
    "street_line": "Königstraße 7",
    "zip": "47051",
    "city": "Duisburg",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Königstraße 7, 47051 Duisburg, Deutschland",
    "map_query": "Königstraße 7, 47051 Duisburg, Deutschland",
    "maps_query": "HARDERS Fashion GmbH, Königstraße 7, 47051 Duisburg, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 226
  },
  {
    "id": "hassel-herrenmoden-49439-steinfeld",
    "name": "Hassel Herrenmoden",
    "type": "Partner Store",
    "street": "Bahnhofstr.",
    "house_number": "47",
    "street_line": "Bahnhofstr. 47",
    "zip": "49439",
    "city": "Steinfeld",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Bahnhofstr. 47, 49439 Steinfeld, Deutschland",
    "map_query": "Bahnhofstr. 47, 49439 Steinfeld, Deutschland",
    "maps_query": "Hassel Herrenmoden, Bahnhofstr. 47, 49439 Steinfeld, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 227
  },
  {
    "id": "haus-der-mode-fur-den-herren-gmbh-6003-luzern",
    "name": "Haus der Mode für den Herren GmbH",
    "type": "Partner Store",
    "street": "Pfistergasse",
    "house_number": "3",
    "street_line": "Pfistergasse 3",
    "zip": "6003",
    "city": "Luzern",
    "country": "Switzerland",
    "country_label": "Schweiz",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Pfistergasse 3, 6003 Luzern, Schweiz",
    "map_query": "Pfistergasse 3, 6003 Luzern, Schweiz",
    "maps_query": "Haus der Mode für den Herren GmbH, Pfistergasse 3, 6003 Luzern, Schweiz",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 228
  },
  {
    "id": "heeren-van-opheusden-bv-97421-schweinfurt",
    "name": "Heeren van Opheusden BV",
    "type": "Partner Store",
    "street": "Wolfsgasse",
    "house_number": "27",
    "street_line": "Wolfsgasse 27",
    "zip": "97421",
    "city": "Schweinfurt",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "The Netherlands",
    "language": "Englisch",
    "address": "Wolfsgasse 27, 97421 Schweinfurt, Deutschland",
    "map_query": "Wolfsgasse 27, 97421 Schweinfurt, Deutschland",
    "maps_query": "Heeren van Opheusden BV, Wolfsgasse 27, 97421 Schweinfurt, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 229
  },
  {
    "id": "heikorn-kleidung-gmbh-4043-km-opheusden",
    "name": "Heikorn Kleidung GmbH",
    "type": "Partner Store",
    "street": "Burgemeester Lodderstraat",
    "house_number": "38",
    "street_line": "Burgemeester Lodderstraat 38",
    "zip": "4043 KM",
    "city": "Opheusden",
    "country": "The Netherlands",
    "country_label": "Niederlande",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Burgemeester Lodderstraat 38, 4043 KM Opheusden, Niederlande",
    "map_query": "Burgemeester Lodderstraat 38, 4043 KM Opheusden, Niederlande",
    "maps_query": "Heikorn Kleidung GmbH, Burgemeester Lodderstraat 38, 4043 KM Opheusden, Niederlande",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 230
  },
  {
    "id": "heil-menswear-78224-singen",
    "name": "Heil Menswear",
    "type": "Partner Store",
    "street": "August-Ruf-Str. 7 -",
    "house_number": "9",
    "street_line": "August-Ruf-Str. 7 - 9",
    "zip": "78224",
    "city": "Singen",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "August-Ruf-Str. 7 - 9, 78224 Singen, Deutschland",
    "map_query": "August-Ruf-Str. 7 - 9, 78224 Singen, Deutschland",
    "maps_query": "Heil Menswear, August-Ruf-Str. 7 - 9, 78224 Singen, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 231
  },
  {
    "id": "heinemann-und-co-gmbh-und-co-kg-67655-kaiserslautern",
    "name": "Heinemann & Co. GmbH & Co. KG",
    "type": "Partner Store",
    "street": "Riesenstraße",
    "house_number": "14",
    "street_line": "Riesenstraße 14",
    "zip": "67655",
    "city": "Kaiserslautern",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Riesenstraße 14, 67655 Kaiserslautern, Deutschland",
    "map_query": "Riesenstraße 14, 67655 Kaiserslautern, Deutschland",
    "maps_query": "Heinemann & Co. GmbH & Co. KG, Riesenstraße 14, 67655 Kaiserslautern, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 232
  },
  {
    "id": "helmut-kohfink-e-k-41460-neuss",
    "name": "Helmut Kohfink e.K.",
    "type": "Partner Store",
    "street": "Büchel 26 -",
    "house_number": "32",
    "street_line": "Büchel 26 - 32",
    "zip": "41460",
    "city": "Neuss",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Büchel 26 - 32, 41460 Neuss, Deutschland",
    "map_query": "Büchel 26 - 32, 41460 Neuss, Deutschland",
    "maps_query": "Helmut Kohfink e.K., Büchel 26 - 32, 41460 Neuss, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 233
  },
  {
    "id": "hendriksen-mannenmode-74080-heilbronn",
    "name": "Hendriksen Mannenmode",
    "type": "Partner Store",
    "street": "Neckargartacher Straße",
    "house_number": "116",
    "street_line": "Neckargartacher Straße 116",
    "zip": "74080",
    "city": "Heilbronn",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "The Netherlands",
    "language": "Englisch",
    "address": "Neckargartacher Straße 116, 74080 Heilbronn, Deutschland",
    "map_query": "Neckargartacher Straße 116, 74080 Heilbronn, Deutschland",
    "maps_query": "Hendriksen Mannenmode, Neckargartacher Straße 116, 74080 Heilbronn, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 234
  },
  {
    "id": "henin-7902-eb-hoogeveen",
    "name": "Henin",
    "type": "Partner Store",
    "street": "Hoofdstraat",
    "house_number": "56",
    "street_line": "Hoofdstraat 56",
    "zip": "7902 EB",
    "city": "Hoogeveen",
    "country": "The Netherlands",
    "country_label": "Niederlande",
    "region": "Belgium",
    "language": "Englisch",
    "address": "Hoofdstraat 56, 7902 EB Hoogeveen, Niederlande",
    "map_query": "Hoofdstraat 56, 7902 EB Hoogeveen, Niederlande",
    "maps_query": "Henin, Hoofdstraat 56, 7902 EB Hoogeveen, Niederlande",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 235
  },
  {
    "id": "henri-s-ladies-und-gents-5590-ciney",
    "name": "Henri`s Ladies & Gents",
    "type": "Partner Store",
    "street": "Avenue Schlogel",
    "house_number": "94",
    "street_line": "Avenue Schlogel 94",
    "zip": "5590",
    "city": "Ciney",
    "country": "Belgium",
    "country_label": "Belgien",
    "region": "The Netherlands",
    "language": "Englisch",
    "address": "Avenue Schlogel 94, 5590 Ciney, Belgien",
    "map_query": "Avenue Schlogel 94, 5590 Ciney, Belgien",
    "maps_query": "Henri`s Ladies & Gents, Avenue Schlogel 94, 5590 Ciney, Belgien",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 236
  },
  {
    "id": "heppel-gmbh-und-co-kg-94104-tittling",
    "name": "Heppel GmbH & Co. KG",
    "type": "Partner Store",
    "street": "Marktplatz 13+15",
    "house_number": "",
    "street_line": "Marktplatz 13+15",
    "zip": "94104",
    "city": "Tittling",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Marktplatz 13+15, 94104 Tittling, Deutschland",
    "map_query": "Heppel GmbH & Co. KG, Marktplatz 13+15, 94104 Tittling, Deutschland",
    "maps_query": "Heppel GmbH & Co. KG, Marktplatz 13+15, 94104 Tittling, Deutschland",
    "note": "Sortiment und Verfügbarkeit können variieren. Adresse bitte vor Besuch über den Händler prüfen.",
    "data_quality": [
      "house_number_missing"
    ],
    "source_row": 237
  },
  {
    "id": "heppel-handels-gmbh-rosenheim-83308-trostberg",
    "name": "Heppel Handels GmbH Rosenheim",
    "type": "Partner Store",
    "street": "Schulstr.",
    "house_number": "1",
    "street_line": "Schulstr. 1",
    "zip": "83308",
    "city": "Trostberg",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Schulstr. 1, 83308 Trostberg, Deutschland",
    "map_query": "Schulstr. 1, 83308 Trostberg, Deutschland",
    "maps_query": "Heppel Handels GmbH Rosenheim, Schulstr. 1, 83308 Trostberg, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 238
  },
  {
    "id": "heren-van-oisterwijk-83022-rosenheim",
    "name": "Heren van Oisterwijk",
    "type": "Partner Store",
    "street": "Max-Josefs-Platz",
    "house_number": "17",
    "street_line": "Max-Josefs-Platz 17",
    "zip": "83022",
    "city": "Rosenheim",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "The Netherlands",
    "language": "Englisch",
    "address": "Max-Josefs-Platz 17, 83022 Rosenheim, Deutschland",
    "map_query": "Max-Josefs-Platz 17, 83022 Rosenheim, Deutschland",
    "maps_query": "Heren van Oisterwijk, Max-Josefs-Platz 17, 83022 Rosenheim, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 239
  },
  {
    "id": "herenkleding-gigolo-5061-hh-oisterwijk",
    "name": "Herenkleding Gigolo",
    "type": "Partner Store",
    "street": "Dorpsstraat",
    "house_number": "13",
    "street_line": "Dorpsstraat 13",
    "zip": "5061 HH",
    "city": "Oisterwijk",
    "country": "The Netherlands",
    "country_label": "Niederlande",
    "region": "Belgium",
    "language": "Englisch",
    "address": "Dorpsstraat 13, 5061 HH Oisterwijk, Niederlande",
    "map_query": "Dorpsstraat 13, 5061 HH Oisterwijk, Niederlande",
    "maps_query": "Herenkleding Gigolo, Dorpsstraat 13, 5061 HH Oisterwijk, Niederlande",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 240
  },
  {
    "id": "herenmode-de-waele-8370-blankenberge",
    "name": "Herenmode De Waele",
    "type": "Partner Store",
    "street": "Manitobaplein",
    "house_number": "16",
    "street_line": "Manitobaplein 16",
    "zip": "8370",
    "city": "Blankenberge",
    "country": "Belgium",
    "country_label": "Belgien",
    "region": "Belgium",
    "language": "Englisch",
    "address": "Manitobaplein 16, 8370 Blankenberge, Belgien",
    "map_query": "Manitobaplein 16, 8370 Blankenberge, Belgien",
    "maps_query": "Herenmode De Waele, Manitobaplein 16, 8370 Blankenberge, Belgien",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 241
  },
  {
    "id": "herenmode-tiecke-und-mulder-7571-bh-oldenzaal",
    "name": "Herenmode Tiecke & Mulder",
    "type": "Partner Store",
    "street": "Steenstraat",
    "house_number": "35",
    "street_line": "Steenstraat 35",
    "zip": "7571 BH",
    "city": "Oldenzaal",
    "country": "The Netherlands",
    "country_label": "Niederlande",
    "region": "The Netherlands",
    "language": "Englisch",
    "address": "Steenstraat 35, 7571 BH Oldenzaal, Niederlande",
    "map_query": "Steenstraat 35, 7571 BH Oldenzaal, Niederlande",
    "maps_query": "Herenmode Tiecke & Mulder, Steenstraat 35, 7571 BH Oldenzaal, Niederlande",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 242
  },
  {
    "id": "herr-muller-herrenmode-8900-ieper",
    "name": "Herr Müller-Herrenmode",
    "type": "Partner Store",
    "street": "Vandenpeereboomplein",
    "house_number": "23",
    "street_line": "Vandenpeereboomplein 23",
    "zip": "8900",
    "city": "Ieper",
    "country": "Belgium",
    "country_label": "Belgien",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Vandenpeereboomplein 23, 8900 Ieper, Belgien",
    "map_query": "Vandenpeereboomplein 23, 8900 Ieper, Belgien",
    "maps_query": "Herr Müller-Herrenmode, Vandenpeereboomplein 23, 8900 Ieper, Belgien",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 243
  },
  {
    "id": "herren-mode-wissing-gmbh-2340-modling",
    "name": "Herren Mode Wissing GmbH",
    "type": "Partner Store",
    "street": "Hauptstraße",
    "house_number": "3-5",
    "street_line": "Hauptstraße 3-5",
    "zip": "2340",
    "city": "Mödling",
    "country": "Austria",
    "country_label": "Österreich",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Hauptstraße 3-5, 2340 Mödling, Österreich",
    "map_query": "Hauptstraße 3-5, 2340 Mödling, Österreich",
    "maps_query": "Herren Mode Wissing GmbH, Hauptstraße 3-5, 2340 Mödling, Österreich",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 244
  },
  {
    "id": "herrenausstatter-de-48599-gronau-epe",
    "name": "herrenausstatter.de",
    "type": "Partner Store",
    "street": "Merschstr.",
    "house_number": "31",
    "street_line": "Merschstr. 31",
    "zip": "48599",
    "city": "Gronau-Epe",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Merschstr. 31, 48599 Gronau-Epe, Deutschland",
    "map_query": "Merschstr. 31, 48599 Gronau-Epe, Deutschland",
    "maps_query": "herrenausstatter.de, Merschstr. 31, 48599 Gronau-Epe, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 245
  },
  {
    "id": "herrenhaus-leer-85748-garching-munchen",
    "name": "Herrenhaus Leer",
    "type": "Partner Store",
    "street": "Gutenbergstr.",
    "house_number": "3a",
    "street_line": "Gutenbergstr. 3a",
    "zip": "85748",
    "city": "Garching München",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Gutenbergstr. 3a, 85748 Garching München, Deutschland",
    "map_query": "Gutenbergstr. 3a, 85748 Garching München, Deutschland",
    "maps_query": "Herrenhaus Leer, Gutenbergstr. 3a, 85748 Garching München, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 246
  },
  {
    "id": "herrenmode-iserlohe-26789-leer",
    "name": "Herrenmode Iserlohe",
    "type": "Partner Store",
    "street": "Mühlenstraße",
    "house_number": "122-124",
    "street_line": "Mühlenstraße 122-124",
    "zip": "26789",
    "city": "Leer",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Mühlenstraße 122-124, 26789 Leer, Deutschland",
    "map_query": "Mühlenstraße 122-124, 26789 Leer, Deutschland",
    "maps_query": "Herrenmode Iserlohe, Mühlenstraße 122-124, 26789 Leer, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 247
  },
  {
    "id": "herrenmode-mock-57610-altenkirchen",
    "name": "Herrenmode Mock",
    "type": "Partner Store",
    "street": "Wilhelmstraße",
    "house_number": "51",
    "street_line": "Wilhelmstraße 51",
    "zip": "57610",
    "city": "Altenkirchen",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Wilhelmstraße 51, 57610 Altenkirchen, Deutschland",
    "map_query": "Wilhelmstraße 51, 57610 Altenkirchen, Deutschland",
    "maps_query": "Herrenmode Mock, Wilhelmstraße 51, 57610 Altenkirchen, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 248
  },
  {
    "id": "herrenmode-mock-anger-1-99610-sommerda",
    "name": "Herrenmode Mock Anger 1",
    "type": "Partner Store",
    "street": "Weißenseer Straße",
    "house_number": "1a",
    "street_line": "Weißenseer Straße 1a",
    "zip": "99610",
    "city": "Sömmerda",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Weißenseer Straße 1a, 99610 Sömmerda, Deutschland",
    "map_query": "Weißenseer Straße 1a, 99610 Sömmerda, Deutschland",
    "maps_query": "Herrenmode Mock Anger 1, Weißenseer Straße 1a, 99610 Sömmerda, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 249
  },
  {
    "id": "herrenmode-mock-classic-99084-erfurt",
    "name": "Herrenmode Mock Classic",
    "type": "Partner Store",
    "street": "Anger",
    "house_number": "1",
    "street_line": "Anger 1",
    "zip": "99084",
    "city": "Erfurt",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "",
    "language": "Deutsch",
    "address": "Anger 1, 99084 Erfurt, Deutschland",
    "map_query": "Anger 1, 99084 Erfurt, Deutschland",
    "maps_query": "Herrenmode Mock Classic, Anger 1, 99084 Erfurt, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 250
  },
  {
    "id": "herrenmode-mock-classic-99091-erfurt",
    "name": "Herrenmode Mock Classic",
    "type": "Partner Store",
    "street": "Nordhäuser Str. 73 T",
    "house_number": "",
    "street_line": "Nordhäuser Str. 73 T",
    "zip": "99091",
    "city": "Erfurt",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Nordhäuser Str. 73 T, 99091 Erfurt, Deutschland",
    "map_query": "Herrenmode Mock Classic, Nordhäuser Str. 73 T, 99091 Erfurt, Deutschland",
    "maps_query": "Herrenmode Mock Classic, Nordhäuser Str. 73 T, 99091 Erfurt, Deutschland",
    "note": "Sortiment und Verfügbarkeit können variieren. Adresse bitte vor Besuch über den Händler prüfen.",
    "data_quality": [
      "house_number_missing"
    ],
    "source_row": 251
  },
  {
    "id": "herrenmode-quedlinburg-s-floreck-99091-erfurt",
    "name": "Herrenmode Quedlinburg S. Floreck",
    "type": "Partner Store",
    "street": "Nordhäuser Str.",
    "house_number": "73",
    "street_line": "Nordhäuser Str. 73",
    "zip": "99091",
    "city": "Erfurt",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Nordhäuser Str. 73, 99091 Erfurt, Deutschland",
    "map_query": "Nordhäuser Str. 73, 99091 Erfurt, Deutschland",
    "maps_query": "Herrenmode Quedlinburg S. Floreck, Nordhäuser Str. 73, 99091 Erfurt, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 252
  },
  {
    "id": "herrenmode-sesterhenn-08340-schwarzenberg",
    "name": "Herrenmode Sesterhenn",
    "type": "Partner Store",
    "street": "Bahnhofstrasse",
    "house_number": "15a",
    "street_line": "Bahnhofstrasse 15a",
    "zip": "08340",
    "city": "Schwarzenberg",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Bahnhofstrasse 15a, 08340 Schwarzenberg, Deutschland",
    "map_query": "Bahnhofstrasse 15a, 08340 Schwarzenberg, Deutschland",
    "maps_query": "Herrenmode Sesterhenn, Bahnhofstrasse 15a, 08340 Schwarzenberg, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 253
  },
  {
    "id": "herrenmode-weckwerth-50996-koln",
    "name": "Herrenmode Weckwerth",
    "type": "Partner Store",
    "street": "Hauptstraße",
    "house_number": "82-84",
    "street_line": "Hauptstraße 82-84",
    "zip": "50996",
    "city": "Köln",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Hauptstraße 82-84, 50996 Köln, Deutschland",
    "map_query": "Hauptstraße 82-84, 50996 Köln, Deutschland",
    "maps_query": "Herrenmode Weckwerth, Hauptstraße 82-84, 50996 Köln, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 254
  },
  {
    "id": "herrenmodehuis-schulte-hillegom-01662-meien",
    "name": "Herrenmodehuis Schulte Hillegom",
    "type": "Partner Store",
    "street": "Burgstr.",
    "house_number": "30",
    "street_line": "Burgstr. 30",
    "zip": "01662",
    "city": "Meißen",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "The Netherlands",
    "language": "Englisch",
    "address": "Burgstr. 30, 01662 Meißen, Deutschland",
    "map_query": "Burgstr. 30, 01662 Meißen, Deutschland",
    "maps_query": "Herrenmodehuis Schulte Hillegom, Burgstr. 30, 01662 Meißen, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 255
  },
  {
    "id": "herrenmoden-egeling-gmbh-2353-ts-leiderdorp",
    "name": "Herrenmoden Egeling GmbH",
    "type": "Partner Store",
    "street": "Winkelhof",
    "house_number": "31",
    "street_line": "Winkelhof 31",
    "zip": "2353 TS",
    "city": "Leiderdorp",
    "country": "The Netherlands",
    "country_label": "Niederlande",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Winkelhof 31, 2353 TS Leiderdorp, Niederlande",
    "map_query": "Winkelhof 31, 2353 TS Leiderdorp, Niederlande",
    "maps_query": "Herrenmoden Egeling GmbH, Winkelhof 31, 2353 TS Leiderdorp, Niederlande",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 256
  },
  {
    "id": "herrenmoden-hmn-e-k-46499-hamminkeln-dingden",
    "name": "Herrenmoden HMN e.K.",
    "type": "Partner Store",
    "street": "Weberstraße",
    "house_number": "13",
    "street_line": "Weberstraße 13",
    "zip": "46499",
    "city": "Hamminkeln-Dingden",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Weberstraße 13, 46499 Hamminkeln-Dingden, Deutschland",
    "map_query": "Weberstraße 13, 46499 Hamminkeln-Dingden, Deutschland",
    "maps_query": "Herrenmoden HMN e.K., Weberstraße 13, 46499 Hamminkeln-Dingden, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 257
  },
  {
    "id": "herrenmoden-iserlohe-gmbh-53359-rheinbach",
    "name": "Herrenmoden Iserlohe GmbH",
    "type": "Partner Store",
    "street": "Vor dem Voigtstor",
    "house_number": "13",
    "street_line": "Vor dem Voigtstor 13",
    "zip": "53359",
    "city": "Rheinbach",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Vor dem Voigtstor 13, 53359 Rheinbach, Deutschland",
    "map_query": "Vor dem Voigtstor 13, 53359 Rheinbach, Deutschland",
    "maps_query": "Herrenmoden Iserlohe GmbH, Vor dem Voigtstor 13, 53359 Rheinbach, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 258
  },
  {
    "id": "herrenmoden-michelberger-57610-altenkirchen",
    "name": "Herrenmoden Michelberger",
    "type": "Partner Store",
    "street": "Wilhelmstraße",
    "house_number": "51",
    "street_line": "Wilhelmstraße 51",
    "zip": "57610",
    "city": "Altenkirchen",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Wilhelmstraße 51, 57610 Altenkirchen, Deutschland",
    "map_query": "Wilhelmstraße 51, 57610 Altenkirchen, Deutschland",
    "maps_query": "Herrenmoden Michelberger, Wilhelmstraße 51, 57610 Altenkirchen, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 259
  },
  {
    "id": "herrenmoden-rettich-88410-bad-wurzach",
    "name": "Herrenmoden Rettich",
    "type": "Partner Store",
    "street": "Marktstr.",
    "house_number": "1-3",
    "street_line": "Marktstr. 1-3",
    "zip": "88410",
    "city": "Bad Wurzach",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Marktstr. 1-3, 88410 Bad Wurzach, Deutschland",
    "map_query": "Marktstr. 1-3, 88410 Bad Wurzach, Deutschland",
    "maps_query": "Herrenmoden Rettich, Marktstr. 1-3, 88410 Bad Wurzach, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 260
  },
  {
    "id": "herrmanns-neue-kleider-e-k-14467-potsdam",
    "name": "Herrmanns neue Kleider e.K.",
    "type": "Partner Store",
    "street": "Brandenburger Strasse",
    "house_number": "69",
    "street_line": "Brandenburger Strasse 69",
    "zip": "14467",
    "city": "Potsdam",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Brandenburger Strasse 69, 14467 Potsdam, Deutschland",
    "map_query": "Brandenburger Strasse 69, 14467 Potsdam, Deutschland",
    "maps_query": "Herrmanns neue Kleider e.K., Brandenburger Strasse 69, 14467 Potsdam, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 261
  },
  {
    "id": "hertle-mann-und-mode-72581-dettingen",
    "name": "Hertle - Mann & Mode",
    "type": "Partner Store",
    "street": "Uracher Str",
    "house_number": "9",
    "street_line": "Uracher Str 9",
    "zip": "72581",
    "city": "Dettingen",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Uracher Str 9, 72581 Dettingen, Deutschland",
    "map_query": "Uracher Str 9, 72581 Dettingen, Deutschland",
    "maps_query": "Hertle - Mann & Mode, Uracher Str 9, 72581 Dettingen, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 262
  },
  {
    "id": "het-pakhuis-mannenmode-89407-dillingen",
    "name": "Het Pakhuis Mannenmode",
    "type": "Partner Store",
    "street": "Kapuzinerstr.",
    "house_number": "22",
    "street_line": "Kapuzinerstr. 22",
    "zip": "89407",
    "city": "Dillingen",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "The Netherlands",
    "language": "Englisch",
    "address": "Kapuzinerstr. 22, 89407 Dillingen, Deutschland",
    "map_query": "Kapuzinerstr. 22, 89407 Dillingen, Deutschland",
    "maps_query": "Het Pakhuis Mannenmode, Kapuzinerstr. 22, 89407 Dillingen, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 263
  },
  {
    "id": "hinzen-herrenmoden-80331-munchen",
    "name": "Hinzen Herrenmoden",
    "type": "Partner Store",
    "street": "Rindermarkt",
    "house_number": "10",
    "street_line": "Rindermarkt 10",
    "zip": "80331",
    "city": "München",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Rindermarkt 10, 80331 München, Deutschland",
    "map_query": "Rindermarkt 10, 80331 München, Deutschland",
    "maps_query": "Hinzen Herrenmoden, Rindermarkt 10, 80331 München, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 264
  },
  {
    "id": "hoffmeyer-gmbh-und-co-kg-9051be-stiens",
    "name": "Hoffmeyer GmbH & Co. KG",
    "type": "Partner Store",
    "street": "Langebuorren",
    "house_number": "29",
    "street_line": "Langebuorren 29",
    "zip": "9051BE",
    "city": "Stiens",
    "country": "The Netherlands",
    "country_label": "Niederlande",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Langebuorren 29, 9051BE Stiens, Niederlande",
    "map_query": "Langebuorren 29, 9051BE Stiens, Niederlande",
    "maps_query": "Hoffmeyer GmbH & Co. KG, Langebuorren 29, 9051BE Stiens, Niederlande",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 265
  },
  {
    "id": "hoffmeyer-gmbh-und-co-kg-78727-oberndorf-a-n",
    "name": "Hoffmeyer GmbH & Co.KG",
    "type": "Partner Store",
    "street": "Langer Weg",
    "house_number": "18",
    "street_line": "Langer Weg 18",
    "zip": "78727",
    "city": "Oberndorf a.N.",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Langer Weg 18, 78727 Oberndorf a.N., Deutschland",
    "map_query": "Langer Weg 18, 78727 Oberndorf a.N., Deutschland",
    "maps_query": "Hoffmeyer GmbH & Co.KG, Langer Weg 18, 78727 Oberndorf a.N., Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 266
  },
  {
    "id": "hofmann-gmbh-78628-rottweil",
    "name": "Hofmann GmbH",
    "type": "Partner Store",
    "street": "Friedrichsplatz",
    "house_number": "2",
    "street_line": "Friedrichsplatz 2",
    "zip": "78628",
    "city": "Rottweil",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Friedrichsplatz 2, 78628 Rottweil, Deutschland",
    "map_query": "Friedrichsplatz 2, 78628 Rottweil, Deutschland",
    "maps_query": "Hofmann GmbH, Friedrichsplatz 2, 78628 Rottweil, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 267
  },
  {
    "id": "hohmann-und-heil-textilvertriebsgesellschaft-mbh-88471-laupheim",
    "name": "Hohmann & Heil Textilvertriebsgesellschaft mbH",
    "type": "Partner Store",
    "street": "Mittelstr.",
    "house_number": "12",
    "street_line": "Mittelstr. 12",
    "zip": "88471",
    "city": "Laupheim",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Mittelstr. 12, 88471 Laupheim, Deutschland",
    "map_query": "Mittelstr. 12, 88471 Laupheim, Deutschland",
    "maps_query": "Hohmann & Heil Textilvertriebsgesellschaft mbH, Mittelstr. 12, 88471 Laupheim, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 268
  },
  {
    "id": "hoogenboom-men-47051-duisburg",
    "name": "Hoogenboom Men",
    "type": "Partner Store",
    "street": "Sonnenwall",
    "house_number": "9",
    "street_line": "Sonnenwall 9",
    "zip": "47051",
    "city": "Duisburg",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "The Netherlands",
    "language": "Englisch",
    "address": "Sonnenwall 9, 47051 Duisburg, Deutschland",
    "map_query": "Sonnenwall 9, 47051 Duisburg, Deutschland",
    "maps_query": "Hoogenboom Men, Sonnenwall 9, 47051 Duisburg, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 269
  },
  {
    "id": "hootsen-kleding-6511-hk-nijmegen",
    "name": "Hootsen Kleding",
    "type": "Partner Store",
    "street": "Molenstraat",
    "house_number": "106-108",
    "street_line": "Molenstraat 106-108",
    "zip": "6511 HK",
    "city": "Nijmegen",
    "country": "The Netherlands",
    "country_label": "Niederlande",
    "region": "The Netherlands",
    "language": "Englisch",
    "address": "Molenstraat 106-108, 6511 HK Nijmegen, Niederlande",
    "map_query": "Molenstraat 106-108, 6511 HK Nijmegen, Niederlande",
    "maps_query": "Hootsen Kleding, Molenstraat 106-108, 6511 HK Nijmegen, Niederlande",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 270
  },
  {
    "id": "hosen-sacco-etage-3774-bn-kootwijkerbroek",
    "name": "Hosen Sacco Etage",
    "type": "Partner Store",
    "street": "Veluweweg",
    "house_number": "66",
    "street_line": "Veluweweg 66",
    "zip": "3774 BN",
    "city": "Kootwijkerbroek",
    "country": "The Netherlands",
    "country_label": "Niederlande",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Veluweweg 66, 3774 BN Kootwijkerbroek, Niederlande",
    "map_query": "Veluweweg 66, 3774 BN Kootwijkerbroek, Niederlande",
    "maps_query": "Hosen Sacco Etage, Veluweweg 66, 3774 BN Kootwijkerbroek, Niederlande",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 271
  },
  {
    "id": "houtman-mode-42103-wuppertal",
    "name": "Houtman Mode",
    "type": "Partner Store",
    "street": "Neumarktstraße",
    "house_number": "36",
    "street_line": "Neumarktstraße 36",
    "zip": "42103",
    "city": "Wuppertal",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "The Netherlands",
    "language": "Englisch",
    "address": "Neumarktstraße 36, 42103 Wuppertal, Deutschland",
    "map_query": "Neumarktstraße 36, 42103 Wuppertal, Deutschland",
    "maps_query": "Houtman Mode, Neumarktstraße 36, 42103 Wuppertal, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 272
  },
  {
    "id": "hovel-herrenmoden-7941-aj-meppel",
    "name": "Hövel-Herrenmoden",
    "type": "Partner Store",
    "street": "Hoofdstraat",
    "house_number": "46",
    "street_line": "Hoofdstraat 46",
    "zip": "7941 AJ",
    "city": "Meppel",
    "country": "The Netherlands",
    "country_label": "Niederlande",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Hoofdstraat 46, 7941 AJ Meppel, Niederlande",
    "map_query": "Hoofdstraat 46, 7941 AJ Meppel, Niederlande",
    "maps_query": "Hövel-Herrenmoden, Hoofdstraat 46, 7941 AJ Meppel, Niederlande",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 273
  },
  {
    "id": "hugo-wusthoff-gmbh-und-co-kg-33098-paderborn",
    "name": "Hugo Wüsthoff GmbH & Co. KG",
    "type": "Partner Store",
    "street": "Rosenstraße",
    "house_number": "6",
    "street_line": "Rosenstraße 6",
    "zip": "33098",
    "city": "Paderborn",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Rosenstraße 6, 33098 Paderborn, Deutschland",
    "map_query": "Rosenstraße 6, 33098 Paderborn, Deutschland",
    "maps_query": "Hugo Wüsthoff GmbH & Co. KG, Rosenstraße 6, 33098 Paderborn, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 274
  },
  {
    "id": "hut-jansen-49074-osnabruck",
    "name": "Hut Jansen",
    "type": "Partner Store",
    "street": "Georgstr.",
    "house_number": "6",
    "street_line": "Georgstr. 6",
    "zip": "49074",
    "city": "Osnabrück",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Georgstr. 6, 49074 Osnabrück, Deutschland",
    "map_query": "Georgstr. 6, 49074 Osnabrück, Deutschland",
    "maps_query": "Hut Jansen, Georgstr. 6, 49074 Osnabrück, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 275
  },
  {
    "id": "huth-fricke-e-k-41812-erkelenz",
    "name": "Huth + Fricke e.K",
    "type": "Partner Store",
    "street": "Kölner Straße",
    "house_number": "15",
    "street_line": "Kölner Straße 15",
    "zip": "41812",
    "city": "Erkelenz",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Kölner Straße 15, 41812 Erkelenz, Deutschland",
    "map_query": "Kölner Straße 15, 41812 Erkelenz, Deutschland",
    "maps_query": "Huth + Fricke e.K, Kölner Straße 15, 41812 Erkelenz, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 276
  },
  {
    "id": "hutmanufaktur-theodor-zwicker-29439-luchow",
    "name": "Hutmanufaktur Theodor Zwicker",
    "type": "Partner Store",
    "street": "Lange Str.",
    "house_number": "13",
    "street_line": "Lange Str. 13",
    "zip": "29439",
    "city": "Lüchow",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Lange Str. 13, 29439 Lüchow, Deutschland",
    "map_query": "Lange Str. 13, 29439 Lüchow, Deutschland",
    "maps_query": "Hutmanufaktur Theodor Zwicker, Lange Str. 13, 29439 Lüchow, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 277
  },
  {
    "id": "hype-nv-trendwalk-78462-konstanz",
    "name": "Hype NV - Trendwalk",
    "type": "Partner Store",
    "street": "Rosgartenstrasse",
    "house_number": "32",
    "street_line": "Rosgartenstrasse 32",
    "zip": "78462",
    "city": "Konstanz",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Belgium",
    "language": "Englisch",
    "address": "Rosgartenstrasse 32, 78462 Konstanz, Deutschland",
    "map_query": "Rosgartenstrasse 32, 78462 Konstanz, Deutschland",
    "maps_query": "Hype NV - Trendwalk, Rosgartenstrasse 32, 78462 Konstanz, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 278
  },
  {
    "id": "icon-bvba-8940-lauwe",
    "name": "Icon BVBA",
    "type": "Partner Store",
    "street": "Schonekeerstraat",
    "house_number": "183A",
    "street_line": "Schonekeerstraat 183A",
    "zip": "8940",
    "city": "Lauwe",
    "country": "Belgium",
    "country_label": "Belgien",
    "region": "Belgium",
    "language": "Englisch",
    "address": "Schonekeerstraat 183A, 8940 Lauwe, Belgien",
    "map_query": "Schonekeerstraat 183A, 8940 Lauwe, Belgien",
    "maps_query": "Icon BVBA, Schonekeerstraat 183A, 8940 Lauwe, Belgien",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 279
  },
  {
    "id": "ignaz-stenger-gmbh-und-co-kg-3500-hasselt",
    "name": "Ignaz Stenger GmbH & Co. KG",
    "type": "Partner Store",
    "street": "Aldestraat",
    "house_number": "38",
    "street_line": "Aldestraat 38",
    "zip": "3500",
    "city": "Hasselt",
    "country": "Belgium",
    "country_label": "Belgien",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Aldestraat 38, 3500 Hasselt, Belgien",
    "map_query": "Aldestraat 38, 3500 Hasselt, Belgien",
    "maps_query": "Ignaz Stenger GmbH & Co. KG, Aldestraat 38, 3500 Hasselt, Belgien",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 280
  },
  {
    "id": "imania-78349-siauliai",
    "name": "Imania",
    "type": "Partner Store",
    "street": "Pailiu",
    "house_number": "6B-12",
    "street_line": "Pailiu 6B-12",
    "zip": "78349",
    "city": "Siauliai",
    "country": "Lithuania",
    "country_label": "Lithuania",
    "region": "Belgium",
    "language": "Englisch",
    "address": "Pailiu 6B-12, 78349 Siauliai, Lithuania",
    "map_query": "Pailiu 6B-12, 78349 Siauliai, Lithuania",
    "maps_query": "Imania, Pailiu 6B-12, 78349 Siauliai, Lithuania",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 281
  },
  {
    "id": "imi-mode-9470-denderleeuw",
    "name": "IMI Mode",
    "type": "Partner Store",
    "street": "Steenweg",
    "house_number": "548",
    "street_line": "Steenweg 548",
    "zip": "9470",
    "city": "Denderleeuw",
    "country": "Belgium",
    "country_label": "Belgien",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Steenweg 548, 9470 Denderleeuw, Belgien",
    "map_query": "Steenweg 548, 9470 Denderleeuw, Belgien",
    "maps_query": "IMI Mode, Steenweg 548, 9470 Denderleeuw, Belgien",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 282
  },
  {
    "id": "it-s-you-82538-geretsried",
    "name": "IT'S YOU",
    "type": "Partner Store",
    "street": "Egerlandstraße",
    "house_number": "47",
    "street_line": "Egerlandstraße 47",
    "zip": "82538",
    "city": "Geretsried",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "The Netherlands",
    "language": "Englisch",
    "address": "Egerlandstraße 47, 82538 Geretsried, Deutschland",
    "map_query": "Egerlandstraße 47, 82538 Geretsried, Deutschland",
    "maps_query": "IT'S YOU, Egerlandstraße 47, 82538 Geretsried, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 283
  },
  {
    "id": "j-n-oberpaur-gmbh-und-co-kg-landshut-9170-de-klinge",
    "name": "J.N. Oberpaur GmbH & Co. KG - Landshut",
    "type": "Partner Store",
    "street": "KLINGEDORP",
    "house_number": "13",
    "street_line": "KLINGEDORP 13",
    "zip": "9170",
    "city": "DE KLINGE",
    "country": "Belgium",
    "country_label": "Belgien",
    "region": "Germany",
    "language": "Deutsch",
    "address": "KLINGEDORP 13, 9170 DE KLINGE, Belgien",
    "map_query": "KLINGEDORP 13, 9170 DE KLINGE, Belgien",
    "maps_query": "J.N. Oberpaur GmbH & Co. KG - Landshut, KLINGEDORP 13, 9170 DE KLINGE, Belgien",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 284
  },
  {
    "id": "j-n-oberpaur-gmbh-und-co-kg-ludwigsburg-84028-landshut",
    "name": "J.N. Oberpaur GmbH & Co. KG - Ludwigsburg",
    "type": "Partner Store",
    "street": "Altstadt",
    "house_number": "52-54",
    "street_line": "Altstadt 52-54",
    "zip": "84028",
    "city": "Landshut",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "",
    "language": "Englisch",
    "address": "Altstadt 52-54, 84028 Landshut, Deutschland",
    "map_query": "Altstadt 52-54, 84028 Landshut, Deutschland",
    "maps_query": "J.N. Oberpaur GmbH & Co. KG - Ludwigsburg, Altstadt 52-54, 84028 Landshut, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 285
  },
  {
    "id": "jacob-mannenmode-7554-tw-hengelo",
    "name": "Jacob Mannenmode",
    "type": "Partner Store",
    "street": "Spinelstraat",
    "house_number": "3",
    "street_line": "Spinelstraat 3",
    "zip": "7554 TW",
    "city": "Hengelo",
    "country": "The Netherlands",
    "country_label": "Niederlande",
    "region": "The Netherlands",
    "language": "Englisch",
    "address": "Spinelstraat 3, 7554 TW Hengelo, Niederlande",
    "map_query": "Spinelstraat 3, 7554 TW Hengelo, Niederlande",
    "maps_query": "Jacob Mannenmode, Spinelstraat 3, 7554 TW Hengelo, Niederlande",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 286
  },
  {
    "id": "jacobs-mode-8911-ck-leeuwarden",
    "name": "Jacobs Mode",
    "type": "Partner Store",
    "street": "Nieuwestad",
    "house_number": "73",
    "street_line": "Nieuwestad 73",
    "zip": "8911 CK",
    "city": "Leeuwarden",
    "country": "The Netherlands",
    "country_label": "Niederlande",
    "region": "Belgium",
    "language": "Englisch",
    "address": "Nieuwestad 73, 8911 CK Leeuwarden, Niederlande",
    "map_query": "Nieuwestad 73, 8911 CK Leeuwarden, Niederlande",
    "maps_query": "Jacobs Mode, Nieuwestad 73, 8911 CK Leeuwarden, Niederlande",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 287
  },
  {
    "id": "jan-de-cock-mode-3945-ham",
    "name": "Jan de cock Mode",
    "type": "Partner Store",
    "street": "Bevrijdingsstraat",
    "house_number": "9",
    "street_line": "Bevrijdingsstraat 9",
    "zip": "3945",
    "city": "Ham",
    "country": "Belgium",
    "country_label": "Belgien",
    "region": "The Netherlands",
    "language": "Englisch",
    "address": "Bevrijdingsstraat 9, 3945 Ham, Belgien",
    "map_query": "Bevrijdingsstraat 9, 3945 Ham, Belgien",
    "maps_query": "Jan de cock Mode, Bevrijdingsstraat 9, 3945 Ham, Belgien",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 288
  },
  {
    "id": "jan-s-shop-mode-bv-8911-jb-leeuwarden",
    "name": "Jan's shop Mode BV",
    "type": "Partner Store",
    "street": "Groentemarkt",
    "house_number": "11",
    "street_line": "Groentemarkt 11",
    "zip": "8911 JB",
    "city": "Leeuwarden",
    "country": "The Netherlands",
    "country_label": "Niederlande",
    "region": "The Netherlands",
    "language": "Englisch",
    "address": "Groentemarkt 11, 8911 JB Leeuwarden, Niederlande",
    "map_query": "Groentemarkt 11, 8911 JB Leeuwarden, Niederlande",
    "maps_query": "Jan's shop Mode BV, Groentemarkt 11, 8911 JB Leeuwarden, Niederlande",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 289
  },
  {
    "id": "jansen-noy-6641-ct-beuningen",
    "name": "Jansen-Noy",
    "type": "Partner Store",
    "street": "Julianaplein",
    "house_number": "164",
    "street_line": "Julianaplein 164",
    "zip": "6641 CT",
    "city": "Beuningen",
    "country": "The Netherlands",
    "country_label": "Niederlande",
    "region": "The Netherlands",
    "language": "Englisch",
    "address": "Julianaplein 164, 6641 CT Beuningen, Niederlande",
    "map_query": "Julianaplein 164, 6641 CT Beuningen, Niederlande",
    "maps_query": "Jansen-Noy, Julianaplein 164, 6641 CT Beuningen, Niederlande",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 290
  },
  {
    "id": "jitse-fashion-5975-rr-sevenum",
    "name": "Jitse Fashion",
    "type": "Partner Store",
    "street": "Deckersgoedtweg",
    "house_number": "6",
    "street_line": "Deckersgoedtweg 6",
    "zip": "5975 RR",
    "city": "Sevenum",
    "country": "The Netherlands",
    "country_label": "Niederlande",
    "region": "The Netherlands",
    "language": "Englisch",
    "address": "Deckersgoedtweg 6, 5975 RR Sevenum, Niederlande",
    "map_query": "Deckersgoedtweg 6, 5975 RR Sevenum, Niederlande",
    "maps_query": "Jitse Fashion, Deckersgoedtweg 6, 5975 RR Sevenum, Niederlande",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 291
  },
  {
    "id": "jo-fashion-bvba-600-akureyri",
    "name": "Jo Fashion BVBA",
    "type": "Partner Store",
    "street": "Gránufélagsgata",
    "house_number": "4",
    "street_line": "Gránufélagsgata 4",
    "zip": "600",
    "city": "Akureyri",
    "country": "Iceland",
    "country_label": "Iceland",
    "region": "Belgium",
    "language": "Englisch",
    "address": "Gránufélagsgata 4, 600 Akureyri, Iceland",
    "map_query": "Gránufélagsgata 4, 600 Akureyri, Iceland",
    "maps_query": "Jo Fashion BVBA, Gránufélagsgata 4, 600 Akureyri, Iceland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 292
  },
  {
    "id": "jo-jansen-herenmode-8020-oostkamp",
    "name": "Jo Jansen Herenmode",
    "type": "Partner Store",
    "street": "Kortrijksestraat",
    "house_number": "49",
    "street_line": "Kortrijksestraat 49",
    "zip": "8020",
    "city": "Oostkamp",
    "country": "Belgium",
    "country_label": "Belgien",
    "region": "The Netherlands",
    "language": "Englisch",
    "address": "Kortrijksestraat 49, 8020 Oostkamp, Belgien",
    "map_query": "Kortrijksestraat 49, 8020 Oostkamp, Belgien",
    "maps_query": "Jo Jansen Herenmode, Kortrijksestraat 49, 8020 Oostkamp, Belgien",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 293
  },
  {
    "id": "jo-mode-7607-cg-almelo",
    "name": "Jo Mode",
    "type": "Partner Store",
    "street": "Grotestraat",
    "house_number": "101",
    "street_line": "Grotestraat 101",
    "zip": "7607 CG",
    "city": "Almelo",
    "country": "The Netherlands",
    "country_label": "Niederlande",
    "region": "Belgium",
    "language": "Englisch",
    "address": "Grotestraat 101, 7607 CG Almelo, Niederlande",
    "map_query": "Grotestraat 101, 7607 CG Almelo, Niederlande",
    "maps_query": "Jo Mode, Grotestraat 101, 7607 CG Almelo, Niederlande",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 294
  },
  {
    "id": "joy-house-of-brands-9080-lochristi",
    "name": "Joy House of Brands",
    "type": "Partner Store",
    "street": "Antwerpsesteenweg",
    "house_number": "52",
    "street_line": "Antwerpsesteenweg 52",
    "zip": "9080",
    "city": "Lochristi",
    "country": "Belgium",
    "country_label": "Belgien",
    "region": "The Netherlands",
    "language": "Englisch",
    "address": "Antwerpsesteenweg 52, 9080 Lochristi, Belgien",
    "map_query": "Antwerpsesteenweg 52, 9080 Lochristi, Belgien",
    "maps_query": "Joy House of Brands, Antwerpsesteenweg 52, 9080 Lochristi, Belgien",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 295
  },
  {
    "id": "juhasz-gmbh-und-co-kg-9301az-roden",
    "name": "Juhasz GmbH & Co. KG",
    "type": "Partner Store",
    "street": "Albertsbaan",
    "house_number": "58",
    "street_line": "Albertsbaan 58",
    "zip": "9301AZ",
    "city": "Roden",
    "country": "The Netherlands",
    "country_label": "Niederlande",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Albertsbaan 58, 9301AZ Roden, Niederlande",
    "map_query": "Albertsbaan 58, 9301AZ Roden, Niederlande",
    "maps_query": "Juhasz GmbH & Co. KG, Albertsbaan 58, 9301AZ Roden, Niederlande",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 296
  },
  {
    "id": "julien-mannenmode-83435-bad-reichenhall",
    "name": "Julien Mannenmode",
    "type": "Partner Store",
    "street": "Ludwigstraße",
    "house_number": "23",
    "street_line": "Ludwigstraße 23",
    "zip": "83435",
    "city": "Bad Reichenhall",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Belgium",
    "language": "Englisch",
    "address": "Ludwigstraße 23, 83435 Bad Reichenhall, Deutschland",
    "map_query": "Ludwigstraße 23, 83435 Bad Reichenhall, Deutschland",
    "maps_query": "Julien Mannenmode, Ludwigstraße 23, 83435 Bad Reichenhall, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 297
  },
  {
    "id": "k-und-k-mode-fur-manner-2870-puurs",
    "name": "K&K Mode für Männer",
    "type": "Partner Store",
    "street": "Stationsstraat",
    "house_number": "14",
    "street_line": "Stationsstraat 14",
    "zip": "2870",
    "city": "Puurs",
    "country": "Belgium",
    "country_label": "Belgien",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Stationsstraat 14, 2870 Puurs, Belgien",
    "map_query": "Stationsstraat 14, 2870 Puurs, Belgien",
    "maps_query": "K&K Mode für Männer, Stationsstraat 14, 2870 Puurs, Belgien",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 298
  },
  {
    "id": "karl-jung-gmbh-und-co-kg-37154-northeim",
    "name": "Karl Jung GmbH & Co. KG",
    "type": "Partner Store",
    "street": "Bahnhofstraße",
    "house_number": "5",
    "street_line": "Bahnhofstraße 5",
    "zip": "37154",
    "city": "Northeim",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Bahnhofstraße 5, 37154 Northeim, Deutschland",
    "map_query": "Bahnhofstraße 5, 37154 Northeim, Deutschland",
    "maps_query": "Karl Jung GmbH & Co. KG, Bahnhofstraße 5, 37154 Northeim, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 299
  },
  {
    "id": "karl-manhenke-gmbh-und-co-kg-86153-augsburg",
    "name": "Karl Manhenke GmbH & Co. KG",
    "type": "Partner Store",
    "street": "Wertachstrasse",
    "house_number": "1",
    "street_line": "Wertachstrasse 1",
    "zip": "86153",
    "city": "Augsburg",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Wertachstrasse 1, 86153 Augsburg, Deutschland",
    "map_query": "Wertachstrasse 1, 86153 Augsburg, Deutschland",
    "maps_query": "Karl Manhenke GmbH & Co. KG, Wertachstrasse 1, 86153 Augsburg, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 300
  },
  {
    "id": "kaufhaus-bauer-gmbh-34497-korbach",
    "name": "Kaufhaus Bauer GmbH",
    "type": "Partner Store",
    "street": "Am Berndorfer Tor",
    "house_number": "4",
    "street_line": "Am Berndorfer Tor 4",
    "zip": "34497",
    "city": "Korbach",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Am Berndorfer Tor 4, 34497 Korbach, Deutschland",
    "map_query": "Am Berndorfer Tor 4, 34497 Korbach, Deutschland",
    "maps_query": "Kaufhaus Bauer GmbH, Am Berndorfer Tor 4, 34497 Korbach, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 301
  },
  {
    "id": "kaufhaus-may-94209-regen",
    "name": "Kaufhaus May",
    "type": "Partner Store",
    "street": "Zwieseler Str",
    "house_number": "23",
    "street_line": "Zwieseler Str 23",
    "zip": "94209",
    "city": "Regen",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Zwieseler Str 23, 94209 Regen, Deutschland",
    "map_query": "Zwieseler Str 23, 94209 Regen, Deutschland",
    "maps_query": "Kaufhaus May, Zwieseler Str 23, 94209 Regen, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 302
  },
  {
    "id": "kaufhaus-rudolf-kochler-79761-waldshut-tiengen",
    "name": "Kaufhaus Rudolf Kochler",
    "type": "Partner Store",
    "street": "Hauptstr.",
    "house_number": "22",
    "street_line": "Hauptstr. 22",
    "zip": "79761",
    "city": "Waldshut-Tiengen",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Hauptstr. 22, 79761 Waldshut-Tiengen, Deutschland",
    "map_query": "Hauptstr. 22, 79761 Waldshut-Tiengen, Deutschland",
    "maps_query": "Kaufhaus Rudolf Kochler, Hauptstr. 22, 79761 Waldshut-Tiengen, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 303
  },
  {
    "id": "kausen-mode-86609-donauworth",
    "name": "Kausen Mode",
    "type": "Partner Store",
    "street": "Bahnhofstraße",
    "house_number": "12",
    "street_line": "Bahnhofstraße 12",
    "zip": "86609",
    "city": "Donauwörth",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Bahnhofstraße 12, 86609 Donauwörth, Deutschland",
    "map_query": "Bahnhofstraße 12, 86609 Donauwörth, Deutschland",
    "maps_query": "Kausen Mode, Bahnhofstraße 12, 86609 Donauwörth, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 304
  },
  {
    "id": "kerschgens-mode-fur-manner-8911cj-leeuwarden",
    "name": "Kerschgens Mode für Männer",
    "type": "Partner Store",
    "street": "Nieuwestad",
    "house_number": "45",
    "street_line": "Nieuwestad 45",
    "zip": "8911CJ",
    "city": "Leeuwarden",
    "country": "The Netherlands",
    "country_label": "Niederlande",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Nieuwestad 45, 8911CJ Leeuwarden, Niederlande",
    "map_query": "Nieuwestad 45, 8911CJ Leeuwarden, Niederlande",
    "maps_query": "Kerschgens Mode für Männer, Nieuwestad 45, 8911CJ Leeuwarden, Niederlande",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 305
  },
  {
    "id": "king-kleding-47167-duisburg",
    "name": "King kleding",
    "type": "Partner Store",
    "street": "Holtenerstrasse",
    "house_number": "208-210",
    "street_line": "Holtenerstrasse 208-210",
    "zip": "47167",
    "city": "Duisburg",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "The Netherlands",
    "language": "Englisch",
    "address": "Holtenerstrasse 208-210, 47167 Duisburg, Deutschland",
    "map_query": "Holtenerstrasse 208-210, 47167 Duisburg, Deutschland",
    "maps_query": "King kleding, Holtenerstrasse 208-210, 47167 Duisburg, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 306
  },
  {
    "id": "klamar-s-fashion-by-robbert-v-o-f-9231-ct-surhuisterveen",
    "name": "Klämar's Fashion by Robbert V.O.F.",
    "type": "Partner Store",
    "street": "De Kolk",
    "house_number": "15a",
    "street_line": "De Kolk 15a",
    "zip": "9231",
    "city": "CT Surhuisterveen",
    "country": "The Netherlands",
    "country_label": "Niederlande",
    "region": "The Netherlands",
    "language": "Englisch",
    "address": "De Kolk 15a, 9231 CT Surhuisterveen, Niederlande",
    "map_query": "De Kolk 15a, 9231 CT Surhuisterveen, Niederlande",
    "maps_query": "Klämar's Fashion by Robbert V.O.F., De Kolk 15a, 9231 CT Surhuisterveen, Niederlande",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 307
  },
  {
    "id": "klaus-dieter-mutzel-gmbh-und-co-kg-34-700-rabka-zdroj",
    "name": "Klaus-Dieter Mützel GmbH & Co. KG",
    "type": "Partner Store",
    "street": "Rynek",
    "house_number": "12",
    "street_line": "Rynek 12",
    "zip": "34-700",
    "city": "Rabka Zdroj",
    "country": "Poland",
    "country_label": "Poland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Rynek 12, 34-700 Rabka Zdroj, Poland",
    "map_query": "Rynek 12, 34-700 Rabka Zdroj, Poland",
    "maps_query": "Klaus-Dieter Mützel GmbH & Co. KG, Rynek 12, 34-700 Rabka Zdroj, Poland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 308
  },
  {
    "id": "kleiderzimmer-97717-euerdorf",
    "name": "Kleiderzimmer",
    "type": "Partner Store",
    "street": "Schweinfurter Str.",
    "house_number": "6-10",
    "street_line": "Schweinfurter Str. 6-10",
    "zip": "97717",
    "city": "Euerdorf",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Switzerland",
    "language": "Englisch",
    "address": "Schweinfurter Str. 6-10, 97717 Euerdorf, Deutschland",
    "map_query": "Schweinfurter Str. 6-10, 97717 Euerdorf, Deutschland",
    "maps_query": "Kleiderzimmer, Schweinfurter Str. 6-10, 97717 Euerdorf, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 309
  },
  {
    "id": "klein-londen-bv-6421-lyssach",
    "name": "KLEIN LONDEN BV",
    "type": "Partner Store",
    "street": "Kernenriedstrasse",
    "house_number": "1",
    "street_line": "Kernenriedstrasse 1",
    "zip": "6421",
    "city": "Lyssach",
    "country": "Switzerland",
    "country_label": "Schweiz",
    "region": "Belgium",
    "language": "Englisch",
    "address": "Kernenriedstrasse 1, 6421 Lyssach, Schweiz",
    "map_query": "Kernenriedstrasse 1, 6421 Lyssach, Schweiz",
    "maps_query": "KLEIN LONDEN BV, Kernenriedstrasse 1, 6421 Lyssach, Schweiz",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 310
  },
  {
    "id": "kleske-3881-bd-putten",
    "name": "Kleske",
    "type": "Partner Store",
    "street": "Dorpsstraat",
    "house_number": "6",
    "street_line": "Dorpsstraat 6",
    "zip": "3881 BD",
    "city": "Putten",
    "country": "The Netherlands",
    "country_label": "Niederlande",
    "region": "Belgium",
    "language": "Englisch",
    "address": "Dorpsstraat 6, 3881 BD Putten, Niederlande",
    "map_query": "Dorpsstraat 6, 3881 BD Putten, Niederlande",
    "maps_query": "Kleske, Dorpsstraat 6, 3881 BD Putten, Niederlande",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 311
  },
  {
    "id": "koedijk-8470-gistel",
    "name": "Koedijk",
    "type": "Partner Store",
    "street": "Stationsstraat",
    "house_number": "2b",
    "street_line": "Stationsstraat 2b",
    "zip": "8470",
    "city": "Gistel",
    "country": "Belgium",
    "country_label": "Belgien",
    "region": "The Netherlands",
    "language": "Englisch",
    "address": "Stationsstraat 2b, 8470 Gistel, Belgien",
    "map_query": "Stationsstraat 2b, 8470 Gistel, Belgien",
    "maps_query": "Koedijk, Stationsstraat 2b, 8470 Gistel, Belgien",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 312
  },
  {
    "id": "koenigs-herrenmode-7461-ke-rijssen",
    "name": "Koenigs Herrenmode",
    "type": "Partner Store",
    "street": "Grotestraat",
    "house_number": "21-25",
    "street_line": "Grotestraat 21-25",
    "zip": "7461 KE",
    "city": "Rijssen",
    "country": "The Netherlands",
    "country_label": "Niederlande",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Grotestraat 21-25, 7461 KE Rijssen, Niederlande",
    "map_query": "Grotestraat 21-25, 7461 KE Rijssen, Niederlande",
    "maps_query": "Koenigs Herrenmode, Grotestraat 21-25, 7461 KE Rijssen, Niederlande",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 313
  },
  {
    "id": "kolesch-textilhandels-gmbh-1050-riga",
    "name": "Kolesch Textilhandels GmbH",
    "type": "Partner Store",
    "street": "Jezusbaznicas",
    "house_number": "7",
    "street_line": "Jezusbaznicas 7",
    "zip": "1050",
    "city": "Riga",
    "country": "Latvia",
    "country_label": "Latvia",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Jezusbaznicas 7, 1050 Riga, Latvia",
    "map_query": "Jezusbaznicas 7, 1050 Riga, Latvia",
    "maps_query": "Kolesch Textilhandels GmbH, Jezusbaznicas 7, 1050 Riga, Latvia",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 314
  },
  {
    "id": "koopman-mode-88400-biberach",
    "name": "Koopman Mode",
    "type": "Partner Store",
    "street": "Consulentengasse zwischen 10 u.",
    "house_number": "12",
    "street_line": "Consulentengasse zwischen 10 u. 12",
    "zip": "88400",
    "city": "Biberach",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "The Netherlands",
    "language": "Englisch",
    "address": "Consulentengasse zwischen 10 u. 12, 88400 Biberach, Deutschland",
    "map_query": "Consulentengasse zwischen 10 u. 12, 88400 Biberach, Deutschland",
    "maps_query": "Koopman Mode, Consulentengasse zwischen 10 u. 12, 88400 Biberach, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 315
  },
  {
    "id": "kooptex-7634-pp-tilligte",
    "name": "Kooptex",
    "type": "Partner Store",
    "street": "Ootmarsumsestraat",
    "house_number": "145",
    "street_line": "Ootmarsumsestraat 145",
    "zip": "7634 PP",
    "city": "Tilligte",
    "country": "The Netherlands",
    "country_label": "Niederlande",
    "region": "The Netherlands",
    "language": "Englisch",
    "address": "Ootmarsumsestraat 145, 7634 PP Tilligte, Niederlande",
    "map_query": "Ootmarsumsestraat 145, 7634 PP Tilligte, Niederlande",
    "maps_query": "Kooptex, Ootmarsumsestraat 145, 7634 PP Tilligte, Niederlande",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 316
  },
  {
    "id": "kovaloff-men-2242-kz-wassenaar",
    "name": "Kovaloff Men",
    "type": "Partner Store",
    "street": "Van Hogendorpstraat",
    "house_number": "6",
    "street_line": "Van Hogendorpstraat 6",
    "zip": "2242 KZ",
    "city": "Wassenaar",
    "country": "The Netherlands",
    "country_label": "Niederlande",
    "region": "Belgium",
    "language": "Englisch",
    "address": "Van Hogendorpstraat 6, 2242 KZ Wassenaar, Niederlande",
    "map_query": "Van Hogendorpstraat 6, 2242 KZ Wassenaar, Niederlande",
    "maps_query": "Kovaloff Men, Van Hogendorpstraat 6, 2242 KZ Wassenaar, Niederlande",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 317
  },
  {
    "id": "kressmann-schwerin-gmbh-und-co-kg-9960-assenede",
    "name": "Kressmann Schwerin GmbH & Co. KG",
    "type": "Partner Store",
    "street": "Stoepestraat",
    "house_number": "7",
    "street_line": "Stoepestraat 7",
    "zip": "9960",
    "city": "Assenede",
    "country": "Belgium",
    "country_label": "Belgien",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Stoepestraat 7, 9960 Assenede, Belgien",
    "map_query": "Stoepestraat 7, 9960 Assenede, Belgien",
    "maps_query": "Kressmann Schwerin GmbH & Co. KG, Stoepestraat 7, 9960 Assenede, Belgien",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 318
  },
  {
    "id": "krios-bvba-exacto-19053-schwerin",
    "name": "KRIOS BVBA (EXACTO)",
    "type": "Partner Store",
    "street": "Mecklenburgstr. 19 -",
    "house_number": "23",
    "street_line": "Mecklenburgstr. 19 - 23",
    "zip": "19053",
    "city": "Schwerin",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Belgium",
    "language": "Englisch",
    "address": "Mecklenburgstr. 19 - 23, 19053 Schwerin, Deutschland",
    "map_query": "Mecklenburgstr. 19 - 23, 19053 Schwerin, Deutschland",
    "maps_query": "KRIOS BVBA (EXACTO), Mecklenburgstr. 19 - 23, 19053 Schwerin, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 319
  },
  {
    "id": "l-uomo-elegante-26817-rhauderfehn",
    "name": "L Uomo elegante",
    "type": "Partner Store",
    "street": "Rhauderwieke",
    "house_number": "33b",
    "street_line": "Rhauderwieke 33b",
    "zip": "26817",
    "city": "Rhauderfehn",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Switzerland",
    "language": "Englisch",
    "address": "Rhauderwieke 33b, 26817 Rhauderfehn, Deutschland",
    "map_query": "Rhauderwieke 33b, 26817 Rhauderfehn, Deutschland",
    "maps_query": "L Uomo elegante, Rhauderwieke 33b, 26817 Rhauderfehn, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 320
  },
  {
    "id": "l-e-f-bv-6037-root",
    "name": "L.E.F. BV",
    "type": "Partner Store",
    "street": "Bahnhofstrasse",
    "house_number": "32",
    "street_line": "Bahnhofstrasse 32",
    "zip": "6037",
    "city": "Root",
    "country": "Switzerland",
    "country_label": "Schweiz",
    "region": "Belgium",
    "language": "Englisch",
    "address": "Bahnhofstrasse 32, 6037 Root, Schweiz",
    "map_query": "Bahnhofstrasse 32, 6037 Root, Schweiz",
    "maps_query": "L.E.F. BV, Bahnhofstrasse 32, 6037 Root, Schweiz",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 321
  },
  {
    "id": "lange-herrenmode-5280-braunau",
    "name": "Lange Herrenmode",
    "type": "Partner Store",
    "street": "Salzburger Vorstadt",
    "house_number": "5",
    "street_line": "Salzburger Vorstadt 5",
    "zip": "5280",
    "city": "Braunau",
    "country": "Austria",
    "country_label": "Österreich",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Salzburger Vorstadt 5, 5280 Braunau, Österreich",
    "map_query": "Salzburger Vorstadt 5, 5280 Braunau, Österreich",
    "maps_query": "Lange Herrenmode, Salzburger Vorstadt 5, 5280 Braunau, Österreich",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 322
  },
  {
    "id": "le-brummel-81-525-gdynia",
    "name": "LE BRUMMEL",
    "type": "Partner Store",
    "street": "Al.Zwyciestwa",
    "house_number": "256",
    "street_line": "Al.Zwyciestwa 256",
    "zip": "81-525",
    "city": "Gdynia",
    "country": "Poland",
    "country_label": "Poland",
    "region": "Belgium",
    "language": "Englisch",
    "address": "Al.Zwyciestwa 256, 81-525 Gdynia, Poland",
    "map_query": "Al.Zwyciestwa 256, 81-525 Gdynia, Poland",
    "maps_query": "LE BRUMMEL, Al.Zwyciestwa 256, 81-525 Gdynia, Poland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 323
  },
  {
    "id": "ledif-bv-4300-waremme",
    "name": "Ledif BV",
    "type": "Partner Store",
    "street": "AVENUE REINE ASTRID",
    "house_number": "48",
    "street_line": "AVENUE REINE ASTRID 48",
    "zip": "4300",
    "city": "WAREMME",
    "country": "Belgium",
    "country_label": "Belgien",
    "region": "Belgium",
    "language": "Englisch",
    "address": "AVENUE REINE ASTRID 48, 4300 WAREMME, Belgien",
    "map_query": "AVENUE REINE ASTRID 48, 4300 WAREMME, Belgien",
    "maps_query": "Ledif BV, AVENUE REINE ASTRID 48, 4300 WAREMME, Belgien",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 324
  },
  {
    "id": "lehmann-herrenmode-ag-35000-rennes",
    "name": "Lehmann Herrenmode AG",
    "type": "Partner Store",
    "street": "quai Robinot de Saint Cyr",
    "house_number": "14",
    "street_line": "quai Robinot de Saint Cyr 14",
    "zip": "35000",
    "city": "Rennes",
    "country": "France",
    "country_label": "Frankreich",
    "region": "Switzerland",
    "language": "Englisch",
    "address": "quai Robinot de Saint Cyr 14, 35000 Rennes, Frankreich",
    "map_query": "quai Robinot de Saint Cyr 14, 35000 Rennes, Frankreich",
    "maps_query": "Lehmann Herrenmode AG, quai Robinot de Saint Cyr 14, 35000 Rennes, Frankreich",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 325
  },
  {
    "id": "leifsteil-by-papermoon-4415-lausen",
    "name": "Leifsteil by Papermoon",
    "type": "Partner Store",
    "street": "Hauptgasse",
    "house_number": "124",
    "street_line": "Hauptgasse 124",
    "zip": "4415",
    "city": "Lausen",
    "country": "Switzerland",
    "country_label": "Schweiz",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Hauptgasse 124, 4415 Lausen, Schweiz",
    "map_query": "Hauptgasse 124, 4415 Lausen, Schweiz",
    "maps_query": "Leifsteil by Papermoon, Hauptgasse 124, 4415 Lausen, Schweiz",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 326
  },
  {
    "id": "lenssen-mannenmode-18225-kuhlungsborn",
    "name": "Lenssen Mannenmode",
    "type": "Partner Store",
    "street": "Strandstr.",
    "house_number": "32",
    "street_line": "Strandstr. 32",
    "zip": "18225",
    "city": "Kühlungsborn",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "The Netherlands",
    "language": "Englisch",
    "address": "Strandstr. 32, 18225 Kühlungsborn, Deutschland",
    "map_query": "Strandstr. 32, 18225 Kühlungsborn, Deutschland",
    "maps_query": "Lenssen Mannenmode, Strandstr. 32, 18225 Kühlungsborn, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 327
  },
  {
    "id": "les-femmes-heureuses-06250-mougins",
    "name": "Les Femmes Heureuses",
    "type": "Partner Store",
    "street": "Chemin de la Grande Bastide V7",
    "house_number": "1031",
    "street_line": "Chemin de la Grande Bastide V7 1031",
    "zip": "06250",
    "city": "Mougins",
    "country": "France",
    "country_label": "Frankreich",
    "region": "Belgium",
    "language": "Englisch",
    "address": "Chemin de la Grande Bastide V7 1031, 06250 Mougins, Frankreich",
    "map_query": "Chemin de la Grande Bastide V7 1031, 06250 Mougins, Frankreich",
    "maps_query": "Les Femmes Heureuses, Chemin de la Grande Bastide V7 1031, 06250 Mougins, Frankreich",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 328
  },
  {
    "id": "liekenbrock-1800-vevey",
    "name": "Liekenbrock",
    "type": "Partner Store",
    "street": "Rue de l'Hôtel-de-Ville",
    "house_number": "17",
    "street_line": "Rue de l'Hôtel-de-Ville 17",
    "zip": "1800",
    "city": "Vevey",
    "country": "Switzerland",
    "country_label": "Schweiz",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Rue de l'Hôtel-de-Ville 17, 1800 Vevey, Schweiz",
    "map_query": "Rue de l'Hôtel-de-Ville 17, 1800 Vevey, Schweiz",
    "maps_query": "Liekenbrock, Rue de l'Hôtel-de-Ville 17, 1800 Vevey, Schweiz",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 329
  },
  {
    "id": "lodewijks-mode-voor-mannen-b-v-33378-rheda-wiedenbruck",
    "name": "Lodewijks Mode Voor Mannen B.V",
    "type": "Partner Store",
    "street": "Lange Straße",
    "house_number": "33",
    "street_line": "Lange Straße 33",
    "zip": "33378",
    "city": "Rheda-Wiedenbrück",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "The Netherlands",
    "language": "Englisch",
    "address": "Lange Straße 33, 33378 Rheda-Wiedenbrück, Deutschland",
    "map_query": "Lange Straße 33, 33378 Rheda-Wiedenbrück, Deutschland",
    "maps_query": "Lodewijks Mode Voor Mannen B.V, Lange Straße 33, 33378 Rheda-Wiedenbrück, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 330
  },
  {
    "id": "lorenz-bv-8801-kz-franeker",
    "name": "Lorenz BV",
    "type": "Partner Store",
    "street": "Voorstraat",
    "house_number": "19-23",
    "street_line": "Voorstraat 19-23",
    "zip": "8801 KZ",
    "city": "Franeker",
    "country": "The Netherlands",
    "country_label": "Niederlande",
    "region": "Belgium",
    "language": "Englisch",
    "address": "Voorstraat 19-23, 8801 KZ Franeker, Niederlande",
    "map_query": "Voorstraat 19-23, 8801 KZ Franeker, Niederlande",
    "maps_query": "Lorenz BV, Voorstraat 19-23, 8801 KZ Franeker, Niederlande",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 331
  },
  {
    "id": "losert-mode-gmbh-3550-heusden-zolder",
    "name": "Losert Mode GmbH",
    "type": "Partner Store",
    "street": "G. Gezellelaan",
    "house_number": "14",
    "street_line": "G. Gezellelaan 14",
    "zip": "3550",
    "city": "Heusden-Zolder",
    "country": "Belgium",
    "country_label": "Belgien",
    "region": "Germany",
    "language": "Deutsch",
    "address": "G. Gezellelaan 14, 3550 Heusden-Zolder, Belgien",
    "map_query": "G. Gezellelaan 14, 3550 Heusden-Zolder, Belgien",
    "maps_query": "Losert Mode GmbH, G. Gezellelaan 14, 3550 Heusden-Zolder, Belgien",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 332
  },
  {
    "id": "louis-menswear-64658-furth",
    "name": "Louis Menswear",
    "type": "Partner Store",
    "street": "In den Betten",
    "house_number": "5",
    "street_line": "In den Betten 5",
    "zip": "64658",
    "city": "Fürth",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Belgium",
    "language": "Englisch",
    "address": "In den Betten 5, 64658 Fürth, Deutschland",
    "map_query": "In den Betten 5, 64658 Fürth, Deutschland",
    "maps_query": "Louis Menswear, In den Betten 5, 64658 Fürth, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 333
  },
  {
    "id": "ludw-montanus-gmbh-und-co-kg-2500-lier",
    "name": "Ludw. Montanus GmbH & Co. KG",
    "type": "Partner Store",
    "street": "Spekkestraat",
    "house_number": "6A",
    "street_line": "Spekkestraat 6A",
    "zip": "2500",
    "city": "Lier",
    "country": "Belgium",
    "country_label": "Belgien",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Spekkestraat 6A, 2500 Lier, Belgien",
    "map_query": "Spekkestraat 6A, 2500 Lier, Belgien",
    "maps_query": "Ludw. Montanus GmbH & Co. KG, Spekkestraat 6A, 2500 Lier, Belgien",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 334
  },
  {
    "id": "lupkemann-gmbh-52006-aachen",
    "name": "Lüpkemann GmbH",
    "type": "Partner Store",
    "street": "Kurbrunnenstr.",
    "house_number": "18",
    "street_line": "Kurbrunnenstr. 18",
    "zip": "52006",
    "city": "Aachen",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Kurbrunnenstr. 18, 52006 Aachen, Deutschland",
    "map_query": "Kurbrunnenstr. 18, 52006 Aachen, Deutschland",
    "maps_query": "Lüpkemann GmbH, Kurbrunnenstr. 18, 52006 Aachen, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 335
  },
  {
    "id": "lutex-nv-55469-simmern",
    "name": "Lutex NV",
    "type": "Partner Store",
    "street": "Schlossstr. 17 -",
    "house_number": "19",
    "street_line": "Schlossstr. 17 - 19",
    "zip": "55469",
    "city": "Simmern",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Belgium",
    "language": "Englisch",
    "address": "Schlossstr. 17 - 19, 55469 Simmern, Deutschland",
    "map_query": "Schlossstr. 17 - 19, 55469 Simmern, Deutschland",
    "maps_query": "Lutex NV, Schlossstr. 17 - 19, 55469 Simmern, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 336
  },
  {
    "id": "m-und-k-premium-fashion-ag-4054-basel",
    "name": "M&K Premium Fashion AG",
    "type": "Partner Store",
    "street": "Neubadenstraße",
    "house_number": "138",
    "street_line": "Neubadenstraße 138",
    "zip": "4054",
    "city": "Basel",
    "country": "Switzerland",
    "country_label": "Schweiz",
    "region": "Switzerland",
    "language": "Englisch",
    "address": "Neubadenstraße 138, 4054 Basel, Schweiz",
    "map_query": "Neubadenstraße 138, 4054 Basel, Schweiz",
    "maps_query": "M&K Premium Fashion AG, Neubadenstraße 138, 4054 Basel, Schweiz",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 337
  },
  {
    "id": "m-baltz-gmbh-6300-zug",
    "name": "M. Baltz GmbH",
    "type": "Partner Store",
    "street": "Baarerstrasse",
    "house_number": "34",
    "street_line": "Baarerstrasse 34",
    "zip": "6300",
    "city": "Zug",
    "country": "Switzerland",
    "country_label": "Schweiz",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Baarerstrasse 34, 6300 Zug, Schweiz",
    "map_query": "Baarerstrasse 34, 6300 Zug, Schweiz",
    "maps_query": "M. Baltz GmbH, Baarerstrasse 34, 6300 Zug, Schweiz",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 338
  },
  {
    "id": "maddox-jeans-b-v-6511-re-nijmegen",
    "name": "Maddox Jeans B.V.",
    "type": "Partner Store",
    "street": "Burchtstraat",
    "house_number": "30",
    "street_line": "Burchtstraat 30",
    "zip": "6511 RE",
    "city": "Nijmegen",
    "country": "The Netherlands",
    "country_label": "Niederlande",
    "region": "The Netherlands",
    "language": "Englisch",
    "address": "Burchtstraat 30, 6511 RE Nijmegen, Niederlande",
    "map_query": "Burchtstraat 30, 6511 RE Nijmegen, Niederlande",
    "maps_query": "Maddox Jeans B.V., Burchtstraat 30, 6511 RE Nijmegen, Niederlande",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 339
  },
  {
    "id": "mahler-manner-mode-15-879-bialystok",
    "name": "Mahler Männer Mode",
    "type": "Partner Store",
    "street": "Sw.Rocha",
    "house_number": "8",
    "street_line": "Sw.Rocha 8",
    "zip": "15-879",
    "city": "Bialystok",
    "country": "Poland",
    "country_label": "Poland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Sw.Rocha 8, 15-879 Bialystok, Poland",
    "map_query": "Sw.Rocha 8, 15-879 Bialystok, Poland",
    "maps_query": "Mahler Männer Mode, Sw.Rocha 8, 15-879 Bialystok, Poland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 340
  },
  {
    "id": "manders-8900-leper",
    "name": "Manders",
    "type": "Partner Store",
    "street": "Boterstraat",
    "house_number": "33",
    "street_line": "Boterstraat 33",
    "zip": "8900",
    "city": "Leper",
    "country": "Belgium",
    "country_label": "Belgien",
    "region": "The Netherlands",
    "language": "Englisch",
    "address": "Boterstraat 33, 8900 Leper, Belgien",
    "map_query": "Boterstraat 33, 8900 Leper, Belgien",
    "maps_query": "Manders, Boterstraat 33, 8900 Leper, Belgien",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 341
  },
  {
    "id": "manmade-nv-5374-bj-schaijk",
    "name": "MANMADE NV",
    "type": "Partner Store",
    "street": "Pastoor van winkelstraat",
    "house_number": "26",
    "street_line": "Pastoor van winkelstraat 26",
    "zip": "5374 BJ",
    "city": "Schaijk",
    "country": "The Netherlands",
    "country_label": "Niederlande",
    "region": "Belgium",
    "language": "Englisch",
    "address": "Pastoor van winkelstraat 26, 5374 BJ Schaijk, Niederlande",
    "map_query": "Pastoor van winkelstraat 26, 5374 BJ Schaijk, Niederlande",
    "maps_query": "MANMADE NV, Pastoor van winkelstraat 26, 5374 BJ Schaijk, Niederlande",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 342
  },
  {
    "id": "mannemode-de-rooij-2220-heist-op-den-berg",
    "name": "Mannemode De Rooij",
    "type": "Partner Store",
    "street": "MECHELSESTEENWEG",
    "house_number": "121A",
    "street_line": "MECHELSESTEENWEG 121A",
    "zip": "2220",
    "city": "HEIST OP DEN BERG",
    "country": "Belgium",
    "country_label": "Belgien",
    "region": "The Netherlands",
    "language": "Englisch",
    "address": "MECHELSESTEENWEG 121A, 2220 HEIST OP DEN BERG, Belgien",
    "map_query": "MECHELSESTEENWEG 121A, 2220 HEIST OP DEN BERG, Belgien",
    "maps_query": "Mannemode De Rooij, MECHELSESTEENWEG 121A, 2220 HEIST OP DEN BERG, Belgien",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 343
  },
  {
    "id": "manner-mode-severin-gmbh-9401-je-assen",
    "name": "Männer-Mode SEVERIN GmbH",
    "type": "Partner Store",
    "street": "Marktstraat",
    "house_number": "1",
    "street_line": "Marktstraat 1",
    "zip": "9401 JE",
    "city": "Assen",
    "country": "The Netherlands",
    "country_label": "Niederlande",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Marktstraat 1, 9401 JE Assen, Niederlande",
    "map_query": "Marktstraat 1, 9401 JE Assen, Niederlande",
    "maps_query": "Männer-Mode SEVERIN GmbH, Marktstraat 1, 9401 JE Assen, Niederlande",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 344
  },
  {
    "id": "mannermode-am-markt-97070-wurzburg",
    "name": "Männermode am Markt",
    "type": "Partner Store",
    "street": "Domstr.",
    "house_number": "8",
    "street_line": "Domstr. 8",
    "zip": "97070",
    "city": "Würzburg",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Domstr. 8, 97070 Würzburg, Deutschland",
    "map_query": "Domstr. 8, 97070 Würzburg, Deutschland",
    "maps_query": "Männermode am Markt, Domstr. 8, 97070 Würzburg, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 345
  },
  {
    "id": "mannermode-ralf-schmitz-52146-wurselen",
    "name": "Männermode Ralf Schmitz",
    "type": "Partner Store",
    "street": "Markt",
    "house_number": "34",
    "street_line": "Markt 34",
    "zip": "52146",
    "city": "Würselen",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Markt 34, 52146 Würselen, Deutschland",
    "map_query": "Markt 34, 52146 Würselen, Deutschland",
    "maps_query": "Männermode Ralf Schmitz, Markt 34, 52146 Würselen, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 346
  },
  {
    "id": "mannermoden-heringsdorf-52499-baesweiler",
    "name": "Männermoden Heringsdorf",
    "type": "Partner Store",
    "street": "Kirchstr. 35 b",
    "house_number": "",
    "street_line": "Kirchstr. 35 b",
    "zip": "52499",
    "city": "Baesweiler",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Kirchstr. 35 b, 52499 Baesweiler, Deutschland",
    "map_query": "Männermoden Heringsdorf, Kirchstr. 35 b, 52499 Baesweiler, Deutschland",
    "maps_query": "Männermoden Heringsdorf, Kirchstr. 35 b, 52499 Baesweiler, Deutschland",
    "note": "Sortiment und Verfügbarkeit können variieren. Adresse bitte vor Besuch über den Händler prüfen.",
    "data_quality": [
      "house_number_missing"
    ],
    "source_row": 347
  },
  {
    "id": "mannersache-fritzlar-66424-homburg",
    "name": "Männersache-Fritzlar",
    "type": "Partner Store",
    "street": "St. Michael-Straße",
    "house_number": "5B",
    "street_line": "St. Michael-Straße 5B",
    "zip": "66424",
    "city": "Homburg",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "St. Michael-Straße 5B, 66424 Homburg, Deutschland",
    "map_query": "St. Michael-Straße 5B, 66424 Homburg, Deutschland",
    "maps_query": "Männersache-Fritzlar, St. Michael-Straße 5B, 66424 Homburg, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 348
  },
  {
    "id": "mannerwerk-ag-34560-fritzlar",
    "name": "Männerwerk AG",
    "type": "Partner Store",
    "street": "Gewerbering",
    "house_number": "1b",
    "street_line": "Gewerbering 1b",
    "zip": "34560",
    "city": "Fritzlar",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Switzerland",
    "language": "Englisch",
    "address": "Gewerbering 1b, 34560 Fritzlar, Deutschland",
    "map_query": "Gewerbering 1b, 34560 Fritzlar, Deutschland",
    "maps_query": "Männerwerk AG, Gewerbering 1b, 34560 Fritzlar, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 349
  },
  {
    "id": "marc-edwards-09232-hartmannsdorf",
    "name": "Marc Edwards",
    "type": "Partner Store",
    "street": "Ernst-Lässig-Straße",
    "house_number": "4",
    "street_line": "Ernst-Lässig-Straße 4",
    "zip": "09232",
    "city": "Hartmannsdorf",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "The Netherlands",
    "language": "Englisch",
    "address": "Ernst-Lässig-Straße 4, 09232 Hartmannsdorf, Deutschland",
    "map_query": "Ernst-Lässig-Straße 4, 09232 Hartmannsdorf, Deutschland",
    "maps_query": "Marc Edwards, Ernst-Lässig-Straße 4, 09232 Hartmannsdorf, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 350
  },
  {
    "id": "marc-edwards-menswear-2011-se-haarlem-bussum",
    "name": "Marc Edwards Menswear",
    "type": "Partner Store",
    "street": "Grote Houtstraat",
    "house_number": "59",
    "street_line": "Grote Houtstraat 59",
    "zip": "2011 SE",
    "city": "Haarlem/Bussum",
    "country": "The Netherlands",
    "country_label": "Niederlande",
    "region": "The Netherlands",
    "language": "Englisch",
    "address": "Grote Houtstraat 59, 2011 SE Haarlem/Bussum, Niederlande",
    "map_query": "Grote Houtstraat 59, 2011 SE Haarlem/Bussum, Niederlande",
    "maps_query": "Marc Edwards Menswear, Grote Houtstraat 59, 2011 SE Haarlem/Bussum, Niederlande",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 351
  },
  {
    "id": "marc-vandeven-bv-portobello-1404-cl-bussum",
    "name": "MARC Vandeven BV – PORTOBELLO",
    "type": "Partner Store",
    "street": "Nassaulaan",
    "house_number": "11",
    "street_line": "Nassaulaan 11",
    "zip": "1404 CL",
    "city": "Bussum",
    "country": "The Netherlands",
    "country_label": "Niederlande",
    "region": "Belgium",
    "language": "Englisch",
    "address": "Nassaulaan 11, 1404 CL Bussum, Niederlande",
    "map_query": "Nassaulaan 11, 1404 CL Bussum, Niederlande",
    "maps_query": "MARC Vandeven BV – PORTOBELLO, Nassaulaan 11, 1404 CL Bussum, Niederlande",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 352
  },
  {
    "id": "marcel-by-middeldorp-3000-leuven",
    "name": "MARCEL BY MIDDELDORP",
    "type": "Partner Store",
    "street": "Bondgenotenlaan",
    "house_number": "16-18",
    "street_line": "Bondgenotenlaan 16-18",
    "zip": "3000",
    "city": "Leuven",
    "country": "Belgium",
    "country_label": "Belgien",
    "region": "The Netherlands",
    "language": "Englisch",
    "address": "Bondgenotenlaan 16-18, 3000 Leuven, Belgien",
    "map_query": "Bondgenotenlaan 16-18, 3000 Leuven, Belgien",
    "maps_query": "MARCEL BY MIDDELDORP, Bondgenotenlaan 16-18, 3000 Leuven, Belgien",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 353
  },
  {
    "id": "mare-baltic-handelsgesellschaft-mbh-2593-ar-den-haag",
    "name": "Mare Baltic Handelsgesellschaft mbH",
    "type": "Partner Store",
    "street": "Theresiastraat",
    "house_number": "70",
    "street_line": "Theresiastraat 70",
    "zip": "2593 AR",
    "city": "Den Haag",
    "country": "The Netherlands",
    "country_label": "Niederlande",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Theresiastraat 70, 2593 AR Den Haag, Niederlande",
    "map_query": "Theresiastraat 70, 2593 AR Den Haag, Niederlande",
    "maps_query": "Mare Baltic Handelsgesellschaft mbH, Theresiastraat 70, 2593 AR Den Haag, Niederlande",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 354
  },
  {
    "id": "markarino-bvba-18069-rostock",
    "name": "Markarino bvba",
    "type": "Partner Store",
    "street": "Industriestraße",
    "house_number": "15",
    "street_line": "Industriestraße 15",
    "zip": "18069",
    "city": "Rostock",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Belgium",
    "language": "Englisch",
    "address": "Industriestraße 15, 18069 Rostock, Deutschland",
    "map_query": "Industriestraße 15, 18069 Rostock, Deutschland",
    "maps_query": "Markarino bvba, Industriestraße 15, 18069 Rostock, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 355
  },
  {
    "id": "markus-hein-3500-hasselt",
    "name": "Markus Hein",
    "type": "Partner Store",
    "street": "Paardsdemerstraat",
    "house_number": "9",
    "street_line": "Paardsdemerstraat 9",
    "zip": "3500",
    "city": "Hasselt",
    "country": "Belgium",
    "country_label": "Belgien",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Paardsdemerstraat 9, 3500 Hasselt, Belgien",
    "map_query": "Paardsdemerstraat 9, 3500 Hasselt, Belgien",
    "maps_query": "Markus Hein, Paardsdemerstraat 9, 3500 Hasselt, Belgien",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 356
  },
  {
    "id": "markus-j-lesmeister-herrenmoden-87600-kaufbeuren",
    "name": "Markus J. Lesmeister Herrenmoden",
    "type": "Partner Store",
    "street": "Kaiser-Max-Str.27",
    "house_number": "",
    "street_line": "Kaiser-Max-Str.27",
    "zip": "87600",
    "city": "Kaufbeuren",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Kaiser-Max-Str.27, 87600 Kaufbeuren, Deutschland",
    "map_query": "Markus J. Lesmeister Herrenmoden, Kaiser-Max-Str.27, 87600 Kaufbeuren, Deutschland",
    "maps_query": "Markus J. Lesmeister Herrenmoden, Kaiser-Max-Str.27, 87600 Kaufbeuren, Deutschland",
    "note": "Sortiment und Verfügbarkeit können variieren. Adresse bitte vor Besuch über den Händler prüfen.",
    "data_quality": [
      "house_number_missing"
    ],
    "source_row": 357
  },
  {
    "id": "martin-hollad-bekleidungs-gmbh-2593-ac-den-haag",
    "name": "Martin Hollad Bekleidungs GmbH",
    "type": "Partner Store",
    "street": "Theresiastraat",
    "house_number": "91",
    "street_line": "Theresiastraat 91",
    "zip": "2593 AC",
    "city": "Den Haag",
    "country": "The Netherlands",
    "country_label": "Niederlande",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Theresiastraat 91, 2593 AC Den Haag, Niederlande",
    "map_query": "Theresiastraat 91, 2593 AC Den Haag, Niederlande",
    "maps_query": "Martin Hollad Bekleidungs GmbH, Theresiastraat 91, 2593 AC Den Haag, Niederlande",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 358
  },
  {
    "id": "martin-menswear-46354-sudlohn",
    "name": "Martin Menswear",
    "type": "Partner Store",
    "street": "Bahnhofstraße",
    "house_number": "7",
    "street_line": "Bahnhofstraße 7",
    "zip": "46354",
    "city": "Südlohn",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "The Netherlands",
    "language": "Englisch",
    "address": "Bahnhofstraße 7, 46354 Südlohn, Deutschland",
    "map_query": "Bahnhofstraße 7, 46354 Südlohn, Deutschland",
    "maps_query": "Martin Menswear, Bahnhofstraße 7, 46354 Südlohn, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 359
  },
  {
    "id": "marty-7772-ca-hardenberg",
    "name": "Marty",
    "type": "Partner Store",
    "street": "Oosteinde",
    "house_number": "11",
    "street_line": "Oosteinde 11",
    "zip": "7772 CA",
    "city": "Hardenberg",
    "country": "The Netherlands",
    "country_label": "Niederlande",
    "region": "Belgium",
    "language": "Englisch",
    "address": "Oosteinde 11, 7772 CA Hardenberg, Niederlande",
    "map_query": "Oosteinde 11, 7772 CA Hardenberg, Niederlande",
    "maps_query": "Marty, Oosteinde 11, 7772 CA Hardenberg, Niederlande",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 360
  },
  {
    "id": "mathias-frey-gmbh-und-co-kg-8302-ec-emmeloord",
    "name": "Mathias Frey GmbH & Co. KG",
    "type": "Partner Store",
    "street": "Lange Nering",
    "house_number": "2",
    "street_line": "Lange Nering 2",
    "zip": "8302 EC",
    "city": "Emmeloord",
    "country": "The Netherlands",
    "country_label": "Niederlande",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Lange Nering 2, 8302 EC Emmeloord, Niederlande",
    "map_query": "Lange Nering 2, 8302 EC Emmeloord, Niederlande",
    "maps_query": "Mathias Frey GmbH & Co. KG, Lange Nering 2, 8302 EC Emmeloord, Niederlande",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 361
  },
  {
    "id": "matzen-kaufhauser-gmbh-und-co-kg-93413-cham",
    "name": "MATZEN Kaufhäuser GmbH & Co. KG",
    "type": "Partner Store",
    "street": "Marktplatz",
    "house_number": "11",
    "street_line": "Marktplatz 11",
    "zip": "93413",
    "city": "Cham",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Marktplatz 11, 93413 Cham, Deutschland",
    "map_query": "Marktplatz 11, 93413 Cham, Deutschland",
    "maps_query": "MATZEN Kaufhäuser GmbH & Co. KG, Marktplatz 11, 93413 Cham, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 362
  },
  {
    "id": "mauro-feucht-herrenmode-ag-23570-travemunde",
    "name": "Mauro Feucht Herrenmode AG",
    "type": "Partner Store",
    "street": "Vorderreihe",
    "house_number": "58",
    "street_line": "Vorderreihe 58",
    "zip": "23570",
    "city": "Travemünde",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Switzerland",
    "language": "Englisch",
    "address": "Vorderreihe 58, 23570 Travemünde, Deutschland",
    "map_query": "Vorderreihe 58, 23570 Travemünde, Deutschland",
    "maps_query": "Mauro Feucht Herrenmode AG, Vorderreihe 58, 23570 Travemünde, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 363
  },
  {
    "id": "may-gmbh-8909-hedigen",
    "name": "May GmbH",
    "type": "Partner Store",
    "street": "Zwillikerstraße",
    "house_number": "3",
    "street_line": "Zwillikerstraße 3",
    "zip": "8909",
    "city": "Hedigen",
    "country": "Switzerland",
    "country_label": "Schweiz",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Zwillikerstraße 3, 8909 Hedigen, Schweiz",
    "map_query": "Zwillikerstraße 3, 8909 Hedigen, Schweiz",
    "maps_query": "May GmbH, Zwillikerstraße 3, 8909 Hedigen, Schweiz",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 364
  },
  {
    "id": "may-gmbh-bad-sackingen-79761-waldshut-tiengen",
    "name": "May GmbH Bad Säckingen",
    "type": "Partner Store",
    "street": "Hauptstraße",
    "house_number": "24",
    "street_line": "Hauptstraße 24",
    "zip": "79761",
    "city": "Waldshut-Tiengen",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "",
    "language": "Englisch",
    "address": "Hauptstraße 24, 79761 Waldshut-Tiengen, Deutschland",
    "map_query": "Hauptstraße 24, 79761 Waldshut-Tiengen, Deutschland",
    "maps_query": "May GmbH Bad Säckingen, Hauptstraße 24, 79761 Waldshut-Tiengen, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 365
  },
  {
    "id": "mayer-mode-gmbh-79713-bad-sackingen",
    "name": "Mayer Mode GmbH",
    "type": "Partner Store",
    "street": "Schützenstraße",
    "house_number": "1",
    "street_line": "Schützenstraße 1",
    "zip": "79713",
    "city": "Bad Säckingen",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Schützenstraße 1, 79713 Bad Säckingen, Deutschland",
    "map_query": "Schützenstraße 1, 79713 Bad Säckingen, Deutschland",
    "maps_query": "Mayer Mode GmbH, Schützenstraße 1, 79713 Bad Säckingen, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 366
  },
  {
    "id": "mc-legros-enterprise-2320-hoogstraaten",
    "name": "MC Legros Enterprise",
    "type": "Partner Store",
    "street": "Vrijheid",
    "house_number": "122",
    "street_line": "Vrijheid 122",
    "zip": "2320",
    "city": "Hoogstraaten",
    "country": "Belgium",
    "country_label": "Belgien",
    "region": "Luxembourg",
    "language": "Englisch",
    "address": "Vrijheid 122, 2320 Hoogstraaten, Belgien",
    "map_query": "Vrijheid 122, 2320 Hoogstraaten, Belgien",
    "maps_query": "MC Legros Enterprise, Vrijheid 122, 2320 Hoogstraaten, Belgien",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 367
  },
  {
    "id": "meierfashion-gmbh-9638-pommerloch",
    "name": "Meierfashion GmbH",
    "type": "Partner Store",
    "street": "Route Du Bestogne",
    "house_number": "19",
    "street_line": "Route Du Bestogne 19",
    "zip": "9638",
    "city": "Pommerloch",
    "country": "Luxembourg",
    "country_label": "Luxemburg",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Route Du Bestogne 19, 9638 Pommerloch, Luxemburg",
    "map_query": "Route Du Bestogne 19, 9638 Pommerloch, Luxemburg",
    "maps_query": "Meierfashion GmbH, Route Du Bestogne 19, 9638 Pommerloch, Luxemburg",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 368
  },
  {
    "id": "melman-business-und-casuals-b-v-2000-neuchatel",
    "name": "Melman Business & Casuals B.V.",
    "type": "Partner Store",
    "street": "Rue Du Seyon",
    "house_number": "7",
    "street_line": "Rue Du Seyon 7",
    "zip": "2000",
    "city": "Neuchâtel",
    "country": "Switzerland",
    "country_label": "Schweiz",
    "region": "The Netherlands",
    "language": "Englisch",
    "address": "Rue Du Seyon 7, 2000 Neuchâtel, Schweiz",
    "map_query": "Rue Du Seyon 7, 2000 Neuchâtel, Schweiz",
    "maps_query": "Melman Business & Casuals B.V., Rue Du Seyon 7, 2000 Neuchâtel, Schweiz",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 369
  },
  {
    "id": "mens-corner-2171-bn-sassenheim",
    "name": "Mens Corner",
    "type": "Partner Store",
    "street": "Hoofdstraat",
    "house_number": "226-228",
    "street_line": "Hoofdstraat 226-228",
    "zip": "2171 BN",
    "city": "Sassenheim",
    "country": "The Netherlands",
    "country_label": "Niederlande",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Hoofdstraat 226-228, 2171 BN Sassenheim, Niederlande",
    "map_query": "Hoofdstraat 226-228, 2171 BN Sassenheim, Niederlande",
    "maps_query": "Mens Corner, Hoofdstraat 226-228, 2171 BN Sassenheim, Niederlande",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 370
  },
  {
    "id": "merz-fashion-gmbh-08056-zwickau",
    "name": "Merz Fashion GmbH",
    "type": "Partner Store",
    "street": "Hauptmarkt",
    "house_number": "3",
    "street_line": "Hauptmarkt 3",
    "zip": "08056",
    "city": "Zwickau",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Hauptmarkt 3, 08056 Zwickau, Deutschland",
    "map_query": "Hauptmarkt 3, 08056 Zwickau, Deutschland",
    "maps_query": "Merz Fashion GmbH, Hauptmarkt 3, 08056 Zwickau, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 371
  },
  {
    "id": "messerich-mode-gmbh-und-co-kg-91550-dinkelsbuhl",
    "name": "Messerich Mode GmbH & Co.KG",
    "type": "Partner Store",
    "street": "Segringer Str.",
    "house_number": "42-46",
    "street_line": "Segringer Str. 42-46",
    "zip": "91550",
    "city": "Dinkelsbühl",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Segringer Str. 42-46, 91550 Dinkelsbühl, Deutschland",
    "map_query": "Segringer Str. 42-46, 91550 Dinkelsbühl, Deutschland",
    "maps_query": "Messerich Mode GmbH & Co.KG, Segringer Str. 42-46, 91550 Dinkelsbühl, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 372
  },
  {
    "id": "metzmeier-gmbh-54634-bitburg",
    "name": "Metzmeier GmbH",
    "type": "Partner Store",
    "street": "Hauptstraße",
    "house_number": "17-19",
    "street_line": "Hauptstraße 17-19",
    "zip": "54634",
    "city": "Bitburg",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Hauptstraße 17-19, 54634 Bitburg, Deutschland",
    "map_query": "Hauptstraße 17-19, 54634 Bitburg, Deutschland",
    "maps_query": "Metzmeier GmbH, Hauptstraße 17-19, 54634 Bitburg, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 373
  },
  {
    "id": "mfg-mode-gmbh-42646-solingen",
    "name": "MFG Mode GmbH",
    "type": "Partner Store",
    "street": "Martinstr.",
    "house_number": "18",
    "street_line": "Martinstr. 18",
    "zip": "42646",
    "city": "Solingen",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Martinstr. 18, 42646 Solingen, Deutschland",
    "map_query": "Martinstr. 18, 42646 Solingen, Deutschland",
    "maps_query": "MFG Mode GmbH, Martinstr. 18, 42646 Solingen, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 374
  },
  {
    "id": "michiels-kleding-bvba-2380-perchtoldsdorf",
    "name": "Michiels Kleding BVBA",
    "type": "Partner Store",
    "street": "Zwingerstraße",
    "house_number": "5",
    "street_line": "Zwingerstraße 5",
    "zip": "2380",
    "city": "Perchtoldsdorf",
    "country": "Austria",
    "country_label": "Österreich",
    "region": "Belgium",
    "language": "Englisch",
    "address": "Zwingerstraße 5, 2380 Perchtoldsdorf, Österreich",
    "map_query": "Zwingerstraße 5, 2380 Perchtoldsdorf, Österreich",
    "maps_query": "Michiels Kleding BVBA, Zwingerstraße 5, 2380 Perchtoldsdorf, Österreich",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 375
  },
  {
    "id": "mikita-9620-zottegem",
    "name": "MIKITA",
    "type": "Partner Store",
    "street": "Stationsstraat",
    "house_number": "26",
    "street_line": "Stationsstraat 26",
    "zip": "9620",
    "city": "Zottegem",
    "country": "Belgium",
    "country_label": "Belgien",
    "region": "Poland",
    "language": "Englisch",
    "address": "Stationsstraat 26, 9620 Zottegem, Belgien",
    "map_query": "Stationsstraat 26, 9620 Zottegem, Belgien",
    "maps_query": "MIKITA, Stationsstraat 26, 9620 Zottegem, Belgien",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 376
  },
  {
    "id": "minder-mode-ag-63-400-ostrow-wielkopolsk",
    "name": "Minder Mode AG",
    "type": "Partner Store",
    "street": "Raszkowska",
    "house_number": "4",
    "street_line": "Raszkowska 4",
    "zip": "63-400",
    "city": "Ostrów Wielkopolsk",
    "country": "Poland",
    "country_label": "Poland",
    "region": "",
    "language": "Englisch",
    "address": "Raszkowska 4, 63-400 Ostrów Wielkopolsk, Poland",
    "map_query": "Raszkowska 4, 63-400 Ostrów Wielkopolsk, Poland",
    "maps_query": "Minder Mode AG, Raszkowska 4, 63-400 Ostrów Wielkopolsk, Poland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 377
  },
  {
    "id": "mister-multibrandstore-for-men-4950-huttwil",
    "name": "Mister - Multibrandstore for men",
    "type": "Partner Store",
    "street": "Bahnhofstrasse",
    "house_number": "21",
    "street_line": "Bahnhofstrasse 21",
    "zip": "4950",
    "city": "Huttwil",
    "country": "Switzerland",
    "country_label": "Schweiz",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Bahnhofstrasse 21, 4950 Huttwil, Schweiz",
    "map_query": "Bahnhofstrasse 21, 4950 Huttwil, Schweiz",
    "maps_query": "Mister - Multibrandstore for men, Bahnhofstrasse 21, 4950 Huttwil, Schweiz",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 378
  },
  {
    "id": "mm-textil-gmbh-41068-monchengladbach",
    "name": "MM Textil GmbH",
    "type": "Partner Store",
    "street": "Rudolfstr.",
    "house_number": "3",
    "street_line": "Rudolfstr. 3",
    "zip": "41068",
    "city": "Mönchengladbach",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Luxembourg",
    "language": "Englisch",
    "address": "Rudolfstr. 3, 41068 Mönchengladbach, Deutschland",
    "map_query": "Rudolfstr. 3, 41068 Mönchengladbach, Deutschland",
    "maps_query": "MM Textil GmbH, Rudolfstr. 3, 41068 Mönchengladbach, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 379
  },
  {
    "id": "mode-und-textil-schlichting-49699-lindern",
    "name": "Mode & Textil Schlichting",
    "type": "Partner Store",
    "street": "Bahnhofstraße",
    "house_number": "7-9",
    "street_line": "Bahnhofstraße 7-9",
    "zip": "49699",
    "city": "Lindern",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Bahnhofstraße 7-9, 49699 Lindern, Deutschland",
    "map_query": "Bahnhofstraße 7-9, 49699 Lindern, Deutschland",
    "maps_query": "Mode & Textil Schlichting, Bahnhofstraße 7-9, 49699 Lindern, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 380
  },
  {
    "id": "mode-burkhard-e-k-32791-lage-lippe",
    "name": "Mode Burkhard e.K.",
    "type": "Partner Store",
    "street": "Bergstrasse",
    "house_number": "22",
    "street_line": "Bergstrasse 22",
    "zip": "32791",
    "city": "Lage (Lippe)",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Bergstrasse 22, 32791 Lage (Lippe), Deutschland",
    "map_query": "Bergstrasse 22, 32791 Lage (Lippe), Deutschland",
    "maps_query": "Mode Burkhard e.K., Bergstrasse 22, 32791 Lage (Lippe), Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 381
  },
  {
    "id": "mode-demes-gmbh-und-co-kg-86551-aichach",
    "name": "Mode Demes GmbH & Co KG",
    "type": "Partner Store",
    "street": "Stadtplatz",
    "house_number": "27",
    "street_line": "Stadtplatz 27",
    "zip": "86551",
    "city": "Aichach",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Stadtplatz 27, 86551 Aichach, Deutschland",
    "map_query": "Stadtplatz 27, 86551 Aichach, Deutschland",
    "maps_query": "Mode Demes GmbH & Co KG, Stadtplatz 27, 86551 Aichach, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 382
  },
  {
    "id": "mode-ecke-46244-bottrop-kirchhellen",
    "name": "Mode Ecke",
    "type": "Partner Store",
    "street": "Hauptstr.",
    "house_number": "52",
    "street_line": "Hauptstr. 52",
    "zip": "46244",
    "city": "Bottrop-Kirchhellen",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Hauptstr. 52, 46244 Bottrop-Kirchhellen, Deutschland",
    "map_query": "Hauptstr. 52, 46244 Bottrop-Kirchhellen, Deutschland",
    "maps_query": "Mode Ecke, Hauptstr. 52, 46244 Bottrop-Kirchhellen, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 383
  },
  {
    "id": "mode-fischer-gmbh-und-co-kg-88400-biberach",
    "name": "Mode Fischer GmbH & Co. KG",
    "type": "Partner Store",
    "street": "Bürgerturmstraße",
    "house_number": "6",
    "street_line": "Bürgerturmstraße 6",
    "zip": "88400",
    "city": "Biberach",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Bürgerturmstraße 6, 88400 Biberach, Deutschland",
    "map_query": "Bürgerturmstraße 6, 88400 Biberach, Deutschland",
    "maps_query": "Mode Fischer GmbH & Co. KG, Bürgerturmstraße 6, 88400 Biberach, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 384
  },
  {
    "id": "mode-flach-gmbh-und-co-kg-57368-lennestadt",
    "name": "Mode Flach GmbH & Co. KG",
    "type": "Partner Store",
    "street": "Bielefelder Str.",
    "house_number": "5a",
    "street_line": "Bielefelder Str. 5a",
    "zip": "57368",
    "city": "Lennestadt",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Bielefelder Str. 5a, 57368 Lennestadt, Deutschland",
    "map_query": "Bielefelder Str. 5a, 57368 Lennestadt, Deutschland",
    "maps_query": "Mode Flach GmbH & Co. KG, Bielefelder Str. 5a, 57368 Lennestadt, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 385
  },
  {
    "id": "mode-frenzel-gmbh-63571-gelnhausen-haitz",
    "name": "Mode Frenzel GmbH",
    "type": "Partner Store",
    "street": "Kremp'sche Spitze",
    "house_number": "2",
    "street_line": "Kremp'sche Spitze 2",
    "zip": "63571",
    "city": "Gelnhausen-Haitz",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Kremp'sche Spitze 2, 63571 Gelnhausen-Haitz, Deutschland",
    "map_query": "Kremp'sche Spitze 2, 63571 Gelnhausen-Haitz, Deutschland",
    "maps_query": "Mode Frenzel GmbH, Kremp'sche Spitze 2, 63571 Gelnhausen-Haitz, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 386
  },
  {
    "id": "mode-funk-kg-91126-schwabach",
    "name": "Mode Funk KG",
    "type": "Partner Store",
    "street": "Südliche Ringstraße",
    "house_number": "2",
    "street_line": "Südliche Ringstraße 2",
    "zip": "91126",
    "city": "Schwabach",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Südliche Ringstraße 2, 91126 Schwabach, Deutschland",
    "map_query": "Südliche Ringstraße 2, 91126 Schwabach, Deutschland",
    "maps_query": "Mode Funk KG, Südliche Ringstraße 2, 91126 Schwabach, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 387
  },
  {
    "id": "mode-heckmann-e-k-73430-aalen",
    "name": "Mode Heckmann e.K.",
    "type": "Partner Store",
    "street": "Spritzenhausplatz",
    "house_number": "8",
    "street_line": "Spritzenhausplatz 8",
    "zip": "73430",
    "city": "Aalen",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Spritzenhausplatz 8, 73430 Aalen, Deutschland",
    "map_query": "Spritzenhausplatz 8, 73430 Aalen, Deutschland",
    "maps_query": "Mode Heckmann e.K., Spritzenhausplatz 8, 73430 Aalen, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 388
  },
  {
    "id": "mode-hempel-gmbh-und-co-kg-45721-haltern-am-see",
    "name": "Mode Hempel GmbH & Co. KG",
    "type": "Partner Store",
    "street": "Rekumer Str. 24 -",
    "house_number": "28",
    "street_line": "Rekumer Str. 24 - 28",
    "zip": "45721",
    "city": "Haltern am See",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Rekumer Str. 24 - 28, 45721 Haltern am See, Deutschland",
    "map_query": "Rekumer Str. 24 - 28, 45721 Haltern am See, Deutschland",
    "maps_query": "Mode Hempel GmbH & Co. KG, Rekumer Str. 24 - 28, 45721 Haltern am See, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 389
  },
  {
    "id": "mode-max-hansen-gmbh-84174-eching",
    "name": "Mode Max Hansen GmbH",
    "type": "Partner Store",
    "street": "Strogenweg",
    "house_number": "7",
    "street_line": "Strogenweg 7",
    "zip": "84174",
    "city": "Eching",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Strogenweg 7, 84174 Eching, Deutschland",
    "map_query": "Strogenweg 7, 84174 Eching, Deutschland",
    "maps_query": "Mode Max Hansen GmbH, Strogenweg 7, 84174 Eching, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 390
  },
  {
    "id": "mode-mehler-gmbh-und-co-kg-24894-tolk",
    "name": "Mode Mehler GmbH & Co KG",
    "type": "Partner Store",
    "street": "Alte Dorfstraße",
    "house_number": "14",
    "street_line": "Alte Dorfstraße 14",
    "zip": "24894",
    "city": "Tolk",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Alte Dorfstraße 14, 24894 Tolk, Deutschland",
    "map_query": "Alte Dorfstraße 14, 24894 Tolk, Deutschland",
    "maps_query": "Mode Mehler GmbH & Co KG, Alte Dorfstraße 14, 24894 Tolk, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 391
  },
  {
    "id": "mode-meier-kg-92526-oberviechtach",
    "name": "Mode Meier KG",
    "type": "Partner Store",
    "street": "Bahnhofstrasse",
    "house_number": "9",
    "street_line": "Bahnhofstrasse 9",
    "zip": "92526",
    "city": "Oberviechtach",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Bahnhofstrasse 9, 92526 Oberviechtach, Deutschland",
    "map_query": "Bahnhofstrasse 9, 92526 Oberviechtach, Deutschland",
    "maps_query": "Mode Meier KG, Bahnhofstrasse 9, 92526 Oberviechtach, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 392
  },
  {
    "id": "mode-neu-76870-kandel",
    "name": "Mode Neu",
    "type": "Partner Store",
    "street": "Hauptstr.",
    "house_number": "90",
    "street_line": "Hauptstr. 90",
    "zip": "76870",
    "city": "Kandel",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Hauptstr. 90, 76870 Kandel, Deutschland",
    "map_query": "Hauptstr. 90, 76870 Kandel, Deutschland",
    "maps_query": "Mode Neu, Hauptstr. 90, 76870 Kandel, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 393
  },
  {
    "id": "mode-stoss-gmbh-85368-moosburg",
    "name": "Mode Stoss GmbH",
    "type": "Partner Store",
    "street": "Herrnstr.",
    "house_number": "1-3",
    "street_line": "Herrnstr. 1-3",
    "zip": "85368",
    "city": "Moosburg",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Switzerland",
    "language": "Englisch",
    "address": "Herrnstr. 1-3, 85368 Moosburg, Deutschland",
    "map_query": "Herrnstr. 1-3, 85368 Moosburg, Deutschland",
    "maps_query": "Mode Stoss GmbH, Herrnstr. 1-3, 85368 Moosburg, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 394
  },
  {
    "id": "mode-van-hauth-e-k-9450-altstatten",
    "name": "Mode van Hauth e.K.",
    "type": "Partner Store",
    "street": "Marktgasse",
    "house_number": "8",
    "street_line": "Marktgasse 8",
    "zip": "9450",
    "city": "Altstätten",
    "country": "Switzerland",
    "country_label": "Schweiz",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Marktgasse 8, 9450 Altstätten, Schweiz",
    "map_query": "Marktgasse 8, 9450 Altstätten, Schweiz",
    "maps_query": "Mode van Hauth e.K., Marktgasse 8, 9450 Altstätten, Schweiz",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 395
  },
  {
    "id": "mode-von-feucht-gmbh-56812-cochem-mosel",
    "name": "Mode von Feucht GmbH",
    "type": "Partner Store",
    "street": "Herrenstr. 18,",
    "house_number": "21-23",
    "street_line": "Herrenstr. 18, 21-23",
    "zip": "56812",
    "city": "Cochem/Mosel",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Austria",
    "language": "Deutsch",
    "address": "Herrenstr. 18, 21-23, 56812 Cochem/Mosel, Deutschland",
    "map_query": "Herrenstr. 18, 21-23, 56812 Cochem/Mosel, Deutschland",
    "maps_query": "Mode von Feucht GmbH, Herrenstr. 18, 21-23, 56812 Cochem/Mosel, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 396
  },
  {
    "id": "mode-wiedemann-6020-innsbruck",
    "name": "Mode Wiedemann",
    "type": "Partner Store",
    "street": "Grabenweg",
    "house_number": "60",
    "street_line": "Grabenweg 60",
    "zip": "6020",
    "city": "Innsbruck",
    "country": "Austria",
    "country_label": "Österreich",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Grabenweg 60, 6020 Innsbruck, Österreich",
    "map_query": "Grabenweg 60, 6020 Innsbruck, Österreich",
    "maps_query": "Mode Wiedemann, Grabenweg 60, 6020 Innsbruck, Österreich",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 397
  },
  {
    "id": "mode-winkler-gmbh-86381-krumbach",
    "name": "Mode Winkler GmbH",
    "type": "Partner Store",
    "street": "Franz-Aletsee-Str.",
    "house_number": "11",
    "street_line": "Franz-Aletsee-Str. 11",
    "zip": "86381",
    "city": "Krumbach",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Franz-Aletsee-Str. 11, 86381 Krumbach, Deutschland",
    "map_query": "Franz-Aletsee-Str. 11, 86381 Krumbach, Deutschland",
    "maps_query": "Mode Winkler GmbH, Franz-Aletsee-Str. 11, 86381 Krumbach, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 398
  },
  {
    "id": "mode-wolf-gmbh-64625-bensheim",
    "name": "Mode Wolf GmbH",
    "type": "Partner Store",
    "street": "Hauptstr.",
    "house_number": "5",
    "street_line": "Hauptstr. 5",
    "zip": "64625",
    "city": "Bensheim",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Hauptstr. 5, 64625 Bensheim, Deutschland",
    "map_query": "Hauptstr. 5, 64625 Bensheim, Deutschland",
    "maps_query": "Mode Wolf GmbH, Hauptstr. 5, 64625 Bensheim, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 399
  },
  {
    "id": "mode-marius-67823-obermoschel",
    "name": "Mode-Marius",
    "type": "Partner Store",
    "street": "Richard-Müller-Str.13",
    "house_number": "",
    "street_line": "Richard-Müller-Str.13",
    "zip": "67823",
    "city": "Obermoschel",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Richard-Müller-Str.13, 67823 Obermoschel, Deutschland",
    "map_query": "Mode-Marius, Richard-Müller-Str.13, 67823 Obermoschel, Deutschland",
    "maps_query": "Mode-Marius, Richard-Müller-Str.13, 67823 Obermoschel, Deutschland",
    "note": "Sortiment und Verfügbarkeit können variieren. Adresse bitte vor Besuch über den Händler prüfen.",
    "data_quality": [
      "house_number_missing"
    ],
    "source_row": 400
  },
  {
    "id": "mode-messner-gmbh-und-co-kg-09456-annaberg-buchholz",
    "name": "Mode-Messner GmbH & Co. KG",
    "type": "Partner Store",
    "street": "Wolkensteiner Strasse",
    "house_number": "2",
    "street_line": "Wolkensteiner Strasse 2",
    "zip": "09456",
    "city": "Annaberg-Buchholz",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Wolkensteiner Strasse 2, 09456 Annaberg-Buchholz, Deutschland",
    "map_query": "Wolkensteiner Strasse 2, 09456 Annaberg-Buchholz, Deutschland",
    "maps_query": "Mode-Messner GmbH & Co. KG, Wolkensteiner Strasse 2, 09456 Annaberg-Buchholz, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 401
  },
  {
    "id": "modebox-22457-hamburg",
    "name": "Modebox",
    "type": "Partner Store",
    "street": "Modering 3 Modecentrum B243",
    "house_number": "",
    "street_line": "Modering 3 Modecentrum B243",
    "zip": "22457",
    "city": "Hamburg",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Modering 3 Modecentrum B243, 22457 Hamburg, Deutschland",
    "map_query": "Modebox, Modering 3 Modecentrum B243, 22457 Hamburg, Deutschland",
    "maps_query": "Modebox, Modering 3 Modecentrum B243, 22457 Hamburg, Deutschland",
    "note": "Sortiment und Verfügbarkeit können variieren. Adresse bitte vor Besuch über den Händler prüfen.",
    "data_quality": [
      "house_number_missing"
    ],
    "source_row": 402
  },
  {
    "id": "modecentrum-westen-b-v-79312-emmendingen",
    "name": "Modecentrum Westen B.V.",
    "type": "Partner Store",
    "street": "Marktplatz",
    "house_number": "12",
    "street_line": "Marktplatz 12",
    "zip": "79312",
    "city": "Emmendingen",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "The Netherlands",
    "language": "Englisch",
    "address": "Marktplatz 12, 79312 Emmendingen, Deutschland",
    "map_query": "Marktplatz 12, 79312 Emmendingen, Deutschland",
    "maps_query": "Modecentrum Westen B.V., Marktplatz 12, 79312 Emmendingen, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 403
  },
  {
    "id": "modehaus-ahrling-9581-al-musselkanaal",
    "name": "Modehaus Ahrling",
    "type": "Partner Store",
    "street": "A-weg",
    "house_number": "29",
    "street_line": "A-weg 29",
    "zip": "9581 AL",
    "city": "Musselkanaal",
    "country": "The Netherlands",
    "country_label": "Niederlande",
    "region": "Germany",
    "language": "Deutsch",
    "address": "A-weg 29, 9581 AL Musselkanaal, Niederlande",
    "map_query": "A-weg 29, 9581 AL Musselkanaal, Niederlande",
    "maps_query": "Modehaus Ahrling, A-weg 29, 9581 AL Musselkanaal, Niederlande",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 404
  },
  {
    "id": "modehaus-alber-49681-garrel",
    "name": "Modehaus Alber",
    "type": "Partner Store",
    "street": "Hauptstr.",
    "house_number": "35",
    "street_line": "Hauptstr. 35",
    "zip": "49681",
    "city": "Garrel",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Hauptstr. 35, 49681 Garrel, Deutschland",
    "map_query": "Hauptstr. 35, 49681 Garrel, Deutschland",
    "maps_query": "Modehaus Alber, Hauptstr. 35, 49681 Garrel, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 405
  },
  {
    "id": "modehaus-bar-gmbh-und-co-kg-72461-albstadt",
    "name": "Modehaus Bär GmbH & Co. KG",
    "type": "Partner Store",
    "street": "Hechinger Str.",
    "house_number": "21",
    "street_line": "Hechinger Str. 21",
    "zip": "72461",
    "city": "Albstadt",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Hechinger Str. 21, 72461 Albstadt, Deutschland",
    "map_query": "Hechinger Str. 21, 72461 Albstadt, Deutschland",
    "maps_query": "Modehaus Bär GmbH & Co. KG, Hechinger Str. 21, 72461 Albstadt, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 406
  },
  {
    "id": "modehaus-bauer-74613-ohringen",
    "name": "Modehaus Bauer",
    "type": "Partner Store",
    "street": "Austr.",
    "house_number": "5",
    "street_line": "Austr. 5",
    "zip": "74613",
    "city": "Öhringen",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Austr. 5, 74613 Öhringen, Deutschland",
    "map_query": "Austr. 5, 74613 Öhringen, Deutschland",
    "maps_query": "Modehaus Bauer, Austr. 5, 74613 Öhringen, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 407
  },
  {
    "id": "modehaus-bauer-ohg-74906-bad-rappenau",
    "name": "Modehaus Bauer oHG",
    "type": "Partner Store",
    "street": "Kirchplatz",
    "house_number": "16",
    "street_line": "Kirchplatz 16",
    "zip": "74906",
    "city": "Bad Rappenau",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Kirchplatz 16, 74906 Bad Rappenau, Deutschland",
    "map_query": "Kirchplatz 16, 74906 Bad Rappenau, Deutschland",
    "maps_query": "Modehaus Bauer oHG, Kirchplatz 16, 74906 Bad Rappenau, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 408
  },
  {
    "id": "modehaus-bertsch-gmbh-72297-seewald",
    "name": "Modehaus Bertsch GmbH",
    "type": "Partner Store",
    "street": "Freudenstädter Str.",
    "house_number": "66",
    "street_line": "Freudenstädter Str. 66",
    "zip": "72297",
    "city": "Seewald",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Freudenstädter Str. 66, 72297 Seewald, Deutschland",
    "map_query": "Freudenstädter Str. 66, 72297 Seewald, Deutschland",
    "maps_query": "Modehaus Bertsch GmbH, Freudenstädter Str. 66, 72297 Seewald, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 409
  },
  {
    "id": "modehaus-buffler-gmbh-85456-wartenberg",
    "name": "Modehaus Buffler GmbH",
    "type": "Partner Store",
    "street": "Marktplatz",
    "house_number": "1",
    "street_line": "Marktplatz 1",
    "zip": "85456",
    "city": "Wartenberg",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Marktplatz 1, 85456 Wartenberg, Deutschland",
    "map_query": "Marktplatz 1, 85456 Wartenberg, Deutschland",
    "maps_query": "Modehaus Buffler GmbH, Marktplatz 1, 85456 Wartenberg, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 410
  },
  {
    "id": "modehaus-clemens-plate-88069-tettnang",
    "name": "Modehaus Clemens Plate",
    "type": "Partner Store",
    "street": "Georgstr.",
    "house_number": "5",
    "street_line": "Georgstr. 5",
    "zip": "88069",
    "city": "Tettnang",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Georgstr. 5, 88069 Tettnang, Deutschland",
    "map_query": "Georgstr. 5, 88069 Tettnang, Deutschland",
    "maps_query": "Modehaus Clemens Plate, Georgstr. 5, 88069 Tettnang, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 411
  },
  {
    "id": "modehaus-drechsler-fuchs-49401-damme",
    "name": "Modehaus Drechsler : Fuchs",
    "type": "Partner Store",
    "street": "Große Str.",
    "house_number": "44",
    "street_line": "Große Str. 44",
    "zip": "49401",
    "city": "Damme",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Große Str. 44, 49401 Damme, Deutschland",
    "map_query": "Große Str. 44, 49401 Damme, Deutschland",
    "maps_query": "Modehaus Drechsler : Fuchs, Große Str. 44, 49401 Damme, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 412
  },
  {
    "id": "modehaus-fuchs-89155-erbach",
    "name": "Modehaus Fuchs",
    "type": "Partner Store",
    "street": "Ehinger Str.",
    "house_number": "21",
    "street_line": "Ehinger Str. 21",
    "zip": "89155",
    "city": "Erbach",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Ehinger Str. 21, 89155 Erbach, Deutschland",
    "map_query": "Ehinger Str. 21, 89155 Erbach, Deutschland",
    "maps_query": "Modehaus Fuchs, Ehinger Str. 21, 89155 Erbach, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 413
  },
  {
    "id": "modehaus-fuss-79346-endingen",
    "name": "Modehaus Fuss",
    "type": "Partner Store",
    "street": "Dielenmarktstr.",
    "house_number": "6",
    "street_line": "Dielenmarktstr. 6",
    "zip": "79346",
    "city": "Endingen",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Dielenmarktstr. 6, 79346 Endingen, Deutschland",
    "map_query": "Dielenmarktstr. 6, 79346 Endingen, Deutschland",
    "maps_query": "Modehaus Fuss, Dielenmarktstr. 6, 79346 Endingen, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 414
  },
  {
    "id": "modehaus-garhammer-gmbh-79199-kirchzarten",
    "name": "Modehaus Garhammer GmbH",
    "type": "Partner Store",
    "street": "Hauptstraße",
    "house_number": "2",
    "street_line": "Hauptstraße 2",
    "zip": "79199",
    "city": "Kirchzarten",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Hauptstraße 2, 79199 Kirchzarten, Deutschland",
    "map_query": "Hauptstraße 2, 79199 Kirchzarten, Deutschland",
    "maps_query": "Modehaus Garhammer GmbH, Hauptstraße 2, 79199 Kirchzarten, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 415
  },
  {
    "id": "modehaus-grau-94065-waldkirchen",
    "name": "Modehaus Grau",
    "type": "Partner Store",
    "street": "Marktplatz",
    "house_number": "28",
    "street_line": "Marktplatz 28",
    "zip": "94065",
    "city": "Waldkirchen",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Marktplatz 28, 94065 Waldkirchen, Deutschland",
    "map_query": "Marktplatz 28, 94065 Waldkirchen, Deutschland",
    "maps_query": "Modehaus Grau, Marktplatz 28, 94065 Waldkirchen, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 416
  },
  {
    "id": "modehaus-havekost-gmbh-91077-neunkirchen-am-brand",
    "name": "Modehaus Havekost GmbH",
    "type": "Partner Store",
    "street": "Innerer Markt",
    "house_number": "4",
    "street_line": "Innerer Markt 4",
    "zip": "91077",
    "city": "Neunkirchen am Brand",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Innerer Markt 4, 91077 Neunkirchen am Brand, Deutschland",
    "map_query": "Innerer Markt 4, 91077 Neunkirchen am Brand, Deutschland",
    "maps_query": "Modehaus Havekost GmbH, Innerer Markt 4, 91077 Neunkirchen am Brand, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 417
  },
  {
    "id": "modehaus-hecht-26939-ovelgonne",
    "name": "Modehaus Hecht",
    "type": "Partner Store",
    "street": "Bahnhofstraße",
    "house_number": "28",
    "street_line": "Bahnhofstraße 28",
    "zip": "26939",
    "city": "Ovelgönne",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Bahnhofstraße 28, 26939 Ovelgönne, Deutschland",
    "map_query": "Bahnhofstraße 28, 26939 Ovelgönne, Deutschland",
    "maps_query": "Modehaus Hecht, Bahnhofstraße 28, 26939 Ovelgönne, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 418
  },
  {
    "id": "modehaus-heinze-gmbh-82377-penzberg",
    "name": "Modehaus Heinze GmbH",
    "type": "Partner Store",
    "street": "Karlstraße",
    "house_number": "21",
    "street_line": "Karlstraße 21",
    "zip": "82377",
    "city": "Penzberg",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Karlstraße 21, 82377 Penzberg, Deutschland",
    "map_query": "Karlstraße 21, 82377 Penzberg, Deutschland",
    "maps_query": "Modehaus Heinze GmbH, Karlstraße 21, 82377 Penzberg, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 419
  },
  {
    "id": "modehaus-hell-kg-35066-frankenberg-eder",
    "name": "Modehaus Hell KG",
    "type": "Partner Store",
    "street": "Neustädter Str. 39 -",
    "house_number": "41",
    "street_line": "Neustädter Str. 39 - 41",
    "zip": "35066",
    "city": "Frankenberg/Eder",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Neustädter Str. 39 - 41, 35066 Frankenberg/Eder, Deutschland",
    "map_query": "Neustädter Str. 39 - 41, 35066 Frankenberg/Eder, Deutschland",
    "maps_query": "Modehaus Hell KG, Neustädter Str. 39 - 41, 35066 Frankenberg/Eder, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 420
  },
  {
    "id": "modehaus-hempel-84539-ampfing",
    "name": "Modehaus Hempel",
    "type": "Partner Store",
    "street": "Mühldorferstr.",
    "house_number": "31",
    "street_line": "Mühldorferstr. 31",
    "zip": "84539",
    "city": "Ampfing",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Mühldorferstr. 31, 84539 Ampfing, Deutschland",
    "map_query": "Mühldorferstr. 31, 84539 Ampfing, Deutschland",
    "maps_query": "Modehaus Hempel, Mühldorferstr. 31, 84539 Ampfing, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 421
  },
  {
    "id": "modehaus-humpert-38440-wolfsburg",
    "name": "Modehaus Humpert",
    "type": "Partner Store",
    "street": "Porschestraße",
    "house_number": "45",
    "street_line": "Porschestraße 45",
    "zip": "38440",
    "city": "Wolfsburg",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Porschestraße 45, 38440 Wolfsburg, Deutschland",
    "map_query": "Porschestraße 45, 38440 Wolfsburg, Deutschland",
    "maps_query": "Modehaus Humpert, Porschestraße 45, 38440 Wolfsburg, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 422
  },
  {
    "id": "modehaus-jung-gmbh-59872-meschede",
    "name": "Modehaus Jung GmbH",
    "type": "Partner Store",
    "street": "Hauptstraße",
    "house_number": "14-16",
    "street_line": "Hauptstraße 14-16",
    "zip": "59872",
    "city": "Meschede",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Hauptstraße 14-16, 59872 Meschede, Deutschland",
    "map_query": "Hauptstraße 14-16, 59872 Meschede, Deutschland",
    "maps_query": "Modehaus Jung GmbH, Hauptstraße 14-16, 59872 Meschede, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 423
  },
  {
    "id": "modehaus-kaenders-gmbh-75172-pforzheim",
    "name": "Modehaus Kaenders GmbH",
    "type": "Partner Store",
    "street": "Westliche Karl-Friedrich-Str.",
    "house_number": "22",
    "street_line": "Westliche Karl-Friedrich-Str. 22",
    "zip": "75172",
    "city": "Pforzheim",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Westliche Karl-Friedrich-Str. 22, 75172 Pforzheim, Deutschland",
    "map_query": "Westliche Karl-Friedrich-Str. 22, 75172 Pforzheim, Deutschland",
    "maps_query": "Modehaus Kaenders GmbH, Westliche Karl-Friedrich-Str. 22, 75172 Pforzheim, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 424
  },
  {
    "id": "modehaus-karl-gmbh-47906-kempen",
    "name": "Modehaus Karl GmbH",
    "type": "Partner Store",
    "street": "Kirchstr.",
    "house_number": "3",
    "street_line": "Kirchstr. 3",
    "zip": "47906",
    "city": "Kempen",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Kirchstr. 3, 47906 Kempen, Deutschland",
    "map_query": "Kirchstr. 3, 47906 Kempen, Deutschland",
    "maps_query": "Modehaus Karl GmbH, Kirchstr. 3, 47906 Kempen, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 425
  },
  {
    "id": "modehaus-kehrer-gmbh-und-co-kg-93133-burglengenfeld",
    "name": "Modehaus Kehrer GmbH & Co.KG",
    "type": "Partner Store",
    "street": "Marktplatz",
    "house_number": "13/15",
    "street_line": "Marktplatz 13/15",
    "zip": "93133",
    "city": "Burglengenfeld",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Marktplatz 13/15, 93133 Burglengenfeld, Deutschland",
    "map_query": "Marktplatz 13/15, 93133 Burglengenfeld, Deutschland",
    "maps_query": "Modehaus Kehrer GmbH & Co.KG, Marktplatz 13/15, 93133 Burglengenfeld, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 426
  },
  {
    "id": "modehaus-kirner-gmbh-70771-leinfelden-echterdingen",
    "name": "Modehaus Kirner GmbH",
    "type": "Partner Store",
    "street": "Im Gäßle",
    "house_number": "1",
    "street_line": "Im Gäßle 1",
    "zip": "70771",
    "city": "Leinfelden-Echterdingen",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Im Gäßle 1, 70771 Leinfelden-Echterdingen, Deutschland",
    "map_query": "Im Gäßle 1, 70771 Leinfelden-Echterdingen, Deutschland",
    "maps_query": "Modehaus Kirner GmbH, Im Gäßle 1, 70771 Leinfelden-Echterdingen, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 427
  },
  {
    "id": "modehaus-kittel-e-k-84098-hohenthann",
    "name": "Modehaus Kittel e.K.",
    "type": "Partner Store",
    "street": "Herrengasse",
    "house_number": "1",
    "street_line": "Herrengasse 1",
    "zip": "84098",
    "city": "Hohenthann",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Herrengasse 1, 84098 Hohenthann, Deutschland",
    "map_query": "Herrengasse 1, 84098 Hohenthann, Deutschland",
    "maps_query": "Modehaus Kittel e.K., Herrengasse 1, 84098 Hohenthann, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 428
  },
  {
    "id": "modehaus-koch-74321-bietigheim-bissingen",
    "name": "Modehaus Koch",
    "type": "Partner Store",
    "street": "Hauptstraße",
    "house_number": "21",
    "street_line": "Hauptstraße 21",
    "zip": "74321",
    "city": "Bietigheim-Bissingen",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Hauptstraße 21, 74321 Bietigheim-Bissingen, Deutschland",
    "map_query": "Hauptstraße 21, 74321 Bietigheim-Bissingen, Deutschland",
    "maps_query": "Modehaus Koch, Hauptstraße 21, 74321 Bietigheim-Bissingen, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 429
  },
  {
    "id": "modehaus-kohl-97753-karlstadt",
    "name": "Modehaus Köhl",
    "type": "Partner Store",
    "street": "Hauptstraße",
    "house_number": "38",
    "street_line": "Hauptstraße 38",
    "zip": "97753",
    "city": "Karlstadt",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Hauptstraße 38, 97753 Karlstadt, Deutschland",
    "map_query": "Hauptstraße 38, 97753 Karlstadt, Deutschland",
    "maps_query": "Modehaus Köhl, Hauptstraße 38, 97753 Karlstadt, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 430
  },
  {
    "id": "modehaus-krauth-gmbh-77694-kehl",
    "name": "Modehaus Krauth GmbH",
    "type": "Partner Store",
    "street": "Hauptstr.",
    "house_number": "40",
    "street_line": "Hauptstr. 40",
    "zip": "77694",
    "city": "Kehl",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Hauptstr. 40, 77694 Kehl, Deutschland",
    "map_query": "Hauptstr. 40, 77694 Kehl, Deutschland",
    "maps_query": "Modehaus Krauth GmbH, Hauptstr. 40, 77694 Kehl, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 431
  },
  {
    "id": "modehaus-kuster-94469-deggendorf",
    "name": "Modehaus Küster",
    "type": "Partner Store",
    "street": "Bahnhofstr.",
    "house_number": "1",
    "street_line": "Bahnhofstr. 1",
    "zip": "94469",
    "city": "Deggendorf",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Bahnhofstr. 1, 94469 Deggendorf, Deutschland",
    "map_query": "Bahnhofstr. 1, 94469 Deggendorf, Deutschland",
    "maps_query": "Modehaus Küster, Bahnhofstr. 1, 94469 Deggendorf, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 432
  },
  {
    "id": "modehaus-lobbers-ek-56727-mayen",
    "name": "Modehaus Löbbers eK",
    "type": "Partner Store",
    "street": "Marktplatz",
    "house_number": "16",
    "street_line": "Marktplatz 16",
    "zip": "56727",
    "city": "Mayen",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Marktplatz 16, 56727 Mayen, Deutschland",
    "map_query": "Marktplatz 16, 56727 Mayen, Deutschland",
    "maps_query": "Modehaus Löbbers eK, Marktplatz 16, 56727 Mayen, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 433
  },
  {
    "id": "modehaus-martin-49477-ibbenburen",
    "name": "Modehaus Martin",
    "type": "Partner Store",
    "street": "Oberer Markt",
    "house_number": "7",
    "street_line": "Oberer Markt 7",
    "zip": "49477",
    "city": "Ibbenbüren",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Oberer Markt 7, 49477 Ibbenbüren, Deutschland",
    "map_query": "Oberer Markt 7, 49477 Ibbenbüren, Deutschland",
    "maps_query": "Modehaus Martin, Oberer Markt 7, 49477 Ibbenbüren, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 434
  },
  {
    "id": "modehaus-mayer-rosa-87616-marktoberdorf",
    "name": "Modehaus Mayer-Rosa",
    "type": "Partner Store",
    "street": "Kaufbeurerstr.",
    "house_number": "2",
    "street_line": "Kaufbeurerstr. 2",
    "zip": "87616",
    "city": "Marktoberdorf",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Kaufbeurerstr. 2, 87616 Marktoberdorf, Deutschland",
    "map_query": "Kaufbeurerstr. 2, 87616 Marktoberdorf, Deutschland",
    "maps_query": "Modehaus Mayer-Rosa, Kaufbeurerstr. 2, 87616 Marktoberdorf, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 435
  },
  {
    "id": "modehaus-nagel-gmbh-88250-weingarten",
    "name": "Modehaus Nagel GmbH",
    "type": "Partner Store",
    "street": "Karlstr. 7 -",
    "house_number": "9",
    "street_line": "Karlstr. 7 - 9",
    "zip": "88250",
    "city": "Weingarten",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Karlstr. 7 - 9, 88250 Weingarten, Deutschland",
    "map_query": "Karlstr. 7 - 9, 88250 Weingarten, Deutschland",
    "maps_query": "Modehaus Nagel GmbH, Karlstr. 7 - 9, 88250 Weingarten, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 436
  },
  {
    "id": "modehaus-peter-ag-76227-karlsruhe",
    "name": "Modehaus Peter AG",
    "type": "Partner Store",
    "street": "Pfinztalstraße",
    "house_number": "76",
    "street_line": "Pfinztalstraße 76",
    "zip": "76227",
    "city": "Karlsruhe",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Switzerland",
    "language": "Englisch",
    "address": "Pfinztalstraße 76, 76227 Karlsruhe, Deutschland",
    "map_query": "Pfinztalstraße 76, 76227 Karlsruhe, Deutschland",
    "maps_query": "Modehaus Peter AG, Pfinztalstraße 76, 76227 Karlsruhe, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 437
  },
  {
    "id": "modehaus-peters-gmbh-6130-willisau",
    "name": "Modehaus Peters GmbH",
    "type": "Partner Store",
    "street": "Hauptgasse",
    "house_number": "36",
    "street_line": "Hauptgasse 36",
    "zip": "6130",
    "city": "Willisau",
    "country": "Switzerland",
    "country_label": "Schweiz",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Hauptgasse 36, 6130 Willisau, Schweiz",
    "map_query": "Hauptgasse 36, 6130 Willisau, Schweiz",
    "maps_query": "Modehaus Peters GmbH, Hauptgasse 36, 6130 Willisau, Schweiz",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 438
  },
  {
    "id": "modehaus-pfahl-21682-stade",
    "name": "Modehaus Pfahl",
    "type": "Partner Store",
    "street": "Sattelmacherstr.",
    "house_number": "2-4",
    "street_line": "Sattelmacherstr. 2-4",
    "zip": "21682",
    "city": "Stade",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Sattelmacherstr. 2-4, 21682 Stade, Deutschland",
    "map_query": "Sattelmacherstr. 2-4, 21682 Stade, Deutschland",
    "maps_query": "Modehaus Pfahl, Sattelmacherstr. 2-4, 21682 Stade, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 439
  },
  {
    "id": "modehaus-rauer-gmbh-14776-brandenburg",
    "name": "Modehaus Rauer GmbH",
    "type": "Partner Store",
    "street": "Hauptstraße",
    "house_number": "11",
    "street_line": "Hauptstraße 11",
    "zip": "14776",
    "city": "Brandenburg",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Hauptstraße 11, 14776 Brandenburg, Deutschland",
    "map_query": "Hauptstraße 11, 14776 Brandenburg, Deutschland",
    "maps_query": "Modehaus Rauer GmbH, Hauptstraße 11, 14776 Brandenburg, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 440
  },
  {
    "id": "modehaus-rauscher-02625-bautzen",
    "name": "Modehaus Rauscher",
    "type": "Partner Store",
    "street": "Wilthener Str.",
    "house_number": "32",
    "street_line": "Wilthener Str. 32",
    "zip": "02625",
    "city": "Bautzen",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Wilthener Str. 32, 02625 Bautzen, Deutschland",
    "map_query": "Wilthener Str. 32, 02625 Bautzen, Deutschland",
    "maps_query": "Modehaus Rauscher, Wilthener Str. 32, 02625 Bautzen, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 441
  },
  {
    "id": "modehaus-schneider-84048-mainburg",
    "name": "Modehaus Schneider",
    "type": "Partner Store",
    "street": "Abensberger Str.",
    "house_number": "12",
    "street_line": "Abensberger Str. 12",
    "zip": "84048",
    "city": "Mainburg",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Abensberger Str. 12, 84048 Mainburg, Deutschland",
    "map_query": "Abensberger Str. 12, 84048 Mainburg, Deutschland",
    "maps_query": "Modehaus Schneider, Abensberger Str. 12, 84048 Mainburg, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 442
  },
  {
    "id": "modehaus-schoser-gmbh-86637-wertingen",
    "name": "Modehaus Schoser GmbH",
    "type": "Partner Store",
    "street": "Hauptstr.",
    "house_number": "16",
    "street_line": "Hauptstr. 16",
    "zip": "86637",
    "city": "Wertingen",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Hauptstr. 16, 86637 Wertingen, Deutschland",
    "map_query": "Hauptstr. 16, 86637 Wertingen, Deutschland",
    "maps_query": "Modehaus Schoser GmbH, Hauptstr. 16, 86637 Wertingen, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 443
  },
  {
    "id": "modehaus-schouren-72818-trochtelfingen",
    "name": "Modehaus Schouren",
    "type": "Partner Store",
    "street": "Marktstr.",
    "house_number": "31",
    "street_line": "Marktstr. 31",
    "zip": "72818",
    "city": "Trochtelfingen",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Marktstr. 31, 72818 Trochtelfingen, Deutschland",
    "map_query": "Marktstr. 31, 72818 Trochtelfingen, Deutschland",
    "maps_query": "Modehaus Schouren, Marktstr. 31, 72818 Trochtelfingen, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 444
  },
  {
    "id": "modehaus-selting-gmbh-41334-nettetal",
    "name": "Modehaus Selting GmbH",
    "type": "Partner Store",
    "street": "Kehrstr.",
    "house_number": "52",
    "street_line": "Kehrstr. 52",
    "zip": "41334",
    "city": "Nettetal",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Kehrstr. 52, 41334 Nettetal, Deutschland",
    "map_query": "Kehrstr. 52, 41334 Nettetal, Deutschland",
    "maps_query": "Modehaus Selting GmbH, Kehrstr. 52, 41334 Nettetal, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 445
  },
  {
    "id": "modehaus-strober-46325-borken",
    "name": "Modehaus Ströber",
    "type": "Partner Store",
    "street": "Schulstr.",
    "house_number": "9",
    "street_line": "Schulstr. 9",
    "zip": "46325",
    "city": "Borken",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Schulstr. 9, 46325 Borken, Deutschland",
    "map_query": "Schulstr. 9, 46325 Borken, Deutschland",
    "maps_query": "Modehaus Ströber, Schulstr. 9, 46325 Borken, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 446
  },
  {
    "id": "modehaus-z-muller-gmbh-und-co-kg-84508-burgkirchen",
    "name": "Modehaus Z. Müller GmbH & Co. KG",
    "type": "Partner Store",
    "street": "Martin-Ofner-Str.",
    "house_number": "10",
    "street_line": "Martin-Ofner-Str. 10",
    "zip": "84508",
    "city": "Burgkirchen",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Martin-Ofner-Str. 10, 84508 Burgkirchen, Deutschland",
    "map_query": "Martin-Ofner-Str. 10, 84508 Burgkirchen, Deutschland",
    "maps_query": "Modehaus Z. Müller GmbH & Co. KG, Martin-Ofner-Str. 10, 84508 Burgkirchen, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 447
  },
  {
    "id": "modehaus-zinser-gmbh-und-co-kg-herrenberg-76571-gaggenau",
    "name": "Modehaus Zinser GmbH & Co KG - Herrenberg",
    "type": "Partner Store",
    "street": "Hauptstr.",
    "house_number": "65",
    "street_line": "Hauptstr. 65",
    "zip": "76571",
    "city": "Gaggenau",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Hauptstr. 65, 76571 Gaggenau, Deutschland",
    "map_query": "Hauptstr. 65, 76571 Gaggenau, Deutschland",
    "maps_query": "Modehaus Zinser GmbH & Co KG - Herrenberg, Hauptstr. 65, 76571 Gaggenau, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 448
  },
  {
    "id": "modehaus-zinser-gmbh-und-co-kg-lahr-72119-ammerbruch",
    "name": "Modehaus Zinser GmbH & Co KG - Lahr",
    "type": "Partner Store",
    "street": "Hagenring",
    "house_number": "23",
    "street_line": "Hagenring 23",
    "zip": "72119",
    "city": "Ammerbruch",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Hagenring 23, 72119 Ammerbruch, Deutschland",
    "map_query": "Hagenring 23, 72119 Ammerbruch, Deutschland",
    "maps_query": "Modehaus Zinser GmbH & Co KG - Lahr, Hagenring 23, 72119 Ammerbruch, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 449
  },
  {
    "id": "modehaus-zinser-gmbh-und-co-kg-mergentheim-72119-ammerbruch",
    "name": "Modehaus Zinser GmbH & Co KG - Mergentheim",
    "type": "Partner Store",
    "street": "Hagenring",
    "house_number": "23",
    "street_line": "Hagenring 23",
    "zip": "72119",
    "city": "Ammerbruch",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Hagenring 23, 72119 Ammerbruch, Deutschland",
    "map_query": "Hagenring 23, 72119 Ammerbruch, Deutschland",
    "maps_query": "Modehaus Zinser GmbH & Co KG - Mergentheim, Hagenring 23, 72119 Ammerbruch, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 450
  },
  {
    "id": "modehaus-zinser-gmbh-und-co-kg-offenburg-72119-ammerbruch",
    "name": "Modehaus Zinser GmbH & Co KG - Offenburg",
    "type": "Partner Store",
    "street": "Hagenring",
    "house_number": "23",
    "street_line": "Hagenring 23",
    "zip": "72119",
    "city": "Ammerbruch",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Hagenring 23, 72119 Ammerbruch, Deutschland",
    "map_query": "Hagenring 23, 72119 Ammerbruch, Deutschland",
    "maps_query": "Modehaus Zinser GmbH & Co KG - Offenburg, Hagenring 23, 72119 Ammerbruch, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 451
  },
  {
    "id": "modehaus-zinser-gmbh-und-co-kg-singen-72119-ammerbruch",
    "name": "Modehaus Zinser GmbH & Co KG - Singen",
    "type": "Partner Store",
    "street": "Hagenring",
    "house_number": "23",
    "street_line": "Hagenring 23",
    "zip": "72119",
    "city": "Ammerbruch",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Hagenring 23, 72119 Ammerbruch, Deutschland",
    "map_query": "Hagenring 23, 72119 Ammerbruch, Deutschland",
    "maps_query": "Modehaus Zinser GmbH & Co KG - Singen, Hagenring 23, 72119 Ammerbruch, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 452
  },
  {
    "id": "modehaus-zinser-gmbh-und-co-kg-tubingen-72119-ammerbruch",
    "name": "Modehaus Zinser GmbH & Co KG - Tübingen",
    "type": "Partner Store",
    "street": "Hagenring",
    "house_number": "23",
    "street_line": "Hagenring 23",
    "zip": "72119",
    "city": "Ammerbruch",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Hagenring 23, 72119 Ammerbruch, Deutschland",
    "map_query": "Hagenring 23, 72119 Ammerbruch, Deutschland",
    "maps_query": "Modehaus Zinser GmbH & Co KG - Tübingen, Hagenring 23, 72119 Ammerbruch, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 453
  },
  {
    "id": "modehaus-zinser-gmbh-und-co-kg-vs-schw-72119-ammerbruch",
    "name": "Modehaus Zinser GmbH & Co KG - VS Schw.",
    "type": "Partner Store",
    "street": "Hagenring",
    "house_number": "23",
    "street_line": "Hagenring 23",
    "zip": "72119",
    "city": "Ammerbruch",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Hagenring 23, 72119 Ammerbruch, Deutschland",
    "map_query": "Hagenring 23, 72119 Ammerbruch, Deutschland",
    "maps_query": "Modehaus Zinser GmbH & Co KG - VS Schw., Hagenring 23, 72119 Ammerbruch, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 454
  },
  {
    "id": "modehaus-zinser-gmbh-und-co-kg-ammerbuch-72119-ammerbruch",
    "name": "Modehaus Zinser GmbH & Co KG -Ammerbuch",
    "type": "Partner Store",
    "street": "Hagenring",
    "house_number": "23",
    "street_line": "Hagenring 23",
    "zip": "72119",
    "city": "Ammerbruch",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Hagenring 23, 72119 Ammerbruch, Deutschland",
    "map_query": "Hagenring 23, 72119 Ammerbruch, Deutschland",
    "maps_query": "Modehaus Zinser GmbH & Co KG -Ammerbuch, Hagenring 23, 72119 Ammerbruch, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 455
  },
  {
    "id": "modehaus-zinser-gmbh-und-co-kg-reutlingen-72119-ammerbruch",
    "name": "Modehaus Zinser GmbH & Co KG Reutlingen",
    "type": "Partner Store",
    "street": "Hagenring",
    "house_number": "23",
    "street_line": "Hagenring 23",
    "zip": "72119",
    "city": "Ammerbruch",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Hagenring 23, 72119 Ammerbruch, Deutschland",
    "map_query": "Hagenring 23, 72119 Ammerbruch, Deutschland",
    "maps_query": "Modehaus Zinser GmbH & Co KG Reutlingen, Hagenring 23, 72119 Ammerbruch, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 456
  },
  {
    "id": "modehaus-zinser-gmbh-und-co-kg-72119-ammerbruch",
    "name": "Modehaus Zinser GmbH & Co. KG",
    "type": "Partner Store",
    "street": "Hagenring",
    "house_number": "23",
    "street_line": "Hagenring 23",
    "zip": "72119",
    "city": "Ammerbruch",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Hagenring 23, 72119 Ammerbruch, Deutschland",
    "map_query": "Hagenring 23, 72119 Ammerbruch, Deutschland",
    "maps_query": "Modehaus Zinser GmbH & Co. KG, Hagenring 23, 72119 Ammerbruch, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 457
  },
  {
    "id": "modehuis-blok-b-v-72072-tubingen",
    "name": "Modehuis Blok B.V.",
    "type": "Partner Store",
    "street": "Friedrichstr.",
    "house_number": "6",
    "street_line": "Friedrichstr. 6",
    "zip": "72072",
    "city": "Tübingen",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "The Netherlands",
    "language": "Englisch",
    "address": "Friedrichstr. 6, 72072 Tübingen, Deutschland",
    "map_query": "Friedrichstr. 6, 72072 Tübingen, Deutschland",
    "maps_query": "Modehuis Blok B.V., Friedrichstr. 6, 72072 Tübingen, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 458
  },
  {
    "id": "modemeile-gmbh-1421-sb-uithoorn",
    "name": "Modemeile Gmbh",
    "type": "Partner Store",
    "street": "Amstelplein",
    "house_number": "19",
    "street_line": "Amstelplein 19",
    "zip": "1421 SB",
    "city": "Uithoorn",
    "country": "The Netherlands",
    "country_label": "Niederlande",
    "region": "Austria",
    "language": "Deutsch",
    "address": "Amstelplein 19, 1421 SB Uithoorn, Niederlande",
    "map_query": "Amstelplein 19, 1421 SB Uithoorn, Niederlande",
    "maps_query": "Modemeile Gmbh, Amstelplein 19, 1421 SB Uithoorn, Niederlande",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 459
  },
  {
    "id": "moden-schweiss-gmbh-5020-salzburg",
    "name": "Moden Schweiss GmbH",
    "type": "Partner Store",
    "street": "Sterneckstraße",
    "house_number": "50",
    "street_line": "Sterneckstraße 50",
    "zip": "5020",
    "city": "Salzburg",
    "country": "Austria",
    "country_label": "Österreich",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Sterneckstraße 50, 5020 Salzburg, Österreich",
    "map_query": "Sterneckstraße 50, 5020 Salzburg, Österreich",
    "maps_query": "Moden Schweiss GmbH, Sterneckstraße 50, 5020 Salzburg, Österreich",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 460
  },
  {
    "id": "modeorth-84069-schierling",
    "name": "ModeOrth",
    "type": "Partner Store",
    "street": "Allersdorfer Str.",
    "house_number": "2",
    "street_line": "Allersdorfer Str. 2",
    "zip": "84069",
    "city": "Schierling",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Allersdorfer Str. 2, 84069 Schierling, Deutschland",
    "map_query": "Allersdorfer Str. 2, 84069 Schierling, Deutschland",
    "maps_query": "ModeOrth, Allersdorfer Str. 2, 84069 Schierling, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 461
  },
  {
    "id": "modepartner-heppel-gmbh-74545-michelfeld",
    "name": "Modepartner Heppel GmbH",
    "type": "Partner Store",
    "street": "Daimlerstr.",
    "house_number": "71",
    "street_line": "Daimlerstr. 71",
    "zip": "74545",
    "city": "Michelfeld",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Daimlerstr. 71, 74545 Michelfeld, Deutschland",
    "map_query": "Daimlerstr. 71, 74545 Michelfeld, Deutschland",
    "maps_query": "Modepartner Heppel GmbH, Daimlerstr. 71, 74545 Michelfeld, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 462
  },
  {
    "id": "modesta-bvba-94107-untergriesbach",
    "name": "Modesta BVBA",
    "type": "Partner Store",
    "street": "Marktplatz",
    "house_number": "2",
    "street_line": "Marktplatz 2",
    "zip": "94107",
    "city": "Untergriesbach",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Belgium",
    "language": "Englisch",
    "address": "Marktplatz 2, 94107 Untergriesbach, Deutschland",
    "map_query": "Marktplatz 2, 94107 Untergriesbach, Deutschland",
    "maps_query": "Modesta BVBA, Marktplatz 2, 94107 Untergriesbach, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 463
  },
  {
    "id": "modewelt-rossmann-gmbh-9600-ronse",
    "name": "Modewelt Rossmann GmbH",
    "type": "Partner Store",
    "street": "Wijnstraat",
    "house_number": "70",
    "street_line": "Wijnstraat 70",
    "zip": "9600",
    "city": "Ronse",
    "country": "Belgium",
    "country_label": "Belgien",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Wijnstraat 70, 9600 Ronse, Belgien",
    "map_query": "Wijnstraat 70, 9600 Ronse, Belgien",
    "maps_query": "Modewelt Rossmann GmbH, Wijnstraat 70, 9600 Ronse, Belgien",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 464
  },
  {
    "id": "modewelt-schwarz-gmbh-und-co-kg-74613-ohringen",
    "name": "Modewelt Schwarz GmbH & Co. KG",
    "type": "Partner Store",
    "street": "Marktstr. 16 -",
    "house_number": "18",
    "street_line": "Marktstr. 16 - 18",
    "zip": "74613",
    "city": "Öhringen",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Marktstr. 16 - 18, 74613 Öhringen, Deutschland",
    "map_query": "Marktstr. 16 - 18, 74613 Öhringen, Deutschland",
    "maps_query": "Modewelt Schwarz GmbH & Co. KG, Marktstr. 16 - 18, 74613 Öhringen, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 465
  },
  {
    "id": "modezar-gmbh-72280-dornstetten",
    "name": "Modezar GmbH",
    "type": "Partner Store",
    "street": "Hauptstr. 34 -",
    "house_number": "36",
    "street_line": "Hauptstr. 34 - 36",
    "zip": "72280",
    "city": "Dornstetten",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Hauptstr. 34 - 36, 72280 Dornstetten, Deutschland",
    "map_query": "Hauptstr. 34 - 36, 72280 Dornstetten, Deutschland",
    "maps_query": "Modezar GmbH, Hauptstr. 34 - 36, 72280 Dornstetten, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 466
  },
  {
    "id": "mohr-gmbh-und-co-kg-79798-jestetten",
    "name": "Mohr GmbH & Co. KG",
    "type": "Partner Store",
    "street": "Waldshuter Str.",
    "house_number": "22",
    "street_line": "Waldshuter Str. 22",
    "zip": "79798",
    "city": "Jestetten",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Waldshuter Str. 22, 79798 Jestetten, Deutschland",
    "map_query": "Waldshuter Str. 22, 79798 Jestetten, Deutschland",
    "maps_query": "Mohr GmbH & Co. KG, Waldshuter Str. 22, 79798 Jestetten, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 467
  },
  {
    "id": "mooiman-meermode-6900-lugano",
    "name": "Mooiman meermode",
    "type": "Partner Store",
    "street": "Via Marconi",
    "house_number": "2",
    "street_line": "Via Marconi 2",
    "zip": "6900",
    "city": "Lugano",
    "country": "Switzerland",
    "country_label": "Schweiz",
    "region": "The Netherlands",
    "language": "Englisch",
    "address": "Via Marconi 2, 6900 Lugano, Schweiz",
    "map_query": "Via Marconi 2, 6900 Lugano, Schweiz",
    "maps_query": "Mooiman meermode, Via Marconi 2, 6900 Lugano, Schweiz",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 468
  },
  {
    "id": "morselt-mode-7101-mv-winterswijk",
    "name": "Morselt Mode",
    "type": "Partner Store",
    "street": "Ratumsestraat",
    "house_number": "6",
    "street_line": "Ratumsestraat 6",
    "zip": "7101 MV",
    "city": "Winterswijk",
    "country": "The Netherlands",
    "country_label": "Niederlande",
    "region": "The Netherlands",
    "language": "Englisch",
    "address": "Ratumsestraat 6, 7101 MV Winterswijk, Niederlande",
    "map_query": "Ratumsestraat 6, 7101 MV Winterswijk, Niederlande",
    "maps_query": "Morselt Mode, Ratumsestraat 6, 7101 MV Winterswijk, Niederlande",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 469
  },
  {
    "id": "mulder-mode-35000-slavonski-brod",
    "name": "Mulder Mode",
    "type": "Partner Store",
    "street": "PETRA KREŠIMIRA IV",
    "house_number": "52/2",
    "street_line": "PETRA KREŠIMIRA IV 52/2",
    "zip": "35000",
    "city": "SLAVONSKI BROD",
    "country": "Croatia",
    "country_label": "Croatia",
    "region": "The Netherlands",
    "language": "Englisch",
    "address": "PETRA KREŠIMIRA IV 52/2, 35000 SLAVONSKI BROD, Croatia",
    "map_query": "PETRA KREŠIMIRA IV 52/2, 35000 SLAVONSKI BROD, Croatia",
    "maps_query": "Mulder Mode, PETRA KREŠIMIRA IV 52/2, 35000 SLAVONSKI BROD, Croatia",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 470
  },
  {
    "id": "mull-castricum-2741-nl-waddinxveen",
    "name": "Mull Castricum",
    "type": "Partner Store",
    "street": "Promenade",
    "house_number": "79-81",
    "street_line": "Promenade 79-81",
    "zip": "2741 NL",
    "city": "Waddinxveen",
    "country": "The Netherlands",
    "country_label": "Niederlande",
    "region": "The Netherlands",
    "language": "Englisch",
    "address": "Promenade 79-81, 2741 NL Waddinxveen, Niederlande",
    "map_query": "Promenade 79-81, 2741 NL Waddinxveen, Niederlande",
    "maps_query": "Mull Castricum, Promenade 79-81, 2741 NL Waddinxveen, Niederlande",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 471
  },
  {
    "id": "muller-ditschler-gmbh-8716-schmerikon",
    "name": "Müller-Ditschler GmbH",
    "type": "Partner Store",
    "street": "Hauptstrasse",
    "house_number": "29/33",
    "street_line": "Hauptstrasse 29/33",
    "zip": "8716",
    "city": "Schmerikon",
    "country": "Switzerland",
    "country_label": "Schweiz",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Hauptstrasse 29/33, 8716 Schmerikon, Schweiz",
    "map_query": "Hauptstrasse 29/33, 8716 Schmerikon, Schweiz",
    "maps_query": "Müller-Ditschler GmbH, Hauptstrasse 29/33, 8716 Schmerikon, Schweiz",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 472
  },
  {
    "id": "muller-ditschler-hanau-gmbh-63645-budingen",
    "name": "Müller-Ditschler Hanau GmbH",
    "type": "Partner Store",
    "street": "Bahnhofstr.",
    "house_number": "39",
    "street_line": "Bahnhofstr. 39",
    "zip": "63645",
    "city": "Büdingen",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Bahnhofstr. 39, 63645 Büdingen, Deutschland",
    "map_query": "Bahnhofstr. 39, 63645 Büdingen, Deutschland",
    "maps_query": "Müller-Ditschler Hanau GmbH, Bahnhofstr. 39, 63645 Büdingen, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 473
  },
  {
    "id": "munch-mode-gmbh-und-co-kg-63450-hanau",
    "name": "Münch Mode GmbH & Co. KG",
    "type": "Partner Store",
    "street": "Rosenstraße",
    "house_number": "14",
    "street_line": "Rosenstraße 14",
    "zip": "63450",
    "city": "Hanau",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Rosenstraße 14, 63450 Hanau, Deutschland",
    "map_query": "Rosenstraße 14, 63450 Hanau, Deutschland",
    "maps_query": "Münch Mode GmbH & Co. KG, Rosenstraße 14, 63450 Hanau, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 474
  },
  {
    "id": "murk-gmbh-und-co-kg-74653-kunzelsau",
    "name": "MURK GmbH & Co. KG",
    "type": "Partner Store",
    "street": "Hauptstr. 36 -",
    "house_number": "40",
    "street_line": "Hauptstr. 36 - 40",
    "zip": "74653",
    "city": "Künzelsau",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Hauptstr. 36 - 40, 74653 Künzelsau, Deutschland",
    "map_query": "Hauptstr. 36 - 40, 74653 Künzelsau, Deutschland",
    "maps_query": "MURK GmbH & Co. KG, Hauptstr. 36 - 40, 74653 Künzelsau, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 475
  },
  {
    "id": "mylilis-4147-aesch",
    "name": "MyLilis",
    "type": "Partner Store",
    "street": "Bahnhofstrasse",
    "house_number": "1",
    "street_line": "Bahnhofstrasse 1",
    "zip": "4147",
    "city": "Aesch",
    "country": "Switzerland",
    "country_label": "Schweiz",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Bahnhofstrasse 1, 4147 Aesch, Schweiz",
    "map_query": "Bahnhofstrasse 1, 4147 Aesch, Schweiz",
    "maps_query": "MyLilis, Bahnhofstrasse 1, 4147 Aesch, Schweiz",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 476
  },
  {
    "id": "nagl-mode-gmbh-6041-gosselies",
    "name": "Nagl Mode GmbH",
    "type": "Partner Store",
    "street": "Avenue Du Chene Saint Jean",
    "house_number": "17",
    "street_line": "Avenue Du Chene Saint Jean 17",
    "zip": "6041",
    "city": "Gosselies",
    "country": "Belgium",
    "country_label": "Belgien",
    "region": "Austria",
    "language": "Deutsch",
    "address": "Avenue Du Chene Saint Jean 17, 6041 Gosselies, Belgien",
    "map_query": "Avenue Du Chene Saint Jean 17, 6041 Gosselies, Belgien",
    "maps_query": "Nagl Mode GmbH, Avenue Du Chene Saint Jean 17, 6041 Gosselies, Belgien",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 477
  },
  {
    "id": "napa-alliance-srl-paradox-27305-bruchhausen-vilsen",
    "name": "Napa Alliance SRL / Paradox",
    "type": "Partner Store",
    "street": "Bahnhofstraße",
    "house_number": "53",
    "street_line": "Bahnhofstraße 53",
    "zip": "27305",
    "city": "Bruchhausen-Vilsen",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Belgium",
    "language": "Englisch",
    "address": "Bahnhofstraße 53, 27305 Bruchhausen-Vilsen, Deutschland",
    "map_query": "Bahnhofstraße 53, 27305 Bruchhausen-Vilsen, Deutschland",
    "maps_query": "Napa Alliance SRL / Paradox, Bahnhofstraße 53, 27305 Bruchhausen-Vilsen, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 478
  },
  {
    "id": "nero-menswear-5101-erpent",
    "name": "NERO Menswear",
    "type": "Partner Store",
    "street": "Chaussee de Marche",
    "house_number": "524",
    "street_line": "Chaussee de Marche 524",
    "zip": "5101",
    "city": "Erpent",
    "country": "Belgium",
    "country_label": "Belgien",
    "region": "The Netherlands",
    "language": "Englisch",
    "address": "Chaussee de Marche 524, 5101 Erpent, Belgien",
    "map_query": "Chaussee de Marche 524, 5101 Erpent, Belgien",
    "maps_query": "NERO Menswear, Chaussee de Marche 524, 5101 Erpent, Belgien",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 479
  },
  {
    "id": "niebel-gmbh-und-co-kg-32-085-modlinica",
    "name": "Niebel GmbH & Co. KG",
    "type": "Partner Store",
    "street": "Czestochowska",
    "house_number": "36",
    "street_line": "Czestochowska 36",
    "zip": "32-085",
    "city": "Modlinica",
    "country": "Poland",
    "country_label": "Poland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Czestochowska 36, 32-085 Modlinica, Poland",
    "map_query": "Czestochowska 36, 32-085 Modlinica, Poland",
    "maps_query": "Niebel GmbH & Co. KG, Czestochowska 36, 32-085 Modlinica, Poland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 480
  },
  {
    "id": "niebel-kg-filiale-walldorf-69121-heidelberg",
    "name": "Niebel KG / Filiale Walldorf",
    "type": "Partner Store",
    "street": "Dossenheimer Landstr.",
    "house_number": "98",
    "street_line": "Dossenheimer Landstr. 98",
    "zip": "69121",
    "city": "Heidelberg",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Dossenheimer Landstr. 98, 69121 Heidelberg, Deutschland",
    "map_query": "Dossenheimer Landstr. 98, 69121 Heidelberg, Deutschland",
    "maps_query": "Niebel KG / Filiale Walldorf, Dossenheimer Landstr. 98, 69121 Heidelberg, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 481
  },
  {
    "id": "nieuwnieuw-69121-heidelberg",
    "name": "Nieuwnieuw",
    "type": "Partner Store",
    "street": "Dossenheimer Landstraße",
    "house_number": "98",
    "street_line": "Dossenheimer Landstraße 98",
    "zip": "69121",
    "city": "Heidelberg",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "The Netherlands",
    "language": "Englisch",
    "address": "Dossenheimer Landstraße 98, 69121 Heidelberg, Deutschland",
    "map_query": "Dossenheimer Landstraße 98, 69121 Heidelberg, Deutschland",
    "maps_query": "Nieuwnieuw, Dossenheimer Landstraße 98, 69121 Heidelberg, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 482
  },
  {
    "id": "noba-nv-9035-eg-dronrijp",
    "name": "Noba nv",
    "type": "Partner Store",
    "street": "Hearewei",
    "house_number": "7",
    "street_line": "Hearewei 7",
    "zip": "9035 EG",
    "city": "Dronrijp",
    "country": "The Netherlands",
    "country_label": "Niederlande",
    "region": "Belgium",
    "language": "Englisch",
    "address": "Hearewei 7, 9035 EG Dronrijp, Niederlande",
    "map_query": "Hearewei 7, 9035 EG Dronrijp, Niederlande",
    "maps_query": "Noba nv, Hearewei 7, 9035 EG Dronrijp, Niederlande",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 483
  },
  {
    "id": "nortex-mode-center-gmbh-co-kg-3740-bilzen",
    "name": "Nortex Mode-Center GmbH Co. KG",
    "type": "Partner Store",
    "street": "Riemsterweg",
    "house_number": "120",
    "street_line": "Riemsterweg 120",
    "zip": "3740",
    "city": "Bilzen",
    "country": "Belgium",
    "country_label": "Belgien",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Riemsterweg 120, 3740 Bilzen, Belgien",
    "map_query": "Riemsterweg 120, 3740 Bilzen, Belgien",
    "maps_query": "Nortex Mode-Center GmbH Co. KG, Riemsterweg 120, 3740 Bilzen, Belgien",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 484
  },
  {
    "id": "north-sea-fashion-bvba-24539-neumunster",
    "name": "North Sea Fashion BVBA",
    "type": "Partner Store",
    "street": "Grüner Weg 9 -",
    "house_number": "11",
    "street_line": "Grüner Weg 9 - 11",
    "zip": "24539",
    "city": "Neumünster",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Belgium",
    "language": "Englisch",
    "address": "Grüner Weg 9 - 11, 24539 Neumünster, Deutschland",
    "map_query": "Grüner Weg 9 - 11, 24539 Neumünster, Deutschland",
    "maps_query": "North Sea Fashion BVBA, Grüner Weg 9 - 11, 24539 Neumünster, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 485
  },
  {
    "id": "nuvelstijn-mode-8660-de-panne",
    "name": "Nuvelstijn Mode",
    "type": "Partner Store",
    "street": "Zeelaan",
    "house_number": "138",
    "street_line": "Zeelaan 138",
    "zip": "8660",
    "city": "De Panne",
    "country": "Belgium",
    "country_label": "Belgien",
    "region": "The Netherlands",
    "language": "Englisch",
    "address": "Zeelaan 138, 8660 De Panne, Belgien",
    "map_query": "Zeelaan 138, 8660 De Panne, Belgien",
    "maps_query": "Nuvelstijn Mode, Zeelaan 138, 8660 De Panne, Belgien",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 486
  },
  {
    "id": "nuyts-herenmode-7701-gw-dedemsvaart",
    "name": "Nuyts herenmode",
    "type": "Partner Store",
    "street": "Markt",
    "house_number": "101",
    "street_line": "Markt 101",
    "zip": "7701 GW",
    "city": "Dedemsvaart",
    "country": "The Netherlands",
    "country_label": "Niederlande",
    "region": "Belgium",
    "language": "Englisch",
    "address": "Markt 101, 7701 GW Dedemsvaart, Niederlande",
    "map_query": "Markt 101, 7701 GW Dedemsvaart, Niederlande",
    "maps_query": "Nuyts herenmode, Markt 101, 7701 GW Dedemsvaart, Niederlande",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 487
  },
  {
    "id": "nv-de-witte-duif-2450-meerhout",
    "name": "NV De Witte Duif",
    "type": "Partner Store",
    "street": "Veldstraat",
    "house_number": "5",
    "street_line": "Veldstraat 5",
    "zip": "2450",
    "city": "Meerhout",
    "country": "Belgium",
    "country_label": "Belgien",
    "region": "Belgium",
    "language": "Englisch",
    "address": "Veldstraat 5, 2450 Meerhout, Belgien",
    "map_query": "Veldstraat 5, 2450 Meerhout, Belgien",
    "maps_query": "NV De Witte Duif, Veldstraat 5, 2450 Meerhout, Belgien",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 488
  },
  {
    "id": "oak-4301-rx-zierikzee",
    "name": "OAK",
    "type": "Partner Store",
    "street": "Ruigendijkweg",
    "house_number": "1",
    "street_line": "Ruigendijkweg 1",
    "zip": "4301 RX",
    "city": "Zierikzee",
    "country": "The Netherlands",
    "country_label": "Niederlande",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Ruigendijkweg 1, 4301 RX Zierikzee, Niederlande",
    "map_query": "Ruigendijkweg 1, 4301 RX Zierikzee, Niederlande",
    "maps_query": "OAK, Ruigendijkweg 1, 4301 RX Zierikzee, Niederlande",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 489
  },
  {
    "id": "oerlemans-mode-33378-rheda-wiedenbruck",
    "name": "Oerlemans Mode",
    "type": "Partner Store",
    "street": "Marienstraße",
    "house_number": "20",
    "street_line": "Marienstraße 20",
    "zip": "33378",
    "city": "Rheda Wiedenbrück",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "The Netherlands",
    "language": "Englisch",
    "address": "Marienstraße 20, 33378 Rheda Wiedenbrück, Deutschland",
    "map_query": "Marienstraße 20, 33378 Rheda Wiedenbrück, Deutschland",
    "maps_query": "Oerlemans Mode, Marienstraße 20, 33378 Rheda Wiedenbrück, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 490
  },
  {
    "id": "ofm-retail-b-v-4651-bn-steenbergen",
    "name": "OFM Retail B.V.",
    "type": "Partner Store",
    "street": "Kaaistraat",
    "house_number": "4",
    "street_line": "Kaaistraat 4",
    "zip": "4651 BN",
    "city": "Steenbergen",
    "country": "The Netherlands",
    "country_label": "Niederlande",
    "region": "The Netherlands",
    "language": "Englisch",
    "address": "Kaaistraat 4, 4651 BN Steenbergen, Niederlande",
    "map_query": "Kaaistraat 4, 4651 BN Steenbergen, Niederlande",
    "maps_query": "OFM Retail B.V., Kaaistraat 4, 4651 BN Steenbergen, Niederlande",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 491
  },
  {
    "id": "oft-aankoop-nv-4191pc-geldermalsen",
    "name": "OFT Aankoop NV",
    "type": "Partner Store",
    "street": "De Aaldor",
    "house_number": "13",
    "street_line": "De Aaldor 13",
    "zip": "4191PC",
    "city": "Geldermalsen",
    "country": "The Netherlands",
    "country_label": "Niederlande",
    "region": "Belgium",
    "language": "Englisch",
    "address": "De Aaldor 13, 4191PC Geldermalsen, Niederlande",
    "map_query": "De Aaldor 13, 4191PC Geldermalsen, Niederlande",
    "maps_query": "OFT Aankoop NV, De Aaldor 13, 4191PC Geldermalsen, Niederlande",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 492
  },
  {
    "id": "omega-mannermode-40476-duesseldorf",
    "name": "OMEGA Männermode",
    "type": "Partner Store",
    "street": "Seydlitzstr.",
    "house_number": "36",
    "street_line": "Seydlitzstr. 36",
    "zip": "40476",
    "city": "Duesseldorf",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Seydlitzstr. 36, 40476 Duesseldorf, Deutschland",
    "map_query": "Seydlitzstr. 36, 40476 Duesseldorf, Deutschland",
    "maps_query": "OMEGA Männermode, Seydlitzstr. 36, 40476 Duesseldorf, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 493
  },
  {
    "id": "ongers-herenmode-17033-neubrandenburg",
    "name": "Ongers Herenmode",
    "type": "Partner Store",
    "street": "Turmstr. 16 -",
    "house_number": "18",
    "street_line": "Turmstr. 16 - 18",
    "zip": "17033",
    "city": "Neubrandenburg",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "The Netherlands",
    "language": "Englisch",
    "address": "Turmstr. 16 - 18, 17033 Neubrandenburg, Deutschland",
    "map_query": "Turmstr. 16 - 18, 17033 Neubrandenburg, Deutschland",
    "maps_query": "Ongers Herenmode, Turmstr. 16 - 18, 17033 Neubrandenburg, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 494
  },
  {
    "id": "ostlander-next-3280-murten",
    "name": "Ostländer Next",
    "type": "Partner Store",
    "street": "Hauptstraße",
    "house_number": "42-48",
    "street_line": "Hauptstraße 42-48",
    "zip": "3280",
    "city": "Murten",
    "country": "Switzerland",
    "country_label": "Schweiz",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Hauptstraße 42-48, 3280 Murten, Schweiz",
    "map_query": "Hauptstraße 42-48, 3280 Murten, Schweiz",
    "maps_query": "Ostländer Next, Hauptstraße 42-48, 3280 Murten, Schweiz",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 495
  },
  {
    "id": "outfit-herrenladen-52249-eschweiler",
    "name": "Outfit Herrenladen",
    "type": "Partner Store",
    "street": "Grabenstr.",
    "house_number": "31",
    "street_line": "Grabenstr. 31",
    "zip": "52249",
    "city": "Eschweiler",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Grabenstr. 31, 52249 Eschweiler, Deutschland",
    "map_query": "Grabenstr. 31, 52249 Eschweiler, Deutschland",
    "maps_query": "Outfit Herrenladen, Grabenstr. 31, 52249 Eschweiler, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 496
  },
  {
    "id": "p-und-c-berlin-ii-010-46562-voerde",
    "name": "P&C Berlin II 010",
    "type": "Partner Store",
    "street": "Alte Prinzenstraße",
    "house_number": "22",
    "street_line": "Alte Prinzenstraße 22",
    "zip": "46562",
    "city": "Voerde",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Alte Prinzenstraße 22, 46562 Voerde, Deutschland",
    "map_query": "Alte Prinzenstraße 22, 46562 Voerde, Deutschland",
    "maps_query": "P&C Berlin II 010, Alte Prinzenstraße 22, 46562 Voerde, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 497
  },
  {
    "id": "p-und-c-den-haag-312-14612-falkensee",
    "name": "P&C Den Haag 312",
    "type": "Partner Store",
    "street": "Straße der Einheit",
    "house_number": "139",
    "street_line": "Straße der Einheit 139",
    "zip": "14612",
    "city": "Falkensee",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "",
    "language": "Englisch",
    "address": "Straße der Einheit 139, 14612 Falkensee, Deutschland",
    "map_query": "Straße der Einheit 139, 14612 Falkensee, Deutschland",
    "maps_query": "P&C Den Haag 312, Straße der Einheit 139, 14612 Falkensee, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 498
  },
  {
    "id": "p-und-c-dortmund-i-040-50181-bedburg",
    "name": "P&C Dortmund I 040",
    "type": "Partner Store",
    "street": "Sany Allee",
    "house_number": "2",
    "street_line": "Sany Allee 2",
    "zip": "50181",
    "city": "Bedburg",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Sany Allee 2, 50181 Bedburg, Deutschland",
    "map_query": "Sany Allee 2, 50181 Bedburg, Deutschland",
    "maps_query": "P&C Dortmund I 040, Sany Allee 2, 50181 Bedburg, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 499
  },
  {
    "id": "p-und-c-dusseldorf-003-50181-bedburg",
    "name": "P&C Düsseldorf 003",
    "type": "Partner Store",
    "street": "Sany",
    "house_number": "2",
    "street_line": "Sany 2",
    "zip": "50181",
    "city": "Bedburg",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Sany 2, 50181 Bedburg, Deutschland",
    "map_query": "Sany 2, 50181 Bedburg, Deutschland",
    "maps_query": "P&C Düsseldorf 003, Sany 2, 50181 Bedburg, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 500
  },
  {
    "id": "p-und-c-essen-i-005-50181-bedburg",
    "name": "P&C Essen I 005",
    "type": "Partner Store",
    "street": "Sany Allee",
    "house_number": "2",
    "street_line": "Sany Allee 2",
    "zip": "50181",
    "city": "Bedburg",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Sany Allee 2, 50181 Bedburg, Deutschland",
    "map_query": "Sany Allee 2, 50181 Bedburg, Deutschland",
    "maps_query": "P&C Essen I 005, Sany Allee 2, 50181 Bedburg, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 501
  },
  {
    "id": "p-und-c-frankfurt-007-50181-bedburg",
    "name": "P&C Frankfurt 007",
    "type": "Partner Store",
    "street": "Sany Allee",
    "house_number": "2",
    "street_line": "Sany Allee 2",
    "zip": "50181",
    "city": "Bedburg",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Sany Allee 2, 50181 Bedburg, Deutschland",
    "map_query": "Sany Allee 2, 50181 Bedburg, Deutschland",
    "maps_query": "P&C Frankfurt 007, Sany Allee 2, 50181 Bedburg, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 502
  },
  {
    "id": "p-und-c-koblenz-lohrcenter-235-63329-egelsbach",
    "name": "P&C Koblenz Löhrcenter 235",
    "type": "Partner Store",
    "street": "Marie-Curie-Straße",
    "house_number": "24",
    "street_line": "Marie-Curie-Straße 24",
    "zip": "63329",
    "city": "Egelsbach",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Marie-Curie-Straße 24, 63329 Egelsbach, Deutschland",
    "map_query": "Marie-Curie-Straße 24, 63329 Egelsbach, Deutschland",
    "maps_query": "P&C Koblenz Löhrcenter 235, Marie-Curie-Straße 24, 63329 Egelsbach, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 503
  },
  {
    "id": "p-und-c-koln-i-226-50181-bedburg",
    "name": "P&C Köln I 226",
    "type": "Partner Store",
    "street": "Sany",
    "house_number": "2",
    "street_line": "Sany 2",
    "zip": "50181",
    "city": "Bedburg",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Sany 2, 50181 Bedburg, Deutschland",
    "map_query": "Sany 2, 50181 Bedburg, Deutschland",
    "maps_query": "P&C Köln I 226, Sany 2, 50181 Bedburg, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 504
  },
  {
    "id": "p-und-c-leipzig-046-50181-bedburg",
    "name": "P&C Leipzig 046",
    "type": "Partner Store",
    "street": "Sany",
    "house_number": "2",
    "street_line": "Sany 2",
    "zip": "50181",
    "city": "Bedburg",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Sany 2, 50181 Bedburg, Deutschland",
    "map_query": "Sany 2, 50181 Bedburg, Deutschland",
    "maps_query": "P&C Leipzig 046, Sany 2, 50181 Bedburg, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 505
  },
  {
    "id": "p-und-c-lepla-266-34355-staufenberg",
    "name": "P&C LEPLA 266",
    "type": "Partner Store",
    "street": "Vor der Hecke",
    "house_number": "4-12a",
    "street_line": "Vor der Hecke 4-12a",
    "zip": "34355",
    "city": "Staufenberg",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Vor der Hecke 4-12a, 34355 Staufenberg, Deutschland",
    "map_query": "Vor der Hecke 4-12a, 34355 Staufenberg, Deutschland",
    "maps_query": "P&C LEPLA 266, Vor der Hecke 4-12a, 34355 Staufenberg, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 506
  },
  {
    "id": "p-und-c-mall-of-nl-327-14612-falkensee",
    "name": "P&C Mall of NL 327",
    "type": "Partner Store",
    "street": "Straße der Einheit",
    "house_number": "139",
    "street_line": "Straße der Einheit 139",
    "zip": "14612",
    "city": "Falkensee",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "",
    "language": "Deutsch",
    "address": "Straße der Einheit 139, 14612 Falkensee, Deutschland",
    "map_query": "Straße der Einheit 139, 14612 Falkensee, Deutschland",
    "maps_query": "P&C Mall of NL 327, Straße der Einheit 139, 14612 Falkensee, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 507
  },
  {
    "id": "p-und-c-mannheim-020-50181-bedburg",
    "name": "P&C Mannheim 020",
    "type": "Partner Store",
    "street": "Sany Allee",
    "house_number": "2",
    "street_line": "Sany Allee 2",
    "zip": "50181",
    "city": "Bedburg",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Sany Allee 2, 50181 Bedburg, Deutschland",
    "map_query": "Sany Allee 2, 50181 Bedburg, Deutschland",
    "maps_query": "P&C Mannheim 020, Sany Allee 2, 50181 Bedburg, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 508
  },
  {
    "id": "p-und-c-mtz-049-63329-egelsbach",
    "name": "P&C MTZ 049",
    "type": "Partner Store",
    "street": "Marie-Curie-Straße",
    "house_number": "24",
    "street_line": "Marie-Curie-Straße 24",
    "zip": "63329",
    "city": "Egelsbach",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Marie-Curie-Straße 24, 63329 Egelsbach, Deutschland",
    "map_query": "Marie-Curie-Straße 24, 63329 Egelsbach, Deutschland",
    "maps_query": "P&C MTZ 049, Marie-Curie-Straße 24, 63329 Egelsbach, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 509
  },
  {
    "id": "p-und-c-oberhausen-centro-241-63329-egelsbach",
    "name": "P&C Oberhausen Centro 241",
    "type": "Partner Store",
    "street": "Marie-Curie-Straße",
    "house_number": "24",
    "street_line": "Marie-Curie-Straße 24",
    "zip": "63329",
    "city": "Egelsbach",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Marie-Curie-Straße 24, 63329 Egelsbach, Deutschland",
    "map_query": "Marie-Curie-Straße 24, 63329 Egelsbach, Deutschland",
    "maps_query": "P&C Oberhausen Centro 241, Marie-Curie-Straße 24, 63329 Egelsbach, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 510
  },
  {
    "id": "p-und-c-omnichannel-546-50181-bedburg",
    "name": "P&C Omnichannel 546",
    "type": "Partner Store",
    "street": "Sany",
    "house_number": "2",
    "street_line": "Sany 2",
    "zip": "50181",
    "city": "Bedburg",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Sany 2, 50181 Bedburg, Deutschland",
    "map_query": "Sany 2, 50181 Bedburg, Deutschland",
    "maps_query": "P&C Omnichannel 546, Sany 2, 50181 Bedburg, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 511
  },
  {
    "id": "p-und-c-retail-buying-gmbh-und-co-kg-63741-aschaffenburg",
    "name": "P&C Retail Buying GmbH & Co. KG",
    "type": "Partner Store",
    "street": "Weichertstraße",
    "house_number": "5",
    "street_line": "Weichertstraße 5",
    "zip": "63741",
    "city": "Aschaffenburg",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Englisch",
    "address": "Weichertstraße 5, 63741 Aschaffenburg, Deutschland",
    "map_query": "Weichertstraße 5, 63741 Aschaffenburg, Deutschland",
    "maps_query": "P&C Retail Buying GmbH & Co. KG, Weichertstraße 5, 63741 Aschaffenburg, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 512
  },
  {
    "id": "p-und-c-rotterdam-307-40212-dusseldorf",
    "name": "P&C Rotterdam 307",
    "type": "Partner Store",
    "street": "Berliner Allee",
    "house_number": "2",
    "street_line": "Berliner Allee 2",
    "zip": "40212",
    "city": "Düsseldorf",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Berliner Allee 2, 40212 Düsseldorf, Deutschland",
    "map_query": "Berliner Allee 2, 40212 Düsseldorf, Deutschland",
    "maps_query": "P&C Rotterdam 307, Berliner Allee 2, 40212 Düsseldorf, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 513
  },
  {
    "id": "p-und-c-stuttgart-227-50181-bedburg",
    "name": "P&C Stuttgart 227",
    "type": "Partner Store",
    "street": "Sany",
    "house_number": "2",
    "street_line": "Sany 2",
    "zip": "50181",
    "city": "Bedburg",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Sany 2, 50181 Bedburg, Deutschland",
    "map_query": "Sany 2, 50181 Bedburg, Deutschland",
    "maps_query": "P&C Stuttgart 227, Sany 2, 50181 Bedburg, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 514
  },
  {
    "id": "p-und-c-weil-am-rhein-258-34355-staufenberg",
    "name": "P&C Weil am Rhein 258",
    "type": "Partner Store",
    "street": "Vor der Hecke",
    "house_number": "4-12a",
    "street_line": "Vor der Hecke 4-12a",
    "zip": "34355",
    "city": "Staufenberg",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Vor der Hecke 4-12a, 34355 Staufenberg, Deutschland",
    "map_query": "Vor der Hecke 4-12a, 34355 Staufenberg, Deutschland",
    "maps_query": "P&C Weil am Rhein 258, Vor der Hecke 4-12a, 34355 Staufenberg, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 515
  },
  {
    "id": "p-und-c-wildau-201-34355-staufenberg",
    "name": "P&C Wildau 201",
    "type": "Partner Store",
    "street": "Vor der Hecke",
    "house_number": "4-12a",
    "street_line": "Vor der Hecke 4-12a",
    "zip": "34355",
    "city": "Staufenberg",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Vor der Hecke 4-12a, 34355 Staufenberg, Deutschland",
    "map_query": "Vor der Hecke 4-12a, 34355 Staufenberg, Deutschland",
    "maps_query": "P&C Wildau 201, Vor der Hecke 4-12a, 34355 Staufenberg, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 516
  },
  {
    "id": "p-und-c-wuppertal-018-14612-falkensee",
    "name": "P&C Wuppertal 018",
    "type": "Partner Store",
    "street": "Straße der Einheit",
    "house_number": "139",
    "street_line": "Straße der Einheit 139",
    "zip": "14612",
    "city": "Falkensee",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Straße der Einheit 139, 14612 Falkensee, Deutschland",
    "map_query": "Straße der Einheit 139, 14612 Falkensee, Deutschland",
    "maps_query": "P&C Wuppertal 018, Straße der Einheit 139, 14612 Falkensee, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 517
  },
  {
    "id": "paul-passant-4102-binningen",
    "name": "Paul Passant",
    "type": "Partner Store",
    "street": "Hauptstrasse",
    "house_number": "122",
    "street_line": "Hauptstrasse 122",
    "zip": "4102",
    "city": "Binningen",
    "country": "Switzerland",
    "country_label": "Schweiz",
    "region": "France",
    "language": "Englisch",
    "address": "Hauptstrasse 122, 4102 Binningen, Schweiz",
    "map_query": "Hauptstrasse 122, 4102 Binningen, Schweiz",
    "maps_query": "Paul Passant, Hauptstrasse 122, 4102 Binningen, Schweiz",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 518
  },
  {
    "id": "pawu-gmbh-23000-gueret",
    "name": "PaWu GmbH",
    "type": "Partner Store",
    "street": "Place du Marché",
    "house_number": "",
    "street_line": "Place du Marché",
    "zip": "23000",
    "city": "Guéret",
    "country": "France",
    "country_label": "Frankreich",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Place du Marché, 23000 Guéret, Frankreich",
    "map_query": "PaWu GmbH, Place du Marché, 23000 Guéret, Frankreich",
    "maps_query": "PaWu GmbH, Place du Marché, 23000 Guéret, Frankreich",
    "note": "Sortiment und Verfügbarkeit können variieren. Adresse bitte vor Besuch über den Händler prüfen.",
    "data_quality": [
      "house_number_missing"
    ],
    "source_row": 519
  },
  {
    "id": "pdk-fashion-55276-oppenheim",
    "name": "PDK Fashion",
    "type": "Partner Store",
    "street": "Sant-Ambrogio-Ring",
    "house_number": "6",
    "street_line": "Sant-Ambrogio-Ring 6",
    "zip": "55276",
    "city": "Oppenheim",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Belgium",
    "language": "Englisch",
    "address": "Sant-Ambrogio-Ring 6, 55276 Oppenheim, Deutschland",
    "map_query": "Sant-Ambrogio-Ring 6, 55276 Oppenheim, Deutschland",
    "maps_query": "PDK Fashion, Sant-Ambrogio-Ring 6, 55276 Oppenheim, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 520
  },
  {
    "id": "pecht-gmbh-3800-sint-truiden",
    "name": "Pecht GmbH",
    "type": "Partner Store",
    "street": "Toekomststraat",
    "house_number": "1",
    "street_line": "Toekomststraat 1",
    "zip": "3800",
    "city": "Sint-Truiden",
    "country": "Belgium",
    "country_label": "Belgien",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Toekomststraat 1, 3800 Sint-Truiden, Belgien",
    "map_query": "Toekomststraat 1, 3800 Sint-Truiden, Belgien",
    "maps_query": "Pecht GmbH, Toekomststraat 1, 3800 Sint-Truiden, Belgien",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 521
  },
  {
    "id": "perfect-man-mode-fur-manner-1201-genf",
    "name": "Perfect Man Mode für Männer",
    "type": "Partner Store",
    "street": "Rue de Berne",
    "house_number": "8",
    "street_line": "Rue de Berne 8",
    "zip": "1201",
    "city": "Genf",
    "country": "Switzerland",
    "country_label": "Schweiz",
    "region": "Austria",
    "language": "Deutsch",
    "address": "Rue de Berne 8, 1201 Genf, Schweiz",
    "map_query": "Rue de Berne 8, 1201 Genf, Schweiz",
    "maps_query": "Perfect Man Mode für Männer, Rue de Berne 8, 1201 Genf, Schweiz",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 522
  },
  {
    "id": "peter-g-ohg-6330-kufstein",
    "name": "Peter G. OHG",
    "type": "Partner Store",
    "street": "Prof.-Sinwel-Weg",
    "house_number": "2",
    "street_line": "Prof.-Sinwel-Weg 2",
    "zip": "6330",
    "city": "Kufstein",
    "country": "Austria",
    "country_label": "Österreich",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Prof.-Sinwel-Weg 2, 6330 Kufstein, Österreich",
    "map_query": "Prof.-Sinwel-Weg 2, 6330 Kufstein, Österreich",
    "maps_query": "Peter G. OHG, Prof.-Sinwel-Weg 2, 6330 Kufstein, Österreich",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 523
  },
  {
    "id": "peter-ruths-ohg-50259-pulheim",
    "name": "Peter Ruths OHG",
    "type": "Partner Store",
    "street": "Auf dem Driesch",
    "house_number": "14-16",
    "street_line": "Auf dem Driesch 14-16",
    "zip": "50259",
    "city": "Pulheim",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Auf dem Driesch 14-16, 50259 Pulheim, Deutschland",
    "map_query": "Auf dem Driesch 14-16, 50259 Pulheim, Deutschland",
    "maps_query": "Peter Ruths OHG, Auf dem Driesch 14-16, 50259 Pulheim, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 524
  },
  {
    "id": "peters-modehaus-gmbh-61169-friedberg",
    "name": "Peters Modehaus GmbH",
    "type": "Partner Store",
    "street": "Kaiserstr. 5 -7",
    "house_number": "",
    "street_line": "Kaiserstr. 5 -7",
    "zip": "61169",
    "city": "Friedberg",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Kaiserstr. 5 -7, 61169 Friedberg, Deutschland",
    "map_query": "Peters Modehaus GmbH, Kaiserstr. 5 -7, 61169 Friedberg, Deutschland",
    "maps_query": "Peters Modehaus GmbH, Kaiserstr. 5 -7, 61169 Friedberg, Deutschland",
    "note": "Sortiment und Verfügbarkeit können variieren. Adresse bitte vor Besuch über den Händler prüfen.",
    "data_quality": [
      "house_number_missing"
    ],
    "source_row": 525
  },
  {
    "id": "pettinger-sarl-50189-elsdorf",
    "name": "Pettinger SARL",
    "type": "Partner Store",
    "street": "Köln-Aachener Straße",
    "house_number": "142-144",
    "street_line": "Köln-Aachener Straße 142-144",
    "zip": "50189",
    "city": "Elsdorf",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Luxembourg",
    "language": "Englisch",
    "address": "Köln-Aachener Straße 142-144, 50189 Elsdorf, Deutschland",
    "map_query": "Köln-Aachener Straße 142-144, 50189 Elsdorf, Deutschland",
    "maps_query": "Pettinger SARL, Köln-Aachener Straße 142-144, 50189 Elsdorf, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 526
  },
  {
    "id": "pfeiffer-gmbh-und-co-kg-hs-achern-6718-grevenmacher",
    "name": "Pfeiffer GmbH & Co. KG Hs Achern",
    "type": "Partner Store",
    "street": "Rue Des Caves",
    "house_number": "2",
    "street_line": "Rue Des Caves 2",
    "zip": "6718",
    "city": "Grevenmacher",
    "country": "Luxembourg",
    "country_label": "Luxemburg",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Rue Des Caves 2, 6718 Grevenmacher, Luxemburg",
    "map_query": "Rue Des Caves 2, 6718 Grevenmacher, Luxemburg",
    "maps_query": "Pfeiffer GmbH & Co. KG Hs Achern, Rue Des Caves 2, 6718 Grevenmacher, Luxemburg",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 527
  },
  {
    "id": "pfeiffer-gmbh-und-co-kg-hs-buhl-77815-buhl",
    "name": "Pfeiffer GmbH & Co. KG Hs Bühl",
    "type": "Partner Store",
    "street": "Eisenbahnstr.",
    "house_number": "22",
    "street_line": "Eisenbahnstr. 22",
    "zip": "77815",
    "city": "Bühl",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Eisenbahnstr. 22, 77815 Bühl, Deutschland",
    "map_query": "Eisenbahnstr. 22, 77815 Bühl, Deutschland",
    "maps_query": "Pfeiffer GmbH & Co. KG Hs Bühl, Eisenbahnstr. 22, 77815 Bühl, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 528
  },
  {
    "id": "policke-herrenkleidung-gmbh-8902-urdorf",
    "name": "Policke Herrenkleidung GmbH",
    "type": "Partner Store",
    "street": "In der Luberzen",
    "house_number": "19",
    "street_line": "In der Luberzen 19",
    "zip": "8902",
    "city": "Urdorf",
    "country": "Switzerland",
    "country_label": "Schweiz",
    "region": "Germany",
    "language": "Deutsch",
    "address": "In der Luberzen 19, 8902 Urdorf, Schweiz",
    "map_query": "In der Luberzen 19, 8902 Urdorf, Schweiz",
    "maps_query": "Policke Herrenkleidung GmbH, In der Luberzen 19, 8902 Urdorf, Schweiz",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 529
  },
  {
    "id": "prego-fashion-20099-hamburg",
    "name": "Prego Fashion",
    "type": "Partner Store",
    "street": "Böckmannstraße",
    "house_number": "56",
    "street_line": "Böckmannstraße 56",
    "zip": "20099",
    "city": "Hamburg",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "The Netherlands",
    "language": "Englisch",
    "address": "Böckmannstraße 56, 20099 Hamburg, Deutschland",
    "map_query": "Böckmannstraße 56, 20099 Hamburg, Deutschland",
    "maps_query": "Prego Fashion, Böckmannstraße 56, 20099 Hamburg, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 530
  },
  {
    "id": "primus-gmbh-3641ea-mijdrecht",
    "name": "Primus GmbH",
    "type": "Partner Store",
    "street": "Dorpsstraat",
    "house_number": "25",
    "street_line": "Dorpsstraat 25",
    "zip": "3641EA",
    "city": "Mijdrecht",
    "country": "The Netherlands",
    "country_label": "Niederlande",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Dorpsstraat 25, 3641EA Mijdrecht, Niederlande",
    "map_query": "Dorpsstraat 25, 3641EA Mijdrecht, Niederlande",
    "maps_query": "Primus GmbH, Dorpsstraat 25, 3641EA Mijdrecht, Niederlande",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 531
  },
  {
    "id": "qemmo-b-v-2981-gc-ridderkerk",
    "name": "QEMMO B.V.",
    "type": "Partner Store",
    "street": "Sint Jorisplein",
    "house_number": "32",
    "street_line": "Sint Jorisplein 32",
    "zip": "2981 GC",
    "city": "Ridderkerk",
    "country": "The Netherlands",
    "country_label": "Niederlande",
    "region": "The Netherlands",
    "language": "Englisch",
    "address": "Sint Jorisplein 32, 2981 GC Ridderkerk, Niederlande",
    "map_query": "Sint Jorisplein 32, 2981 GC Ridderkerk, Niederlande",
    "maps_query": "QEMMO B.V., Sint Jorisplein 32, 2981 GC Ridderkerk, Niederlande",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 532
  },
  {
    "id": "re-port-mens-wear-7531-xg-enschede",
    "name": "Re-port Men´s wear",
    "type": "Partner Store",
    "street": "Floreparkstraat",
    "house_number": "175",
    "street_line": "Floreparkstraat 175",
    "zip": "7531 XG",
    "city": "Enschede",
    "country": "The Netherlands",
    "country_label": "Niederlande",
    "region": "The Netherlands",
    "language": "Englisch",
    "address": "Floreparkstraat 175, 7531 XG Enschede, Niederlande",
    "map_query": "Floreparkstraat 175, 7531 XG Enschede, Niederlande",
    "maps_query": "Re-port Men´s wear, Floreparkstraat 175, 7531 XG Enschede, Niederlande",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 533
  },
  {
    "id": "reip-45665-recklinghausen",
    "name": "Reip",
    "type": "Partner Store",
    "street": "Sachsenstrasse 28 C",
    "house_number": "",
    "street_line": "Sachsenstrasse 28 C",
    "zip": "45665",
    "city": "Recklinghausen",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Belgium",
    "language": "Englisch",
    "address": "Sachsenstrasse 28 C, 45665 Recklinghausen, Deutschland",
    "map_query": "Reip, Sachsenstrasse 28 C, 45665 Recklinghausen, Deutschland",
    "maps_query": "Reip, Sachsenstrasse 28 C, 45665 Recklinghausen, Deutschland",
    "note": "Sortiment und Verfügbarkeit können variieren. Adresse bitte vor Besuch über den Händler prüfen.",
    "data_quality": [
      "house_number_missing"
    ],
    "source_row": 534
  },
  {
    "id": "reischmann-gmbh-und-co-kgaa-haus-ravensburg-4700-eupen",
    "name": "Reischmann GmbH & Co. KGaA Haus Ravensburg",
    "type": "Partner Store",
    "street": "Marktplatz",
    "house_number": "20",
    "street_line": "Marktplatz 20",
    "zip": "4700",
    "city": "Eupen",
    "country": "Belgium",
    "country_label": "Belgien",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Marktplatz 20, 4700 Eupen, Belgien",
    "map_query": "Marktplatz 20, 4700 Eupen, Belgien",
    "maps_query": "Reischmann GmbH & Co. KGaA Haus Ravensburg, Marktplatz 20, 4700 Eupen, Belgien",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 535
  },
  {
    "id": "reischmann-gmbh-und-co-kgaa-haus-kempten-88213-ravensburg",
    "name": "Reischmann GmbH & Co.KGaA Haus Kempten",
    "type": "Partner Store",
    "street": "Franz-Xaver-Honer-Str",
    "house_number": "13",
    "street_line": "Franz-Xaver-Honer-Str 13",
    "zip": "88213",
    "city": "Ravensburg",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Franz-Xaver-Honer-Str 13, 88213 Ravensburg, Deutschland",
    "map_query": "Franz-Xaver-Honer-Str 13, 88213 Ravensburg, Deutschland",
    "maps_query": "Reischmann GmbH & Co.KGaA Haus Kempten, Franz-Xaver-Honer-Str 13, 88213 Ravensburg, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 536
  },
  {
    "id": "reischmann-gmbh-und-co-kgaa-haus-memmingen-88213-ravensburg",
    "name": "Reischmann GmbH & Co.KGaA Haus Memmingen",
    "type": "Partner Store",
    "street": "Franz-Xaver-Honer-Str",
    "house_number": "13",
    "street_line": "Franz-Xaver-Honer-Str 13",
    "zip": "88213",
    "city": "Ravensburg",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Franz-Xaver-Honer-Str 13, 88213 Ravensburg, Deutschland",
    "map_query": "Franz-Xaver-Honer-Str 13, 88213 Ravensburg, Deutschland",
    "maps_query": "Reischmann GmbH & Co.KGaA Haus Memmingen, Franz-Xaver-Honer-Str 13, 88213 Ravensburg, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 537
  },
  {
    "id": "reischmann-gmbh-und-co-kgaa-th-kempten-88213-ravensburg",
    "name": "Reischmann GmbH & Co.KGaA TH Kempten",
    "type": "Partner Store",
    "street": "Franz-Xaver-Honer-Str",
    "house_number": "13",
    "street_line": "Franz-Xaver-Honer-Str 13",
    "zip": "88213",
    "city": "Ravensburg",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Franz-Xaver-Honer-Str 13, 88213 Ravensburg, Deutschland",
    "map_query": "Franz-Xaver-Honer-Str 13, 88213 Ravensburg, Deutschland",
    "maps_query": "Reischmann GmbH & Co.KGaA TH Kempten, Franz-Xaver-Honer-Str 13, 88213 Ravensburg, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 538
  },
  {
    "id": "reischmann-gmbh-und-co-kgaa-trendhaus-ravensburg-88213-ravensburg",
    "name": "Reischmann GmbH & Co.KGaA Trendhaus Ravensburg",
    "type": "Partner Store",
    "street": "Franz-Xaver-Honer-Str",
    "house_number": "13",
    "street_line": "Franz-Xaver-Honer-Str 13",
    "zip": "88213",
    "city": "Ravensburg",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Franz-Xaver-Honer-Str 13, 88213 Ravensburg, Deutschland",
    "map_query": "Franz-Xaver-Honer-Str 13, 88213 Ravensburg, Deutschland",
    "maps_query": "Reischmann GmbH & Co.KGaA Trendhaus Ravensburg, Franz-Xaver-Honer-Str 13, 88213 Ravensburg, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 539
  },
  {
    "id": "rejeanne-88213-ravensburg",
    "name": "Rejeanne",
    "type": "Partner Store",
    "street": "Franz-Xaver-Honer-Str",
    "house_number": "13",
    "street_line": "Franz-Xaver-Honer-Str 13",
    "zip": "88213",
    "city": "Ravensburg",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Belgium",
    "language": "Englisch",
    "address": "Franz-Xaver-Honer-Str 13, 88213 Ravensburg, Deutschland",
    "map_query": "Franz-Xaver-Honer-Str 13, 88213 Ravensburg, Deutschland",
    "maps_query": "Rejeanne, Franz-Xaver-Honer-Str 13, 88213 Ravensburg, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 540
  },
  {
    "id": "retzlaff-hinkelmann-gbr-9890-gavere",
    "name": "Retzlaff Hinkelmann GbR",
    "type": "Partner Store",
    "street": "Stationsstraat",
    "house_number": "153",
    "street_line": "Stationsstraat 153",
    "zip": "9890",
    "city": "Gavere",
    "country": "Belgium",
    "country_label": "Belgien",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Stationsstraat 153, 9890 Gavere, Belgien",
    "map_query": "Stationsstraat 153, 9890 Gavere, Belgien",
    "maps_query": "Retzlaff Hinkelmann GbR, Stationsstraat 153, 9890 Gavere, Belgien",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 541
  },
  {
    "id": "rm-retail-gmbh-und-co-kg-85276-pfaffenhofen",
    "name": "RM Retail GmbH & Co. KG",
    "type": "Partner Store",
    "street": "Ingolstädter Str.",
    "house_number": "27",
    "street_line": "Ingolstädter Str. 27",
    "zip": "85276",
    "city": "Pfaffenhofen",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Ingolstädter Str. 27, 85276 Pfaffenhofen, Deutschland",
    "map_query": "Ingolstädter Str. 27, 85276 Pfaffenhofen, Deutschland",
    "maps_query": "RM Retail GmbH & Co. KG, Ingolstädter Str. 27, 85276 Pfaffenhofen, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 542
  },
  {
    "id": "rob-business-en-casual-38100-braunschweig",
    "name": "Rob Business en Casual",
    "type": "Partner Store",
    "street": "Papenstieg",
    "house_number": "4-7",
    "street_line": "Papenstieg 4-7",
    "zip": "38100",
    "city": "Braunschweig",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "The Netherlands",
    "language": "Englisch",
    "address": "Papenstieg 4-7, 38100 Braunschweig, Deutschland",
    "map_query": "Papenstieg 4-7, 38100 Braunschweig, Deutschland",
    "maps_query": "Rob Business en Casual, Papenstieg 4-7, 38100 Braunschweig, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 543
  },
  {
    "id": "rob-haver-mannenmode-2661-cg-bergschenhoek",
    "name": "Rob Haver Mannenmode",
    "type": "Partner Store",
    "street": "Dorpsstraat",
    "house_number": "34",
    "street_line": "Dorpsstraat 34",
    "zip": "2661 CG",
    "city": "Bergschenhoek",
    "country": "The Netherlands",
    "country_label": "Niederlande",
    "region": "The Netherlands",
    "language": "Englisch",
    "address": "Dorpsstraat 34, 2661 CG Bergschenhoek, Niederlande",
    "map_query": "Dorpsstraat 34, 2661 CG Bergschenhoek, Niederlande",
    "maps_query": "Rob Haver Mannenmode, Dorpsstraat 34, 2661 CG Bergschenhoek, Niederlande",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 544
  },
  {
    "id": "robert-ley-damen-und-herrenmode-gmbh-und-co-kg-5707-cd-helmond",
    "name": "Robert Ley Damen- und Herrenmode GmbH & Co. KG",
    "type": "Partner Store",
    "street": "Steenweg",
    "house_number": "15",
    "street_line": "Steenweg 15",
    "zip": "5707 CD",
    "city": "Helmond",
    "country": "The Netherlands",
    "country_label": "Niederlande",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Steenweg 15, 5707 CD Helmond, Niederlande",
    "map_query": "Steenweg 15, 5707 CD Helmond, Niederlande",
    "maps_query": "Robert Ley Damen- und Herrenmode GmbH & Co. KG, Steenweg 15, 5707 CD Helmond, Niederlande",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 545
  },
  {
    "id": "ronellenfitsch-gmbh-und-co-kg-46035-benimamet-valencia",
    "name": "Ronellenfitsch GmbH & Co KG",
    "type": "Partner Store",
    "street": "Senda del Secanet",
    "house_number": "27",
    "street_line": "Senda del Secanet 27",
    "zip": "46035",
    "city": "Benimàmet - Valencia",
    "country": "Spain",
    "country_label": "Spain",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Senda del Secanet 27, 46035 Benimàmet - Valencia, Spain",
    "map_query": "Senda del Secanet 27, 46035 Benimàmet - Valencia, Spain",
    "maps_query": "Ronellenfitsch GmbH & Co KG, Senda del Secanet 27, 46035 Benimàmet - Valencia, Spain",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 546
  },
  {
    "id": "roos-herrenmode-gmbh-66663-merzig",
    "name": "Roos Herrenmode Gmbh",
    "type": "Partner Store",
    "street": "Poststr. 34 -",
    "house_number": "36",
    "street_line": "Poststr. 34 - 36",
    "zip": "66663",
    "city": "Merzig",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Switzerland",
    "language": "Englisch",
    "address": "Poststr. 34 - 36, 66663 Merzig, Deutschland",
    "map_query": "Poststr. 34 - 36, 66663 Merzig, Deutschland",
    "maps_query": "Roos Herrenmode Gmbh, Poststr. 34 - 36, 66663 Merzig, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 547
  },
  {
    "id": "roosen-8610-uster",
    "name": "Roosen",
    "type": "Partner Store",
    "street": "Freiestrasse",
    "house_number": "4",
    "street_line": "Freiestrasse 4",
    "zip": "8610",
    "city": "Uster",
    "country": "Switzerland",
    "country_label": "Schweiz",
    "region": "Belgium",
    "language": "Englisch",
    "address": "Freiestrasse 4, 8610 Uster, Schweiz",
    "map_query": "Freiestrasse 4, 8610 Uster, Schweiz",
    "maps_query": "Roosen, Freiestrasse 4, 8610 Uster, Schweiz",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 548
  },
  {
    "id": "roro-herrenkonfektion-ag-3800-sint-truiden",
    "name": "Roro-Herrenkonfektion AG",
    "type": "Partner Store",
    "street": "Stapelstraat",
    "house_number": "23",
    "street_line": "Stapelstraat 23",
    "zip": "3800",
    "city": "Sint-Truiden",
    "country": "Belgium",
    "country_label": "Belgien",
    "region": "Switzerland",
    "language": "Englisch",
    "address": "Stapelstraat 23, 3800 Sint-Truiden, Belgien",
    "map_query": "Stapelstraat 23, 3800 Sint-Truiden, Belgien",
    "maps_query": "Roro-Herrenkonfektion AG, Stapelstraat 23, 3800 Sint-Truiden, Belgien",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 549
  },
  {
    "id": "rosch-gmbh-3800-interlaken",
    "name": "Rösch GmbH",
    "type": "Partner Store",
    "street": "Untere Bönigstrasse",
    "house_number": "10a",
    "street_line": "Untere Bönigstrasse 10a",
    "zip": "3800",
    "city": "Interlaken",
    "country": "Switzerland",
    "country_label": "Schweiz",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Untere Bönigstrasse 10a, 3800 Interlaken, Schweiz",
    "map_query": "Untere Bönigstrasse 10a, 3800 Interlaken, Schweiz",
    "maps_query": "Rösch GmbH, Untere Bönigstrasse 10a, 3800 Interlaken, Schweiz",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 550
  },
  {
    "id": "roth-modehaus-ges-m-b-h-73312-geislingen",
    "name": "Roth Modehaus Ges. m.b.H.",
    "type": "Partner Store",
    "street": "Karlstr.",
    "house_number": "21",
    "street_line": "Karlstr. 21",
    "zip": "73312",
    "city": "Geislingen",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Austria",
    "language": "Deutsch",
    "address": "Karlstr. 21, 73312 Geislingen, Deutschland",
    "map_query": "Karlstr. 21, 73312 Geislingen, Deutschland",
    "maps_query": "Roth Modehaus Ges. m.b.H., Karlstr. 21, 73312 Geislingen, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 551
  },
  {
    "id": "rottele-gmbh-8342-gnas",
    "name": "Röttele GmbH",
    "type": "Partner Store",
    "street": "Hauptplatz",
    "house_number": "14",
    "street_line": "Hauptplatz 14",
    "zip": "8342",
    "city": "Gnas",
    "country": "Austria",
    "country_label": "Österreich",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Hauptplatz 14, 8342 Gnas, Österreich",
    "map_query": "Hauptplatz 14, 8342 Gnas, Österreich",
    "maps_query": "Röttele GmbH, Hauptplatz 14, 8342 Gnas, Österreich",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 552
  },
  {
    "id": "rudolphi-modehaus-gmbh-und-co-kg-47441-moers",
    "name": "Rudolphi Modehaus GmbH & Co. KG",
    "type": "Partner Store",
    "street": "Neumarkt 2 -",
    "house_number": "4",
    "street_line": "Neumarkt 2 - 4",
    "zip": "47441",
    "city": "Moers",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Neumarkt 2 - 4, 47441 Moers, Deutschland",
    "map_query": "Neumarkt 2 - 4, 47441 Moers, Deutschland",
    "maps_query": "Rudolphi Modehaus GmbH & Co. KG, Neumarkt 2 - 4, 47441 Moers, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 553
  },
  {
    "id": "rufus-nv-37431-bad-lauterberg-im-harz",
    "name": "Rufus NV",
    "type": "Partner Store",
    "street": "Hauptstraße",
    "house_number": "115-121",
    "street_line": "Hauptstraße 115-121",
    "zip": "37431",
    "city": "Bad Lauterberg im Harz",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Belgium",
    "language": "Englisch",
    "address": "Hauptstraße 115-121, 37431 Bad Lauterberg im Harz, Deutschland",
    "map_query": "Hauptstraße 115-121, 37431 Bad Lauterberg im Harz, Deutschland",
    "maps_query": "Rufus NV, Hauptstraße 115-121, 37431 Bad Lauterberg im Harz, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 554
  },
  {
    "id": "rummel-modehaus-8620-nieuwpoort",
    "name": "Rummel Modehaus",
    "type": "Partner Store",
    "street": "Oostendestraat",
    "house_number": "15",
    "street_line": "Oostendestraat 15",
    "zip": "8620",
    "city": "Nieuwpoort",
    "country": "Belgium",
    "country_label": "Belgien",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Oostendestraat 15, 8620 Nieuwpoort, Belgien",
    "map_query": "Oostendestraat 15, 8620 Nieuwpoort, Belgien",
    "maps_query": "Rummel Modehaus, Oostendestraat 15, 8620 Nieuwpoort, Belgien",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 555
  },
  {
    "id": "s-und-s-herrenausstatter-91522-ansbach",
    "name": "S&S Herrenausstatter",
    "type": "Partner Store",
    "street": "Uzstraße 5 -",
    "house_number": "7",
    "street_line": "Uzstraße 5 - 7",
    "zip": "91522",
    "city": "Ansbach",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Uzstraße 5 - 7, 91522 Ansbach, Deutschland",
    "map_query": "Uzstraße 5 - 7, 91522 Ansbach, Deutschland",
    "maps_query": "S&S Herrenausstatter, Uzstraße 5 - 7, 91522 Ansbach, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 556
  },
  {
    "id": "s-r-l-nelcath-07743-jena",
    "name": "S.R.L. Nelcath",
    "type": "Partner Store",
    "street": "Oberlauengasse",
    "house_number": "5",
    "street_line": "Oberlauengasse 5",
    "zip": "07743",
    "city": "Jena",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Belgium",
    "language": "Englisch",
    "address": "Oberlauengasse 5, 07743 Jena, Deutschland",
    "map_query": "Oberlauengasse 5, 07743 Jena, Deutschland",
    "maps_query": "S.R.L. Nelcath, Oberlauengasse 5, 07743 Jena, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 557
  },
  {
    "id": "s-v-g-bvba-4900-spa",
    "name": "S.V.G. BVBA",
    "type": "Partner Store",
    "street": "Place du monument",
    "house_number": "24",
    "street_line": "Place du monument 24",
    "zip": "4900",
    "city": "Spa",
    "country": "Belgium",
    "country_label": "Belgien",
    "region": "Belgium",
    "language": "Englisch",
    "address": "Place du monument 24, 4900 Spa, Belgien",
    "map_query": "Place du monument 24, 4900 Spa, Belgien",
    "maps_query": "S.V.G. BVBA, Place du monument 24, 4900 Spa, Belgien",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 558
  },
  {
    "id": "sample-1730-asse",
    "name": "Sample",
    "type": "Partner Store",
    "street": "Mollestraat",
    "house_number": "5",
    "street_line": "Mollestraat 5",
    "zip": "1730",
    "city": "Asse",
    "country": "Belgium",
    "country_label": "Belgien",
    "region": "The Netherlands",
    "language": "Englisch",
    "address": "Mollestraat 5, 1730 Asse, Belgien",
    "map_query": "Mollestraat 5, 1730 Asse, Belgien",
    "maps_query": "Sample, Mollestraat 5, 1730 Asse, Belgien",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 559
  },
  {
    "id": "sandberg-modegesellschaft-m-b-h-2353-ts-leiderdorp",
    "name": "Sandberg Modegesellschaft m.b.H.",
    "type": "Partner Store",
    "street": "Winkelhof",
    "house_number": "26",
    "street_line": "Winkelhof 26",
    "zip": "2353 TS",
    "city": "Leiderdorp",
    "country": "The Netherlands",
    "country_label": "Niederlande",
    "region": "Austria",
    "language": "Deutsch",
    "address": "Winkelhof 26, 2353 TS Leiderdorp, Niederlande",
    "map_query": "Winkelhof 26, 2353 TS Leiderdorp, Niederlande",
    "maps_query": "Sandberg Modegesellschaft m.b.H., Winkelhof 26, 2353 TS Leiderdorp, Niederlande",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 560
  },
  {
    "id": "sarl-creamod-1010-wien",
    "name": "Sarl Creamod",
    "type": "Partner Store",
    "street": "Am Lugeck",
    "house_number": "1-2",
    "street_line": "Am Lugeck 1-2",
    "zip": "1010",
    "city": "Wien",
    "country": "Austria",
    "country_label": "Österreich",
    "region": "France",
    "language": "Englisch",
    "address": "Am Lugeck 1-2, 1010 Wien, Österreich",
    "map_query": "Am Lugeck 1-2, 1010 Wien, Österreich",
    "maps_query": "Sarl Creamod, Am Lugeck 1-2, 1010 Wien, Österreich",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 561
  },
  {
    "id": "saturn-herrenmode-albrecht-gmbh-06100-nice",
    "name": "Saturn Herrenmode Albrecht GmbH",
    "type": "Partner Store",
    "street": "Rue des Chevaliers de Malte",
    "house_number": "18",
    "street_line": "Rue des Chevaliers de Malte 18",
    "zip": "06100",
    "city": "Nice",
    "country": "France",
    "country_label": "Frankreich",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Rue des Chevaliers de Malte 18, 06100 Nice, Frankreich",
    "map_query": "Rue des Chevaliers de Malte 18, 06100 Nice, Frankreich",
    "maps_query": "Saturn Herrenmode Albrecht GmbH, Rue des Chevaliers de Malte 18, 06100 Nice, Frankreich",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 562
  },
  {
    "id": "sauer-modehandels-gmbh-73430-aalen",
    "name": "Sauer Modehandels GmbH",
    "type": "Partner Store",
    "street": "Spritzenhausplatz",
    "house_number": "5",
    "street_line": "Spritzenhausplatz 5",
    "zip": "73430",
    "city": "Aalen",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Spritzenhausplatz 5, 73430 Aalen, Deutschland",
    "map_query": "Spritzenhausplatz 5, 73430 Aalen, Deutschland",
    "maps_query": "Sauer Modehandels GmbH, Spritzenhausplatz 5, 73430 Aalen, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 563
  },
  {
    "id": "schick-mode-ug-87509-immenstadt",
    "name": "Schick Mode UG",
    "type": "Partner Store",
    "street": "Bräuhausstr. 6 -",
    "house_number": "8",
    "street_line": "Bräuhausstr. 6 - 8",
    "zip": "87509",
    "city": "Immenstadt",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Bräuhausstr. 6 - 8, 87509 Immenstadt, Deutschland",
    "map_query": "Bräuhausstr. 6 - 8, 87509 Immenstadt, Deutschland",
    "maps_query": "Schick Mode UG, Bräuhausstr. 6 - 8, 87509 Immenstadt, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 564
  },
  {
    "id": "schlosser-kleding-79618-rheinfelden-baden",
    "name": "Schlösser Kleding",
    "type": "Partner Store",
    "street": "Rudolf-Vogel-Anlage 5+6",
    "house_number": "",
    "street_line": "Rudolf-Vogel-Anlage 5+6",
    "zip": "79618",
    "city": "Rheinfelden (Baden)",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "The Netherlands",
    "language": "Englisch",
    "address": "Rudolf-Vogel-Anlage 5+6, 79618 Rheinfelden (Baden), Deutschland",
    "map_query": "Schlösser Kleding, Rudolf-Vogel-Anlage 5+6, 79618 Rheinfelden (Baden), Deutschland",
    "maps_query": "Schlösser Kleding, Rudolf-Vogel-Anlage 5+6, 79618 Rheinfelden (Baden), Deutschland",
    "note": "Sortiment und Verfügbarkeit können variieren. Adresse bitte vor Besuch über den Händler prüfen.",
    "data_quality": [
      "house_number_missing"
    ],
    "source_row": 565
  },
  {
    "id": "schmid-damen-und-herren-mode-7001-bv-doetinchem",
    "name": "Schmid Damen & Herren Mode",
    "type": "Partner Store",
    "street": "Walstraat",
    "house_number": "104",
    "street_line": "Walstraat 104",
    "zip": "7001 BV",
    "city": "Doetinchem",
    "country": "The Netherlands",
    "country_label": "Niederlande",
    "region": "Austria",
    "language": "Deutsch",
    "address": "Walstraat 104, 7001 BV Doetinchem, Niederlande",
    "map_query": "Walstraat 104, 7001 BV Doetinchem, Niederlande",
    "maps_query": "Schmid Damen & Herren Mode, Walstraat 104, 7001 BV Doetinchem, Niederlande",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 566
  },
  {
    "id": "schmidt-arkaden-gmbh-und-co-kg-4470-enns",
    "name": "Schmidt Arkaden GmbH & Co. KG",
    "type": "Partner Store",
    "street": "Dragoner Straße",
    "house_number": "4",
    "street_line": "Dragoner Straße 4",
    "zip": "4470",
    "city": "Enns",
    "country": "Austria",
    "country_label": "Österreich",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Dragoner Straße 4, 4470 Enns, Österreich",
    "map_query": "Dragoner Straße 4, 4470 Enns, Österreich",
    "maps_query": "Schmidt Arkaden GmbH & Co. KG, Dragoner Straße 4, 4470 Enns, Österreich",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 567
  },
  {
    "id": "schmiederer-gmbh-79837-st-blasien",
    "name": "Schmiederer GmbH",
    "type": "Partner Store",
    "street": "Hauptstraße",
    "house_number": "3-5",
    "street_line": "Hauptstraße 3-5",
    "zip": "79837",
    "city": "St. Blasien",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Hauptstraße 3-5, 79837 St. Blasien, Deutschland",
    "map_query": "Hauptstraße 3-5, 79837 St. Blasien, Deutschland",
    "maps_query": "Schmiederer GmbH, Hauptstraße 3-5, 79837 St. Blasien, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 568
  },
  {
    "id": "schmitt-gmbh-79539-lorrach",
    "name": "Schmitt GmbH",
    "type": "Partner Store",
    "street": "Basler Str.",
    "house_number": "173",
    "street_line": "Basler Str. 173",
    "zip": "79539",
    "city": "Lörrach",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Basler Str. 173, 79539 Lörrach, Deutschland",
    "map_query": "Basler Str. 173, 79539 Lörrach, Deutschland",
    "maps_query": "Schmitt GmbH, Basler Str. 173, 79539 Lörrach, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 569
  },
  {
    "id": "schnittger-moden-e-k-67433-neustadt",
    "name": "Schnittger Moden e.K.",
    "type": "Partner Store",
    "street": "Marktplatz",
    "house_number": "8",
    "street_line": "Marktplatz 8",
    "zip": "67433",
    "city": "Neustadt",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Marktplatz 8, 67433 Neustadt, Deutschland",
    "map_query": "Marktplatz 8, 67433 Neustadt, Deutschland",
    "maps_query": "Schnittger Moden e.K., Marktplatz 8, 67433 Neustadt, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 570
  },
  {
    "id": "schnuckel-gmbh-26316-varel",
    "name": "Schnückel GmbH",
    "type": "Partner Store",
    "street": "Obernstr.",
    "house_number": "1-5",
    "street_line": "Obernstr. 1-5",
    "zip": "26316",
    "city": "Varel",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Obernstr. 1-5, 26316 Varel, Deutschland",
    "map_query": "Obernstr. 1-5, 26316 Varel, Deutschland",
    "maps_query": "Schnückel GmbH, Obernstr. 1-5, 26316 Varel, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 571
  },
  {
    "id": "scholte-beheer-b-v-59423-unna",
    "name": "Scholte Beheer B.V.",
    "type": "Partner Store",
    "street": "Massener Straße 2 -",
    "house_number": "8",
    "street_line": "Massener Straße 2 - 8",
    "zip": "59423",
    "city": "Unna",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "The Netherlands",
    "language": "Englisch",
    "address": "Massener Straße 2 - 8, 59423 Unna, Deutschland",
    "map_query": "Massener Straße 2 - 8, 59423 Unna, Deutschland",
    "maps_query": "Scholte Beheer B.V., Massener Straße 2 - 8, 59423 Unna, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 572
  },
  {
    "id": "schonenberger-gmbh-2923-bk-krimpen-aan-den-ijssel",
    "name": "Schönenberger GmbH",
    "type": "Partner Store",
    "street": "Stad en Landschap",
    "house_number": "33",
    "street_line": "Stad en Landschap 33",
    "zip": "2923 BK",
    "city": "Krimpen aan den IJssel",
    "country": "The Netherlands",
    "country_label": "Niederlande",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Stad en Landschap 33, 2923 BK Krimpen aan den IJssel, Niederlande",
    "map_query": "Stad en Landschap 33, 2923 BK Krimpen aan den IJssel, Niederlande",
    "maps_query": "Schönenberger GmbH, Stad en Landschap 33, 2923 BK Krimpen aan den IJssel, Niederlande",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 573
  },
  {
    "id": "schuck-mode-gmbh-55232-alzey",
    "name": "Schuck Mode GmbH",
    "type": "Partner Store",
    "street": "Antoniterstraße",
    "house_number": "16",
    "street_line": "Antoniterstraße 16",
    "zip": "55232",
    "city": "Alzey",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Antoniterstraße 16, 55232 Alzey, Deutschland",
    "map_query": "Antoniterstraße 16, 55232 Alzey, Deutschland",
    "maps_query": "Schuck Mode GmbH, Antoniterstraße 16, 55232 Alzey, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 574
  },
  {
    "id": "schuhhaus-stietzel-84524-neuotting",
    "name": "Schuhhaus Stietzel",
    "type": "Partner Store",
    "street": "Simbacher Straße",
    "house_number": "55",
    "street_line": "Simbacher Straße 55",
    "zip": "84524",
    "city": "Neuötting",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "",
    "language": "Deutsch",
    "address": "Simbacher Straße 55, 84524 Neuötting, Deutschland",
    "map_query": "Simbacher Straße 55, 84524 Neuötting, Deutschland",
    "maps_query": "Schuhhaus Stietzel, Simbacher Straße 55, 84524 Neuötting, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 575
  },
  {
    "id": "schuler-mode-38640-goslar",
    "name": "Schuler Mode",
    "type": "Partner Store",
    "street": "Breite Strasse",
    "house_number": "100 - 101",
    "street_line": "Breite Strasse 100 - 101",
    "zip": "38640",
    "city": "Goslar",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Breite Strasse 100 - 101, 38640 Goslar, Deutschland",
    "map_query": "Breite Strasse 100 - 101, 38640 Goslar, Deutschland",
    "maps_query": "Schuler Mode, Breite Strasse 100 - 101, 38640 Goslar, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 576
  },
  {
    "id": "schutz-fashion-88239-wangen",
    "name": "Schutz Fashion",
    "type": "Partner Store",
    "street": "Schmiedstraße",
    "house_number": "37-39",
    "street_line": "Schmiedstraße 37-39",
    "zip": "88239",
    "city": "Wangen",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "The Netherlands",
    "language": "Englisch",
    "address": "Schmiedstraße 37-39, 88239 Wangen, Deutschland",
    "map_query": "Schmiedstraße 37-39, 88239 Wangen, Deutschland",
    "maps_query": "Schutz Fashion, Schmiedstraße 37-39, 88239 Wangen, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 577
  },
  {
    "id": "schwarte-gmbh-1621-jd-hoorn",
    "name": "Schwarte GmbH",
    "type": "Partner Store",
    "street": "Kleine Noord",
    "house_number": "23-25",
    "street_line": "Kleine Noord 23-25",
    "zip": "1621 JD",
    "city": "Hoorn",
    "country": "The Netherlands",
    "country_label": "Niederlande",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Kleine Noord 23-25, 1621 JD Hoorn, Niederlande",
    "map_query": "Kleine Noord 23-25, 1621 JD Hoorn, Niederlande",
    "maps_query": "Schwarte GmbH, Kleine Noord 23-25, 1621 JD Hoorn, Niederlande",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 578
  },
  {
    "id": "schweiger-herrenmoden-49661-cloppenburg",
    "name": "Schweiger Herrenmoden",
    "type": "Partner Store",
    "street": "Bahnhofstraße",
    "house_number": "56-60",
    "street_line": "Bahnhofstraße 56-60",
    "zip": "49661",
    "city": "Cloppenburg",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Bahnhofstraße 56-60, 49661 Cloppenburg, Deutschland",
    "map_query": "Bahnhofstraße 56-60, 49661 Cloppenburg, Deutschland",
    "maps_query": "Schweiger Herrenmoden, Bahnhofstraße 56-60, 49661 Cloppenburg, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 579
  },
  {
    "id": "schwing-modevertriebs-gmbh-und-co-kg-97437-hafurt",
    "name": "Schwing Modevertriebs GmbH & Co. KG",
    "type": "Partner Store",
    "street": "Hauptstr.",
    "house_number": "28",
    "street_line": "Hauptstr. 28",
    "zip": "97437",
    "city": "Haßfurt",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Hauptstr. 28, 97437 Haßfurt, Deutschland",
    "map_query": "Hauptstr. 28, 97437 Haßfurt, Deutschland",
    "maps_query": "Schwing Modevertriebs GmbH & Co. KG, Hauptstr. 28, 97437 Haßfurt, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 580
  },
  {
    "id": "sebastian-alphen-74821-mosbach",
    "name": "Sebastian Alphen",
    "type": "Partner Store",
    "street": "Hauptstr.",
    "house_number": "78",
    "street_line": "Hauptstr. 78",
    "zip": "74821",
    "city": "Mosbach",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "The Netherlands",
    "language": "Englisch",
    "address": "Hauptstr. 78, 74821 Mosbach, Deutschland",
    "map_query": "Hauptstr. 78, 74821 Mosbach, Deutschland",
    "maps_query": "Sebastian Alphen, Hauptstr. 78, 74821 Mosbach, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 581
  },
  {
    "id": "seeger-gmbh-2405-cb-alphen-aan-de-rijn",
    "name": "Seeger GmbH",
    "type": "Partner Store",
    "street": "Castellumstraat 1-D",
    "house_number": "",
    "street_line": "Castellumstraat 1-D",
    "zip": "2405 CB",
    "city": "Alphen aan de Rijn",
    "country": "The Netherlands",
    "country_label": "Niederlande",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Castellumstraat 1-D, 2405 CB Alphen aan de Rijn, Niederlande",
    "map_query": "Seeger GmbH, Castellumstraat 1-D, 2405 CB Alphen aan de Rijn, Niederlande",
    "maps_query": "Seeger GmbH, Castellumstraat 1-D, 2405 CB Alphen aan de Rijn, Niederlande",
    "note": "Sortiment und Verfügbarkeit können variieren. Adresse bitte vor Besuch über den Händler prüfen.",
    "data_quality": [
      "house_number_missing"
    ],
    "source_row": 582
  },
  {
    "id": "seegers-72213-altensteig",
    "name": "Seegers",
    "type": "Partner Store",
    "street": "Poststr.",
    "house_number": "21",
    "street_line": "Poststr. 21",
    "zip": "72213",
    "city": "Altensteig",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "The Netherlands",
    "language": "Englisch",
    "address": "Poststr. 21, 72213 Altensteig, Deutschland",
    "map_query": "Poststr. 21, 72213 Altensteig, Deutschland",
    "maps_query": "Seegers, Poststr. 21, 72213 Altensteig, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 583
  },
  {
    "id": "seidoria-gmbh-5492-at-st-oedenrode",
    "name": "Seidoria GmbH",
    "type": "Partner Store",
    "street": "Borchgrave",
    "house_number": "45",
    "street_line": "Borchgrave 45",
    "zip": "5492 AT",
    "city": "St. Oedenrode",
    "country": "The Netherlands",
    "country_label": "Niederlande",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Borchgrave 45, 5492 AT St. Oedenrode, Niederlande",
    "map_query": "Borchgrave 45, 5492 AT St. Oedenrode, Niederlande",
    "maps_query": "Seidoria GmbH, Borchgrave 45, 5492 AT St. Oedenrode, Niederlande",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 584
  },
  {
    "id": "sens-d-o-o-07545-gera",
    "name": "SENS d.o.o.",
    "type": "Partner Store",
    "street": "Humboldstraße",
    "house_number": "18",
    "street_line": "Humboldstraße 18",
    "zip": "07545",
    "city": "Gera",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "",
    "language": "Englisch",
    "address": "Humboldstraße 18, 07545 Gera, Deutschland",
    "map_query": "Humboldstraße 18, 07545 Gera, Deutschland",
    "maps_query": "SENS d.o.o., Humboldstraße 18, 07545 Gera, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 585
  },
  {
    "id": "setpoint-1000-ljubljana",
    "name": "Setpoint",
    "type": "Partner Store",
    "street": "Italijanska ulica",
    "house_number": "8",
    "street_line": "Italijanska ulica 8",
    "zip": "1000",
    "city": "Ljubljana",
    "country": "Slovenia",
    "country_label": "Slovenia",
    "region": "The Netherlands",
    "language": "Englisch",
    "address": "Italijanska ulica 8, 1000 Ljubljana, Slovenia",
    "map_query": "Italijanska ulica 8, 1000 Ljubljana, Slovenia",
    "maps_query": "Setpoint, Italijanska ulica 8, 1000 Ljubljana, Slovenia",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 586
  },
  {
    "id": "seventytoo-men-and-women-wear-bv-9712-aa-groningen",
    "name": "Seventytoo Men and Women Wear BV",
    "type": "Partner Store",
    "street": "Brugstraat",
    "house_number": "9",
    "street_line": "Brugstraat 9",
    "zip": "9712 AA",
    "city": "Groningen",
    "country": "The Netherlands",
    "country_label": "Niederlande",
    "region": "The Netherlands",
    "language": "Englisch",
    "address": "Brugstraat 9, 9712 AA Groningen, Niederlande",
    "map_query": "Brugstraat 9, 9712 AA Groningen, Niederlande",
    "maps_query": "Seventytoo Men and Women Wear BV, Brugstraat 9, 9712 AA Groningen, Niederlande",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 587
  },
  {
    "id": "sfilata-di-moda-3401-dg-ijsselstein",
    "name": "Sfilata Di Moda",
    "type": "Partner Store",
    "street": "Benschopperstraat",
    "house_number": "29",
    "street_line": "Benschopperstraat 29",
    "zip": "3401 DG",
    "city": "Ijsselstein",
    "country": "The Netherlands",
    "country_label": "Niederlande",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Benschopperstraat 29, 3401 DG Ijsselstein, Niederlande",
    "map_query": "Benschopperstraat 29, 3401 DG Ijsselstein, Niederlande",
    "maps_query": "Sfilata Di Moda, Benschopperstraat 29, 3401 DG Ijsselstein, Niederlande",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 588
  },
  {
    "id": "shine-bride-1291-skofljica",
    "name": "Shine Bride",
    "type": "Partner Store",
    "street": "Gorenje Blato",
    "house_number": "113",
    "street_line": "Gorenje Blato 113",
    "zip": "1291",
    "city": "Skofljica",
    "country": "Slovenia",
    "country_label": "Slovenia",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Gorenje Blato 113, 1291 Skofljica, Slovenia",
    "map_query": "Gorenje Blato 113, 1291 Skofljica, Slovenia",
    "maps_query": "Shine Bride, Gorenje Blato 113, 1291 Skofljica, Slovenia",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 589
  },
  {
    "id": "shirtcenter-nv-99310-arnstadt",
    "name": "Shirtcenter NV",
    "type": "Partner Store",
    "street": "Unterm Markt",
    "house_number": "5",
    "street_line": "Unterm Markt 5",
    "zip": "99310",
    "city": "Arnstadt",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Belgium",
    "language": "Englisch",
    "address": "Unterm Markt 5, 99310 Arnstadt, Deutschland",
    "map_query": "Unterm Markt 5, 99310 Arnstadt, Deutschland",
    "maps_query": "Shirtcenter NV, Unterm Markt 5, 99310 Arnstadt, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 590
  },
  {
    "id": "shirts-und-more-at-herenmode-2900-schoten",
    "name": "Shirts & More / AT Herenmode",
    "type": "Partner Store",
    "street": "Parking 't Ven",
    "house_number": "12",
    "street_line": "Parking 't Ven 12",
    "zip": "2900",
    "city": "Schoten",
    "country": "Belgium",
    "country_label": "Belgien",
    "region": "The Netherlands",
    "language": "Englisch",
    "address": "Parking 't Ven 12, 2900 Schoten, Belgien",
    "map_query": "Parking 't Ven 12, 2900 Schoten, Belgien",
    "maps_query": "Shirts & More / AT Herenmode, Parking 't Ven 12, 2900 Schoten, Belgien",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 591
  },
  {
    "id": "silhouet-mannenmode-77202-siaulai",
    "name": "Silhouet Mannenmode",
    "type": "Partner Store",
    "street": "Zaliukiu str",
    "house_number": "77b",
    "street_line": "Zaliukiu str 77b",
    "zip": "77202",
    "city": "Siaulai",
    "country": "Lithuania",
    "country_label": "Lithuania",
    "region": "Belgium",
    "language": "Englisch",
    "address": "Zaliukiu str 77b, 77202 Siaulai, Lithuania",
    "map_query": "Zaliukiu str 77b, 77202 Siaulai, Lithuania",
    "maps_query": "Silhouet Mannenmode, Zaliukiu str 77b, 77202 Siaulai, Lithuania",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 592
  },
  {
    "id": "silverbeij-bv-8600-diksmuide",
    "name": "Silverbeij BV",
    "type": "Partner Store",
    "street": "Vaartstraat",
    "house_number": "7",
    "street_line": "Vaartstraat 7",
    "zip": "8600",
    "city": "Diksmuide",
    "country": "Belgium",
    "country_label": "Belgien",
    "region": "The Netherlands",
    "language": "Englisch",
    "address": "Vaartstraat 7, 8600 Diksmuide, Belgien",
    "map_query": "Vaartstraat 7, 8600 Diksmuide, Belgien",
    "maps_query": "Silverbeij BV, Vaartstraat 7, 8600 Diksmuide, Belgien",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 593
  },
  {
    "id": "silverbeij-bv-2611ge-delft",
    "name": "Silverbeij BV",
    "type": "Partner Store",
    "street": "Jozefstraat",
    "house_number": "29",
    "street_line": "Jozefstraat 29",
    "zip": "2611GE",
    "city": "Delft",
    "country": "The Netherlands",
    "country_label": "Niederlande",
    "region": "",
    "language": "Englisch",
    "address": "Jozefstraat 29, 2611GE Delft, Niederlande",
    "map_query": "Jozefstraat 29, 2611GE Delft, Niederlande",
    "maps_query": "Silverbeij BV, Jozefstraat 29, 2611GE Delft, Niederlande",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 594
  },
  {
    "id": "silverbeij-bv-store-1-delft-8911-cw-leeuwarden",
    "name": "Silverbeij BV Store 1 Delft",
    "type": "Partner Store",
    "street": "Nieuwestad",
    "house_number": "78-80",
    "street_line": "Nieuwestad 78-80",
    "zip": "8911 CW",
    "city": "Leeuwarden",
    "country": "The Netherlands",
    "country_label": "Niederlande",
    "region": "The Netherlands",
    "language": "Englisch",
    "address": "Nieuwestad 78-80, 8911 CW Leeuwarden, Niederlande",
    "map_query": "Nieuwestad 78-80, 8911 CW Leeuwarden, Niederlande",
    "maps_query": "Silverbeij BV Store 1 Delft, Nieuwestad 78-80, 8911 CW Leeuwarden, Niederlande",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 595
  },
  {
    "id": "silverbeij-bv-store-22-tilburg-2611-es-delft",
    "name": "Silverbeij BV Store 22 Tilburg",
    "type": "Partner Store",
    "street": "Jacob Gerritstraat",
    "house_number": "12",
    "street_line": "Jacob Gerritstraat 12",
    "zip": "2611 ES",
    "city": "Delft",
    "country": "The Netherlands",
    "country_label": "Niederlande",
    "region": "The Netherlands",
    "language": "Englisch",
    "address": "Jacob Gerritstraat 12, 2611 ES Delft, Niederlande",
    "map_query": "Jacob Gerritstraat 12, 2611 ES Delft, Niederlande",
    "maps_query": "Silverbeij BV Store 22 Tilburg, Jacob Gerritstraat 12, 2611 ES Delft, Niederlande",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 596
  },
  {
    "id": "silverbeij-bv-store-29-middelharnis-5038-ac-tilburg",
    "name": "Silverbeij BV Store 29 Middelharnis",
    "type": "Partner Store",
    "street": "Heuvelstraat",
    "house_number": "63",
    "street_line": "Heuvelstraat 63",
    "zip": "5038 AC",
    "city": "Tilburg",
    "country": "The Netherlands",
    "country_label": "Niederlande",
    "region": "The Netherlands",
    "language": "Englisch",
    "address": "Heuvelstraat 63, 5038 AC Tilburg, Niederlande",
    "map_query": "Heuvelstraat 63, 5038 AC Tilburg, Niederlande",
    "maps_query": "Silverbeij BV Store 29 Middelharnis, Heuvelstraat 63, 5038 AC Tilburg, Niederlande",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 597
  },
  {
    "id": "silverbeij-bv-store-3-gouda-3241-gx-middelharnis",
    "name": "Silverbeij BV Store 3 Gouda",
    "type": "Partner Store",
    "street": "Zandpad",
    "house_number": "24",
    "street_line": "Zandpad 24",
    "zip": "3241 GX",
    "city": "Middelharnis",
    "country": "The Netherlands",
    "country_label": "Niederlande",
    "region": "The Netherlands",
    "language": "Englisch",
    "address": "Zandpad 24, 3241 GX Middelharnis, Niederlande",
    "map_query": "Zandpad 24, 3241 GX Middelharnis, Niederlande",
    "maps_query": "Silverbeij BV Store 3 Gouda, Zandpad 24, 3241 GX Middelharnis, Niederlande",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 598
  },
  {
    "id": "silverbeij-bv-store-30-sliedrecht-2801-gh-gouda",
    "name": "Silverbeij BV Store 30 Sliedrecht",
    "type": "Partner Store",
    "street": "Kleiweg",
    "house_number": "34",
    "street_line": "Kleiweg 34",
    "zip": "2801 GH",
    "city": "Gouda",
    "country": "The Netherlands",
    "country_label": "Niederlande",
    "region": "The Netherlands",
    "language": "Englisch",
    "address": "Kleiweg 34, 2801 GH Gouda, Niederlande",
    "map_query": "Kleiweg 34, 2801 GH Gouda, Niederlande",
    "maps_query": "Silverbeij BV Store 30 Sliedrecht, Kleiweg 34, 2801 GH Gouda, Niederlande",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 599
  },
  {
    "id": "silverbeij-bv-store-33-apeldoorn-3361-wb-sliedrecht",
    "name": "Silverbeij BV Store 33 Apeldoorn",
    "type": "Partner Store",
    "street": "Gantelweg",
    "house_number": "14",
    "street_line": "Gantelweg 14",
    "zip": "3361 WB",
    "city": "Sliedrecht",
    "country": "The Netherlands",
    "country_label": "Niederlande",
    "region": "The Netherlands",
    "language": "Englisch",
    "address": "Gantelweg 14, 3361 WB Sliedrecht, Niederlande",
    "map_query": "Gantelweg 14, 3361 WB Sliedrecht, Niederlande",
    "maps_query": "Silverbeij BV Store 33 Apeldoorn, Gantelweg 14, 3361 WB Sliedrecht, Niederlande",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 600
  },
  {
    "id": "simons4-bv-2611-ge-delft",
    "name": "SIMONS4 BV",
    "type": "Partner Store",
    "street": "Jozefstraat",
    "house_number": "29",
    "street_line": "Jozefstraat 29",
    "zip": "2611 GE",
    "city": "Delft",
    "country": "The Netherlands",
    "country_label": "Niederlande",
    "region": "Belgium",
    "language": "Englisch",
    "address": "Jozefstraat 29, 2611 GE Delft, Niederlande",
    "map_query": "Jozefstraat 29, 2611 GE Delft, Niederlande",
    "maps_query": "SIMONS4 BV, Jozefstraat 29, 2611 GE Delft, Niederlande",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 601
  },
  {
    "id": "sissi-brautmoden-58099-hagen",
    "name": "Sissi Brautmoden",
    "type": "Partner Store",
    "street": "Batheyer Straße",
    "house_number": "115-117",
    "street_line": "Batheyer Straße 115-117",
    "zip": "58099",
    "city": "Hagen",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Batheyer Straße 115-117, 58099 Hagen, Deutschland",
    "map_query": "Batheyer Straße 115-117, 58099 Hagen, Deutschland",
    "maps_query": "Sissi Brautmoden, Batheyer Straße 115-117, 58099 Hagen, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 602
  },
  {
    "id": "skm-nv-39112-magdeburg",
    "name": "Skm NV",
    "type": "Partner Store",
    "street": "Am Fuchsberg",
    "house_number": "11",
    "street_line": "Am Fuchsberg 11",
    "zip": "39112",
    "city": "Magdeburg",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Belgium",
    "language": "Englisch",
    "address": "Am Fuchsberg 11, 39112 Magdeburg, Deutschland",
    "map_query": "Am Fuchsberg 11, 39112 Magdeburg, Deutschland",
    "maps_query": "Skm NV, Am Fuchsberg 11, 39112 Magdeburg, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 603
  },
  {
    "id": "smalville-bv-2630-aartselaar",
    "name": "Smalville BV",
    "type": "Partner Store",
    "street": "Boomsesteenweg",
    "house_number": "35",
    "street_line": "Boomsesteenweg 35",
    "zip": "2630",
    "city": "Aartselaar",
    "country": "Belgium",
    "country_label": "Belgien",
    "region": "Belgium",
    "language": "Englisch",
    "address": "Boomsesteenweg 35, 2630 Aartselaar, Belgien",
    "map_query": "Boomsesteenweg 35, 2630 Aartselaar, Belgien",
    "maps_query": "Smalville BV, Boomsesteenweg 35, 2630 Aartselaar, Belgien",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 604
  },
  {
    "id": "smit-mode-tims-20-b-v-9700-oudenaarde",
    "name": "Smit mode Tims 20 B.V.",
    "type": "Partner Store",
    "street": "Nederstraat",
    "house_number": "65",
    "street_line": "Nederstraat 65",
    "zip": "9700",
    "city": "Oudenaarde",
    "country": "Belgium",
    "country_label": "Belgien",
    "region": "The Netherlands",
    "language": "Englisch",
    "address": "Nederstraat 65, 9700 Oudenaarde, Belgien",
    "map_query": "Nederstraat 65, 9700 Oudenaarde, Belgien",
    "maps_query": "Smit mode Tims 20 B.V., Nederstraat 65, 9700 Oudenaarde, Belgien",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 605
  },
  {
    "id": "smits-mode-3341ll-hendrik-ido-ambacht",
    "name": "Smits Mode",
    "type": "Partner Store",
    "street": "Veersedijk",
    "house_number": "73",
    "street_line": "Veersedijk 73",
    "zip": "3341LL",
    "city": "Hendrik Ido Ambacht",
    "country": "The Netherlands",
    "country_label": "Niederlande",
    "region": "The Netherlands",
    "language": "Englisch",
    "address": "Veersedijk 73, 3341LL Hendrik Ido Ambacht, Niederlande",
    "map_query": "Veersedijk 73, 3341LL Hendrik Ido Ambacht, Niederlande",
    "maps_query": "Smits Mode, Veersedijk 73, 3341LL Hendrik Ido Ambacht, Niederlande",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 606
  },
  {
    "id": "soels-exclusieve-herenmode-b-v-5721-hb-asten",
    "name": "Soels Exclusieve Herenmode B.V.",
    "type": "Partner Store",
    "street": "Emmastraat",
    "house_number": "4",
    "street_line": "Emmastraat 4",
    "zip": "5721 HB",
    "city": "Asten",
    "country": "The Netherlands",
    "country_label": "Niederlande",
    "region": "The Netherlands",
    "language": "Englisch",
    "address": "Emmastraat 4, 5721 HB Asten, Niederlande",
    "map_query": "Emmastraat 4, 5721 HB Asten, Niederlande",
    "maps_query": "Soels Exclusieve Herenmode B.V., Emmastraat 4, 5721 HB Asten, Niederlande",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 607
  },
  {
    "id": "speksnijder-mode-9940-sleidinge",
    "name": "Speksnijder mode",
    "type": "Partner Store",
    "street": "Sleidinge Dorp",
    "house_number": "131",
    "street_line": "Sleidinge Dorp 131",
    "zip": "9940",
    "city": "Sleidinge",
    "country": "Belgium",
    "country_label": "Belgien",
    "region": "The Netherlands",
    "language": "Englisch",
    "address": "Sleidinge Dorp 131, 9940 Sleidinge, Belgien",
    "map_query": "Sleidinge Dorp 131, 9940 Sleidinge, Belgien",
    "maps_query": "Speksnijder mode, Sleidinge Dorp 131, 9940 Sleidinge, Belgien",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 608
  },
  {
    "id": "spiess-fashion-2861-an-bergambacht",
    "name": "Spiess Fashion",
    "type": "Partner Store",
    "street": "Hoofdstraat",
    "house_number": "105",
    "street_line": "Hoofdstraat 105",
    "zip": "2861 AN",
    "city": "Bergambacht",
    "country": "The Netherlands",
    "country_label": "Niederlande",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Hoofdstraat 105, 2861 AN Bergambacht, Niederlande",
    "map_query": "Hoofdstraat 105, 2861 AN Bergambacht, Niederlande",
    "maps_query": "Spiess Fashion, Hoofdstraat 105, 2861 AN Bergambacht, Niederlande",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 609
  },
  {
    "id": "sport-und-mode-schuhmacher-gmbh-75031-eppingen",
    "name": "Sport & Mode Schuhmacher GmbH",
    "type": "Partner Store",
    "street": "Bahnhofstraße",
    "house_number": "3",
    "street_line": "Bahnhofstraße 3",
    "zip": "75031",
    "city": "Eppingen",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Bahnhofstraße 3, 75031 Eppingen, Deutschland",
    "map_query": "Bahnhofstraße 3, 75031 Eppingen, Deutschland",
    "maps_query": "Sport & Mode Schuhmacher GmbH, Bahnhofstraße 3, 75031 Eppingen, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 610
  },
  {
    "id": "srl-a-drft-76709-kronau",
    "name": "SRL A. DRFT",
    "type": "Partner Store",
    "street": "Bahnhofstr. 32 -",
    "house_number": "36",
    "street_line": "Bahnhofstr. 32 - 36",
    "zip": "76709",
    "city": "Kronau",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Belgium",
    "language": "Englisch",
    "address": "Bahnhofstr. 32 - 36, 76709 Kronau, Deutschland",
    "map_query": "Bahnhofstr. 32 - 36, 76709 Kronau, Deutschland",
    "maps_query": "SRL A. DRFT, Bahnhofstr. 32 - 36, 76709 Kronau, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 611
  },
  {
    "id": "stadler-modehaus-4800-verviers",
    "name": "Stadler Modehaus",
    "type": "Partner Store",
    "street": "Rue Du Brou",
    "house_number": "74",
    "street_line": "Rue Du Brou 74",
    "zip": "4800",
    "city": "Verviers",
    "country": "Belgium",
    "country_label": "Belgien",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Rue Du Brou 74, 4800 Verviers, Belgien",
    "map_query": "Rue Du Brou 74, 4800 Verviers, Belgien",
    "maps_query": "Stadler Modehaus, Rue Du Brou 74, 4800 Verviers, Belgien",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 612
  },
  {
    "id": "stanford-bv-84130-dingolfing",
    "name": "STANFORD BV",
    "type": "Partner Store",
    "street": "Bruckstraße",
    "house_number": "13",
    "street_line": "Bruckstraße 13",
    "zip": "84130",
    "city": "Dingolfing",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Belgium",
    "language": "Englisch",
    "address": "Bruckstraße 13, 84130 Dingolfing, Deutschland",
    "map_query": "Bruckstraße 13, 84130 Dingolfing, Deutschland",
    "maps_query": "STANFORD BV, Bruckstraße 13, 84130 Dingolfing, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 613
  },
  {
    "id": "steba-07501-trebisov",
    "name": "Steba",
    "type": "Partner Store",
    "street": "M.R.Stefanika",
    "house_number": "3481/54",
    "street_line": "M.R.Stefanika 3481/54",
    "zip": "07501",
    "city": "Trebisov",
    "country": "Slovakia",
    "country_label": "Slovakia",
    "region": "The Netherlands",
    "language": "Englisch",
    "address": "M.R.Stefanika 3481/54, 07501 Trebisov, Slovakia",
    "map_query": "M.R.Stefanika 3481/54, 07501 Trebisov, Slovakia",
    "maps_query": "Steba, M.R.Stefanika 3481/54, 07501 Trebisov, Slovakia",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 614
  },
  {
    "id": "steegenga-balk-4561-eh-hulst",
    "name": "Steegenga Balk",
    "type": "Partner Store",
    "street": "Gentsestraat",
    "house_number": "25",
    "street_line": "Gentsestraat 25",
    "zip": "4561 EH",
    "city": "Hulst",
    "country": "The Netherlands",
    "country_label": "Niederlande",
    "region": "The Netherlands",
    "language": "Englisch",
    "address": "Gentsestraat 25, 4561 EH Hulst, Niederlande",
    "map_query": "Gentsestraat 25, 4561 EH Hulst, Niederlande",
    "maps_query": "Steegenga Balk, Gentsestraat 25, 4561 EH Hulst, Niederlande",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 615
  },
  {
    "id": "steendam-mode-b-v-8561-aw-balk",
    "name": "Steendam Mode B.V.",
    "type": "Partner Store",
    "street": "Pypsterstikke",
    "house_number": "1",
    "street_line": "Pypsterstikke 1",
    "zip": "8561 AW",
    "city": "Balk",
    "country": "The Netherlands",
    "country_label": "Niederlande",
    "region": "The Netherlands",
    "language": "Englisch",
    "address": "Pypsterstikke 1, 8561 AW Balk, Niederlande",
    "map_query": "Pypsterstikke 1, 8561 AW Balk, Niederlande",
    "maps_query": "Steendam Mode B.V., Pypsterstikke 1, 8561 AW Balk, Niederlande",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 616
  },
  {
    "id": "steinecker-moden-gmbh-2611-cs-delft",
    "name": "Steinecker Moden Gmbh",
    "type": "Partner Store",
    "street": "Wijnhaven 20 A",
    "house_number": "",
    "street_line": "Wijnhaven 20 A",
    "zip": "2611 CS",
    "city": "Delft",
    "country": "The Netherlands",
    "country_label": "Niederlande",
    "region": "Austria",
    "language": "Deutsch",
    "address": "Wijnhaven 20 A, 2611 CS Delft, Niederlande",
    "map_query": "Steinecker Moden Gmbh, Wijnhaven 20 A, 2611 CS Delft, Niederlande",
    "maps_query": "Steinecker Moden Gmbh, Wijnhaven 20 A, 2611 CS Delft, Niederlande",
    "note": "Sortiment und Verfügbarkeit können variieren. Adresse bitte vor Besuch über den Händler prüfen.",
    "data_quality": [
      "house_number_missing"
    ],
    "source_row": 617
  },
  {
    "id": "stekelinck-mode-b-v-3263-randegg",
    "name": "Stekelinck Mode B.V.",
    "type": "Partner Store",
    "street": "Randegg",
    "house_number": "34",
    "street_line": "Randegg 34",
    "zip": "3263",
    "city": "Randegg",
    "country": "Austria",
    "country_label": "Österreich",
    "region": "The Netherlands",
    "language": "Englisch",
    "address": "Randegg 34, 3263 Randegg, Österreich",
    "map_query": "Randegg 34, 3263 Randegg, Österreich",
    "maps_query": "Stekelinck Mode B.V., Randegg 34, 3263 Randegg, Österreich",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 618
  },
  {
    "id": "stephanoff-bvba-1552-kopenhagen",
    "name": "STEPHANOFF BVBA",
    "type": "Partner Store",
    "street": "Vester Voldgade",
    "house_number": "6",
    "street_line": "Vester Voldgade 6",
    "zip": "1552",
    "city": "Kopenhagen",
    "country": "Denmark",
    "country_label": "Dänemark",
    "region": "Belgium",
    "language": "Englisch",
    "address": "Vester Voldgade 6, 1552 Kopenhagen, Dänemark",
    "map_query": "Vester Voldgade 6, 1552 Kopenhagen, Dänemark",
    "maps_query": "STEPHANOFF BVBA, Vester Voldgade 6, 1552 Kopenhagen, Dänemark",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 619
  },
  {
    "id": "stilkraft-mannermode-gmbh-2930-brasschaat",
    "name": "STILKRAFT Männermode GmbH",
    "type": "Partner Store",
    "street": "BREDABAAN",
    "house_number": "301",
    "street_line": "BREDABAAN 301",
    "zip": "2930",
    "city": "Brasschaat",
    "country": "Belgium",
    "country_label": "Belgien",
    "region": "Germany",
    "language": "Deutsch",
    "address": "BREDABAAN 301, 2930 Brasschaat, Belgien",
    "map_query": "BREDABAAN 301, 2930 Brasschaat, Belgien",
    "maps_query": "STILKRAFT Männermode GmbH, BREDABAAN 301, 2930 Brasschaat, Belgien",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 620
  },
  {
    "id": "stogmuller-mode-gmbh-63739-aschaffenburg",
    "name": "Stögmüller Mode Gmbh",
    "type": "Partner Store",
    "street": "Sandgasse",
    "house_number": "7",
    "street_line": "Sandgasse 7",
    "zip": "63739",
    "city": "Aschaffenburg",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Austria",
    "language": "Deutsch",
    "address": "Sandgasse 7, 63739 Aschaffenburg, Deutschland",
    "map_query": "Sandgasse 7, 63739 Aschaffenburg, Deutschland",
    "maps_query": "Stögmüller Mode Gmbh, Sandgasse 7, 63739 Aschaffenburg, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 621
  },
  {
    "id": "stolk-van-dam-4810-gmunden",
    "name": "Stolk van Dam",
    "type": "Partner Store",
    "street": "Bahnhofstrasse",
    "house_number": "11",
    "street_line": "Bahnhofstrasse 11",
    "zip": "4810",
    "city": "Gmunden",
    "country": "Austria",
    "country_label": "Österreich",
    "region": "The Netherlands",
    "language": "Englisch",
    "address": "Bahnhofstrasse 11, 4810 Gmunden, Österreich",
    "map_query": "Bahnhofstrasse 11, 4810 Gmunden, Österreich",
    "maps_query": "Stolk van Dam, Bahnhofstrasse 11, 4810 Gmunden, Österreich",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 622
  },
  {
    "id": "strak-in-pakken-3701-je-zeist",
    "name": "Strak in Pakken",
    "type": "Partner Store",
    "street": "Voorheuvel",
    "house_number": "40",
    "street_line": "Voorheuvel 40",
    "zip": "3701 JE",
    "city": "Zeist",
    "country": "The Netherlands",
    "country_label": "Niederlande",
    "region": "The Netherlands",
    "language": "Englisch",
    "address": "Voorheuvel 40, 3701 JE Zeist, Niederlande",
    "map_query": "Voorheuvel 40, 3701 JE Zeist, Niederlande",
    "maps_query": "Strak in Pakken, Voorheuvel 40, 3701 JE Zeist, Niederlande",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 623
  },
  {
    "id": "straton-nv-1811-jn-alkmaar",
    "name": "Straton NV",
    "type": "Partner Store",
    "street": "Houttil",
    "house_number": "58",
    "street_line": "Houttil 58",
    "zip": "1811 JN",
    "city": "Alkmaar",
    "country": "The Netherlands",
    "country_label": "Niederlande",
    "region": "Belgium",
    "language": "Englisch",
    "address": "Houttil 58, 1811 JN Alkmaar, Niederlande",
    "map_query": "Houttil 58, 1811 JN Alkmaar, Niederlande",
    "maps_query": "Straton NV, Houttil 58, 1811 JN Alkmaar, Niederlande",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 624
  },
  {
    "id": "style-by-van-gastel-8400-oostende",
    "name": "Style by van Gastel",
    "type": "Partner Store",
    "street": "Ijslandstraat",
    "house_number": "8",
    "street_line": "Ijslandstraat 8",
    "zip": "8400",
    "city": "Oostende",
    "country": "Belgium",
    "country_label": "Belgien",
    "region": "The Netherlands",
    "language": "Englisch",
    "address": "Ijslandstraat 8, 8400 Oostende, Belgien",
    "map_query": "Ijslandstraat 8, 8400 Oostende, Belgien",
    "maps_query": "Style by van Gastel, Ijslandstraat 8, 8400 Oostende, Belgien",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 625
  },
  {
    "id": "suits-und-more-2200-herentals",
    "name": "Suits&More",
    "type": "Partner Store",
    "street": "Zandkuil",
    "house_number": "13",
    "street_line": "Zandkuil 13",
    "zip": "2200",
    "city": "Herentals",
    "country": "Belgium",
    "country_label": "Belgien",
    "region": "The Netherlands",
    "language": "Englisch",
    "address": "Zandkuil 13, 2200 Herentals, Belgien",
    "map_query": "Zandkuil 13, 2200 Herentals, Belgien",
    "maps_query": "Suits&More, Zandkuil 13, 2200 Herentals, Belgien",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 626
  },
  {
    "id": "sweetex-e-k-3841-cb-harderwijk",
    "name": "Sweetex e.K",
    "type": "Partner Store",
    "street": "Donkerstraat",
    "house_number": "31",
    "street_line": "Donkerstraat 31",
    "zip": "3841 CB",
    "city": "Harderwijk",
    "country": "The Netherlands",
    "country_label": "Niederlande",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Donkerstraat 31, 3841 CB Harderwijk, Niederlande",
    "map_query": "Donkerstraat 31, 3841 CB Harderwijk, Niederlande",
    "maps_query": "Sweetex e.K, Donkerstraat 31, 3841 CB Harderwijk, Niederlande",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 627
  },
  {
    "id": "taste-for-shirts-8152-glattbrugg",
    "name": "Taste for Shirts",
    "type": "Partner Store",
    "street": "Industriestrasse",
    "house_number": "57",
    "street_line": "Industriestrasse 57",
    "zip": "8152",
    "city": "Glattbrugg",
    "country": "Switzerland",
    "country_label": "Schweiz",
    "region": "The Netherlands",
    "language": "Englisch",
    "address": "Industriestrasse 57, 8152 Glattbrugg, Schweiz",
    "map_query": "Industriestrasse 57, 8152 Glattbrugg, Schweiz",
    "maps_query": "Taste for Shirts, Industriestrasse 57, 8152 Glattbrugg, Schweiz",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 628
  },
  {
    "id": "tc-buckenmaier-gmbh-und-co-kg-2406-bd-alphen-a-d-rijn",
    "name": "TC Buckenmaier GmbH & Co. KG",
    "type": "Partner Store",
    "street": "VAN BOETZELAERSTRAAT",
    "house_number": "47",
    "street_line": "VAN BOETZELAERSTRAAT 47",
    "zip": "2406 BD",
    "city": "ALPHEN A/D RIJN",
    "country": "The Netherlands",
    "country_label": "Niederlande",
    "region": "Germany",
    "language": "Deutsch",
    "address": "VAN BOETZELAERSTRAAT 47, 2406 BD ALPHEN A/D RIJN, Niederlande",
    "map_query": "VAN BOETZELAERSTRAAT 47, 2406 BD ALPHEN A/D RIJN, Niederlande",
    "maps_query": "TC Buckenmaier GmbH & Co. KG, VAN BOETZELAERSTRAAT 47, 2406 BD ALPHEN A/D RIJN, Niederlande",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 629
  },
  {
    "id": "tc-ingrid-buckenmaier-gmbh-und-co-kg-91522-ansbach",
    "name": "TC Ingrid Buckenmaier GmbH & Co. KG",
    "type": "Partner Store",
    "street": "Residenzstraße",
    "house_number": "2-6",
    "street_line": "Residenzstraße 2-6",
    "zip": "91522",
    "city": "Ansbach",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Residenzstraße 2-6, 91522 Ansbach, Deutschland",
    "map_query": "Residenzstraße 2-6, 91522 Ansbach, Deutschland",
    "maps_query": "TC Ingrid Buckenmaier GmbH & Co. KG, Residenzstraße 2-6, 91522 Ansbach, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 630
  },
  {
    "id": "ten-oever-mannenmode-74564-crailsheim",
    "name": "Ten Oever Mannenmode",
    "type": "Partner Store",
    "street": "Wilhelmstr. 1 -",
    "house_number": "5",
    "street_line": "Wilhelmstr. 1 - 5",
    "zip": "74564",
    "city": "Crailsheim",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "The Netherlands",
    "language": "Englisch",
    "address": "Wilhelmstr. 1 - 5, 74564 Crailsheim, Deutschland",
    "map_query": "Wilhelmstr. 1 - 5, 74564 Crailsheim, Deutschland",
    "maps_query": "Ten Oever Mannenmode, Wilhelmstr. 1 - 5, 74564 Crailsheim, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 631
  },
  {
    "id": "ter-haar-mode-8331-jd-steenwijk",
    "name": "Ter Haar Mode",
    "type": "Partner Store",
    "street": "Woldpromenade",
    "house_number": "21-23",
    "street_line": "Woldpromenade 21-23",
    "zip": "8331 JD",
    "city": "Steenwijk",
    "country": "The Netherlands",
    "country_label": "Niederlande",
    "region": "The Netherlands",
    "language": "Englisch",
    "address": "Woldpromenade 21-23, 8331 JD Steenwijk, Niederlande",
    "map_query": "Woldpromenade 21-23, 8331 JD Steenwijk, Niederlande",
    "maps_query": "Ter Haar Mode, Woldpromenade 21-23, 8331 JD Steenwijk, Niederlande",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 632
  },
  {
    "id": "teunissen-mode-v-o-f-8501-ah-joure",
    "name": "Teunissen Mode V.O.F.",
    "type": "Partner Store",
    "street": "Midstraat",
    "house_number": "91-93",
    "street_line": "Midstraat 91-93",
    "zip": "8501 AH",
    "city": "Joure",
    "country": "The Netherlands",
    "country_label": "Niederlande",
    "region": "The Netherlands",
    "language": "Englisch",
    "address": "Midstraat 91-93, 8501 AH Joure, Niederlande",
    "map_query": "Midstraat 91-93, 8501 AH Joure, Niederlande",
    "maps_query": "Teunissen Mode V.O.F., Midstraat 91-93, 8501 AH Joure, Niederlande",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 633
  },
  {
    "id": "tex-labels-int-bv-7261-ax-ruurlo",
    "name": "Tex Labels Int. Bv",
    "type": "Partner Store",
    "street": "Dorpsstraat",
    "house_number": "60",
    "street_line": "Dorpsstraat 60",
    "zip": "7261 AX",
    "city": "Ruurlo",
    "country": "The Netherlands",
    "country_label": "Niederlande",
    "region": "Belgium",
    "language": "Englisch",
    "address": "Dorpsstraat 60, 7261 AX Ruurlo, Niederlande",
    "map_query": "Dorpsstraat 60, 7261 AX Ruurlo, Niederlande",
    "maps_query": "Tex Labels Int. Bv, Dorpsstraat 60, 7261 AX Ruurlo, Niederlande",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 634
  },
  {
    "id": "texanel-nv-9420-erpe-mere",
    "name": "Texanel NV",
    "type": "Partner Store",
    "street": "Oudenaardsesteenweg",
    "house_number": "325",
    "street_line": "Oudenaardsesteenweg 325",
    "zip": "9420",
    "city": "Erpe-Mere",
    "country": "Belgium",
    "country_label": "Belgien",
    "region": "Belgium",
    "language": "Englisch",
    "address": "Oudenaardsesteenweg 325, 9420 Erpe-Mere, Belgien",
    "map_query": "Oudenaardsesteenweg 325, 9420 Erpe-Mere, Belgien",
    "maps_query": "Texanel NV, Oudenaardsesteenweg 325, 9420 Erpe-Mere, Belgien",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 635
  },
  {
    "id": "textila-bv-9100-sint-niklaas",
    "name": "Textila BV",
    "type": "Partner Store",
    "street": "Industriepark-West",
    "house_number": "66",
    "street_line": "Industriepark-West 66",
    "zip": "9100",
    "city": "Sint-Niklaas",
    "country": "Belgium",
    "country_label": "Belgien",
    "region": "Belgium",
    "language": "Englisch",
    "address": "Industriepark-West 66, 9100 Sint-Niklaas, Belgien",
    "map_query": "Industriepark-West 66, 9100 Sint-Niklaas, Belgien",
    "maps_query": "Textila BV, Industriepark-West 66, 9100 Sint-Niklaas, Belgien",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 636
  },
  {
    "id": "textilhaus-render-gmbh-24321-lutjenburg",
    "name": "Textilhaus Render GmbH",
    "type": "Partner Store",
    "street": "Markt",
    "house_number": "22",
    "street_line": "Markt 22",
    "zip": "24321",
    "city": "Lütjenburg",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Markt 22, 24321 Lütjenburg, Deutschland",
    "map_query": "Markt 22, 24321 Lütjenburg, Deutschland",
    "maps_query": "Textilhaus Render GmbH, Markt 22, 24321 Lütjenburg, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 637
  },
  {
    "id": "textilhaus-rieke-gmbh-48683-ahaus",
    "name": "Textilhaus Rieke GmbH",
    "type": "Partner Store",
    "street": "Kirchstraße",
    "house_number": "15",
    "street_line": "Kirchstraße 15",
    "zip": "48683",
    "city": "Ahaus",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Kirchstraße 15, 48683 Ahaus, Deutschland",
    "map_query": "Kirchstraße 15, 48683 Ahaus, Deutschland",
    "maps_query": "Textilhaus Rieke GmbH, Kirchstraße 15, 48683 Ahaus, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 638
  },
  {
    "id": "the-fashion-store-bv-49838-lengerich",
    "name": "The Fashion Store BV",
    "type": "Partner Store",
    "street": "Kirchstrasse",
    "house_number": "7",
    "street_line": "Kirchstrasse 7",
    "zip": "49838",
    "city": "Lengerich",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Belgium",
    "language": "Englisch",
    "address": "Kirchstrasse 7, 49838 Lengerich, Deutschland",
    "map_query": "Kirchstrasse 7, 49838 Lengerich, Deutschland",
    "maps_query": "The Fashion Store BV, Kirchstrasse 7, 49838 Lengerich, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 639
  },
  {
    "id": "thimister-30159-hannover",
    "name": "THIMISTER",
    "type": "Partner Store",
    "street": "Große Packhof Straße",
    "house_number": "14",
    "street_line": "Große Packhof Straße 14",
    "zip": "30159",
    "city": "Hannover",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Belgium",
    "language": "Englisch",
    "address": "Große Packhof Straße 14, 30159 Hannover, Deutschland",
    "map_query": "Große Packhof Straße 14, 30159 Hannover, Deutschland",
    "maps_query": "THIMISTER, Große Packhof Straße 14, 30159 Hannover, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 640
  },
  {
    "id": "tisser-4651-herve",
    "name": "Tisser",
    "type": "Partner Store",
    "street": "OUTRE COUR",
    "house_number": "29",
    "street_line": "OUTRE COUR 29",
    "zip": "4651",
    "city": "HERVE",
    "country": "Belgium",
    "country_label": "Belgien",
    "region": "Belgium",
    "language": "Englisch",
    "address": "OUTRE COUR 29, 4651 HERVE, Belgien",
    "map_query": "OUTRE COUR 29, 4651 HERVE, Belgien",
    "maps_query": "Tisser, OUTRE COUR 29, 4651 HERVE, Belgien",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 641
  },
  {
    "id": "toni-volemann-fashion-gmbh-wd17-1tx-watford-herts",
    "name": "Toni Volemann Fashion GmbH",
    "type": "Partner Store",
    "street": "Clarendon Road",
    "house_number": "73",
    "street_line": "Clarendon Road 73",
    "zip": "WD17 1TX",
    "city": "Watford, Herts",
    "country": "United Kingdom",
    "country_label": "United Kingdom",
    "region": "Austria",
    "language": "Deutsch",
    "address": "Clarendon Road 73, WD17 1TX Watford, Herts, United Kingdom",
    "map_query": "Clarendon Road 73, WD17 1TX Watford, Herts, United Kingdom",
    "maps_query": "Toni Volemann Fashion GmbH, Clarendon Road 73, WD17 1TX Watford, Herts, United Kingdom",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 642
  },
  {
    "id": "top-fashion-van-genderen-1090-wien",
    "name": "Top Fashion - Van Genderen",
    "type": "Partner Store",
    "street": "Alserstraße",
    "house_number": "12-14",
    "street_line": "Alserstraße 12-14",
    "zip": "1090",
    "city": "Wien",
    "country": "Austria",
    "country_label": "Österreich",
    "region": "The Netherlands",
    "language": "Englisch",
    "address": "Alserstraße 12-14, 1090 Wien, Österreich",
    "map_query": "Alserstraße 12-14, 1090 Wien, Österreich",
    "maps_query": "Top Fashion - Van Genderen, Alserstraße 12-14, 1090 Wien, Österreich",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 643
  },
  {
    "id": "trachten-strohmayer-und-erl-modeatelier-2921-ap-krimpen-aan-den-ijssel",
    "name": "Trachten Strohmayer & Erl Modeatelier",
    "type": "Partner Store",
    "street": "Rotterdamseweg",
    "house_number": "4",
    "street_line": "Rotterdamseweg 4",
    "zip": "2921 AP",
    "city": "Krimpen aan den Ijssel",
    "country": "The Netherlands",
    "country_label": "Niederlande",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Rotterdamseweg 4, 2921 AP Krimpen aan den Ijssel, Niederlande",
    "map_query": "Rotterdamseweg 4, 2921 AP Krimpen aan den Ijssel, Niederlande",
    "maps_query": "Trachten Strohmayer & Erl Modeatelier, Rotterdamseweg 4, 2921 AP Krimpen aan den Ijssel, Niederlande",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 644
  },
  {
    "id": "trautwein-leder-mode-tracht-gmbh-83352-altenmarkt-alz",
    "name": "Trautwein Leder Mode Tracht GmbH",
    "type": "Partner Store",
    "street": "Marktplatz",
    "house_number": "1",
    "street_line": "Marktplatz 1",
    "zip": "83352",
    "city": "Altenmarkt/Alz",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Marktplatz 1, 83352 Altenmarkt/Alz, Deutschland",
    "map_query": "Marktplatz 1, 83352 Altenmarkt/Alz, Deutschland",
    "maps_query": "Trautwein Leder Mode Tracht GmbH, Marktplatz 1, 83352 Altenmarkt/Alz, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 645
  },
  {
    "id": "trend-factory-bvba-77761-schiltach",
    "name": "Trend Factory BVBA",
    "type": "Partner Store",
    "street": "Am Hirschen",
    "house_number": "1",
    "street_line": "Am Hirschen 1",
    "zip": "77761",
    "city": "Schiltach",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Belgium",
    "language": "Englisch",
    "address": "Am Hirschen 1, 77761 Schiltach, Deutschland",
    "map_query": "Am Hirschen 1, 77761 Schiltach, Deutschland",
    "maps_query": "Trend Factory BVBA, Am Hirschen 1, 77761 Schiltach, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 646
  },
  {
    "id": "trend-lord-9240-zele",
    "name": "Trend Lord",
    "type": "Partner Store",
    "street": "Cesar Meeusstraat",
    "house_number": "28",
    "street_line": "Cesar Meeusstraat 28",
    "zip": "9240",
    "city": "Zele",
    "country": "Belgium",
    "country_label": "Belgien",
    "region": "The Netherlands",
    "language": "Englisch",
    "address": "Cesar Meeusstraat 28, 9240 Zele, Belgien",
    "map_query": "Cesar Meeusstraat 28, 9240 Zele, Belgien",
    "maps_query": "Trend Lord, Cesar Meeusstraat 28, 9240 Zele, Belgien",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 647
  },
  {
    "id": "trend-man-3401-cn-ijsselstein",
    "name": "Trend Man",
    "type": "Partner Store",
    "street": "Kerkstraat",
    "house_number": "10",
    "street_line": "Kerkstraat 10",
    "zip": "3401 CN",
    "city": "IJsselstein",
    "country": "The Netherlands",
    "country_label": "Niederlande",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Kerkstraat 10, 3401 CN IJsselstein, Niederlande",
    "map_query": "Kerkstraat 10, 3401 CN IJsselstein, Niederlande",
    "maps_query": "Trend Man, Kerkstraat 10, 3401 CN IJsselstein, Niederlande",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 648
  },
  {
    "id": "trendy-trade-s-r-o-53177-bonn-bad-godesberg",
    "name": "Trendy Trade S.R.O.",
    "type": "Partner Store",
    "street": "Am Fronhof",
    "house_number": "10",
    "street_line": "Am Fronhof 10",
    "zip": "53177",
    "city": "Bonn Bad Godesberg",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "",
    "language": "Englisch",
    "address": "Am Fronhof 10, 53177 Bonn Bad Godesberg, Deutschland",
    "map_query": "Am Fronhof 10, 53177 Bonn Bad Godesberg, Deutschland",
    "maps_query": "Trendy Trade S.R.O., Am Fronhof 10, 53177 Bonn Bad Godesberg, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 649
  },
  {
    "id": "trico-paul-971-01-prievidza",
    "name": "Trico Paul",
    "type": "Partner Store",
    "street": "Nábr. Sv.Cyrila",
    "house_number": "315/26",
    "street_line": "Nábr. Sv.Cyrila 315/26",
    "zip": "971 01",
    "city": "Prievidza",
    "country": "Slovakia",
    "country_label": "Slovakia",
    "region": "Belgium",
    "language": "Englisch",
    "address": "Nábr. Sv.Cyrila 315/26, 971 01 Prievidza, Slovakia",
    "map_query": "Nábr. Sv.Cyrila 315/26, 971 01 Prievidza, Slovakia",
    "maps_query": "Trico Paul, Nábr. Sv.Cyrila 315/26, 971 01 Prievidza, Slovakia",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 650
  },
  {
    "id": "tricobel-sa-3272-testelt",
    "name": "Tricobel SA",
    "type": "Partner Store",
    "street": "Kattestraat",
    "house_number": "41",
    "street_line": "Kattestraat 41",
    "zip": "3272",
    "city": "Testelt",
    "country": "Belgium",
    "country_label": "Belgien",
    "region": "Belgium",
    "language": "Englisch",
    "address": "Kattestraat 41, 3272 Testelt, Belgien",
    "map_query": "Kattestraat 41, 3272 Testelt, Belgien",
    "maps_query": "Tricobel SA, Kattestraat 41, 3272 Testelt, Belgien",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 651
  },
  {
    "id": "tuktuk49-b-v-3600-thun",
    "name": "Tuktuk49 B.V.",
    "type": "Partner Store",
    "street": "Untere Hauptgasse",
    "house_number": "14",
    "street_line": "Untere Hauptgasse 14",
    "zip": "3600",
    "city": "Thun",
    "country": "Switzerland",
    "country_label": "Schweiz",
    "region": "The Netherlands",
    "language": "Englisch",
    "address": "Untere Hauptgasse 14, 3600 Thun, Schweiz",
    "map_query": "Untere Hauptgasse 14, 3600 Thun, Schweiz",
    "maps_query": "Tuktuk49 B.V., Untere Hauptgasse 14, 3600 Thun, Schweiz",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 652
  },
  {
    "id": "turban-der-herrenausstatter-3512-gh-utrecht",
    "name": "Turban - Der Herrenausstatter",
    "type": "Partner Store",
    "street": "Oudkerkhof",
    "house_number": "5",
    "street_line": "Oudkerkhof 5",
    "zip": "3512 GH",
    "city": "Utrecht",
    "country": "The Netherlands",
    "country_label": "Niederlande",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Oudkerkhof 5, 3512 GH Utrecht, Niederlande",
    "map_query": "Oudkerkhof 5, 3512 GH Utrecht, Niederlande",
    "maps_query": "Turban - Der Herrenausstatter, Oudkerkhof 5, 3512 GH Utrecht, Niederlande",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 653
  },
  {
    "id": "udo-weiss-herrenausstatter-03150-vilnius",
    "name": "Udo Weiss Herrenausstatter",
    "type": "Partner Store",
    "street": "Savanoriu pr.",
    "house_number": "139",
    "street_line": "Savanoriu pr. 139",
    "zip": "03150",
    "city": "Vilnius",
    "country": "Lithuania",
    "country_label": "Lithuania",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Savanoriu pr. 139, 03150 Vilnius, Lithuania",
    "map_query": "Savanoriu pr. 139, 03150 Vilnius, Lithuania",
    "maps_query": "Udo Weiss Herrenausstatter, Savanoriu pr. 139, 03150 Vilnius, Lithuania",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 654
  },
  {
    "id": "udos-fashion-werkstatt-58239-schwerte",
    "name": "Udo´s Fashion Werkstatt",
    "type": "Partner Store",
    "street": "Rathausstraße",
    "house_number": "6",
    "street_line": "Rathausstraße 6",
    "zip": "58239",
    "city": "Schwerte",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Rathausstraße 6, 58239 Schwerte, Deutschland",
    "map_query": "Rathausstraße 6, 58239 Schwerte, Deutschland",
    "maps_query": "Udo´s Fashion Werkstatt, Rathausstraße 6, 58239 Schwerte, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 655
  },
  {
    "id": "ute-hapke-gmbh-3011-bern",
    "name": "Ute Hapke GmbH",
    "type": "Partner Store",
    "street": "Marktgasse",
    "house_number": "32",
    "street_line": "Marktgasse 32",
    "zip": "3011",
    "city": "Bern",
    "country": "Switzerland",
    "country_label": "Schweiz",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Marktgasse 32, 3011 Bern, Schweiz",
    "map_query": "Marktgasse 32, 3011 Bern, Schweiz",
    "maps_query": "Ute Hapke GmbH, Marktgasse 32, 3011 Bern, Schweiz",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 656
  },
  {
    "id": "utz-mode-gmbh-31785-hameln",
    "name": "Utz Mode GmbH",
    "type": "Partner Store",
    "street": "Osterstraße",
    "house_number": "20",
    "street_line": "Osterstraße 20",
    "zip": "31785",
    "city": "Hameln",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Switzerland",
    "language": "Englisch",
    "address": "Osterstraße 20, 31785 Hameln, Deutschland",
    "map_query": "Osterstraße 20, 31785 Hameln, Deutschland",
    "maps_query": "Utz Mode GmbH, Osterstraße 20, 31785 Hameln, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 657
  },
  {
    "id": "v-o-f-lemsom-6017-ruswil",
    "name": "V.O.F. Lemsom",
    "type": "Partner Store",
    "street": "Hellbühlerstr.",
    "house_number": "12",
    "street_line": "Hellbühlerstr. 12",
    "zip": "6017",
    "city": "Ruswil",
    "country": "Switzerland",
    "country_label": "Schweiz",
    "region": "The Netherlands",
    "language": "Englisch",
    "address": "Hellbühlerstr. 12, 6017 Ruswil, Schweiz",
    "map_query": "Hellbühlerstr. 12, 6017 Ruswil, Schweiz",
    "maps_query": "V.O.F. Lemsom, Hellbühlerstr. 12, 6017 Ruswil, Schweiz",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 658
  },
  {
    "id": "van-beuzekom-1251ks-laren",
    "name": "Van Beuzekom",
    "type": "Partner Store",
    "street": "Brink",
    "house_number": "17",
    "street_line": "Brink 17",
    "zip": "1251KS",
    "city": "Laren",
    "country": "The Netherlands",
    "country_label": "Niederlande",
    "region": "The Netherlands",
    "language": "Englisch",
    "address": "Brink 17, 1251KS Laren, Niederlande",
    "map_query": "Brink 17, 1251KS Laren, Niederlande",
    "maps_query": "Van Beuzekom, Brink 17, 1251KS Laren, Niederlande",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 659
  },
  {
    "id": "van-dal-mannenmode-b-v-barneveld-4201-jp-gorinchem",
    "name": "Van Dal Mannenmode B.V. Barneveld",
    "type": "Partner Store",
    "street": "Botersteeg",
    "house_number": "17",
    "street_line": "Botersteeg 17",
    "zip": "4201 JP",
    "city": "Gorinchem",
    "country": "The Netherlands",
    "country_label": "Niederlande",
    "region": "The Netherlands",
    "language": "Englisch",
    "address": "Botersteeg 17, 4201 JP Gorinchem, Niederlande",
    "map_query": "Botersteeg 17, 4201 JP Gorinchem, Niederlande",
    "maps_query": "Van Dal Mannenmode B.V. Barneveld, Botersteeg 17, 4201 JP Gorinchem, Niederlande",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 660
  },
  {
    "id": "van-dal-mannenmode-b-v-hoogeveen-3771-bc-barneveld",
    "name": "Van Dal Mannenmode B.V. Hoogeveen",
    "type": "Partner Store",
    "street": "Langstraat",
    "house_number": "59",
    "street_line": "Langstraat 59",
    "zip": "3771 BC",
    "city": "Barneveld",
    "country": "The Netherlands",
    "country_label": "Niederlande",
    "region": "The Netherlands",
    "language": "Englisch",
    "address": "Langstraat 59, 3771 BC Barneveld, Niederlande",
    "map_query": "Langstraat 59, 3771 BC Barneveld, Niederlande",
    "maps_query": "Van Dal Mannenmode B.V. Hoogeveen, Langstraat 59, 3771 BC Barneveld, Niederlande",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 661
  },
  {
    "id": "van-dal-mannenmode-b-v-beek-7901-jx-hoogeveen",
    "name": "Van Dal Mannenmode B.V. Beek",
    "type": "Partner Store",
    "street": "Hoofdstraat",
    "house_number": "198",
    "street_line": "Hoofdstraat 198",
    "zip": "7901 JX",
    "city": "Hoogeveen",
    "country": "The Netherlands",
    "country_label": "Niederlande",
    "region": "The Netherlands",
    "language": "Englisch",
    "address": "Hoofdstraat 198, 7901 JX Hoogeveen, Niederlande",
    "map_query": "Hoofdstraat 198, 7901 JX Hoogeveen, Niederlande",
    "maps_query": "Van Dal Mannenmode B.V. Beek, Hoofdstraat 198, 7901 JX Hoogeveen, Niederlande",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 662
  },
  {
    "id": "van-dal-mannenmode-b-v-etten-leur-6191-na-beek",
    "name": "Van Dal Mannenmode B.V. Etten Leur",
    "type": "Partner Store",
    "street": "Wethouder Sangersstraat",
    "house_number": "160",
    "street_line": "Wethouder Sangersstraat 160",
    "zip": "6191 NA",
    "city": "Beek",
    "country": "The Netherlands",
    "country_label": "Niederlande",
    "region": "The Netherlands",
    "language": "Englisch",
    "address": "Wethouder Sangersstraat 160, 6191 NA Beek, Niederlande",
    "map_query": "Wethouder Sangersstraat 160, 6191 NA Beek, Niederlande",
    "maps_query": "Van Dal Mannenmode B.V. Etten Leur, Wethouder Sangersstraat 160, 6191 NA Beek, Niederlande",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 663
  },
  {
    "id": "van-dal-mannenmode-b-v-goes-4873-az-etten-leur",
    "name": "Van Dal Mannenmode B.V. Goes",
    "type": "Partner Store",
    "street": "Hof van den Houte",
    "house_number": "49",
    "street_line": "Hof van den Houte 49",
    "zip": "4873 AZ",
    "city": "Etten Leur",
    "country": "The Netherlands",
    "country_label": "Niederlande",
    "region": "",
    "language": "Englisch",
    "address": "Hof van den Houte 49, 4873 AZ Etten Leur, Niederlande",
    "map_query": "Hof van den Houte 49, 4873 AZ Etten Leur, Niederlande",
    "maps_query": "Van Dal Mannenmode B.V. Goes, Hof van den Houte 49, 4873 AZ Etten Leur, Niederlande",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 664
  },
  {
    "id": "van-dal-mannenmode-b-v-heerenveen-4461-jp-goes",
    "name": "Van Dal Mannenmode B.V. Heerenveen",
    "type": "Partner Store",
    "street": "Lange Vorstraat",
    "house_number": "41",
    "street_line": "Lange Vorstraat 41",
    "zip": "4461 JP",
    "city": "Goes",
    "country": "The Netherlands",
    "country_label": "Niederlande",
    "region": "The Netherlands",
    "language": "Englisch",
    "address": "Lange Vorstraat 41, 4461 JP Goes, Niederlande",
    "map_query": "Lange Vorstraat 41, 4461 JP Goes, Niederlande",
    "maps_query": "Van Dal Mannenmode B.V. Heerenveen, Lange Vorstraat 41, 4461 JP Goes, Niederlande",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 665
  },
  {
    "id": "van-dal-mannenmode-b-v-maassluis-8442-bm-heerenveen",
    "name": "Van Dal Mannenmode B.V. Maassluis",
    "type": "Partner Store",
    "street": "Dracht",
    "house_number": "87",
    "street_line": "Dracht 87",
    "zip": "8442 BM",
    "city": "Heerenveen",
    "country": "The Netherlands",
    "country_label": "Niederlande",
    "region": "The Netherlands",
    "language": "Englisch",
    "address": "Dracht 87, 8442 BM Heerenveen, Niederlande",
    "map_query": "Dracht 87, 8442 BM Heerenveen, Niederlande",
    "maps_query": "Van Dal Mannenmode B.V. Maassluis, Dracht 87, 8442 BM Heerenveen, Niederlande",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 666
  },
  {
    "id": "van-dal-mannenmode-b-v-meppel-3144-ba-maassluis",
    "name": "Van Dal Mannenmode B.V. Meppel",
    "type": "Partner Store",
    "street": "Koningshoek",
    "house_number": "92-298",
    "street_line": "Koningshoek 92-298",
    "zip": "3144 BA",
    "city": "Maassluis",
    "country": "The Netherlands",
    "country_label": "Niederlande",
    "region": "The Netherlands",
    "language": "Englisch",
    "address": "Koningshoek 92-298, 3144 BA Maassluis, Niederlande",
    "map_query": "Koningshoek 92-298, 3144 BA Maassluis, Niederlande",
    "maps_query": "Van Dal Mannenmode B.V. Meppel, Koningshoek 92-298, 3144 BA Maassluis, Niederlande",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 667
  },
  {
    "id": "van-dal-mannenmode-b-v-nieuwegein-7941-lg-meppel",
    "name": "Van Dal Mannenmode B.V. Nieuwegein",
    "type": "Partner Store",
    "street": "Woldstraat",
    "house_number": "49",
    "street_line": "Woldstraat 49",
    "zip": "7941 LG",
    "city": "Meppel",
    "country": "The Netherlands",
    "country_label": "Niederlande",
    "region": "The Netherlands",
    "language": "Englisch",
    "address": "Woldstraat 49, 7941 LG Meppel, Niederlande",
    "map_query": "Woldstraat 49, 7941 LG Meppel, Niederlande",
    "maps_query": "Van Dal Mannenmode B.V. Nieuwegein, Woldstraat 49, 7941 LG Meppel, Niederlande",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 668
  },
  {
    "id": "van-dal-mannenmode-b-v-veenendaal-3431-hh-nieuwegein",
    "name": "Van Dal Mannenmode B.V. Veenendaal",
    "type": "Partner Store",
    "street": "Boogstede",
    "house_number": "18",
    "street_line": "Boogstede 18",
    "zip": "3431 HH",
    "city": "Nieuwegein",
    "country": "The Netherlands",
    "country_label": "Niederlande",
    "region": "The Netherlands",
    "language": "Englisch",
    "address": "Boogstede 18, 3431 HH Nieuwegein, Niederlande",
    "map_query": "Boogstede 18, 3431 HH Nieuwegein, Niederlande",
    "maps_query": "Van Dal Mannenmode B.V. Veenendaal, Boogstede 18, 3431 HH Nieuwegein, Niederlande",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 669
  },
  {
    "id": "van-de-belt-4817-ze-breda",
    "name": "Van de Belt",
    "type": "Partner Store",
    "street": "Gijzenveld",
    "house_number": "6",
    "street_line": "Gijzenveld 6",
    "zip": "4817 ZE",
    "city": "Breda",
    "country": "The Netherlands",
    "country_label": "Niederlande",
    "region": "The Netherlands",
    "language": "Englisch",
    "address": "Gijzenveld 6, 4817 ZE Breda, Niederlande",
    "map_query": "Gijzenveld 6, 4817 ZE Breda, Niederlande",
    "maps_query": "Van de Belt, Gijzenveld 6, 4817 ZE Breda, Niederlande",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 670
  },
  {
    "id": "van-de-walle-und-co-bv-7957-aw-de-wijk",
    "name": "Van De Walle & Co BV",
    "type": "Partner Store",
    "street": "Dorpsstraat",
    "house_number": "44",
    "street_line": "Dorpsstraat 44",
    "zip": "7957 AW",
    "city": "De Wijk",
    "country": "The Netherlands",
    "country_label": "Niederlande",
    "region": "Belgium",
    "language": "Englisch",
    "address": "Dorpsstraat 44, 7957 AW De Wijk, Niederlande",
    "map_query": "Dorpsstraat 44, 7957 AW De Wijk, Niederlande",
    "maps_query": "Van De Walle & Co BV, Dorpsstraat 44, 7957 AW De Wijk, Niederlande",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 671
  },
  {
    "id": "van-delden-mode-9230-wetteren",
    "name": "Van Delden Mode",
    "type": "Partner Store",
    "street": "Stationsstraat",
    "house_number": "16",
    "street_line": "Stationsstraat 16",
    "zip": "9230",
    "city": "Wetteren",
    "country": "Belgium",
    "country_label": "Belgien",
    "region": "The Netherlands",
    "language": "Englisch",
    "address": "Stationsstraat 16, 9230 Wetteren, Belgien",
    "map_query": "Stationsstraat 16, 9230 Wetteren, Belgien",
    "maps_query": "Van Delden Mode, Stationsstraat 16, 9230 Wetteren, Belgien",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 672
  },
  {
    "id": "van-der-brandhof-mannenmode-1971-gc-ijmuiden",
    "name": "Van der Brandhof Mannenmode",
    "type": "Partner Store",
    "street": "Plein 1945 -",
    "house_number": "52",
    "street_line": "Plein 1945 - 52",
    "zip": "1971 GC",
    "city": "IJmuiden",
    "country": "The Netherlands",
    "country_label": "Niederlande",
    "region": "The Netherlands",
    "language": "Englisch",
    "address": "Plein 1945 - 52, 1971 GC IJmuiden, Niederlande",
    "map_query": "Plein 1945 - 52, 1971 GC IJmuiden, Niederlande",
    "maps_query": "Van der Brandhof Mannenmode, Plein 1945 - 52, 1971 GC IJmuiden, Niederlande",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 673
  },
  {
    "id": "van-der-weerden-kleding-bv-3861-bj-nijkerk",
    "name": "Van der Weerden Kleding BV",
    "type": "Partner Store",
    "street": "Oosterstraat",
    "house_number": "10",
    "street_line": "Oosterstraat 10",
    "zip": "3861 BJ",
    "city": "Nijkerk",
    "country": "The Netherlands",
    "country_label": "Niederlande",
    "region": "The Netherlands",
    "language": "Englisch",
    "address": "Oosterstraat 10, 3861 BJ Nijkerk, Niederlande",
    "map_query": "Oosterstraat 10, 3861 BJ Nijkerk, Niederlande",
    "maps_query": "Van der Weerden Kleding BV, Oosterstraat 10, 3861 BJ Nijkerk, Niederlande",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 674
  },
  {
    "id": "van-groeningen-5711-aa-someren",
    "name": "Van Groeningen",
    "type": "Partner Store",
    "street": "Floreffestraat",
    "house_number": "1",
    "street_line": "Floreffestraat 1",
    "zip": "5711 AA",
    "city": "Someren",
    "country": "The Netherlands",
    "country_label": "Niederlande",
    "region": "The Netherlands",
    "language": "Englisch",
    "address": "Floreffestraat 1, 5711 AA Someren, Niederlande",
    "map_query": "Floreffestraat 1, 5711 AA Someren, Niederlande",
    "maps_query": "Van Groeningen, Floreffestraat 1, 5711 AA Someren, Niederlande",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 675
  },
  {
    "id": "van-peer-3421-ag-oudewater",
    "name": "Van Peer",
    "type": "Partner Store",
    "street": "Korte Havenstraat",
    "house_number": "8",
    "street_line": "Korte Havenstraat 8",
    "zip": "3421 AG",
    "city": "Oudewater",
    "country": "The Netherlands",
    "country_label": "Niederlande",
    "region": "Belgium",
    "language": "Englisch",
    "address": "Korte Havenstraat 8, 3421 AG Oudewater, Niederlande",
    "map_query": "Korte Havenstraat 8, 3421 AG Oudewater, Niederlande",
    "maps_query": "Van Peer, Korte Havenstraat 8, 3421 AG Oudewater, Niederlande",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 676
  },
  {
    "id": "van-rijbroek-boekel-b-v-2275-poederlee",
    "name": "Van Rijbroek Boekel B.V.",
    "type": "Partner Store",
    "street": "Dorp",
    "house_number": "42",
    "street_line": "Dorp 42",
    "zip": "2275",
    "city": "Poederlee",
    "country": "Belgium",
    "country_label": "Belgien",
    "region": "The Netherlands",
    "language": "Englisch",
    "address": "Dorp 42, 2275 Poederlee, Belgien",
    "map_query": "Dorp 42, 2275 Poederlee, Belgien",
    "maps_query": "Van Rijbroek Boekel B.V., Dorp 42, 2275 Poederlee, Belgien",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 677
  },
  {
    "id": "van-soest-menswear-5427bb-boekel",
    "name": "Van Soest Menswear",
    "type": "Partner Store",
    "street": "Kerkstraat 29 -",
    "house_number": "44",
    "street_line": "Kerkstraat 29 - 44",
    "zip": "5427BB",
    "city": "Boekel",
    "country": "The Netherlands",
    "country_label": "Niederlande",
    "region": "The Netherlands",
    "language": "Englisch",
    "address": "Kerkstraat 29 - 44, 5427BB Boekel, Niederlande",
    "map_query": "Kerkstraat 29 - 44, 5427BB Boekel, Niederlande",
    "maps_query": "Van Soest Menswear, Kerkstraat 29 - 44, 5427BB Boekel, Niederlande",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 678
  },
  {
    "id": "van-westen-4201-ka-gorinchem",
    "name": "Van Westen",
    "type": "Partner Store",
    "street": "Arkelstraat",
    "house_number": "29",
    "street_line": "Arkelstraat 29",
    "zip": "4201 KA",
    "city": "Gorinchem",
    "country": "The Netherlands",
    "country_label": "Niederlande",
    "region": "The Netherlands",
    "language": "Englisch",
    "address": "Arkelstraat 29, 4201 KA Gorinchem, Niederlande",
    "map_query": "Arkelstraat 29, 4201 KA Gorinchem, Niederlande",
    "maps_query": "Van Westen, Arkelstraat 29, 4201 KA Gorinchem, Niederlande",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 679
  },
  {
    "id": "van-westen-mannen-4461-jr-goes",
    "name": "Van Westen mannen",
    "type": "Partner Store",
    "street": "Lange Vorststraat",
    "house_number": "102",
    "street_line": "Lange Vorststraat 102",
    "zip": "4461 JR",
    "city": "Goes",
    "country": "The Netherlands",
    "country_label": "Niederlande",
    "region": "The Netherlands",
    "language": "Englisch",
    "address": "Lange Vorststraat 102, 4461 JR Goes, Niederlande",
    "map_query": "Lange Vorststraat 102, 4461 JR Goes, Niederlande",
    "maps_query": "Van Westen mannen, Lange Vorststraat 102, 4461 JR Goes, Niederlande",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 680
  },
  {
    "id": "vanhoof-pol-herenkleding-bv-4543-bh-zaamslag",
    "name": "Vanhoof Pol Herenkleding bv",
    "type": "Partner Store",
    "street": "Plein",
    "house_number": "10-11",
    "street_line": "Plein 10-11",
    "zip": "4543 BH",
    "city": "Zaamslag",
    "country": "The Netherlands",
    "country_label": "Niederlande",
    "region": "Belgium",
    "language": "Englisch",
    "address": "Plein 10-11, 4543 BH Zaamslag, Niederlande",
    "map_query": "Plein 10-11, 4543 BH Zaamslag, Niederlande",
    "maps_query": "Vanhoof Pol Herenkleding bv, Plein 10-11, 4543 BH Zaamslag, Niederlande",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 681
  },
  {
    "id": "veldhuis-man-und-mode-9200-dendermonde",
    "name": "Veldhuis Man & Mode",
    "type": "Partner Store",
    "street": "Oude Vest",
    "house_number": "84a",
    "street_line": "Oude Vest 84a",
    "zip": "9200",
    "city": "Dendermonde",
    "country": "Belgium",
    "country_label": "Belgien",
    "region": "The Netherlands",
    "language": "Englisch",
    "address": "Oude Vest 84a, 9200 Dendermonde, Belgien",
    "map_query": "Oude Vest 84a, 9200 Dendermonde, Belgien",
    "maps_query": "Veldhuis Man & Mode, Oude Vest 84a, 9200 Dendermonde, Belgien",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 682
  },
  {
    "id": "verbrigghe-bvba-7121-dn-aalten",
    "name": "Verbrigghe BVBA",
    "type": "Partner Store",
    "street": "Kerkstraat",
    "house_number": "7",
    "street_line": "Kerkstraat 7",
    "zip": "7121 DN",
    "city": "Aalten",
    "country": "The Netherlands",
    "country_label": "Niederlande",
    "region": "Belgium",
    "language": "Englisch",
    "address": "Kerkstraat 7, 7121 DN Aalten, Niederlande",
    "map_query": "Kerkstraat 7, 7121 DN Aalten, Niederlande",
    "maps_query": "Verbrigghe BVBA, Kerkstraat 7, 7121 DN Aalten, Niederlande",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 683
  },
  {
    "id": "vetements-charles-26000-valence",
    "name": "Vêtements Charles",
    "type": "Partner Store",
    "street": "rue Sauniere",
    "house_number": "16",
    "street_line": "rue Sauniere 16",
    "zip": "26000",
    "city": "Valence",
    "country": "France",
    "country_label": "Frankreich",
    "region": "France",
    "language": "Englisch",
    "address": "rue Sauniere 16, 26000 Valence, Frankreich",
    "map_query": "rue Sauniere 16, 26000 Valence, Frankreich",
    "maps_query": "Vêtements Charles, rue Sauniere 16, 26000 Valence, Frankreich",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 684
  },
  {
    "id": "viego-fashion-bv-69230-saint-genis-laval",
    "name": "Viego Fashion BV",
    "type": "Partner Store",
    "street": "avenue Charles De Gaulle",
    "house_number": "2",
    "street_line": "avenue Charles De Gaulle 2",
    "zip": "69230",
    "city": "Saint Genis Laval",
    "country": "France",
    "country_label": "Frankreich",
    "region": "The Netherlands",
    "language": "Englisch",
    "address": "avenue Charles De Gaulle 2, 69230 Saint Genis Laval, Frankreich",
    "map_query": "avenue Charles De Gaulle 2, 69230 Saint Genis Laval, Frankreich",
    "maps_query": "Viego Fashion BV, avenue Charles De Gaulle 2, 69230 Saint Genis Laval, Frankreich",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 685
  },
  {
    "id": "viktor-hafner-1211-bn-hilversum",
    "name": "Viktor Hafner",
    "type": "Partner Store",
    "street": "'s Gravelandseweg 27-A",
    "house_number": "",
    "street_line": "'s Gravelandseweg 27-A",
    "zip": "1211 BN",
    "city": "Hilversum",
    "country": "The Netherlands",
    "country_label": "Niederlande",
    "region": "Germany",
    "language": "Deutsch",
    "address": "'s Gravelandseweg 27-A, 1211 BN Hilversum, Niederlande",
    "map_query": "Viktor Hafner, 's Gravelandseweg 27-A, 1211 BN Hilversum, Niederlande",
    "maps_query": "Viktor Hafner, 's Gravelandseweg 27-A, 1211 BN Hilversum, Niederlande",
    "note": "Sortiment und Verfügbarkeit können variieren. Adresse bitte vor Besuch über den Händler prüfen.",
    "data_quality": [
      "house_number_missing"
    ],
    "source_row": 686
  },
  {
    "id": "vince-herenmode-78713-schramberg",
    "name": "Vince Herenmode",
    "type": "Partner Store",
    "street": "Hauptstraße",
    "house_number": "50",
    "street_line": "Hauptstraße 50",
    "zip": "78713",
    "city": "Schramberg",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "The Netherlands",
    "language": "Englisch",
    "address": "Hauptstraße 50, 78713 Schramberg, Deutschland",
    "map_query": "Hauptstraße 50, 78713 Schramberg, Deutschland",
    "maps_query": "Vince Herenmode, Hauptstraße 50, 78713 Schramberg, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 687
  },
  {
    "id": "vincent-verlaine-srl-8471-jj-wolvega",
    "name": "Vincent Verlaine SRL",
    "type": "Partner Store",
    "street": "Hoofdstraat Oost",
    "house_number": "47",
    "street_line": "Hoofdstraat Oost 47",
    "zip": "8471 JJ",
    "city": "Wolvega",
    "country": "The Netherlands",
    "country_label": "Niederlande",
    "region": "Belgium",
    "language": "Englisch",
    "address": "Hoofdstraat Oost 47, 8471 JJ Wolvega, Niederlande",
    "map_query": "Hoofdstraat Oost 47, 8471 JJ Wolvega, Niederlande",
    "maps_query": "Vincent Verlaine SRL, Hoofdstraat Oost 47, 8471 JJ Wolvega, Niederlande",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 688
  },
  {
    "id": "vink-fashion-4000-liege",
    "name": "Vink Fashion",
    "type": "Partner Store",
    "street": "Rue du Pot d'Or",
    "house_number": "19",
    "street_line": "Rue du Pot d'Or 19",
    "zip": "4000",
    "city": "Liege",
    "country": "Belgium",
    "country_label": "Belgien",
    "region": "The Netherlands",
    "language": "Englisch",
    "address": "Rue du Pot d'Or 19, 4000 Liege, Belgien",
    "map_query": "Rue du Pot d'Or 19, 4000 Liege, Belgien",
    "maps_query": "Vink Fashion, Rue du Pot d'Or 19, 4000 Liege, Belgien",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 689
  },
  {
    "id": "vixx-nv-1315-at-almere",
    "name": "VIXX NV",
    "type": "Partner Store",
    "street": "Zoetelaarpassage",
    "house_number": "7",
    "street_line": "Zoetelaarpassage 7",
    "zip": "1315 AT",
    "city": "Almere",
    "country": "The Netherlands",
    "country_label": "Niederlande",
    "region": "Belgium",
    "language": "Englisch",
    "address": "Zoetelaarpassage 7, 1315 AT Almere, Niederlande",
    "map_query": "Zoetelaarpassage 7, 1315 AT Almere, Niederlande",
    "maps_query": "VIXX NV, Zoetelaarpassage 7, 1315 AT Almere, Niederlande",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 690
  },
  {
    "id": "vohl-und-meyer-gmbh-2042-lm-zandvoort",
    "name": "Vohl & Meyer GmbH",
    "type": "Partner Store",
    "street": "Haltestraat",
    "house_number": "2",
    "street_line": "Haltestraat 2",
    "zip": "2042 LM",
    "city": "Zandvoort",
    "country": "The Netherlands",
    "country_label": "Niederlande",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Haltestraat 2, 2042 LM Zandvoort, Niederlande",
    "map_query": "Haltestraat 2, 2042 LM Zandvoort, Niederlande",
    "maps_query": "Vohl & Meyer GmbH, Haltestraat 2, 2042 LM Zandvoort, Niederlande",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 691
  },
  {
    "id": "voorwinden-retail-b-v-28203-bremen",
    "name": "Voorwinden Retail B.V.",
    "type": "Partner Store",
    "street": "Ostertorsteinweg",
    "house_number": "42",
    "street_line": "Ostertorsteinweg 42",
    "zip": "28203",
    "city": "Bremen",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "The Netherlands",
    "language": "Englisch",
    "address": "Ostertorsteinweg 42, 28203 Bremen, Deutschland",
    "map_query": "Ostertorsteinweg 42, 28203 Bremen, Deutschland",
    "maps_query": "Voorwinden Retail B.V., Ostertorsteinweg 42, 28203 Bremen, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 692
  },
  {
    "id": "vos-fashion-diest-3295-bt-s-gravendeel",
    "name": "Vos fashion Diest",
    "type": "Partner Store",
    "street": "Smidsweg",
    "house_number": "7",
    "street_line": "Smidsweg 7",
    "zip": "3295 BT",
    "city": "'s-Gravendeel",
    "country": "The Netherlands",
    "country_label": "Niederlande",
    "region": "Belgium",
    "language": "Englisch",
    "address": "Smidsweg 7, 3295 BT 's-Gravendeel, Niederlande",
    "map_query": "Smidsweg 7, 3295 BT 's-Gravendeel, Niederlande",
    "maps_query": "Vos fashion Diest, Smidsweg 7, 3295 BT 's-Gravendeel, Niederlande",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 693
  },
  {
    "id": "vossen-kleding-nv-3290-diest",
    "name": "Vossen Kleding NV",
    "type": "Partner Store",
    "street": "Zoutstraat",
    "house_number": "1",
    "street_line": "Zoutstraat 1",
    "zip": "3290",
    "city": "Diest",
    "country": "Belgium",
    "country_label": "Belgien",
    "region": "Belgium",
    "language": "Englisch",
    "address": "Zoutstraat 1, 3290 Diest, Belgien",
    "map_query": "Zoutstraat 1, 3290 Diest, Belgien",
    "maps_query": "Vossen Kleding NV, Zoutstraat 1, 3290 Diest, Belgien",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 694
  },
  {
    "id": "vossen-mannenmode-nv-3700-tongeren",
    "name": "Vossen Mannenmode NV",
    "type": "Partner Store",
    "street": "Luikersteenweg 151 bus",
    "house_number": "16",
    "street_line": "Luikersteenweg 151 bus 16",
    "zip": "3700",
    "city": "Tongeren",
    "country": "Belgium",
    "country_label": "Belgien",
    "region": "Belgium",
    "language": "Englisch",
    "address": "Luikersteenweg 151 bus 16, 3700 Tongeren, Belgien",
    "map_query": "Luikersteenweg 151 bus 16, 3700 Tongeren, Belgien",
    "maps_query": "Vossen Mannenmode NV, Luikersteenweg 151 bus 16, 3700 Tongeren, Belgien",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 695
  },
  {
    "id": "wagener-gmbh-und-co-kg-2490-balen-wezel",
    "name": "Wagener GmbH & Co. KG",
    "type": "Partner Store",
    "street": "Bankei",
    "house_number": "22",
    "street_line": "Bankei 22",
    "zip": "2490",
    "city": "Balen-Wezel",
    "country": "Belgium",
    "country_label": "Belgien",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Bankei 22, 2490 Balen-Wezel, Belgien",
    "map_query": "Bankei 22, 2490 Balen-Wezel, Belgien",
    "maps_query": "Wagener GmbH & Co. KG, Bankei 22, 2490 Balen-Wezel, Belgien",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 696
  },
  {
    "id": "walter-de-lange-v-o-f-herenmode-76530-baden-baden",
    "name": "Walter de Lange V.O.F. Herenmode",
    "type": "Partner Store",
    "street": "Lange Str.",
    "house_number": "44",
    "street_line": "Lange Str. 44",
    "zip": "76530",
    "city": "Baden-Baden",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "The Netherlands",
    "language": "Englisch",
    "address": "Lange Str. 44, 76530 Baden-Baden, Deutschland",
    "map_query": "Lange Str. 44, 76530 Baden-Baden, Deutschland",
    "maps_query": "Walter de Lange V.O.F. Herenmode, Lange Str. 44, 76530 Baden-Baden, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 697
  },
  {
    "id": "weber-bekleidung-ag-3332-eh-zwijndrecht",
    "name": "Weber Bekleidung AG",
    "type": "Partner Store",
    "street": "Hof van Holland",
    "house_number": "114",
    "street_line": "Hof van Holland 114",
    "zip": "3332 EH",
    "city": "Zwijndrecht",
    "country": "The Netherlands",
    "country_label": "Niederlande",
    "region": "Switzerland",
    "language": "Englisch",
    "address": "Hof van Holland 114, 3332 EH Zwijndrecht, Niederlande",
    "map_query": "Hof van Holland 114, 3332 EH Zwijndrecht, Niederlande",
    "maps_query": "Weber Bekleidung AG, Hof van Holland 114, 3332 EH Zwijndrecht, Niederlande",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 698
  },
  {
    "id": "weingarten-gmbh-und-co-kg-9430-st-margrethen",
    "name": "Weingarten GmbH & Co. KG",
    "type": "Partner Store",
    "street": "Rheinpark",
    "house_number": "",
    "street_line": "Rheinpark",
    "zip": "9430",
    "city": "St Margrethen",
    "country": "Switzerland",
    "country_label": "Schweiz",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Rheinpark, 9430 St Margrethen, Schweiz",
    "map_query": "Weingarten GmbH & Co. KG, Rheinpark, 9430 St Margrethen, Schweiz",
    "maps_query": "Weingarten GmbH & Co. KG, Rheinpark, 9430 St Margrethen, Schweiz",
    "note": "Sortiment und Verfügbarkeit können variieren. Adresse bitte vor Besuch über den Händler prüfen.",
    "data_quality": [
      "house_number_missing"
    ],
    "source_row": 699
  },
  {
    "id": "weippert-gmbh-und-co-kg-50825-koln",
    "name": "Weippert GmbH & Co. KG",
    "type": "Partner Store",
    "street": "Maarweg",
    "house_number": "231-232",
    "street_line": "Maarweg 231-232",
    "zip": "50825",
    "city": "Köln",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Maarweg 231-232, 50825 Köln, Deutschland",
    "map_query": "Maarweg 231-232, 50825 Köln, Deutschland",
    "maps_query": "Weippert GmbH & Co. KG, Maarweg 231-232, 50825 Köln, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 700
  },
  {
    "id": "weller-mode-ag-72108-rottenburg-am-neckar",
    "name": "Weller Mode AG",
    "type": "Partner Store",
    "street": "Königstraße",
    "house_number": "40",
    "street_line": "Königstraße 40",
    "zip": "72108",
    "city": "Rottenburg am Neckar",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Switzerland",
    "language": "Englisch",
    "address": "Königstraße 40, 72108 Rottenburg am Neckar, Deutschland",
    "map_query": "Königstraße 40, 72108 Rottenburg am Neckar, Deutschland",
    "maps_query": "Weller Mode AG, Königstraße 40, 72108 Rottenburg am Neckar, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 701
  },
  {
    "id": "wellner-das-modehaus-gmbh-und-co-kg-4132-muttenz",
    "name": "Wellner - das Modehaus GmbH & Co. KG",
    "type": "Partner Store",
    "street": "Hauptstraße",
    "house_number": "72",
    "street_line": "Hauptstraße 72",
    "zip": "4132",
    "city": "Muttenz",
    "country": "Switzerland",
    "country_label": "Schweiz",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Hauptstraße 72, 4132 Muttenz, Schweiz",
    "map_query": "Hauptstraße 72, 4132 Muttenz, Schweiz",
    "maps_query": "Wellner - das Modehaus GmbH & Co. KG, Hauptstraße 72, 4132 Muttenz, Schweiz",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 702
  },
  {
    "id": "wienand-ausstatter-31785-hameln",
    "name": "Wienand ausstatter",
    "type": "Partner Store",
    "street": "Ritterstraße",
    "house_number": "3-4",
    "street_line": "Ritterstraße 3-4",
    "zip": "31785",
    "city": "Hameln",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Ritterstraße 3-4, 31785 Hameln, Deutschland",
    "map_query": "Ritterstraße 3-4, 31785 Hameln, Deutschland",
    "maps_query": "Wienand ausstatter, Ritterstraße 3-4, 31785 Hameln, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 703
  },
  {
    "id": "wieschhorster-gmbh-52062-aachen",
    "name": "Wieschhörster GmbH",
    "type": "Partner Store",
    "street": "Alexanderstrasse",
    "house_number": "18-20",
    "street_line": "Alexanderstrasse 18-20",
    "zip": "52062",
    "city": "Aachen",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Alexanderstrasse 18-20, 52062 Aachen, Deutschland",
    "map_query": "Alexanderstrasse 18-20, 52062 Aachen, Deutschland",
    "maps_query": "Wieschhörster GmbH, Alexanderstrasse 18-20, 52062 Aachen, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 704
  },
  {
    "id": "wigo-s-c-d-wieczorek-e-wieczorek-48268-greven",
    "name": "WIGO S.C. D.Wieczorek E.Wieczorek",
    "type": "Partner Store",
    "street": "An der Martinischule",
    "house_number": "2",
    "street_line": "An der Martinischule 2",
    "zip": "48268",
    "city": "Greven",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Poland",
    "language": "Englisch",
    "address": "An der Martinischule 2, 48268 Greven, Deutschland",
    "map_query": "An der Martinischule 2, 48268 Greven, Deutschland",
    "maps_query": "WIGO S.C. D.Wieczorek E.Wieczorek, An der Martinischule 2, 48268 Greven, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 705
  },
  {
    "id": "wilan-61-131-poznan",
    "name": "Wilan",
    "type": "Partner Store",
    "street": "Ludwika Zamenhofa",
    "house_number": "133",
    "street_line": "Ludwika Zamenhofa 133",
    "zip": "61-131",
    "city": "Poznan",
    "country": "Poland",
    "country_label": "Poland",
    "region": "Belgium",
    "language": "Englisch",
    "address": "Ludwika Zamenhofa 133, 61-131 Poznan, Poland",
    "map_query": "Ludwika Zamenhofa 133, 61-131 Poznan, Poland",
    "maps_query": "Wilan, Ludwika Zamenhofa 133, 61-131 Poznan, Poland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 706
  },
  {
    "id": "wilfried-heim-gmbh-2930-brasschaat-mariaburg",
    "name": "Wilfried Heim Gmbh",
    "type": "Partner Store",
    "street": "Kapelsesteenweg",
    "house_number": "376-380",
    "street_line": "Kapelsesteenweg 376-380",
    "zip": "2930",
    "city": "Brasschaat (Mariaburg)",
    "country": "Belgium",
    "country_label": "Belgien",
    "region": "Austria",
    "language": "Deutsch",
    "address": "Kapelsesteenweg 376-380, 2930 Brasschaat (Mariaburg), Belgien",
    "map_query": "Kapelsesteenweg 376-380, 2930 Brasschaat (Mariaburg), Belgien",
    "maps_query": "Wilfried Heim Gmbh, Kapelsesteenweg 376-380, 2930 Brasschaat (Mariaburg), Belgien",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 707
  },
  {
    "id": "wilh-ranck-gmbh-und-co-kg-6700-bludenz",
    "name": "Wilh. Ranck GmbH & Co. KG",
    "type": "Partner Store",
    "street": "Wichnerstraße",
    "house_number": "31",
    "street_line": "Wichnerstraße 31",
    "zip": "6700",
    "city": "Bludenz",
    "country": "Austria",
    "country_label": "Österreich",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Wichnerstraße 31, 6700 Bludenz, Österreich",
    "map_query": "Wichnerstraße 31, 6700 Bludenz, Österreich",
    "maps_query": "Wilh. Ranck GmbH & Co. KG, Wichnerstraße 31, 6700 Bludenz, Österreich",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 708
  },
  {
    "id": "willemin-mode-s-a-27232-sulingen",
    "name": "Willemin Mode S.A.",
    "type": "Partner Store",
    "street": "Lange Str. 1 -",
    "house_number": "3",
    "street_line": "Lange Str. 1 - 3",
    "zip": "27232",
    "city": "Sulingen",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "Switzerland",
    "language": "Englisch",
    "address": "Lange Str. 1 - 3, 27232 Sulingen, Deutschland",
    "map_query": "Lange Str. 1 - 3, 27232 Sulingen, Deutschland",
    "maps_query": "Willemin Mode S.A., Lange Str. 1 - 3, 27232 Sulingen, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 709
  },
  {
    "id": "wilsmann-anziehbar-2854-bassecourt",
    "name": "Wilsmann Anziehbar",
    "type": "Partner Store",
    "street": "Rue de l'Abbé-Monnin",
    "house_number": "10",
    "street_line": "Rue de l'Abbé-Monnin 10",
    "zip": "2854",
    "city": "Bassecourt",
    "country": "Switzerland",
    "country_label": "Schweiz",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Rue de l'Abbé-Monnin 10, 2854 Bassecourt, Schweiz",
    "map_query": "Rue de l'Abbé-Monnin 10, 2854 Bassecourt, Schweiz",
    "maps_query": "Wilsmann Anziehbar, Rue de l'Abbé-Monnin 10, 2854 Bassecourt, Schweiz",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 710
  },
  {
    "id": "wilso-mannenmode-33397-rietberg",
    "name": "Wilso Mannenmode",
    "type": "Partner Store",
    "street": "Westerwieherstraße",
    "house_number": "253",
    "street_line": "Westerwieherstraße 253",
    "zip": "33397",
    "city": "Rietberg",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "The Netherlands",
    "language": "Englisch",
    "address": "Westerwieherstraße 253, 33397 Rietberg, Deutschland",
    "map_query": "Westerwieherstraße 253, 33397 Rietberg, Deutschland",
    "maps_query": "Wilso Mannenmode, Westerwieherstraße 253, 33397 Rietberg, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 711
  },
  {
    "id": "wilux-sarl-3121-ca-schiedam",
    "name": "Wilux SARL",
    "type": "Partner Store",
    "street": "Hof van Spaland",
    "house_number": "19",
    "street_line": "Hof van Spaland 19",
    "zip": "3121 CA",
    "city": "Schiedam",
    "country": "The Netherlands",
    "country_label": "Niederlande",
    "region": "",
    "language": "Englisch",
    "address": "Hof van Spaland 19, 3121 CA Schiedam, Niederlande",
    "map_query": "Hof van Spaland 19, 3121 CA Schiedam, Niederlande",
    "maps_query": "Wilux SARL, Hof van Spaland 19, 3121 CA Schiedam, Niederlande",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 712
  },
  {
    "id": "wouter-wehberg-mode-30159-hannover",
    "name": "Wouter Wehberg Mode",
    "type": "Partner Store",
    "street": "Grosse Packhofstr.",
    "house_number": "14",
    "street_line": "Grosse Packhofstr. 14",
    "zip": "30159",
    "city": "Hannover",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "The Netherlands",
    "language": "Englisch",
    "address": "Grosse Packhofstr. 14, 30159 Hannover, Deutschland",
    "map_query": "Grosse Packhofstr. 14, 30159 Hannover, Deutschland",
    "maps_query": "Wouter Wehberg Mode, Grosse Packhofstr. 14, 30159 Hannover, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 713
  },
  {
    "id": "wusthoff-gmbh-und-co-kg-5341-ec-oss",
    "name": "Wüsthoff GmbH & Co. KG",
    "type": "Partner Store",
    "street": "Walplein",
    "house_number": "1",
    "street_line": "Walplein 1",
    "zip": "5341 EC",
    "city": "Oss",
    "country": "The Netherlands",
    "country_label": "Niederlande",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Walplein 1, 5341 EC Oss, Niederlande",
    "map_query": "Walplein 1, 5341 EC Oss, Niederlande",
    "maps_query": "Wüsthoff GmbH & Co. KG, Walplein 1, 5341 EC Oss, Niederlande",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 714
  },
  {
    "id": "xl-bedrijfskleding-b-v-36330-le-poinconnet",
    "name": "XL Bedrijfskleding B.V.",
    "type": "Partner Store",
    "street": "Le Forum",
    "house_number": "",
    "street_line": "Le Forum",
    "zip": "36330",
    "city": "LE POINCONNET",
    "country": "France",
    "country_label": "Frankreich",
    "region": "The Netherlands",
    "language": "Englisch",
    "address": "Le Forum, 36330 LE POINCONNET, Frankreich",
    "map_query": "XL Bedrijfskleding B.V., Le Forum, 36330 LE POINCONNET, Frankreich",
    "maps_query": "XL Bedrijfskleding B.V., Le Forum, 36330 LE POINCONNET, Frankreich",
    "note": "Sortiment und Verfügbarkeit können variieren. Adresse bitte vor Besuch über den Händler prüfen.",
    "data_quality": [
      "house_number_missing"
    ],
    "source_row": 715
  },
  {
    "id": "zanotta-mode-sarl-2676-lv-maasdijk",
    "name": "Zanotta Mode Sarl",
    "type": "Partner Store",
    "street": "Honderdland",
    "house_number": "225",
    "street_line": "Honderdland 225",
    "zip": "2676 LV",
    "city": "Maasdijk",
    "country": "The Netherlands",
    "country_label": "Niederlande",
    "region": "Switzerland",
    "language": "Englisch",
    "address": "Honderdland 225, 2676 LV Maasdijk, Niederlande",
    "map_query": "Honderdland 225, 2676 LV Maasdijk, Niederlande",
    "maps_query": "Zanotta Mode Sarl, Honderdland 225, 2676 LV Maasdijk, Niederlande",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 716
  },
  {
    "id": "zeller-1400-yvedone-les-bains",
    "name": "Zeller",
    "type": "Partner Store",
    "street": "Rue du Milieu",
    "house_number": "5",
    "street_line": "Rue du Milieu 5",
    "zip": "1400",
    "city": "Yvedone les Bains",
    "country": "Switzerland",
    "country_label": "Schweiz",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Rue du Milieu 5, 1400 Yvedone les Bains, Schweiz",
    "map_query": "Rue du Milieu 5, 1400 Yvedone les Bains, Schweiz",
    "maps_query": "Zeller, Rue du Milieu 5, 1400 Yvedone les Bains, Schweiz",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 717
  },
  {
    "id": "zerbinotto-maastricht-77855-achern",
    "name": "Zerbinotto Maastricht",
    "type": "Partner Store",
    "street": "Kapellenstraße",
    "house_number": "3",
    "street_line": "Kapellenstraße 3",
    "zip": "77855",
    "city": "Achern",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "The Netherlands",
    "language": "Englisch",
    "address": "Kapellenstraße 3, 77855 Achern, Deutschland",
    "map_query": "Kapellenstraße 3, 77855 Achern, Deutschland",
    "maps_query": "Zerbinotto Maastricht, Kapellenstraße 3, 77855 Achern, Deutschland",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 718
  },
  {
    "id": "zur-blauen-hand-gmbh-und-co-kg-6211-eg-maastricht",
    "name": "ZUR BLAUEN HAND GmbH & Co. KG",
    "type": "Partner Store",
    "street": "Muntstraat",
    "house_number": "7",
    "street_line": "Muntstraat 7",
    "zip": "6211 EG",
    "city": "Maastricht",
    "country": "The Netherlands",
    "country_label": "Niederlande",
    "region": "Germany",
    "language": "Deutsch",
    "address": "Muntstraat 7, 6211 EG Maastricht, Niederlande",
    "map_query": "Muntstraat 7, 6211 EG Maastricht, Niederlande",
    "maps_query": "ZUR BLAUEN HAND GmbH & Co. KG, Muntstraat 7, 6211 EG Maastricht, Niederlande",
    "note": "Sortiment und Verfügbarkeit können je Standort variieren.",
    "data_quality": [],
    "source_row": 719
  },
  {
    "id": "zuitable-partner-54290-trier",
    "name": "Zuitable Partner",
    "type": "Partner Store",
    "street": "Brotstr.41",
    "house_number": "",
    "street_line": "Brotstr.41",
    "zip": "54290",
    "city": "Trier",
    "country": "Germany",
    "country_label": "Deutschland",
    "region": "",
    "language": "",
    "address": "Brotstr.41, 54290 Trier, Deutschland",
    "map_query": "Zuitable Partner, Brotstr.41, 54290 Trier, Deutschland",
    "maps_query": "Zuitable Partner, Brotstr.41, 54290 Trier, Deutschland",
    "note": "Sortiment und Verfügbarkeit können variieren. Adresse bitte vor Besuch über den Händler prüfen.",
    "data_quality": [
      "house_number_missing"
    ],
    "source_row": 720
  }
];